import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var AcademicTermSeason;
(function (AcademicTermSeason) {
    AcademicTermSeason["Fall"] = "FALL";
    AcademicTermSeason["Spring"] = "SPRING";
})(AcademicTermSeason || (AcademicTermSeason = {}));
export var ActivityState;
(function (ActivityState) {
    ActivityState["Draft"] = "draft";
    ActivityState["Published"] = "published";
    ActivityState["Scheduled"] = "scheduled";
})(ActivityState || (ActivityState = {}));
export var ActivityType;
(function (ActivityType) {
    ActivityType["Aitutor"] = "AITUTOR";
    ActivityType["Assessment"] = "ASSESSMENT";
    ActivityType["Assignment"] = "ASSIGNMENT";
    ActivityType["AxioResource"] = "AXIO_RESOURCE";
    ActivityType["Page"] = "PAGE";
    ActivityType["Project"] = "PROJECT";
    ActivityType["Review"] = "REVIEW";
})(ActivityType || (ActivityType = {}));
export var AnnouncementScope;
(function (AnnouncementScope) {
    AnnouncementScope["School"] = "SCHOOL";
    AnnouncementScope["SpecificGroups"] = "SPECIFIC_GROUPS";
})(AnnouncementScope || (AnnouncementScope = {}));
export var AssessmentSubmissionStatus;
(function (AssessmentSubmissionStatus) {
    AssessmentSubmissionStatus["Completed"] = "COMPLETED";
    AssessmentSubmissionStatus["Running"] = "RUNNING";
})(AssessmentSubmissionStatus || (AssessmentSubmissionStatus = {}));
export var AssessmentType;
(function (AssessmentType) {
    AssessmentType["Mcq"] = "MCQ";
    AssessmentType["SocraticDialog"] = "SOCRATIC_DIALOG";
})(AssessmentType || (AssessmentType = {}));
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType["Assignment"] = "assignment";
    AttachmentType["Document"] = "document";
    AttachmentType["Todo"] = "todo";
})(AttachmentType || (AttachmentType = {}));
export var AudienceType;
(function (AudienceType) {
    AudienceType["Faculty"] = "FACULTY";
    AudienceType["School"] = "SCHOOL";
    AudienceType["SpecificGroups"] = "SPECIFIC_GROUPS";
    AudienceType["Students"] = "STUDENTS";
})(AudienceType || (AudienceType = {}));
export var AuditEventType;
(function (AuditEventType) {
    AuditEventType["ConnectorAuthCompleted"] = "connector_auth_completed";
    AuditEventType["ConnectorAuthExpired"] = "connector_auth_expired";
    AuditEventType["ConnectorAuthFailed"] = "connector_auth_failed";
    AuditEventType["ConnectorAuthRefreshed"] = "connector_auth_refreshed";
    AuditEventType["ConnectorAuthStarted"] = "connector_auth_started";
    AuditEventType["ConnectorDisconnectCompleted"] = "connector_disconnect_completed";
    AuditEventType["ConnectorDisconnectFailed"] = "connector_disconnect_failed";
    AuditEventType["ConnectorDisconnectStarted"] = "connector_disconnect_started";
    AuditEventType["ConnectorSetupCompleted"] = "connector_setup_completed";
    AuditEventType["ConnectorSetupFailed"] = "connector_setup_failed";
    AuditEventType["ConnectorSetupStarted"] = "connector_setup_started";
    AuditEventType["CourseArchitectInvitationSent"] = "course_architect_invitation_sent";
    AuditEventType["CourseAssignedToFaculty"] = "course_assigned_to_faculty";
    AuditEventType["CourseCreated"] = "course_created";
    AuditEventType["CourseDeleted"] = "course_deleted";
    AuditEventType["CourseEnrollmentAdded"] = "course_enrollment_added";
    AuditEventType["CourseEnrollmentRemoved"] = "course_enrollment_removed";
    AuditEventType["CourseInvitationAdded"] = "course_invitation_added";
    AuditEventType["CoursePublished"] = "course_published";
    AuditEventType["CourseRemovedFromFaculty"] = "course_removed_from_faculty";
    AuditEventType["CourseUnpublished"] = "course_unpublished";
    AuditEventType["CourseUpdated"] = "course_updated";
    AuditEventType["DegreeCreated"] = "degree_created";
    AuditEventType["DegreeDeleted"] = "degree_deleted";
    AuditEventType["DegreeEnrollmentAdded"] = "degree_enrollment_added";
    AuditEventType["DegreeEnrollmentRemoved"] = "degree_enrollment_removed";
    AuditEventType["DegreeInvitationAdded"] = "degree_invitation_added";
    AuditEventType["DegreeUpdated"] = "degree_updated";
    AuditEventType["IngestionFileCompleted"] = "ingestion_file_completed";
    AuditEventType["IngestionFileFailed"] = "ingestion_file_failed";
    AuditEventType["IngestionFileStarted"] = "ingestion_file_started";
    AuditEventType["IngestionFolderCompleted"] = "ingestion_folder_completed";
    AuditEventType["IngestionFolderFailed"] = "ingestion_folder_failed";
    AuditEventType["IngestionFolderStarted"] = "ingestion_folder_started";
    AuditEventType["IngestionVideoCompleted"] = "ingestion_video_completed";
    AuditEventType["IngestionVideoFailed"] = "ingestion_video_failed";
    AuditEventType["IngestionVideoStarted"] = "ingestion_video_started";
    AuditEventType["UserCourseAssignmentChanged"] = "user_course_assignment_changed";
    AuditEventType["UserCreated"] = "user_created";
    AuditEventType["UserEnrollmentAdded"] = "user_enrollment_added";
    AuditEventType["UserInvitationAdded"] = "user_invitation_added";
    AuditEventType["UserInvitationRemoved"] = "user_invitation_removed";
    AuditEventType["UserRolesChanged"] = "user_roles_changed";
})(AuditEventType || (AuditEventType = {}));
export var BlockType;
(function (BlockType) {
    BlockType["Artifact"] = "artifact";
    BlockType["File"] = "file";
    BlockType["Image"] = "image";
    BlockType["McqQuestion"] = "mcq_question";
    BlockType["SubjectiveQuestion"] = "subjective_question";
    BlockType["Text"] = "text";
    BlockType["Video"] = "video";
    BlockType["Visualization"] = "visualization";
})(BlockType || (BlockType = {}));
export var CheckInFrequency;
(function (CheckInFrequency) {
    CheckInFrequency["Minimal"] = "MINIMAL";
    CheckInFrequency["Normal"] = "NORMAL";
    CheckInFrequency["Proactive"] = "PROACTIVE";
})(CheckInFrequency || (CheckInFrequency = {}));
export var CommentThreadStatus;
(function (CommentThreadStatus) {
    CommentThreadStatus["Open"] = "OPEN";
    CommentThreadStatus["Outdated"] = "OUTDATED";
    CommentThreadStatus["Resolved"] = "RESOLVED";
})(CommentThreadStatus || (CommentThreadStatus = {}));
export var CompanionOnboardingStatus;
(function (CompanionOnboardingStatus) {
    CompanionOnboardingStatus["Completed"] = "COMPLETED";
    CompanionOnboardingStatus["InProgress"] = "IN_PROGRESS";
    CompanionOnboardingStatus["NotStarted"] = "NOT_STARTED";
    CompanionOnboardingStatus["Skipped"] = "SKIPPED";
})(CompanionOnboardingStatus || (CompanionOnboardingStatus = {}));
export var ConnectorAuthMode;
(function (ConnectorAuthMode) {
    ConnectorAuthMode["ApiKey"] = "API_KEY";
    ConnectorAuthMode["InstitutionalOauth2"] = "INSTITUTIONAL_OAUTH2";
    ConnectorAuthMode["ServiceAccount"] = "SERVICE_ACCOUNT";
    ConnectorAuthMode["SessionToken"] = "SESSION_TOKEN";
    ConnectorAuthMode["UserOauth2"] = "USER_OAUTH2";
})(ConnectorAuthMode || (ConnectorAuthMode = {}));
export var ConnectorCapability;
(function (ConnectorCapability) {
    ConnectorCapability["Browse"] = "BROWSE";
    ConnectorCapability["Ingest"] = "INGEST";
    ConnectorCapability["LiveQuery"] = "LIVE_QUERY";
    ConnectorCapability["Search"] = "SEARCH";
    ConnectorCapability["Transcript"] = "TRANSCRIPT";
    ConnectorCapability["VideoPlayback"] = "VIDEO_PLAYBACK";
})(ConnectorCapability || (ConnectorCapability = {}));
export var ConnectorCategory;
(function (ConnectorCategory) {
    ConnectorCategory["AdminKnowledgeBase"] = "ADMIN_KNOWLEDGE_BASE";
    ConnectorCategory["CloudStorage"] = "CLOUD_STORAGE";
    ConnectorCategory["LibraryRepository"] = "LIBRARY_REPOSITORY";
    ConnectorCategory["LmsRepository"] = "LMS_REPOSITORY";
    ConnectorCategory["SyllabusRepository"] = "SYLLABUS_REPOSITORY";
    ConnectorCategory["VideoService"] = "VIDEO_SERVICE";
    ConnectorCategory["WebCms"] = "WEB_CMS";
})(ConnectorCategory || (ConnectorCategory = {}));
export var ConnectorCredentialFieldStorage;
(function (ConnectorCredentialFieldStorage) {
    ConnectorCredentialFieldStorage["Credential"] = "CREDENTIAL";
    ConnectorCredentialFieldStorage["ProviderConfig"] = "PROVIDER_CONFIG";
})(ConnectorCredentialFieldStorage || (ConnectorCredentialFieldStorage = {}));
export var ConnectorInstanceStatus;
(function (ConnectorInstanceStatus) {
    ConnectorInstanceStatus["Active"] = "ACTIVE";
    ConnectorInstanceStatus["Error"] = "ERROR";
    ConnectorInstanceStatus["Inactive"] = "INACTIVE";
})(ConnectorInstanceStatus || (ConnectorInstanceStatus = {}));
export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Concourse"] = "CONCOURSE";
    ConnectorType["GoogleDrive"] = "GOOGLE_DRIVE";
    ConnectorType["Kaltura"] = "KALTURA";
    ConnectorType["LegacyConnector"] = "LEGACY_CONNECTOR";
    ConnectorType["OneDrive"] = "ONE_DRIVE";
})(ConnectorType || (ConnectorType = {}));
export var CourseGenerationStatus;
(function (CourseGenerationStatus) {
    CourseGenerationStatus["Completed"] = "completed";
    CourseGenerationStatus["Failed"] = "failed";
    CourseGenerationStatus["GeneratedInReview"] = "generated_in_review";
    CourseGenerationStatus["GeneratingActivities"] = "generating_activities";
    CourseGenerationStatus["GeneratingImage"] = "generating_image";
    CourseGenerationStatus["GeneratingImageCompleted"] = "generating_image_completed";
    CourseGenerationStatus["GeneratingImageFailed"] = "generating_image_failed";
    CourseGenerationStatus["GeneratingModules"] = "generating_modules";
    CourseGenerationStatus["GeneratingStructure"] = "generating_structure";
    CourseGenerationStatus["IntakeInProgress"] = "intake_in_progress";
    CourseGenerationStatus["NotStarted"] = "not_started";
    CourseGenerationStatus["Processing"] = "processing";
})(CourseGenerationStatus || (CourseGenerationStatus = {}));
export var CourseInsightsRiskLevel;
(function (CourseInsightsRiskLevel) {
    CourseInsightsRiskLevel["AtRisk"] = "AT_RISK";
    CourseInsightsRiskLevel["NoData"] = "NO_DATA";
    CourseInsightsRiskLevel["OnTrack"] = "ON_TRACK";
    CourseInsightsRiskLevel["Watch"] = "WATCH";
})(CourseInsightsRiskLevel || (CourseInsightsRiskLevel = {}));
export var CourseInsightsScope;
(function (CourseInsightsScope) {
    CourseInsightsScope["Course"] = "COURSE";
    CourseInsightsScope["Module"] = "MODULE";
})(CourseInsightsScope || (CourseInsightsScope = {}));
export var CourseInsightsSentimentLabel;
(function (CourseInsightsSentimentLabel) {
    CourseInsightsSentimentLabel["Negative"] = "NEGATIVE";
    CourseInsightsSentimentLabel["Neutral"] = "NEUTRAL";
    CourseInsightsSentimentLabel["Positive"] = "POSITIVE";
})(CourseInsightsSentimentLabel || (CourseInsightsSentimentLabel = {}));
export var CourseIntakeMaterialAnalysisStatus;
(function (CourseIntakeMaterialAnalysisStatus) {
    CourseIntakeMaterialAnalysisStatus["Completed"] = "COMPLETED";
    CourseIntakeMaterialAnalysisStatus["Failed"] = "FAILED";
    CourseIntakeMaterialAnalysisStatus["Processing"] = "PROCESSING";
    CourseIntakeMaterialAnalysisStatus["Queued"] = "QUEUED";
    CourseIntakeMaterialAnalysisStatus["Unsupported"] = "UNSUPPORTED";
})(CourseIntakeMaterialAnalysisStatus || (CourseIntakeMaterialAnalysisStatus = {}));
export var CourseIntakeMaterialRetentionPolicy;
(function (CourseIntakeMaterialRetentionPolicy) {
    CourseIntakeMaterialRetentionPolicy["PurgeAfterModernization"] = "PURGE_AFTER_MODERNIZATION";
    CourseIntakeMaterialRetentionPolicy["Retain"] = "RETAIN";
})(CourseIntakeMaterialRetentionPolicy || (CourseIntakeMaterialRetentionPolicy = {}));
export var CourseModality;
(function (CourseModality) {
    CourseModality["FaceToFace"] = "FACE_TO_FACE";
    CourseModality["Hybrid"] = "HYBRID";
    CourseModality["OnlineAsync"] = "ONLINE_ASYNC";
    CourseModality["OnlineSync"] = "ONLINE_SYNC";
})(CourseModality || (CourseModality = {}));
export var CourseModernizerIntakeStatus;
(function (CourseModernizerIntakeStatus) {
    CourseModernizerIntakeStatus["Evaluating"] = "evaluating";
    CourseModernizerIntakeStatus["IntakeInProgress"] = "intake_in_progress";
    CourseModernizerIntakeStatus["IntakeReady"] = "intake_ready";
    CourseModernizerIntakeStatus["Invited"] = "invited";
    CourseModernizerIntakeStatus["NotStarted"] = "not_started";
    CourseModernizerIntakeStatus["Published"] = "published";
    CourseModernizerIntakeStatus["ReadyForReview"] = "ready_for_review";
    CourseModernizerIntakeStatus["ReadyToEvaluate"] = "ready_to_evaluate";
})(CourseModernizerIntakeStatus || (CourseModernizerIntakeStatus = {}));
export var CourseModernizerSourceType;
(function (CourseModernizerSourceType) {
    CourseModernizerSourceType["Concourse"] = "CONCOURSE";
    CourseModernizerSourceType["Imscc"] = "IMSCC";
    CourseModernizerSourceType["Lms"] = "LMS";
    CourseModernizerSourceType["PdfDocx"] = "PDF_DOCX";
})(CourseModernizerSourceType || (CourseModernizerSourceType = {}));
export var CourseType;
(function (CourseType) {
    CourseType["Blueprint"] = "BLUEPRINT";
    CourseType["LiveSection"] = "LIVE_SECTION";
})(CourseType || (CourseType = {}));
export var DescriptionFormat;
(function (DescriptionFormat) {
    DescriptionFormat["Html"] = "HTML";
    DescriptionFormat["Richtext"] = "RICHTEXT";
})(DescriptionFormat || (DescriptionFormat = {}));
export var DocumentSourceType;
(function (DocumentSourceType) {
    DocumentSourceType["Aitutor"] = "aitutor";
    DocumentSourceType["Assessment"] = "assessment";
    DocumentSourceType["Assignment"] = "assignment";
    DocumentSourceType["Course"] = "course";
    DocumentSourceType["ExternalSource"] = "external_source";
    DocumentSourceType["Message"] = "message";
    DocumentSourceType["Resource"] = "resource";
})(DocumentSourceType || (DocumentSourceType = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["Completed"] = "completed";
    DocumentStatus["Failed"] = "failed";
    DocumentStatus["Pending"] = "pending";
    DocumentStatus["Processing"] = "processing";
})(DocumentStatus || (DocumentStatus = {}));
export var EditableValue;
(function (EditableValue) {
    EditableValue["IleRecommendation"] = "ILE_RECOMMENDATION";
    EditableValue["InaccessibleDocument"] = "INACCESSIBLE_DOCUMENT";
    EditableValue["OtherEditField"] = "OTHER_EDIT_FIELD";
    EditableValue["RecommendedDescription"] = "RECOMMENDED_DESCRIPTION";
    EditableValue["RecommendedDueDate"] = "RECOMMENDED_DUE_DATE";
    EditableValue["RecommendedPointsPossible"] = "RECOMMENDED_POINTS_POSSIBLE";
    EditableValue["RecommendedTitle"] = "RECOMMENDED_TITLE";
    EditableValue["Status"] = "STATUS";
})(EditableValue || (EditableValue = {}));
export var EditingTeamRole;
(function (EditingTeamRole) {
    EditingTeamRole["Architect"] = "ARCHITECT";
    EditingTeamRole["InstructionalDesigner"] = "INSTRUCTIONAL_DESIGNER";
    EditingTeamRole["Instructor"] = "INSTRUCTOR";
    EditingTeamRole["Observer"] = "OBSERVER";
})(EditingTeamRole || (EditingTeamRole = {}));
export var EducationLevel;
(function (EducationLevel) {
    EducationLevel["Graduate"] = "GRADUATE";
    EducationLevel["K12"] = "K12";
    EducationLevel["Professional"] = "PROFESSIONAL";
    EducationLevel["Undergraduate"] = "UNDERGRADUATE";
})(EducationLevel || (EducationLevel = {}));
export var ExternalAnnouncementVisibility;
(function (ExternalAnnouncementVisibility) {
    ExternalAnnouncementVisibility["Hidden"] = "HIDDEN";
    ExternalAnnouncementVisibility["Published"] = "PUBLISHED";
    ExternalAnnouncementVisibility["Unknown"] = "UNKNOWN";
    ExternalAnnouncementVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalAnnouncementVisibility || (ExternalAnnouncementVisibility = {}));
export var ExternalAssignmentSubmissionKind;
(function (ExternalAssignmentSubmissionKind) {
    ExternalAssignmentSubmissionKind["ExternalTool"] = "external_tool";
    ExternalAssignmentSubmissionKind["FileUpload"] = "file_upload";
    ExternalAssignmentSubmissionKind["LinkAttachment"] = "link_attachment";
    ExternalAssignmentSubmissionKind["Observed"] = "observed";
    ExternalAssignmentSubmissionKind["OnPaper"] = "on_paper";
    ExternalAssignmentSubmissionKind["Other"] = "other";
    ExternalAssignmentSubmissionKind["TextEntry"] = "text_entry";
})(ExternalAssignmentSubmissionKind || (ExternalAssignmentSubmissionKind = {}));
export var ExternalAssignmentVisibility;
(function (ExternalAssignmentVisibility) {
    ExternalAssignmentVisibility["Hidden"] = "HIDDEN";
    ExternalAssignmentVisibility["Published"] = "PUBLISHED";
    ExternalAssignmentVisibility["Unknown"] = "UNKNOWN";
    ExternalAssignmentVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalAssignmentVisibility || (ExternalAssignmentVisibility = {}));
export var ExternalCourseListSourceType;
(function (ExternalCourseListSourceType) {
    ExternalCourseListSourceType["CommonCartridge"] = "COMMON_CARTRIDGE";
    ExternalCourseListSourceType["Docx"] = "DOCX";
    ExternalCourseListSourceType["Lms"] = "LMS";
    ExternalCourseListSourceType["Pdf"] = "PDF";
})(ExternalCourseListSourceType || (ExternalCourseListSourceType = {}));
export var ExternalCourseModernizationStatus;
(function (ExternalCourseModernizationStatus) {
    ExternalCourseModernizationStatus["Evaluating"] = "evaluating";
    ExternalCourseModernizationStatus["InProgress"] = "in_progress";
    ExternalCourseModernizationStatus["IntakeInProgress"] = "intake_in_progress";
    ExternalCourseModernizationStatus["IntakeReady"] = "intake_ready";
    ExternalCourseModernizationStatus["Invited"] = "invited";
    ExternalCourseModernizationStatus["Modernized"] = "modernized";
    ExternalCourseModernizationStatus["NotStarted"] = "not_started";
    ExternalCourseModernizationStatus["Published"] = "published";
    ExternalCourseModernizationStatus["ReadyForReview"] = "ready_for_review";
    ExternalCourseModernizationStatus["ReadyToEvaluate"] = "ready_to_evaluate";
})(ExternalCourseModernizationStatus || (ExternalCourseModernizationStatus = {}));
export var ExternalCourseVisibility;
(function (ExternalCourseVisibility) {
    ExternalCourseVisibility["Hidden"] = "HIDDEN";
    ExternalCourseVisibility["Published"] = "PUBLISHED";
    ExternalCourseVisibility["Unknown"] = "UNKNOWN";
    ExternalCourseVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalCourseVisibility || (ExternalCourseVisibility = {}));
export var ExternalCredentialProvider;
(function (ExternalCredentialProvider) {
    ExternalCredentialProvider["Accredible"] = "ACCREDIBLE";
})(ExternalCredentialProvider || (ExternalCredentialProvider = {}));
export var ExternalDiscussionVisibility;
(function (ExternalDiscussionVisibility) {
    ExternalDiscussionVisibility["Hidden"] = "HIDDEN";
    ExternalDiscussionVisibility["Published"] = "PUBLISHED";
    ExternalDiscussionVisibility["Unknown"] = "UNKNOWN";
    ExternalDiscussionVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalDiscussionVisibility || (ExternalDiscussionVisibility = {}));
export var ExternalFileAttachedToType;
(function (ExternalFileAttachedToType) {
    ExternalFileAttachedToType["Announcement"] = "ANNOUNCEMENT";
    ExternalFileAttachedToType["Assignment"] = "ASSIGNMENT";
    ExternalFileAttachedToType["Course"] = "COURSE";
    ExternalFileAttachedToType["Discussion"] = "DISCUSSION";
    ExternalFileAttachedToType["ModuleItem"] = "MODULE_ITEM";
    ExternalFileAttachedToType["Page"] = "PAGE";
    ExternalFileAttachedToType["Quiz"] = "QUIZ";
    ExternalFileAttachedToType["Submission"] = "SUBMISSION";
})(ExternalFileAttachedToType || (ExternalFileAttachedToType = {}));
export var ExternalFileVisibility;
(function (ExternalFileVisibility) {
    ExternalFileVisibility["Hidden"] = "HIDDEN";
    ExternalFileVisibility["Locked"] = "LOCKED";
    ExternalFileVisibility["Published"] = "PUBLISHED";
    ExternalFileVisibility["Unknown"] = "UNKNOWN";
    ExternalFileVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalFileVisibility || (ExternalFileVisibility = {}));
export var ExternalGradeVisibility;
(function (ExternalGradeVisibility) {
    ExternalGradeVisibility["Hidden"] = "HIDDEN";
    ExternalGradeVisibility["Published"] = "PUBLISHED";
    ExternalGradeVisibility["Unknown"] = "UNKNOWN";
    ExternalGradeVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalGradeVisibility || (ExternalGradeVisibility = {}));
export var ExternalItemType;
(function (ExternalItemType) {
    ExternalItemType["Article"] = "ARTICLE";
    ExternalItemType["Audio"] = "AUDIO";
    ExternalItemType["File"] = "FILE";
    ExternalItemType["Folder"] = "FOLDER";
    ExternalItemType["Page"] = "PAGE";
    ExternalItemType["Video"] = "VIDEO";
})(ExternalItemType || (ExternalItemType = {}));
export var ExternalModuleItemType;
(function (ExternalModuleItemType) {
    ExternalModuleItemType["Assignment"] = "ASSIGNMENT";
    ExternalModuleItemType["Discussion"] = "DISCUSSION";
    ExternalModuleItemType["ExternalTool"] = "EXTERNAL_TOOL";
    ExternalModuleItemType["ExternalUrl"] = "EXTERNAL_URL";
    ExternalModuleItemType["File"] = "FILE";
    ExternalModuleItemType["Page"] = "PAGE";
    ExternalModuleItemType["Quiz"] = "QUIZ";
    ExternalModuleItemType["SubHeader"] = "SUB_HEADER";
})(ExternalModuleItemType || (ExternalModuleItemType = {}));
export var ExternalModuleVisibility;
(function (ExternalModuleVisibility) {
    ExternalModuleVisibility["Hidden"] = "HIDDEN";
    ExternalModuleVisibility["Published"] = "PUBLISHED";
    ExternalModuleVisibility["Unknown"] = "UNKNOWN";
    ExternalModuleVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalModuleVisibility || (ExternalModuleVisibility = {}));
export var ExternalPageVisibility;
(function (ExternalPageVisibility) {
    ExternalPageVisibility["Hidden"] = "HIDDEN";
    ExternalPageVisibility["Published"] = "PUBLISHED";
    ExternalPageVisibility["Unknown"] = "UNKNOWN";
    ExternalPageVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalPageVisibility || (ExternalPageVisibility = {}));
export var ExternalQuizAttemptKind;
(function (ExternalQuizAttemptKind) {
    ExternalQuizAttemptKind["Limited"] = "LIMITED";
    ExternalQuizAttemptKind["Unknown"] = "UNKNOWN";
    ExternalQuizAttemptKind["Unlimited"] = "UNLIMITED";
})(ExternalQuizAttemptKind || (ExternalQuizAttemptKind = {}));
export var ExternalQuizVisibility;
(function (ExternalQuizVisibility) {
    ExternalQuizVisibility["Hidden"] = "HIDDEN";
    ExternalQuizVisibility["Published"] = "PUBLISHED";
    ExternalQuizVisibility["Unknown"] = "UNKNOWN";
    ExternalQuizVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalQuizVisibility || (ExternalQuizVisibility = {}));
export var ExternalSourceChunkingStrategyInput;
(function (ExternalSourceChunkingStrategyInput) {
    ExternalSourceChunkingStrategyInput["CustomTextSplitting"] = "CUSTOM_TEXT_SPLITTING";
    ExternalSourceChunkingStrategyInput["RecursiveTextSplitting"] = "RECURSIVE_TEXT_SPLITTING";
    ExternalSourceChunkingStrategyInput["UnstructuredSimple"] = "UNSTRUCTURED_SIMPLE";
    ExternalSourceChunkingStrategyInput["UnstructuredWithImages"] = "UNSTRUCTURED_WITH_IMAGES";
})(ExternalSourceChunkingStrategyInput || (ExternalSourceChunkingStrategyInput = {}));
export var ExternalSourceContentKind;
(function (ExternalSourceContentKind) {
    ExternalSourceContentKind["File"] = "FILE";
    ExternalSourceContentKind["Html"] = "HTML";
    ExternalSourceContentKind["Reference"] = "REFERENCE";
    ExternalSourceContentKind["Text"] = "TEXT";
    ExternalSourceContentKind["Transcript"] = "TRANSCRIPT";
})(ExternalSourceContentKind || (ExternalSourceContentKind = {}));
export var ExternalSourceSystem;
(function (ExternalSourceSystem) {
    ExternalSourceSystem["Brightspace"] = "BRIGHTSPACE";
    ExternalSourceSystem["Canvas"] = "CANVAS";
    ExternalSourceSystem["Docx"] = "DOCX";
    ExternalSourceSystem["Imscc"] = "IMSCC";
    ExternalSourceSystem["Pdf"] = "PDF";
})(ExternalSourceSystem || (ExternalSourceSystem = {}));
export var ExternalSubmissionAttemptKind;
(function (ExternalSubmissionAttemptKind) {
    ExternalSubmissionAttemptKind["File"] = "FILE";
    ExternalSubmissionAttemptKind["Lti"] = "LTI";
    ExternalSubmissionAttemptKind["Other"] = "OTHER";
    ExternalSubmissionAttemptKind["Text"] = "TEXT";
    ExternalSubmissionAttemptKind["Url"] = "URL";
})(ExternalSubmissionAttemptKind || (ExternalSubmissionAttemptKind = {}));
export var ExternalSubmissionContentType;
(function (ExternalSubmissionContentType) {
    ExternalSubmissionContentType["Assignment"] = "ASSIGNMENT";
    ExternalSubmissionContentType["Discussion"] = "DISCUSSION";
    ExternalSubmissionContentType["Quiz"] = "QUIZ";
})(ExternalSubmissionContentType || (ExternalSubmissionContentType = {}));
export var ExternalSubmissionStatus;
(function (ExternalSubmissionStatus) {
    ExternalSubmissionStatus["Excused"] = "EXCUSED";
    ExternalSubmissionStatus["Graded"] = "GRADED";
    ExternalSubmissionStatus["Late"] = "LATE";
    ExternalSubmissionStatus["Missing"] = "MISSING";
    ExternalSubmissionStatus["NotSubmitted"] = "NOT_SUBMITTED";
    ExternalSubmissionStatus["Returned"] = "RETURNED";
    ExternalSubmissionStatus["Submitted"] = "SUBMITTED";
    ExternalSubmissionStatus["Unknown"] = "UNKNOWN";
})(ExternalSubmissionStatus || (ExternalSubmissionStatus = {}));
export var ExternalTokenHealthStatus;
(function (ExternalTokenHealthStatus) {
    ExternalTokenHealthStatus["Expired"] = "EXPIRED";
    ExternalTokenHealthStatus["Expiring"] = "EXPIRING";
    ExternalTokenHealthStatus["Healthy"] = "HEALTHY";
    ExternalTokenHealthStatus["Revoked"] = "REVOKED";
    ExternalTokenHealthStatus["Unknown"] = "UNKNOWN";
})(ExternalTokenHealthStatus || (ExternalTokenHealthStatus = {}));
export var ExternalVisibility;
(function (ExternalVisibility) {
    ExternalVisibility["Hidden"] = "HIDDEN";
    ExternalVisibility["Published"] = "PUBLISHED";
    ExternalVisibility["Unknown"] = "UNKNOWN";
    ExternalVisibility["Unpublished"] = "UNPUBLISHED";
})(ExternalVisibility || (ExternalVisibility = {}));
export var FileBlockPurpose;
(function (FileBlockPurpose) {
    FileBlockPurpose["Attachment"] = "attachment";
    FileBlockPurpose["Input"] = "input";
    FileBlockPurpose["Output"] = "output";
})(FileBlockPurpose || (FileBlockPurpose = {}));
export var FileStatus;
(function (FileStatus) {
    FileStatus["Completed"] = "completed";
    FileStatus["Pending"] = "pending";
    FileStatus["Processing"] = "processing";
    FileStatus["Rejected"] = "rejected";
    FileStatus["Uploaded"] = "uploaded";
})(FileStatus || (FileStatus = {}));
export var FoundationsMode;
(function (FoundationsMode) {
    FoundationsMode["Disabled"] = "DISABLED";
    FoundationsMode["Optional"] = "OPTIONAL";
    FoundationsMode["Required"] = "REQUIRED";
})(FoundationsMode || (FoundationsMode = {}));
export var GeneratingNotificationStatus;
(function (GeneratingNotificationStatus) {
    GeneratingNotificationStatus["Failure"] = "FAILURE";
    GeneratingNotificationStatus["Pending"] = "PENDING";
    GeneratingNotificationStatus["Success"] = "SUCCESS";
})(GeneratingNotificationStatus || (GeneratingNotificationStatus = {}));
export var GradebookActivityType;
(function (GradebookActivityType) {
    GradebookActivityType["Assessment"] = "ASSESSMENT";
    GradebookActivityType["Assignment"] = "ASSIGNMENT";
    GradebookActivityType["Project"] = "PROJECT";
})(GradebookActivityType || (GradebookActivityType = {}));
export var GradebookCellStatus;
(function (GradebookCellStatus) {
    GradebookCellStatus["Excused"] = "EXCUSED";
    GradebookCellStatus["Graded"] = "GRADED";
    GradebookCellStatus["Late"] = "LATE";
    GradebookCellStatus["Missing"] = "MISSING";
    GradebookCellStatus["NeedsGrading"] = "NEEDS_GRADING";
    GradebookCellStatus["NeedsReview"] = "NEEDS_REVIEW";
    GradebookCellStatus["RetakeRequested"] = "RETAKE_REQUESTED";
})(GradebookCellStatus || (GradebookCellStatus = {}));
export var GradebookTotalMode;
(function (GradebookTotalMode) {
    GradebookTotalMode["Cumulative"] = "CUMULATIVE";
    GradebookTotalMode["Total"] = "TOTAL";
})(GradebookTotalMode || (GradebookTotalMode = {}));
export var GuidelineProcessingStatus;
(function (GuidelineProcessingStatus) {
    GuidelineProcessingStatus["Failed"] = "FAILED";
    GuidelineProcessingStatus["Pending"] = "PENDING";
    GuidelineProcessingStatus["Processing"] = "PROCESSING";
    GuidelineProcessingStatus["Ready"] = "READY";
})(GuidelineProcessingStatus || (GuidelineProcessingStatus = {}));
export var HealthStatus;
(function (HealthStatus) {
    HealthStatus["Degraded"] = "DEGRADED";
    HealthStatus["Failed"] = "FAILED";
    HealthStatus["Healthy"] = "HEALTHY";
})(HealthStatus || (HealthStatus = {}));
export var IleCompletionStatus;
(function (IleCompletionStatus) {
    IleCompletionStatus["Active"] = "active";
    IleCompletionStatus["Completed"] = "completed";
})(IleCompletionStatus || (IleCompletionStatus = {}));
export var IleType;
(function (IleType) {
    IleType["AssignmentBased"] = "assignment_based";
    IleType["CourseBased"] = "course_based";
    IleType["TopicBased"] = "topic_based";
})(IleType || (IleType = {}));
export var ImageBlockStatus;
(function (ImageBlockStatus) {
    ImageBlockStatus["Completed"] = "completed";
    ImageBlockStatus["Failed"] = "failed";
    ImageBlockStatus["Generating"] = "generating";
})(ImageBlockStatus || (ImageBlockStatus = {}));
export var InstitutionalExternalAuthStatus;
(function (InstitutionalExternalAuthStatus) {
    InstitutionalExternalAuthStatus["Active"] = "ACTIVE";
    InstitutionalExternalAuthStatus["Disconnected"] = "DISCONNECTED";
    InstitutionalExternalAuthStatus["Error"] = "ERROR";
    InstitutionalExternalAuthStatus["ReauthRequired"] = "REAUTH_REQUIRED";
})(InstitutionalExternalAuthStatus || (InstitutionalExternalAuthStatus = {}));
export var LmsSource;
(function (LmsSource) {
    LmsSource["Brightspace"] = "BRIGHTSPACE";
    LmsSource["Canvas"] = "CANVAS";
})(LmsSource || (LmsSource = {}));
export var LearningOutcomeApprovalStatus;
(function (LearningOutcomeApprovalStatus) {
    LearningOutcomeApprovalStatus["ApprovedEmpty"] = "APPROVED_EMPTY";
    LearningOutcomeApprovalStatus["ApprovedWithOutcomes"] = "APPROVED_WITH_OUTCOMES";
    LearningOutcomeApprovalStatus["NotApproved"] = "NOT_APPROVED";
    LearningOutcomeApprovalStatus["Stale"] = "STALE";
})(LearningOutcomeApprovalStatus || (LearningOutcomeApprovalStatus = {}));
export var LearningOutcomeExtractionJobStatus;
(function (LearningOutcomeExtractionJobStatus) {
    LearningOutcomeExtractionJobStatus["Completed"] = "COMPLETED";
    LearningOutcomeExtractionJobStatus["Failed"] = "FAILED";
    LearningOutcomeExtractionJobStatus["Queued"] = "QUEUED";
    LearningOutcomeExtractionJobStatus["Running"] = "RUNNING";
})(LearningOutcomeExtractionJobStatus || (LearningOutcomeExtractionJobStatus = {}));
export var LearningOutcomeSourceKind;
(function (LearningOutcomeSourceKind) {
    LearningOutcomeSourceKind["AiGenerated"] = "AI_GENERATED";
    LearningOutcomeSourceKind["AiRevised"] = "AI_REVISED";
    LearningOutcomeSourceKind["ConcourseImported"] = "CONCOURSE_IMPORTED";
    LearningOutcomeSourceKind["ConcourseProgramObjective"] = "CONCOURSE_PROGRAM_OBJECTIVE";
    LearningOutcomeSourceKind["ImsccImported"] = "IMSCC_IMPORTED";
    LearningOutcomeSourceKind["LmsExtracted"] = "LMS_EXTRACTED";
    LearningOutcomeSourceKind["Manual"] = "MANUAL";
    LearningOutcomeSourceKind["MaterialExtracted"] = "MATERIAL_EXTRACTED";
    LearningOutcomeSourceKind["PdfDocExtracted"] = "PDF_DOC_EXTRACTED";
})(LearningOutcomeSourceKind || (LearningOutcomeSourceKind = {}));
export var LmsLaunchSyncStatus;
(function (LmsLaunchSyncStatus) {
    LmsLaunchSyncStatus["Active"] = "ACTIVE";
    LmsLaunchSyncStatus["Completed"] = "COMPLETED";
    LmsLaunchSyncStatus["Failed"] = "FAILED";
    LmsLaunchSyncStatus["Pending"] = "PENDING";
})(LmsLaunchSyncStatus || (LmsLaunchSyncStatus = {}));
export var LtiGradePassbackStatus;
(function (LtiGradePassbackStatus) {
    LtiGradePassbackStatus["Failed"] = "FAILED";
    LtiGradePassbackStatus["Pending"] = "PENDING";
    LtiGradePassbackStatus["Posted"] = "POSTED";
})(LtiGradePassbackStatus || (LtiGradePassbackStatus = {}));
export var MediaBlockKind;
(function (MediaBlockKind) {
    MediaBlockKind["Video"] = "video";
    MediaBlockKind["Visualization"] = "visualization";
})(MediaBlockKind || (MediaBlockKind = {}));
export var MessageRole;
(function (MessageRole) {
    MessageRole["Ai"] = "ai";
    MessageRole["Human"] = "human";
    MessageRole["System"] = "system";
    MessageRole["Tool"] = "tool";
})(MessageRole || (MessageRole = {}));
export var ModerationCategory;
(function (ModerationCategory) {
    ModerationCategory["AdaAccommodation"] = "ADA_ACCOMMODATION";
    ModerationCategory["Harassment"] = "HARASSMENT";
    ModerationCategory["HarassmentThreatening"] = "HARASSMENT_THREATENING";
    ModerationCategory["Hate"] = "HATE";
    ModerationCategory["HateThreatening"] = "HATE_THREATENING";
    ModerationCategory["SelfHarm"] = "SELF_HARM";
    ModerationCategory["SelfHarmInstructions"] = "SELF_HARM_INSTRUCTIONS";
    ModerationCategory["SelfHarmIntent"] = "SELF_HARM_INTENT";
    ModerationCategory["Sexual"] = "SEXUAL";
    ModerationCategory["SexualMinors"] = "SEXUAL_MINORS";
    ModerationCategory["Violence"] = "VIOLENCE";
    ModerationCategory["ViolenceGraphic"] = "VIOLENCE_GRAPHIC";
    ModerationCategory["Withdrawal"] = "WITHDRAWAL";
})(ModerationCategory || (ModerationCategory = {}));
export var ModernizeCourseGenerationStatus;
(function (ModernizeCourseGenerationStatus) {
    ModernizeCourseGenerationStatus["Completed"] = "COMPLETED";
    ModernizeCourseGenerationStatus["Failed"] = "FAILED";
    ModernizeCourseGenerationStatus["NotStarted"] = "NOT_STARTED";
    ModernizeCourseGenerationStatus["Running"] = "RUNNING";
})(ModernizeCourseGenerationStatus || (ModernizeCourseGenerationStatus = {}));
export var ModernizedActivityCreationSource;
(function (ModernizedActivityCreationSource) {
    ModernizedActivityCreationSource["EvaluatorSuggestion"] = "EVALUATOR_SUGGESTION";
    ModernizedActivityCreationSource["LmsIngest"] = "LMS_INGEST";
    ModernizedActivityCreationSource["ManualAuthoring"] = "MANUAL_AUTHORING";
})(ModernizedActivityCreationSource || (ModernizedActivityCreationSource = {}));
export var ModernizedActivityEntityType;
(function (ModernizedActivityEntityType) {
    ModernizedActivityEntityType["Assessment"] = "assessment";
    ModernizedActivityEntityType["Assignment"] = "assignment";
    ModernizedActivityEntityType["AxioResource"] = "axioResource";
    ModernizedActivityEntityType["ContentSection"] = "contentSection";
    ModernizedActivityEntityType["IleRecommendation"] = "ileRecommendation";
    ModernizedActivityEntityType["Module"] = "module";
    ModernizedActivityEntityType["OtherActivity"] = "otherActivity";
    ModernizedActivityEntityType["Project"] = "project";
})(ModernizedActivityEntityType || (ModernizedActivityEntityType = {}));
export var ModernizedActivityStatus;
(function (ModernizedActivityStatus) {
    ModernizedActivityStatus["Published"] = "PUBLISHED";
    ModernizedActivityStatus["Queued"] = "QUEUED";
    ModernizedActivityStatus["Skipped"] = "SKIPPED";
    ModernizedActivityStatus["Undecided"] = "UNDECIDED";
})(ModernizedActivityStatus || (ModernizedActivityStatus = {}));
export var ModernizedAssessmentType;
(function (ModernizedAssessmentType) {
    ModernizedAssessmentType["Mcq"] = "MCQ";
    ModernizedAssessmentType["Other"] = "OTHER";
    ModernizedAssessmentType["Quiz"] = "QUIZ";
})(ModernizedAssessmentType || (ModernizedAssessmentType = {}));
export var ModernizedAuditStatus;
(function (ModernizedAuditStatus) {
    ModernizedAuditStatus["Archived"] = "archived";
    ModernizedAuditStatus["InProgress"] = "in_progress";
    ModernizedAuditStatus["Modernized"] = "modernized";
    ModernizedAuditStatus["NotStarted"] = "not_started";
})(ModernizedAuditStatus || (ModernizedAuditStatus = {}));
export var ModernizedCourseContentSectionType;
(function (ModernizedCourseContentSectionType) {
    ModernizedCourseContentSectionType["CourseMaterialsList"] = "COURSE_MATERIALS_LIST";
    ModernizedCourseContentSectionType["InstructorAvailability"] = "INSTRUCTOR_AVAILABILITY";
    ModernizedCourseContentSectionType["LearningObjectives"] = "LEARNING_OBJECTIVES";
    ModernizedCourseContentSectionType["Other"] = "OTHER";
})(ModernizedCourseContentSectionType || (ModernizedCourseContentSectionType = {}));
export var ModernizedCourseExportFormat;
(function (ModernizedCourseExportFormat) {
    ModernizedCourseExportFormat["Imscc"] = "IMSCC";
    ModernizedCourseExportFormat["Pdf"] = "PDF";
})(ModernizedCourseExportFormat || (ModernizedCourseExportFormat = {}));
export var ModernizedDeliveryMode;
(function (ModernizedDeliveryMode) {
    ModernizedDeliveryMode["Hybrid"] = "HYBRID";
    ModernizedDeliveryMode["InPerson"] = "IN_PERSON";
    ModernizedDeliveryMode["Online"] = "ONLINE";
})(ModernizedDeliveryMode || (ModernizedDeliveryMode = {}));
export var ModernizedDescriptionFormat;
(function (ModernizedDescriptionFormat) {
    ModernizedDescriptionFormat["Html"] = "HTML";
    ModernizedDescriptionFormat["Markdown"] = "MARKDOWN";
    ModernizedDescriptionFormat["Plaintext"] = "PLAINTEXT";
})(ModernizedDescriptionFormat || (ModernizedDescriptionFormat = {}));
export var ModernizedEvaluatorEntityType;
(function (ModernizedEvaluatorEntityType) {
    ModernizedEvaluatorEntityType["Activity"] = "activity";
    ModernizedEvaluatorEntityType["Course"] = "course";
    ModernizedEvaluatorEntityType["Module"] = "module";
})(ModernizedEvaluatorEntityType || (ModernizedEvaluatorEntityType = {}));
export var ModernizedEvaluatorIssueStatus;
(function (ModernizedEvaluatorIssueStatus) {
    ModernizedEvaluatorIssueStatus["Fixed"] = "FIXED";
    ModernizedEvaluatorIssueStatus["Open"] = "OPEN";
    ModernizedEvaluatorIssueStatus["Waived"] = "WAIVED";
})(ModernizedEvaluatorIssueStatus || (ModernizedEvaluatorIssueStatus = {}));
export var ModernizedLearnerContext;
(function (ModernizedLearnerContext) {
    ModernizedLearnerContext["GraduateStudent"] = "GRADUATE_STUDENT";
    ModernizedLearnerContext["Mixed"] = "MIXED";
    ModernizedLearnerContext["TraditionalStudent"] = "TRADITIONAL_STUDENT";
    ModernizedLearnerContext["WorkingProfessional"] = "WORKING_PROFESSIONAL";
})(ModernizedLearnerContext || (ModernizedLearnerContext = {}));
export var ModernizedQualityIndicator;
(function (ModernizedQualityIndicator) {
    ModernizedQualityIndicator["Excellent"] = "EXCELLENT";
    ModernizedQualityIndicator["Fair"] = "FAIR";
    ModernizedQualityIndicator["Good"] = "GOOD";
    ModernizedQualityIndicator["NeedsRevision"] = "NEEDS_REVISION";
})(ModernizedQualityIndicator || (ModernizedQualityIndicator = {}));
export var ModernizedRecommendationSourceType;
(function (ModernizedRecommendationSourceType) {
    ModernizedRecommendationSourceType["Accessibility"] = "ACCESSIBILITY";
    ModernizedRecommendationSourceType["General"] = "GENERAL";
    ModernizedRecommendationSourceType["Industry"] = "INDUSTRY";
    ModernizedRecommendationSourceType["Institutional"] = "INSTITUTIONAL";
    ModernizedRecommendationSourceType["Rubric"] = "RUBRIC";
})(ModernizedRecommendationSourceType || (ModernizedRecommendationSourceType = {}));
export var ModernizedScoreCategory;
(function (ModernizedScoreCategory) {
    ModernizedScoreCategory["Accessibility"] = "ACCESSIBILITY";
    ModernizedScoreCategory["Assessment"] = "ASSESSMENT";
    ModernizedScoreCategory["CourseDesign"] = "COURSE_DESIGN";
    ModernizedScoreCategory["Engagement"] = "ENGAGEMENT";
})(ModernizedScoreCategory || (ModernizedScoreCategory = {}));
export var ModuleImageGenerationStatus;
(function (ModuleImageGenerationStatus) {
    ModuleImageGenerationStatus["Completed"] = "completed";
    ModuleImageGenerationStatus["Failed"] = "failed";
    ModuleImageGenerationStatus["Generating"] = "generating";
    ModuleImageGenerationStatus["NotStarted"] = "not_started";
})(ModuleImageGenerationStatus || (ModuleImageGenerationStatus = {}));
export var NodeLabel;
(function (NodeLabel) {
    NodeLabel["Chapter"] = "Chapter";
    NodeLabel["Field"] = "Field";
    NodeLabel["Subchapter"] = "Subchapter";
    NodeLabel["Subfield"] = "Subfield";
    NodeLabel["Topic"] = "Topic";
})(NodeLabel || (NodeLabel = {}));
export var NotificationEventType;
(function (NotificationEventType) {
    NotificationEventType["AnnouncementPosted"] = "ANNOUNCEMENT_POSTED";
    NotificationEventType["AnnouncementUpdated"] = "ANNOUNCEMENT_UPDATED";
    NotificationEventType["AssessmentSubmission"] = "ASSESSMENT_SUBMISSION";
    NotificationEventType["AssignmentSubmission"] = "ASSIGNMENT_SUBMISSION";
    NotificationEventType["CommentMention"] = "COMMENT_MENTION";
    NotificationEventType["DownloadUrl"] = "DOWNLOAD_URL";
    NotificationEventType["ProjectSubmission"] = "PROJECT_SUBMISSION";
    NotificationEventType["TokenHealthInstitutional"] = "TOKEN_HEALTH_INSTITUTIONAL";
    NotificationEventType["TokenHealthPersonal"] = "TOKEN_HEALTH_PERSONAL";
})(NotificationEventType || (NotificationEventType = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["DownloadFile"] = "DOWNLOAD_FILE";
    NotificationType["Info"] = "INFO";
})(NotificationType || (NotificationType = {}));
export var NudgeChannel;
(function (NudgeChannel) {
    NudgeChannel["Email"] = "EMAIL";
    NudgeChannel["Sms"] = "SMS";
})(NudgeChannel || (NudgeChannel = {}));
export var NudgeConfigScope;
(function (NudgeConfigScope) {
    NudgeConfigScope["Global"] = "GLOBAL";
    NudgeConfigScope["Tenant"] = "TENANT";
})(NudgeConfigScope || (NudgeConfigScope = {}));
export var NudgeCourseRefType;
(function (NudgeCourseRefType) {
    NudgeCourseRefType["Course"] = "COURSE";
    NudgeCourseRefType["ExternalCourse"] = "EXTERNAL_COURSE";
})(NudgeCourseRefType || (NudgeCourseRefType = {}));
export var NudgeEventState;
(function (NudgeEventState) {
    NudgeEventState["Delivered"] = "DELIVERED";
    NudgeEventState["Exhausted"] = "EXHAUSTED";
    NudgeEventState["Failed"] = "FAILED";
    NudgeEventState["Processing"] = "PROCESSING";
})(NudgeEventState || (NudgeEventState = {}));
export var NudgeFrequency;
(function (NudgeFrequency) {
    NudgeFrequency["Daily"] = "DAILY";
    NudgeFrequency["EveryOtherDay"] = "EVERY_OTHER_DAY";
    NudgeFrequency["Never"] = "NEVER";
    NudgeFrequency["Weekly"] = "WEEKLY";
})(NudgeFrequency || (NudgeFrequency = {}));
export var NudgeParentType;
(function (NudgeParentType) {
    NudgeParentType["AiTutor"] = "ai_tutor";
    NudgeParentType["Announcement"] = "announcement";
    NudgeParentType["Assessment"] = "assessment";
    NudgeParentType["Assignment"] = "assignment";
    NudgeParentType["Course"] = "course";
    NudgeParentType["ExternalAnnouncement"] = "external_announcement";
    NudgeParentType["ExternalAssignment"] = "external_assignment";
    NudgeParentType["ExternalDiscussion"] = "external_discussion";
    NudgeParentType["Module"] = "module";
    NudgeParentType["Project"] = "project";
    NudgeParentType["ProjectRequirement"] = "project_requirement";
    NudgeParentType["Quiz"] = "quiz";
    NudgeParentType["User"] = "user";
})(NudgeParentType || (NudgeParentType = {}));
export var NudgeState;
(function (NudgeState) {
    NudgeState["Active"] = "ACTIVE";
    NudgeState["Completed"] = "COMPLETED";
    NudgeState["Dismissed"] = "DISMISSED";
    NudgeState["Potential"] = "POTENTIAL";
    NudgeState["Ready"] = "READY";
    NudgeState["Scheduled"] = "SCHEDULED";
    NudgeState["Snoozed"] = "SNOOZED";
})(NudgeState || (NudgeState = {}));
export var NudgeTriggerEventType;
(function (NudgeTriggerEventType) {
    NudgeTriggerEventType["NudgeActivityAvailabilityChanged"] = "NudgeActivityAvailabilityChanged";
    NudgeTriggerEventType["NudgeActivityCompleted"] = "NudgeActivityCompleted";
    NudgeTriggerEventType["NudgeActivityDueDateChanged"] = "NudgeActivityDueDateChanged";
    NudgeTriggerEventType["NudgeGradePosted"] = "NudgeGradePosted";
})(NudgeTriggerEventType || (NudgeTriggerEventType = {}));
export var NudgeType;
(function (NudgeType) {
    NudgeType["AssignmentDueSoon"] = "ASSIGNMENT_DUE_SOON";
    NudgeType["NewAnnouncement"] = "NEW_ANNOUNCEMENT";
    NudgeType["QuizOpen"] = "QUIZ_OPEN";
    NudgeType["SubmissionFeedbackReady"] = "SUBMISSION_FEEDBACK_READY";
})(NudgeType || (NudgeType = {}));
export var OralAssessmentSessionStatus;
(function (OralAssessmentSessionStatus) {
    OralAssessmentSessionStatus["AwaitingAnswer"] = "AWAITING_ANSWER";
    OralAssessmentSessionStatus["Completed"] = "COMPLETED";
    OralAssessmentSessionStatus["Intro"] = "INTRO";
    OralAssessmentSessionStatus["TimedOut"] = "TIMED_OUT";
})(OralAssessmentSessionStatus || (OralAssessmentSessionStatus = {}));
export var Priority;
(function (Priority) {
    Priority["Critical"] = "CRITICAL";
    Priority["High"] = "HIGH";
    Priority["Low"] = "LOW";
    Priority["Medium"] = "MEDIUM";
})(Priority || (Priority = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["Archived"] = "ARCHIVED";
    ProjectStatus["Draft"] = "DRAFT";
    ProjectStatus["Published"] = "PUBLISHED";
})(ProjectStatus || (ProjectStatus = {}));
export var ProjectSubmissionStatus;
(function (ProjectSubmissionStatus) {
    ProjectSubmissionStatus["Approved"] = "APPROVED";
    ProjectSubmissionStatus["Completed"] = "COMPLETED";
    ProjectSubmissionStatus["Draft"] = "DRAFT";
    ProjectSubmissionStatus["NeedsRevision"] = "NEEDS_REVISION";
    ProjectSubmissionStatus["Rejected"] = "REJECTED";
    ProjectSubmissionStatus["Submitted"] = "SUBMITTED";
    ProjectSubmissionStatus["UnderReview"] = "UNDER_REVIEW";
})(ProjectSubmissionStatus || (ProjectSubmissionStatus = {}));
export var ProjectVettingStatus;
(function (ProjectVettingStatus) {
    ProjectVettingStatus["Approved"] = "APPROVED";
    ProjectVettingStatus["InProgress"] = "IN_PROGRESS";
    ProjectVettingStatus["NeedsRevision"] = "NEEDS_REVISION";
    ProjectVettingStatus["NotStarted"] = "NOT_STARTED";
    ProjectVettingStatus["Rejected"] = "REJECTED";
})(ProjectVettingStatus || (ProjectVettingStatus = {}));
export var QuestionGenerationStatus;
(function (QuestionGenerationStatus) {
    QuestionGenerationStatus["Completed"] = "completed";
    QuestionGenerationStatus["Failed"] = "failed";
    QuestionGenerationStatus["Processing"] = "processing";
})(QuestionGenerationStatus || (QuestionGenerationStatus = {}));
export var RequirementType;
(function (RequirementType) {
    RequirementType["Deliverable"] = "DELIVERABLE";
    RequirementType["Documentation"] = "DOCUMENTATION";
    RequirementType["Milestone"] = "MILESTONE";
    RequirementType["Presentation"] = "PRESENTATION";
    RequirementType["Research"] = "RESEARCH";
    RequirementType["Testing"] = "TESTING";
})(RequirementType || (RequirementType = {}));
export var RubricCategory;
(function (RubricCategory) {
    RubricCategory["Accessibility"] = "ACCESSIBILITY";
    RubricCategory["Assessment"] = "ASSESSMENT";
    RubricCategory["CourseDesign"] = "COURSE_DESIGN";
    RubricCategory["Engagement"] = "ENGAGEMENT";
})(RubricCategory || (RubricCategory = {}));
export var RubricFrameworkType;
(function (RubricFrameworkType) {
    RubricFrameworkType["Custom"] = "CUSTOM";
    RubricFrameworkType["Olc"] = "OLC";
    RubricFrameworkType["Qm"] = "QM";
})(RubricFrameworkType || (RubricFrameworkType = {}));
export var RubricParseStatus;
(function (RubricParseStatus) {
    RubricParseStatus["Failed"] = "FAILED";
    RubricParseStatus["Parsing"] = "PARSING";
    RubricParseStatus["Pending"] = "PENDING";
    RubricParseStatus["Ready"] = "READY";
})(RubricParseStatus || (RubricParseStatus = {}));
export var Severity;
(function (Severity) {
    Severity["Critical"] = "CRITICAL";
    Severity["High"] = "HIGH";
    Severity["Low"] = "LOW";
    Severity["Medium"] = "MEDIUM";
})(Severity || (Severity = {}));
export var SnapshotDiffChangeType;
(function (SnapshotDiffChangeType) {
    SnapshotDiffChangeType["Added"] = "ADDED";
    SnapshotDiffChangeType["Changed"] = "CHANGED";
    SnapshotDiffChangeType["Removed"] = "REMOVED";
})(SnapshotDiffChangeType || (SnapshotDiffChangeType = {}));
export var SnapshotSourceTag;
(function (SnapshotSourceTag) {
    SnapshotSourceTag["AiGeneration"] = "AI_GENERATION";
    SnapshotSourceTag["BatchApprove"] = "BATCH_APPROVE";
    SnapshotSourceTag["ManualEdit"] = "MANUAL_EDIT";
    SnapshotSourceTag["ManualReview"] = "MANUAL_REVIEW";
    SnapshotSourceTag["ResetToIntake"] = "RESET_TO_INTAKE";
    SnapshotSourceTag["Restore"] = "RESTORE";
    SnapshotSourceTag["ViaAiAssistant"] = "VIA_AI_ASSISTANT";
})(SnapshotSourceTag || (SnapshotSourceTag = {}));
/** An enum for sorting in either ascending or descending order. */
export var SortDirection;
(function (SortDirection) {
    /** Sort by field values in ascending order. */
    SortDirection["Asc"] = "ASC";
    /** Sort by field values in descending order. */
    SortDirection["Desc"] = "DESC";
})(SortDirection || (SortDirection = {}));
export var StoragePathType;
(function (StoragePathType) {
    StoragePathType["AdminDocuments"] = "admin_documents";
    StoragePathType["AssignmentsWorksheets"] = "assignments_worksheets";
    StoragePathType["ChatAttachments"] = "chat_attachments";
    StoragePathType["CourseModernizerDocuments"] = "course_modernizer_documents";
    StoragePathType["ExportCourse"] = "export_course";
    StoragePathType["ExportGradeSubmissions"] = "export_grade_submissions";
    StoragePathType["ExportGradebook"] = "export_gradebook";
    StoragePathType["ExportsCsv"] = "exports_csv";
    StoragePathType["ExportsRoster"] = "exports_roster";
    StoragePathType["FeedbackAttachments"] = "feedback_attachments";
    StoragePathType["IntakeMaterials"] = "intake_materials";
    StoragePathType["LessonPlans"] = "lesson__plans";
    StoragePathType["ProjectStarterResources"] = "project_starterResources";
    StoragePathType["ProjectSubmissions"] = "project_submissions";
    StoragePathType["Resources"] = "resources";
    StoragePathType["RichTextEditorImages"] = "rich_text_editor_images";
    StoragePathType["Rubrics"] = "rubrics";
    StoragePathType["TenantFavicon"] = "tenant_favicon";
    StoragePathType["TenantLogo"] = "tenant_logo";
    StoragePathType["Thumbnails"] = "thumbnails";
    StoragePathType["UsersProfileImages"] = "users_profile__images";
})(StoragePathType || (StoragePathType = {}));
export var StudentActivityStatus;
(function (StudentActivityStatus) {
    StudentActivityStatus["Cleared"] = "CLEARED";
    StudentActivityStatus["Excused"] = "EXCUSED";
    StudentActivityStatus["LateAllowed"] = "LATE_ALLOWED";
    StudentActivityStatus["Missing"] = "MISSING";
})(StudentActivityStatus || (StudentActivityStatus = {}));
export var StudyTime;
(function (StudyTime) {
    StudyTime["Afternoon"] = "AFTERNOON";
    StudyTime["Evening"] = "EVENING";
    StudyTime["Morning"] = "MORNING";
})(StudyTime || (StudyTime = {}));
export var TopQuestionScopeFilter;
(function (TopQuestionScopeFilter) {
    TopQuestionScopeFilter["All"] = "ALL";
    TopQuestionScopeFilter["Assignment"] = "ASSIGNMENT";
    TopQuestionScopeFilter["Course"] = "COURSE";
})(TopQuestionScopeFilter || (TopQuestionScopeFilter = {}));
export var UpdatedEntityType;
(function (UpdatedEntityType) {
    UpdatedEntityType["Question"] = "QUESTION";
    UpdatedEntityType["Rubric"] = "RUBRIC";
    UpdatedEntityType["Submission"] = "SUBMISSION";
})(UpdatedEntityType || (UpdatedEntityType = {}));
export var UserExternalAuthStatus;
(function (UserExternalAuthStatus) {
    UserExternalAuthStatus["Active"] = "ACTIVE";
    UserExternalAuthStatus["Error"] = "ERROR";
    UserExternalAuthStatus["ReauthRequired"] = "REAUTH_REQUIRED";
    UserExternalAuthStatus["Revoked"] = "REVOKED";
    UserExternalAuthStatus["TenantDisconnected"] = "TENANT_DISCONNECTED";
    UserExternalAuthStatus["UserDisconnected"] = "USER_DISCONNECTED";
})(UserExternalAuthStatus || (UserExternalAuthStatus = {}));
export var VisualizationStatus;
(function (VisualizationStatus) {
    VisualizationStatus["Completed"] = "completed";
    VisualizationStatus["Failed"] = "failed";
    VisualizationStatus["Processing"] = "processing";
})(VisualizationStatus || (VisualizationStatus = {}));
export var WorksheetGenerationStatus;
(function (WorksheetGenerationStatus) {
    WorksheetGenerationStatus["Completed"] = "completed";
    WorksheetGenerationStatus["Failed"] = "failed";
    WorksheetGenerationStatus["Processing"] = "processing";
})(WorksheetGenerationStatus || (WorksheetGenerationStatus = {}));
export var WorkspaceType;
(function (WorkspaceType) {
    WorkspaceType["Course"] = "course";
    WorkspaceType["Support"] = "support";
})(WorkspaceType || (WorkspaceType = {}));
export const GetLmsLaunchSyncStatusDocument = gql `
    query GetLmsLaunchSyncStatus($jobId: String!) {
  getLmsLaunchSyncStatus(jobId: $jobId) {
    jobId
    status
    failedReason
  }
}
    `;
/**
 * __useGetLmsLaunchSyncStatusQuery__
 *
 * To run a query within a React component, call `useGetLmsLaunchSyncStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLmsLaunchSyncStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLmsLaunchSyncStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetLmsLaunchSyncStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLmsLaunchSyncStatusDocument, options);
}
export function useGetLmsLaunchSyncStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLmsLaunchSyncStatusDocument, options);
}
export function useGetLmsLaunchSyncStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLmsLaunchSyncStatusDocument, options);
}
export const LoginDocument = gql `
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    accessToken
    refreshToken
    user {
      id
      email
      isOnboarded
      isPro
      name
      googleAuthTokens {
        access_token
        refresh_token
        scope
        token_type
        expiry_date
      }
      isEmailVerified
      otpPreference
      countryCode
      phoneNumber
      fullPhoneNumber
    }
  }
}
    `;
/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LoginDocument, options);
}
export const LogoutDocument = gql `
    mutation Logout {
  logout {
    message
    success
  }
}
    `;
/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LogoutDocument, options);
}
export const RefreshTokenDocument = gql `
    mutation RefreshToken($refreshToken: String!) {
  refreshToken(refreshToken: $refreshToken) {
    accessToken
    refreshToken
  }
}
    `;
/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RefreshTokenDocument, options);
}
export const ResetPasswordDocument = gql `
    mutation ResetPassword($newPassword: String!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token) {
    message
    success
  }
}
    `;
/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetPasswordDocument, options);
}
export const SignupDocument = gql `
    mutation Signup($email: String!, $name: String!, $password: String!, $gender: String, $birthday: String!, $dailyEmailOptIn: Boolean!, $language: String!, $timezone: String!) {
  signup(
    email: $email
    name: $name
    password: $password
    gender: $gender
    birthday: $birthday
    dailyEmailOptIn: $dailyEmailOptIn
    language: $language
    timezone: $timezone
  ) {
    accessToken
    refreshToken
    user {
      id
      email
      name
      isPro
      isOnboarded
      otpPreference
      isEmailVerified
      fullPhoneNumber
      preferences {
        language
      }
    }
  }
}
    `;
/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      gender: // value for 'gender'
 *      birthday: // value for 'birthday'
 *      dailyEmailOptIn: // value for 'dailyEmailOptIn'
 *      language: // value for 'language'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useSignupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SignupDocument, options);
}
export const LoginSuperAdminDocument = gql `
    mutation LoginSuperAdmin($email: String!, $password: String!) {
  loginSuperAdmin(email: $email, password: $password) {
    accessToken
    refreshToken
    user {
      id
      email
      isOnboarded
      isPro
      name
      googleAuthTokens {
        access_token
        refresh_token
        scope
        token_type
        expiry_date
      }
      isEmailVerified
      otpPreference
      countryCode
      phoneNumber
      fullPhoneNumber
    }
  }
}
    `;
/**
 * __useLoginSuperAdminMutation__
 *
 * To run a mutation, you first call `useLoginSuperAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSuperAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSuperAdminMutation, { data, loading, error }] = useLoginSuperAdminMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginSuperAdminMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(LoginSuperAdminDocument, options);
}
export const CareerIsLoadingDocument = gql `
    mutation careerIsLoading($isLoading: Boolean!) {
  careerIsLoading(isLoading: $isLoading) {
    isCareerLoading
  }
}
    `;
/**
 * __useCareerIsLoadingMutation__
 *
 * To run a mutation, you first call `useCareerIsLoadingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerIsLoadingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerIsLoadingMutation, { data, loading, error }] = useCareerIsLoadingMutation({
 *   variables: {
 *      isLoading: // value for 'isLoading'
 *   },
 * });
 */
export function useCareerIsLoadingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CareerIsLoadingDocument, options);
}
export const CareerSubmitFormDocument = gql `
    mutation CareerSubmitForm($currentOccupation: String!, $careerPathName: String!, $careerGoal: String!) {
  careerSubmitForm(
    currentOccupation: $currentOccupation
    careerPathName: $careerPathName
    careerGoal: $careerGoal
  )
}
    `;
/**
 * __useCareerSubmitFormMutation__
 *
 * To run a mutation, you first call `useCareerSubmitFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCareerSubmitFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [careerSubmitFormMutation, { data, loading, error }] = useCareerSubmitFormMutation({
 *   variables: {
 *      currentOccupation: // value for 'currentOccupation'
 *      careerPathName: // value for 'careerPathName'
 *      careerGoal: // value for 'careerGoal'
 *   },
 * });
 */
export function useCareerSubmitFormMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CareerSubmitFormDocument, options);
}
export const SetCareerPathActiveDocument = gql `
    mutation SetCareerPathActive($careerId: ID) {
  setCareerPathActive(careerId: $careerId)
}
    `;
/**
 * __useSetCareerPathActiveMutation__
 *
 * To run a mutation, you first call `useSetCareerPathActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCareerPathActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCareerPathActiveMutation, { data, loading, error }] = useSetCareerPathActiveMutation({
 *   variables: {
 *      careerId: // value for 'careerId'
 *   },
 * });
 */
export function useSetCareerPathActiveMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetCareerPathActiveDocument, options);
}
export const CloseMediaBlockSessionDocument = gql `
    mutation CloseMediaBlockSession($aiTutorId: ID!, $mediaChatId: ID!, $blockId: ID!, $mediaBlockKind: MediaBlockKind!, $mediaFocus: String!) {
  closeMediaBlockSession(
    aiTutorId: $aiTutorId
    mediaChatId: $mediaChatId
    blockId: $blockId
    mediaBlockKind: $mediaBlockKind
    mediaFocus: $mediaFocus
  ) {
    success
    message
  }
}
    `;
/**
 * __useCloseMediaBlockSessionMutation__
 *
 * To run a mutation, you first call `useCloseMediaBlockSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseMediaBlockSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeMediaBlockSessionMutation, { data, loading, error }] = useCloseMediaBlockSessionMutation({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *      mediaChatId: // value for 'mediaChatId'
 *      blockId: // value for 'blockId'
 *      mediaBlockKind: // value for 'mediaBlockKind'
 *      mediaFocus: // value for 'mediaFocus'
 *   },
 * });
 */
export function useCloseMediaBlockSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CloseMediaBlockSessionDocument, options);
}
export const CreateMediaBlockChatDocument = gql `
    mutation CreateMediaBlockChat($aiTutorId: ID!, $blockId: ID!, $mediaBlockKind: MediaBlockKind!) {
  createMediaBlockChat(
    aiTutorId: $aiTutorId
    blockId: $blockId
    mediaBlockKind: $mediaBlockKind
  ) {
    success
    message
    mediaChatId
  }
}
    `;
/**
 * __useCreateMediaBlockChatMutation__
 *
 * To run a mutation, you first call `useCreateMediaBlockChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaBlockChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaBlockChatMutation, { data, loading, error }] = useCreateMediaBlockChatMutation({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *      blockId: // value for 'blockId'
 *      mediaBlockKind: // value for 'mediaBlockKind'
 *   },
 * });
 */
export function useCreateMediaBlockChatMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateMediaBlockChatDocument, options);
}
export const DeleteAspectDocument = gql `
    mutation DeleteAspect($nodeId: ID!) {
  deleteAspect(nodeId: $nodeId) {
    message
    success
  }
}
    `;
/**
 * __useDeleteAspectMutation__
 *
 * To run a mutation, you first call `useDeleteAspectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAspectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAspectMutation, { data, loading, error }] = useDeleteAspectMutation({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useDeleteAspectMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAspectDocument, options);
}
export const DeleteCompanionChatDocument = gql `
    mutation DeleteCompanionChat($id: ID!) {
  deleteCompanionChat(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteCompanionChatMutation__
 *
 * To run a mutation, you first call `useDeleteCompanionChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanionChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanionChatMutation, { data, loading, error }] = useDeleteCompanionChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanionChatMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteCompanionChatDocument, options);
}
export const DeleteMessageDocument = gql `
    mutation DeleteMessage($id: String!) {
  deleteMessage(id: $id) {
    id
  }
}
    `;
/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteMessageDocument, options);
}
export const EditCompanionMessageDocument = gql `
    mutation EditCompanionMessage($chatId: ID!, $messageId: ID!, $newText: String!) {
  editCompanionMessage(chatId: $chatId, messageId: $messageId, newText: $newText) {
    success
    message
  }
}
    `;
/**
 * __useEditCompanionMessageMutation__
 *
 * To run a mutation, you first call `useEditCompanionMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanionMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanionMessageMutation, { data, loading, error }] = useEditCompanionMessageMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *      newText: // value for 'newText'
 *   },
 * });
 */
export function useEditCompanionMessageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EditCompanionMessageDocument, options);
}
export const ProcessAttachmentDocument = gql `
    mutation ProcessAttachment($fileId: String!) {
  processAttachment(fileId: $fileId) {
    message
    count
    success
  }
}
    `;
/**
 * __useProcessAttachmentMutation__
 *
 * To run a mutation, you first call `useProcessAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processAttachmentMutation, { data, loading, error }] = useProcessAttachmentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useProcessAttachmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ProcessAttachmentDocument, options);
}
export const ProcessCompanionChatAttachmentDocument = gql `
    mutation ProcessCompanionChatAttachment($fileId: String!) {
  processCompanionChatAttachment(fileId: $fileId) {
    success
    message
    data {
      fileId
      fileName
      documentId
    }
  }
}
    `;
/**
 * __useProcessCompanionChatAttachmentMutation__
 *
 * To run a mutation, you first call `useProcessCompanionChatAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCompanionChatAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCompanionChatAttachmentMutation, { data, loading, error }] = useProcessCompanionChatAttachmentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useProcessCompanionChatAttachmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ProcessCompanionChatAttachmentDocument, options);
}
export const UpdateCompanionChatDocument = gql `
    mutation UpdateCompanionChat($id: ID!, $name: String!) {
  updateCompanionChat(id: $id, name: $name) {
    success
    message
  }
}
    `;
/**
 * __useUpdateCompanionChatMutation__
 *
 * To run a mutation, you first call `useUpdateCompanionChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanionChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanionChatMutation, { data, loading, error }] = useUpdateCompanionChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateCompanionChatMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateCompanionChatDocument, options);
}
export const SetMcqQuestionBlockAnswerDocument = gql `
    mutation SetMcqQuestionBlockAnswer($messageId: ID!, $questionId: ID!, $selectedChoiceIndex: Int!) {
  setMcqQuestionBlockAnswer(
    messageId: $messageId
    questionId: $questionId
    selectedChoiceIndex: $selectedChoiceIndex
  ) {
    success
    message
  }
}
    `;
/**
 * __useSetMcqQuestionBlockAnswerMutation__
 *
 * To run a mutation, you first call `useSetMcqQuestionBlockAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMcqQuestionBlockAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMcqQuestionBlockAnswerMutation, { data, loading, error }] = useSetMcqQuestionBlockAnswerMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      questionId: // value for 'questionId'
 *      selectedChoiceIndex: // value for 'selectedChoiceIndex'
 *   },
 * });
 */
export function useSetMcqQuestionBlockAnswerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetMcqQuestionBlockAnswerDocument, options);
}
export const SetMessageFeedbackDocument = gql `
    mutation SetMessageFeedback($messageId: ID!, $value: String!) {
  setMessageFeedback(messageId: $messageId, value: $value) {
    success
    message
  }
}
    `;
/**
 * __useSetMessageFeedbackMutation__
 *
 * To run a mutation, you first call `useSetMessageFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMessageFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMessageFeedbackMutation, { data, loading, error }] = useSetMessageFeedbackMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSetMessageFeedbackMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetMessageFeedbackDocument, options);
}
export const SwitchBranchDocument = gql `
    mutation SwitchBranch($chatId: ID!, $anchorMessageId: ID!, $targetBranchId: ID) {
  switchBranch(
    chatId: $chatId
    anchorMessageId: $anchorMessageId
    targetBranchId: $targetBranchId
  ) {
    success
    message
  }
}
    `;
/**
 * __useSwitchBranchMutation__
 *
 * To run a mutation, you first call `useSwitchBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchBranchMutation, { data, loading, error }] = useSwitchBranchMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      anchorMessageId: // value for 'anchorMessageId'
 *      targetBranchId: // value for 'targetBranchId'
 *   },
 * });
 */
export function useSwitchBranchMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SwitchBranchDocument, options);
}
export const SyncMediaBlockPrimarySummaryDocument = gql `
    mutation SyncMediaBlockPrimarySummary($aiTutorId: ID!, $mediaChatId: ID!) {
  syncMediaBlockPrimarySummary(aiTutorId: $aiTutorId, mediaChatId: $mediaChatId) {
    success
    message
  }
}
    `;
/**
 * __useSyncMediaBlockPrimarySummaryMutation__
 *
 * To run a mutation, you first call `useSyncMediaBlockPrimarySummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMediaBlockPrimarySummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMediaBlockPrimarySummaryMutation, { data, loading, error }] = useSyncMediaBlockPrimarySummaryMutation({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *      mediaChatId: // value for 'mediaChatId'
 *   },
 * });
 */
export function useSyncMediaBlockPrimarySummaryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SyncMediaBlockPrimarySummaryDocument, options);
}
export const AddAssignmentDocument = gql `
    mutation AddAssignment($courseId: ID!, $moduleName: String!, $newAssignmentName: String!, $updatedHtml: String!) {
  addAssignment(
    courseId: $courseId
    moduleName: $moduleName
    newAssignmentName: $newAssignmentName
    updatedHtml: $updatedHtml
  ) {
    success
    message
  }
}
    `;
/**
 * __useAddAssignmentMutation__
 *
 * To run a mutation, you first call `useAddAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentMutation, { data, loading, error }] = useAddAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      newAssignmentName: // value for 'newAssignmentName'
 *      updatedHtml: // value for 'updatedHtml'
 *   },
 * });
 */
export function useAddAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddAssignmentDocument, options);
}
export const AddContentModuleDocument = gql `
    mutation AddContentModule($courseId: ID!, $moduleName: String!) {
  addContentModule(courseId: $courseId, moduleName: $moduleName) {
    success
    message
  }
}
    `;
/**
 * __useAddContentModuleMutation__
 *
 * To run a mutation, you first call `useAddContentModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContentModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContentModuleMutation, { data, loading, error }] = useAddContentModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *   },
 * });
 */
export function useAddContentModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddContentModuleDocument, options);
}
export const CourseCreationDocument = gql `
    mutation CourseCreation($title: String!, $standard: String!, $weeks: Int!, $objectives: [String!]!, $urls: [String!]!) {
  courseCreation(
    title: $title
    standard: $standard
    weeks: $weeks
    objectives: $objectives
    urls: $urls
  ) {
    success
    message
    data {
      name
      standard
      weeks
      objectives
      modules {
        module_name
        assignments {
          assignment_name
          html
        }
      }
      created
      last_modified
    }
  }
}
    `;
/**
 * __useCourseCreationMutation__
 *
 * To run a mutation, you first call `useCourseCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseCreationMutation, { data, loading, error }] = useCourseCreationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      standard: // value for 'standard'
 *      weeks: // value for 'weeks'
 *      objectives: // value for 'objectives'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useCourseCreationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CourseCreationDocument, options);
}
export const CourseIsLoadingDocument = gql `
    mutation courseIsLoading($isLoading: Boolean!) {
  courseIsLoading(isLoading: $isLoading) {
    isCourseLoading
  }
}
    `;
/**
 * __useCourseIsLoadingMutation__
 *
 * To run a mutation, you first call `useCourseIsLoadingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCourseIsLoadingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [courseIsLoadingMutation, { data, loading, error }] = useCourseIsLoadingMutation({
 *   variables: {
 *      isLoading: // value for 'isLoading'
 *   },
 * });
 */
export function useCourseIsLoadingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CourseIsLoadingDocument, options);
}
export const DeleteContentAssignmentDocument = gql `
    mutation DeleteContentAssignment($courseId: ID!, $moduleName: String!, $assignmentName: String!) {
  deleteContentAssignment(
    courseId: $courseId
    moduleName: $moduleName
    assignmentName: $assignmentName
  ) {
    success
    message
  }
}
    `;
/**
 * __useDeleteContentAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteContentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentAssignmentMutation, { data, loading, error }] = useDeleteContentAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      assignmentName: // value for 'assignmentName'
 *   },
 * });
 */
export function useDeleteContentAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteContentAssignmentDocument, options);
}
export const DeleteContentModuleDocument = gql `
    mutation DeleteContentModule($courseId: ID!, $moduleName: String!) {
  deleteContentModule(courseId: $courseId, moduleName: $moduleName) {
    success
    message
  }
}
    `;
/**
 * __useDeleteContentModuleMutation__
 *
 * To run a mutation, you first call `useDeleteContentModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentModuleMutation, { data, loading, error }] = useDeleteContentModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *   },
 * });
 */
export function useDeleteContentModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteContentModuleDocument, options);
}
export const UpdateAssignmentDocument = gql `
    mutation UpdateAssignment($courseId: ID!, $moduleName: String!, $currentAssignmentName: String!, $newAssignmentName: String!, $updatedHtml: String!) {
  updateAssignment(
    courseId: $courseId
    moduleName: $moduleName
    currentAssignmentName: $currentAssignmentName
    newAssignmentName: $newAssignmentName
    updatedHtml: $updatedHtml
  ) {
    success
    message
    data {
      assignment_name
      html
    }
  }
}
    `;
/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleName: // value for 'moduleName'
 *      currentAssignmentName: // value for 'currentAssignmentName'
 *      newAssignmentName: // value for 'newAssignmentName'
 *      updatedHtml: // value for 'updatedHtml'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAssignmentDocument, options);
}
export const UpdateContentModuleNameDocument = gql `
    mutation UpdateContentModuleName($courseId: ID!, $oldModuleName: String!, $newModuleName: String!) {
  updateContentModuleName(
    courseId: $courseId
    oldModuleName: $oldModuleName
    newModuleName: $newModuleName
  ) {
    success
    message
  }
}
    `;
/**
 * __useUpdateContentModuleNameMutation__
 *
 * To run a mutation, you first call `useUpdateContentModuleNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentModuleNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentModuleNameMutation, { data, loading, error }] = useUpdateContentModuleNameMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      oldModuleName: // value for 'oldModuleName'
 *      newModuleName: // value for 'newModuleName'
 *   },
 * });
 */
export function useUpdateContentModuleNameMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateContentModuleNameDocument, options);
}
export const CreateInstitutionalGuidelineFromFileDocument = gql `
    mutation CreateInstitutionalGuidelineFromFile($input: CreateInstitutionalGuidelineFromFileInput!) {
  createInstitutionalGuidelineFromFile(input: $input) {
    success
    message
    count
    data {
      id
      name
      summary
      processingStatus
      processingError
      created
      lastModified
      sourceFile {
        id
        fileName
      }
    }
  }
}
    `;
/**
 * __useCreateInstitutionalGuidelineFromFileMutation__
 *
 * To run a mutation, you first call `useCreateInstitutionalGuidelineFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstitutionalGuidelineFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstitutionalGuidelineFromFileMutation, { data, loading, error }] = useCreateInstitutionalGuidelineFromFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInstitutionalGuidelineFromFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateInstitutionalGuidelineFromFileDocument, options);
}
export const CreateRubricSetFromFileDocument = gql `
    mutation CreateRubricSetFromFile($input: CreateRubricSetFromFileInput!) {
  createRubricSetFromFile(input: $input) {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
        title
        description
        originalTitle
        originalDescription
        isEdited
        displayOrder
        sourceLocator
        criteria {
          id
          code
          title
          description
          originalTitle
          originalDescription
          originalSectionId
          isEdited
          isDeleted
          scoringGuidance
          maxScore
          category
          confidence
          displayOrder
          sourceExcerpt
        }
      }
    }
  }
}
    `;
/**
 * __useCreateRubricSetFromFileMutation__
 *
 * To run a mutation, you first call `useCreateRubricSetFromFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRubricSetFromFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRubricSetFromFileMutation, { data, loading, error }] = useCreateRubricSetFromFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRubricSetFromFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateRubricSetFromFileDocument, options);
}
export const DeleteInstitutionalGuidelineDocument = gql `
    mutation DeleteInstitutionalGuideline($id: ID!) {
  deleteInstitutionalGuideline(id: $id) {
    success
    message
    count
    data {
      id
      name
      sourceFile {
        id
        fileName
      }
    }
  }
}
    `;
/**
 * __useDeleteInstitutionalGuidelineMutation__
 *
 * To run a mutation, you first call `useDeleteInstitutionalGuidelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstitutionalGuidelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstitutionalGuidelineMutation, { data, loading, error }] = useDeleteInstitutionalGuidelineMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInstitutionalGuidelineMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteInstitutionalGuidelineDocument, options);
}
export const SetActiveRubricSetDocument = gql `
    mutation SetActiveRubricSet($id: ID!) {
  setActiveRubricSet(id: $id) {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
        title
        description
        originalTitle
        originalDescription
        isEdited
        displayOrder
        sourceLocator
        criteria {
          id
          code
          title
          description
          originalTitle
          originalDescription
          originalSectionId
          isEdited
          isDeleted
          scoringGuidance
          maxScore
          category
          confidence
          displayOrder
          sourceExcerpt
        }
      }
    }
  }
}
    `;
/**
 * __useSetActiveRubricSetMutation__
 *
 * To run a mutation, you first call `useSetActiveRubricSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveRubricSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveRubricSetMutation, { data, loading, error }] = useSetActiveRubricSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetActiveRubricSetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetActiveRubricSetDocument, options);
}
export const UpdateRubricSetDocument = gql `
    mutation UpdateRubricSet($input: UpdateRubricSetInput!) {
  updateRubricSet(input: $input) {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
        title
        description
        originalTitle
        originalDescription
        isEdited
        displayOrder
        sourceLocator
        criteria {
          id
          code
          title
          description
          originalTitle
          originalDescription
          originalSectionId
          isEdited
          isDeleted
          scoringGuidance
          maxScore
          category
          confidence
          displayOrder
          sourceExcerpt
        }
      }
    }
  }
}
    `;
/**
 * __useUpdateRubricSetMutation__
 *
 * To run a mutation, you first call `useUpdateRubricSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRubricSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRubricSetMutation, { data, loading, error }] = useUpdateRubricSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRubricSetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateRubricSetDocument, options);
}
export const AssignThreadDocument = gql `
    mutation AssignThread($threadId: ID!, $assigneeId: ID!) {
  assignThread(threadId: $threadId, assigneeId: $assigneeId) {
    success
    thread {
      id
      lastModified
      assignee {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useAssignThreadMutation__
 *
 * To run a mutation, you first call `useAssignThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignThreadMutation, { data, loading, error }] = useAssignThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useAssignThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AssignThreadDocument, options);
}
export const ClearModernizedCoursePublishHistoryDocument = gql `
    mutation ClearModernizedCoursePublishHistory($courseId: ID!) {
  clearModernizedCoursePublishHistory(courseId: $courseId) {
    success
    archivedCount
  }
}
    `;
/**
 * __useClearModernizedCoursePublishHistoryMutation__
 *
 * To run a mutation, you first call `useClearModernizedCoursePublishHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearModernizedCoursePublishHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearModernizedCoursePublishHistoryMutation, { data, loading, error }] = useClearModernizedCoursePublishHistoryMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useClearModernizedCoursePublishHistoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ClearModernizedCoursePublishHistoryDocument, options);
}
export const CreateCommentThreadDocument = gql `
    mutation CreateCommentThread($entityId: ID!, $entityType: ModernizedActivityEntityType!, $text: String!, $mentionedUserIds: [ID!]!) {
  createCommentThread(
    entityId: $entityId
    entityType: $entityType
    text: $text
    mentionedUserIds: $mentionedUserIds
  ) {
    success
    thread {
      id
      created
      lastModified
      status
      entityId
      entityType
      assignee {
        id
        name
        username
      }
      comments {
        id
        created
        text
        author {
          id
          name
          username
        }
        mentionedUsers {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useCreateCommentThreadMutation__
 *
 * To run a mutation, you first call `useCreateCommentThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentThreadMutation, { data, loading, error }] = useCreateCommentThreadMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      text: // value for 'text'
 *      mentionedUserIds: // value for 'mentionedUserIds'
 *   },
 * });
 */
export function useCreateCommentThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateCommentThreadDocument, options);
}
export const CreateIleForModernizedRecommendationDocument = gql `
    mutation CreateIleForModernizedRecommendation($courseId: ID!, $recommendationId: ID!, $ile: CreateILEInput!) {
  createIleForModernizedRecommendation(
    courseId: $courseId
    recommendationId: $recommendationId
    ile: $ile
  ) {
    success
    message
    ile {
      id
      title
      description
      context
      dueDate
      targetAudience
      activityState
      scheduledDate
      objectives {
        id
        objective
        sequence
        evalCriteria
      }
    }
    recommendation {
      id
      status
      aiTutor {
        id
        title
        description
        context
        dueDate
        targetAudience
        activityState
        scheduledDate
        objectives {
          id
          objective
          sequence
          evalCriteria
        }
      }
    }
  }
}
    `;
/**
 * __useCreateIleForModernizedRecommendationMutation__
 *
 * To run a mutation, you first call `useCreateIleForModernizedRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIleForModernizedRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIleForModernizedRecommendationMutation, { data, loading, error }] = useCreateIleForModernizedRecommendationMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      recommendationId: // value for 'recommendationId'
 *      ile: // value for 'ile'
 *   },
 * });
 */
export function useCreateIleForModernizedRecommendationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateIleForModernizedRecommendationDocument, options);
}
export const CreateModernizedAssessmentActivityDocument = gql `
    mutation CreateModernizedAssessmentActivity($input: CreateModernizedAssessmentActivityInput!) {
  createModernizedAssessmentActivity(input: $input) {
    success
    message
    activity {
      id
      created
      lastModified
      isNew
      title
      status
      externalVisibility
      assessmentType
      numberOfQuestions
      timeLimitMinutes
      aiTutorIds
      dueDate
      scheduledDate
    }
  }
}
    `;
/**
 * __useCreateModernizedAssessmentActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedAssessmentActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedAssessmentActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedAssessmentActivityMutation, { data, loading, error }] = useCreateModernizedAssessmentActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModernizedAssessmentActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedAssessmentActivityDocument, options);
}
export const CreateModernizedAssignmentActivityDocument = gql `
    mutation CreateModernizedAssignmentActivity($input: CreateModernizedAssignmentActivityInput!) {
  createModernizedAssignmentActivity(input: $input) {
    success
    message
    activity {
      id
      creationSource
    }
  }
}
    `;
/**
 * __useCreateModernizedAssignmentActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedAssignmentActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedAssignmentActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedAssignmentActivityMutation, { data, loading, error }] = useCreateModernizedAssignmentActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModernizedAssignmentActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedAssignmentActivityDocument, options);
}
export const CreateModernizedIleActivityDocument = gql `
    mutation CreateModernizedIleActivity($courseId: ID!, $moduleId: ID!, $ile: CreateILEInput!) {
  createModernizedIleActivity(courseId: $courseId, moduleId: $moduleId, ile: $ile) {
    success
    message
    activity {
      id
      created
      lastModified
      isNew
      creationSource
      title
      description
      status
      aiTutor {
        id
        title
        description
        context
        dueDate
      }
    }
    ile {
      id
      title
      description
      context
      dueDate
    }
  }
}
    `;
/**
 * __useCreateModernizedIleActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedIleActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedIleActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedIleActivityMutation, { data, loading, error }] = useCreateModernizedIleActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleId: // value for 'moduleId'
 *      ile: // value for 'ile'
 *   },
 * });
 */
export function useCreateModernizedIleActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedIleActivityDocument, options);
}
export const CreateModernizedModuleDocument = gql `
    mutation CreateModernizedModule($courseId: ID!, $title: String!, $description: String) {
  createModernizedModule(
    courseId: $courseId
    title: $title
    description: $description
  ) {
    success
    message
    module {
      id
      created
      lastModified
      isNew
      title
      description
      recommendedTitle
      recommendedDescription
      status
      activityOrder
      externalVisibility
      externalUrl
    }
  }
}
    `;
/**
 * __useCreateModernizedModuleMutation__
 *
 * To run a mutation, you first call `useCreateModernizedModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedModuleMutation, { data, loading, error }] = useCreateModernizedModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateModernizedModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedModuleDocument, options);
}
export const CreateModernizedPageActivityDocument = gql `
    mutation CreateModernizedPageActivity($input: CreateModernizedPageActivityInput!) {
  createModernizedPageActivity(input: $input) {
    success
    message
    activity {
      id
      created
      lastModified
      isNew
      creationSource
      activityType
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      externalVisibility
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
    }
  }
}
    `;
/**
 * __useCreateModernizedPageActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedPageActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedPageActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedPageActivityMutation, { data, loading, error }] = useCreateModernizedPageActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModernizedPageActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedPageActivityDocument, options);
}
export const CreateModernizedProjectActivityDocument = gql `
    mutation CreateModernizedProjectActivity($input: CreateModernizedProjectActivityInput!) {
  createModernizedProjectActivity(input: $input) {
    success
    message
    activity {
      id
      created
      lastModified
      isNew
      creationSource
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      externalVisibility
      dueDate
      scheduledDate
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
    }
  }
}
    `;
/**
 * __useCreateModernizedProjectActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedProjectActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedProjectActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedProjectActivityMutation, { data, loading, error }] = useCreateModernizedProjectActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModernizedProjectActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedProjectActivityDocument, options);
}
export const CreateModernizedResourceActivityDocument = gql `
    mutation CreateModernizedResourceActivity($input: CreateModernizedResourceActivityInput!) {
  createModernizedResourceActivity(input: $input) {
    success
    message
    activity {
      id
      created
      lastModified
      isNew
      title
      descriptionText
      descriptionHtml
      descriptionFormat
      recommendedTitle
      recommendedDescription
      status
      videoUrl
      scheduledDate
      externalVisibility
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
    }
  }
}
    `;
/**
 * __useCreateModernizedResourceActivityMutation__
 *
 * To run a mutation, you first call `useCreateModernizedResourceActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModernizedResourceActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModernizedResourceActivityMutation, { data, loading, error }] = useCreateModernizedResourceActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateModernizedResourceActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModernizedResourceActivityDocument, options);
}
export const DeleteModernizedAssignmentActivityDocument = gql `
    mutation DeleteModernizedAssignmentActivity($courseId: ID!, $activityId: ID!) {
  deleteModernizedAssignmentActivity(courseId: $courseId, activityId: $activityId) {
    success
    message
    activityId
    deletedActivityId
    wasDiscarded
    pendingDelete
  }
}
    `;
/**
 * __useDeleteModernizedAssignmentActivityMutation__
 *
 * To run a mutation, you first call `useDeleteModernizedAssignmentActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModernizedAssignmentActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModernizedAssignmentActivityMutation, { data, loading, error }] = useDeleteModernizedAssignmentActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteModernizedAssignmentActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModernizedAssignmentActivityDocument, options);
}
export const DeleteModernizedIleActivityDocument = gql `
    mutation DeleteModernizedIleActivity($courseId: ID!, $activityId: ID!) {
  deleteModernizedIleActivity(courseId: $courseId, activityId: $activityId) {
    success
    message
    activityId
    deletedActivityId
    wasDiscarded
    pendingDelete
  }
}
    `;
/**
 * __useDeleteModernizedIleActivityMutation__
 *
 * To run a mutation, you first call `useDeleteModernizedIleActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModernizedIleActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModernizedIleActivityMutation, { data, loading, error }] = useDeleteModernizedIleActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteModernizedIleActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModernizedIleActivityDocument, options);
}
export const DeleteModernizedModuleDocument = gql `
    mutation DeleteModernizedModule($courseId: ID!, $moduleId: ID!) {
  deleteModernizedModule(courseId: $courseId, moduleId: $moduleId) {
    success
    message
    moduleId
    activeActivityCount
    wasDiscarded
  }
}
    `;
/**
 * __useDeleteModernizedModuleMutation__
 *
 * To run a mutation, you first call `useDeleteModernizedModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModernizedModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModernizedModuleMutation, { data, loading, error }] = useDeleteModernizedModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useDeleteModernizedModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModernizedModuleDocument, options);
}
export const DeleteModernizedPageActivityDocument = gql `
    mutation DeleteModernizedPageActivity($courseId: ID!, $activityId: ID!) {
  deleteModernizedPageActivity(courseId: $courseId, activityId: $activityId) {
    success
    message
    activityId
    deletedActivityId
    wasDiscarded
    pendingDelete
  }
}
    `;
/**
 * __useDeleteModernizedPageActivityMutation__
 *
 * To run a mutation, you first call `useDeleteModernizedPageActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModernizedPageActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModernizedPageActivityMutation, { data, loading, error }] = useDeleteModernizedPageActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteModernizedPageActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModernizedPageActivityDocument, options);
}
export const DeleteModernizedProjectActivityDocument = gql `
    mutation DeleteModernizedProjectActivity($courseId: ID!, $activityId: ID!) {
  deleteModernizedProjectActivity(courseId: $courseId, activityId: $activityId) {
    success
    message
    activityId
    deletedActivityId
    wasDiscarded
    pendingDelete
  }
}
    `;
/**
 * __useDeleteModernizedProjectActivityMutation__
 *
 * To run a mutation, you first call `useDeleteModernizedProjectActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModernizedProjectActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModernizedProjectActivityMutation, { data, loading, error }] = useDeleteModernizedProjectActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      activityId: // value for 'activityId'
 *   },
 * });
 */
export function useDeleteModernizedProjectActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModernizedProjectActivityDocument, options);
}
export const GenerateIleRecommendationContentDocument = gql `
    mutation GenerateIleRecommendationContent($courseId: ID!, $recommendationId: ID!) {
  generateIleRecommendationContent(
    courseId: $courseId
    recommendationId: $recommendationId
  ) {
    success
    message
    description
    objectives {
      objective
      sequence
      evalCriteria
    }
  }
}
    `;
/**
 * __useGenerateIleRecommendationContentMutation__
 *
 * To run a mutation, you first call `useGenerateIleRecommendationContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateIleRecommendationContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateIleRecommendationContentMutation, { data, loading, error }] = useGenerateIleRecommendationContentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      recommendationId: // value for 'recommendationId'
 *   },
 * });
 */
export function useGenerateIleRecommendationContentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateIleRecommendationContentDocument, options);
}
export const GenerateModernizationAiRewriteSuggestionDocument = gql `
    mutation GenerateModernizationAiRewriteSuggestion($input: ModernizationAiRewriteSuggestionInput!) {
  generateModernizationAiRewriteSuggestion(input: $input) {
    success
    rewrittenText
    message
  }
}
    `;
/**
 * __useGenerateModernizationAiRewriteSuggestionMutation__
 *
 * To run a mutation, you first call `useGenerateModernizationAiRewriteSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateModernizationAiRewriteSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateModernizationAiRewriteSuggestionMutation, { data, loading, error }] = useGenerateModernizationAiRewriteSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateModernizationAiRewriteSuggestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateModernizationAiRewriteSuggestionDocument, options);
}
export const MoveModernizedModuleActivityDocument = gql `
    mutation MoveModernizedModuleActivity($courseId: ID!, $sourceModuleId: ID!, $targetModuleId: ID!, $activityId: ID!, $sourceActivityIds: [ID!]!, $targetActivityIds: [ID!]!) {
  moveModernizedModuleActivity(
    courseId: $courseId
    sourceModuleId: $sourceModuleId
    targetModuleId: $targetModuleId
    activityId: $activityId
    sourceActivityIds: $sourceActivityIds
    targetActivityIds: $targetActivityIds
  ) {
    success
    message
    sourceActivityOrder
    targetActivityOrder
  }
}
    `;
/**
 * __useMoveModernizedModuleActivityMutation__
 *
 * To run a mutation, you first call `useMoveModernizedModuleActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveModernizedModuleActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveModernizedModuleActivityMutation, { data, loading, error }] = useMoveModernizedModuleActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      sourceModuleId: // value for 'sourceModuleId'
 *      targetModuleId: // value for 'targetModuleId'
 *      activityId: // value for 'activityId'
 *      sourceActivityIds: // value for 'sourceActivityIds'
 *      targetActivityIds: // value for 'targetActivityIds'
 *   },
 * });
 */
export function useMoveModernizedModuleActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MoveModernizedModuleActivityDocument, options);
}
export const PublishModernizedActivitiesDocument = gql `
    mutation PublishModernizedActivities($courseId: ID!, $itemIds: [ID!]!) {
  publishModernizedActivities(courseId: $courseId, itemIds: $itemIds) {
    success
    publishedCount
    publishedAt
    publishEventId
    externalPublishSuccess
    externalPublishErrors
    items {
      id
      status
    }
  }
}
    `;
/**
 * __usePublishModernizedActivitiesMutation__
 *
 * To run a mutation, you first call `usePublishModernizedActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishModernizedActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishModernizedActivitiesMutation, { data, loading, error }] = usePublishModernizedActivitiesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function usePublishModernizedActivitiesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(PublishModernizedActivitiesDocument, options);
}
export const RemoveModernizedCourseEditingTeamMemberDocument = gql `
    mutation RemoveModernizedCourseEditingTeamMember($courseId: ID!, $userId: ID!) {
  removeEditingTeamMember(courseId: $courseId, userId: $userId) {
    success
    message
  }
}
    `;
/**
 * __useRemoveModernizedCourseEditingTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveModernizedCourseEditingTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveModernizedCourseEditingTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeModernizedCourseEditingTeamMemberMutation, { data, loading, error }] = useRemoveModernizedCourseEditingTeamMemberMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveModernizedCourseEditingTeamMemberMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemoveModernizedCourseEditingTeamMemberDocument, options);
}
export const ReopenThreadDocument = gql `
    mutation ReopenThread($threadId: ID!) {
  reopenThread(threadId: $threadId) {
    success
    thread {
      id
      status
      lastModified
    }
  }
}
    `;
/**
 * __useReopenThreadMutation__
 *
 * To run a mutation, you first call `useReopenThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenThreadMutation, { data, loading, error }] = useReopenThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useReopenThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReopenThreadDocument, options);
}
export const ReorderModernizedModuleActivitiesDocument = gql `
    mutation ReorderModernizedModuleActivities($courseId: ID!, $moduleId: ID!, $activityIds: [ID!]!) {
  reorderModernizedModuleActivities(
    courseId: $courseId
    moduleId: $moduleId
    activityIds: $activityIds
  ) {
    success
    message
    activityOrder
  }
}
    `;
/**
 * __useReorderModernizedModuleActivitiesMutation__
 *
 * To run a mutation, you first call `useReorderModernizedModuleActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderModernizedModuleActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderModernizedModuleActivitiesMutation, { data, loading, error }] = useReorderModernizedModuleActivitiesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleId: // value for 'moduleId'
 *      activityIds: // value for 'activityIds'
 *   },
 * });
 */
export function useReorderModernizedModuleActivitiesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReorderModernizedModuleActivitiesDocument, options);
}
export const ReorderModernizedModulesDocument = gql `
    mutation ReorderModernizedModules($courseId: ID!, $moduleIds: [ID!]!) {
  reorderModernizedModules(courseId: $courseId, moduleIds: $moduleIds) {
    success
    message
    moduleOrder
  }
}
    `;
/**
 * __useReorderModernizedModulesMutation__
 *
 * To run a mutation, you first call `useReorderModernizedModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderModernizedModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderModernizedModulesMutation, { data, loading, error }] = useReorderModernizedModulesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleIds: // value for 'moduleIds'
 *   },
 * });
 */
export function useReorderModernizedModulesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReorderModernizedModulesDocument, options);
}
export const ReplyToThreadDocument = gql `
    mutation ReplyToThread($threadId: ID!, $text: String!, $mentionedUserIds: [ID!]!) {
  replyToThread(
    threadId: $threadId
    text: $text
    mentionedUserIds: $mentionedUserIds
  ) {
    success
    comment {
      id
      created
      text
      author {
        id
        name
        username
      }
      mentionedUsers {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useReplyToThreadMutation__
 *
 * To run a mutation, you first call `useReplyToThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToThreadMutation, { data, loading, error }] = useReplyToThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      text: // value for 'text'
 *      mentionedUserIds: // value for 'mentionedUserIds'
 *   },
 * });
 */
export function useReplyToThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReplyToThreadDocument, options);
}
export const RequestModernizedCourseExportDocument = gql `
    mutation RequestModernizedCourseExport($courseId: ID!, $format: ModernizedCourseExportFormat!) {
  requestModernizedCourseExport(courseId: $courseId, format: $format) {
    success
    message
    downloadUrl
  }
}
    `;
/**
 * __useRequestModernizedCourseExportMutation__
 *
 * To run a mutation, you first call `useRequestModernizedCourseExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestModernizedCourseExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestModernizedCourseExportMutation, { data, loading, error }] = useRequestModernizedCourseExportMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      format: // value for 'format'
 *   },
 * });
 */
export function useRequestModernizedCourseExportMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestModernizedCourseExportDocument, options);
}
export const ResolveThreadDocument = gql `
    mutation ResolveThread($threadId: ID!) {
  resolveThread(threadId: $threadId) {
    success
    thread {
      id
      status
      lastModified
    }
  }
}
    `;
/**
 * __useResolveThreadMutation__
 *
 * To run a mutation, you first call `useResolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveThreadMutation, { data, loading, error }] = useResolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useResolveThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResolveThreadDocument, options);
}
export const RestoreCourseDocument = gql `
    mutation RestoreCourse($courseId: ID!, $snapshotId: ID!) {
  restoreCourse(courseId: $courseId, snapshotId: $snapshotId) {
    success
    message
    newSnapshotId
  }
}
    `;
/**
 * __useRestoreCourseMutation__
 *
 * To run a mutation, you first call `useRestoreCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreCourseMutation, { data, loading, error }] = useRestoreCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useRestoreCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RestoreCourseDocument, options);
}
export const SetModernizedCourseEditingTeamMemberDocument = gql `
    mutation SetModernizedCourseEditingTeamMember($courseId: ID!, $userId: ID!, $role: EditingTeamRole!) {
  setEditingTeamMember(courseId: $courseId, userId: $userId, role: $role) {
    success
    message
  }
}
    `;
/**
 * __useSetModernizedCourseEditingTeamMemberMutation__
 *
 * To run a mutation, you first call `useSetModernizedCourseEditingTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetModernizedCourseEditingTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setModernizedCourseEditingTeamMemberMutation, { data, loading, error }] = useSetModernizedCourseEditingTeamMemberMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSetModernizedCourseEditingTeamMemberMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetModernizedCourseEditingTeamMemberDocument, options);
}
export const UnassignThreadDocument = gql `
    mutation UnassignThread($threadId: ID!) {
  unassignThread(threadId: $threadId) {
    success
    thread {
      id
      lastModified
      assignee {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUnassignThreadMutation__
 *
 * To run a mutation, you first call `useUnassignThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignThreadMutation, { data, loading, error }] = useUnassignThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useUnassignThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UnassignThreadDocument, options);
}
export const UndoDeleteModernizedActivityDocument = gql `
    mutation UndoDeleteModernizedActivity($courseId: ID!, $activityId: ID!, $entityType: ModernizedActivityEntityType!) {
  undoDeleteModernizedActivity(
    courseId: $courseId
    activityId: $activityId
    entityType: $entityType
  ) {
    success
    message
    activityId
  }
}
    `;
/**
 * __useUndoDeleteModernizedActivityMutation__
 *
 * To run a mutation, you first call `useUndoDeleteModernizedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoDeleteModernizedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoDeleteModernizedActivityMutation, { data, loading, error }] = useUndoDeleteModernizedActivityMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      activityId: // value for 'activityId'
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useUndoDeleteModernizedActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UndoDeleteModernizedActivityDocument, options);
}
export const UndoDeleteModernizedModuleDocument = gql `
    mutation UndoDeleteModernizedModule($courseId: ID!, $moduleId: ID!) {
  undoDeleteModernizedModule(courseId: $courseId, moduleId: $moduleId) {
    success
    message
    moduleId
  }
}
    `;
/**
 * __useUndoDeleteModernizedModuleMutation__
 *
 * To run a mutation, you first call `useUndoDeleteModernizedModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoDeleteModernizedModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoDeleteModernizedModuleMutation, { data, loading, error }] = useUndoDeleteModernizedModuleMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useUndoDeleteModernizedModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UndoDeleteModernizedModuleDocument, options);
}
export const UpdateModernizedActivityFieldsDocument = gql `
    mutation UpdateModernizedActivityFields($entityId: ID!, $entityType: ModernizedActivityEntityType!, $courseId: ID, $recommendedTitle: String, $recommendedDescription: String, $recommendedDescriptionFormat: ModernizedDescriptionFormat, $recommendedValue: String, $recommendedPointsPossible: Float, $recommendedDueDate: DateTime, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: $entityType
    courseId: $courseId
    recommendedTitle: $recommendedTitle
    recommendedDescription: $recommendedDescription
    recommendedDescriptionFormat: $recommendedDescriptionFormat
    recommendedValue: $recommendedValue
    recommendedPointsPossible: $recommendedPointsPossible
    recommendedDueDate: $recommendedDueDate
    status: $status
  ) {
    success
  }
}
    `;
/**
 * __useUpdateModernizedActivityFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedActivityFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedActivityFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedActivityFieldsMutation, { data, loading, error }] = useUpdateModernizedActivityFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityType: // value for 'entityType'
 *      courseId: // value for 'courseId'
 *      recommendedTitle: // value for 'recommendedTitle'
 *      recommendedDescription: // value for 'recommendedDescription'
 *      recommendedDescriptionFormat: // value for 'recommendedDescriptionFormat'
 *      recommendedValue: // value for 'recommendedValue'
 *      recommendedPointsPossible: // value for 'recommendedPointsPossible'
 *      recommendedDueDate: // value for 'recommendedDueDate'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedActivityFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedActivityFieldsDocument, options);
}
export const UpdateModernizedAssessmentFieldsDocument = gql `
    mutation UpdateModernizedAssessmentFields($entityId: ID!, $recommendedPointsPossible: Float, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: assessment
    recommendedPointsPossible: $recommendedPointsPossible
    status: $status
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedAssessmentFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedAssessmentFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedAssessmentFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedAssessmentFieldsMutation, { data, loading, error }] = useUpdateModernizedAssessmentFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedPointsPossible: // value for 'recommendedPointsPossible'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedAssessmentFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedAssessmentFieldsDocument, options);
}
export const UpdateModernizedAssignmentFieldsDocument = gql `
    mutation UpdateModernizedAssignmentFields($entityId: ID!, $recommendedTitle: String, $recommendedDescription: String, $recommendedPointsPossible: Float, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: assignment
    recommendedTitle: $recommendedTitle
    recommendedDescription: $recommendedDescription
    recommendedPointsPossible: $recommendedPointsPossible
    status: $status
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedAssignmentFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedAssignmentFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedAssignmentFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedAssignmentFieldsMutation, { data, loading, error }] = useUpdateModernizedAssignmentFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedTitle: // value for 'recommendedTitle'
 *      recommendedDescription: // value for 'recommendedDescription'
 *      recommendedPointsPossible: // value for 'recommendedPointsPossible'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedAssignmentFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedAssignmentFieldsDocument, options);
}
export const UpdateModernizedCourseContentSectionFieldsDocument = gql `
    mutation UpdateModernizedCourseContentSectionFields($entityId: ID!, $recommendedValue: String) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: contentSection
    recommendedValue: $recommendedValue
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedCourseContentSectionFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedCourseContentSectionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedCourseContentSectionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedCourseContentSectionFieldsMutation, { data, loading, error }] = useUpdateModernizedCourseContentSectionFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedValue: // value for 'recommendedValue'
 *   },
 * });
 */
export function useUpdateModernizedCourseContentSectionFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedCourseContentSectionFieldsDocument, options);
}
export const UpdateModernizedEvaluatorIssueStatusDocument = gql `
    mutation UpdateModernizedEvaluatorIssueStatus($issueId: ID!, $status: ModernizedEvaluatorIssueStatus!) {
  updateModernizedEvaluatorIssueStatus(issueId: $issueId, status: $status) {
    success
    issue {
      id
      status
      statusUpdatedAt
      statusUpdatedBy
      lastModified
    }
  }
}
    `;
/**
 * __useUpdateModernizedEvaluatorIssueStatusMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedEvaluatorIssueStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedEvaluatorIssueStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedEvaluatorIssueStatusMutation, { data, loading, error }] = useUpdateModernizedEvaluatorIssueStatusMutation({
 *   variables: {
 *      issueId: // value for 'issueId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedEvaluatorIssueStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedEvaluatorIssueStatusDocument, options);
}
export const UpdateModernizedModuleFieldsDocument = gql `
    mutation UpdateModernizedModuleFields($entityId: ID!, $recommendedTitle: String, $recommendedDescription: String, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: module
    recommendedTitle: $recommendedTitle
    recommendedDescription: $recommendedDescription
    status: $status
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedModuleFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedModuleFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedModuleFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedModuleFieldsMutation, { data, loading, error }] = useUpdateModernizedModuleFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedTitle: // value for 'recommendedTitle'
 *      recommendedDescription: // value for 'recommendedDescription'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedModuleFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedModuleFieldsDocument, options);
}
export const UpdateModernizedOtherActivityFieldsDocument = gql `
    mutation UpdateModernizedOtherActivityFields($entityId: ID!, $recommendedTitle: String, $recommendedDescription: String, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: otherActivity
    recommendedTitle: $recommendedTitle
    recommendedDescription: $recommendedDescription
    status: $status
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedOtherActivityFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedOtherActivityFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedOtherActivityFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedOtherActivityFieldsMutation, { data, loading, error }] = useUpdateModernizedOtherActivityFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedTitle: // value for 'recommendedTitle'
 *      recommendedDescription: // value for 'recommendedDescription'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedOtherActivityFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedOtherActivityFieldsDocument, options);
}
export const UpdateModernizedProjectFieldsDocument = gql `
    mutation UpdateModernizedProjectFields($entityId: ID!, $recommendedTitle: String, $recommendedDescription: String, $status: ModernizedActivityStatus) {
  updateModernizedActivityFields(
    entityId: $entityId
    entityType: project
    recommendedTitle: $recommendedTitle
    recommendedDescription: $recommendedDescription
    status: $status
  ) {
    success
    editLogs {
      id
      created
      fieldName
      beforeValue
      afterValue
      actor {
        id
        name
        username
      }
    }
  }
}
    `;
/**
 * __useUpdateModernizedProjectFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateModernizedProjectFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModernizedProjectFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModernizedProjectFieldsMutation, { data, loading, error }] = useUpdateModernizedProjectFieldsMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      recommendedTitle: // value for 'recommendedTitle'
 *      recommendedDescription: // value for 'recommendedDescription'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateModernizedProjectFieldsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModernizedProjectFieldsDocument, options);
}
export const MakeCoursePaymentDocument = gql `
    mutation MakeCoursePayment($courseId: String!) {
  createCheckoutSession(courseId: $courseId) {
    success
    message
    url
  }
}
    `;
/**
 * __useMakeCoursePaymentMutation__
 *
 * To run a mutation, you first call `useMakeCoursePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCoursePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCoursePaymentMutation, { data, loading, error }] = useMakeCoursePaymentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useMakeCoursePaymentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MakeCoursePaymentDocument, options);
}
export const CreateAiTutorDocument = gql `
    mutation CreateAITutor($title: String!, $description: String!, $parentModuleId: ID!, $objectives: [ObjectiveInput!]!, $context: String, $visualizationId: ID, $videoPool: [VideoDataInput], $imagePool: [ImageDataInput], $targetAudience: String, $dueDate: DateTime, $activityState: ActivityState, $scheduledDate: DateTime) {
  createAITutor(
    aiTutor: {title: $title, description: $description, parentModuleId: $parentModuleId, objectives: $objectives, context: $context, visualizationId: $visualizationId, videoPool: $videoPool, imagePool: $imagePool, targetAudience: $targetAudience, dueDate: $dueDate, activityState: $activityState, scheduledDate: $scheduledDate}
  ) {
    success
    message
    data {
      title
      description
      targetAudience
      dueDate
      objectives {
        objective
        sequence
      }
      activityState
      scheduledDate
    }
  }
}
    `;
/**
 * __useCreateAiTutorMutation__
 *
 * To run a mutation, you first call `useCreateAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiTutorMutation, { data, loading, error }] = useCreateAiTutorMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      parentModuleId: // value for 'parentModuleId'
 *      objectives: // value for 'objectives'
 *      context: // value for 'context'
 *      visualizationId: // value for 'visualizationId'
 *      videoPool: // value for 'videoPool'
 *      imagePool: // value for 'imagePool'
 *      targetAudience: // value for 'targetAudience'
 *      dueDate: // value for 'dueDate'
 *      activityState: // value for 'activityState'
 *      scheduledDate: // value for 'scheduledDate'
 *   },
 * });
 */
export function useCreateAiTutorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAiTutorDocument, options);
}
export const DeleteAiTutorDocument = gql `
    mutation DeleteAITutor($id: ID!) {
  deleteAITutor(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteAiTutorMutation__
 *
 * To run a mutation, you first call `useDeleteAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAiTutorMutation, { data, loading, error }] = useDeleteAiTutorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAiTutorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAiTutorDocument, options);
}
export const BulkAssessmentCreateDocument = gql `
    mutation BulkAssessmentCreate($input: BulkAssessmentCreateInput!) {
  bulkAssessmentCreate(input: $input) {
    success
    message
    jobId
  }
}
    `;
/**
 * __useBulkAssessmentCreateMutation__
 *
 * To run a mutation, you first call `useBulkAssessmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssessmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssessmentCreateMutation, { data, loading, error }] = useBulkAssessmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkAssessmentCreateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BulkAssessmentCreateDocument, options);
}
export const CreateLearningOutcomeDocument = gql `
    mutation CreateLearningOutcome($input: CreateLearningOutcomeInput!) {
  createLearningOutcome(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      sourceReferenceId
      sourceUrl
      sourceProvenance
      originalText
      extractionNotes
      aiPromptVersion
      aiModel
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useCreateLearningOutcomeMutation__
 *
 * To run a mutation, you first call `useCreateLearningOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLearningOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLearningOutcomeMutation, { data, loading, error }] = useCreateLearningOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLearningOutcomeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateLearningOutcomeDocument, options);
}
export const UpdateLearningOutcomeDocument = gql `
    mutation UpdateLearningOutcome($input: UpdateLearningOutcomeInput!) {
  updateLearningOutcome(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      sourceReferenceId
      sourceUrl
      sourceProvenance
      originalText
      extractionNotes
      aiPromptVersion
      aiModel
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useUpdateLearningOutcomeMutation__
 *
 * To run a mutation, you first call `useUpdateLearningOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningOutcomeMutation, { data, loading, error }] = useUpdateLearningOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLearningOutcomeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateLearningOutcomeDocument, options);
}
export const GenerateLearningOutcomeSetDocument = gql `
    mutation GenerateLearningOutcomeSet($input: GenerateLearningOutcomeSetInput!) {
  generateLearningOutcomeSet(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      sourceReferenceId
      sourceUrl
      sourceProvenance
      originalText
      extractionNotes
      aiPromptVersion
      aiModel
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useGenerateLearningOutcomeSetMutation__
 *
 * To run a mutation, you first call `useGenerateLearningOutcomeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningOutcomeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningOutcomeSetMutation, { data, loading, error }] = useGenerateLearningOutcomeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningOutcomeSetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateLearningOutcomeSetDocument, options);
}
export const ReviseLearningOutcomeWithAiDocument = gql `
    mutation ReviseLearningOutcomeWithAI($input: ReviseLearningOutcomeWithAIInput!) {
  reviseLearningOutcomeWithAI(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      sourceReferenceId
      sourceUrl
      sourceProvenance
      originalText
      extractionNotes
      aiPromptVersion
      aiModel
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useReviseLearningOutcomeWithAiMutation__
 *
 * To run a mutation, you first call `useReviseLearningOutcomeWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseLearningOutcomeWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseLearningOutcomeWithAiMutation, { data, loading, error }] = useReviseLearningOutcomeWithAiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviseLearningOutcomeWithAiMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReviseLearningOutcomeWithAiDocument, options);
}
export const RevertLearningOutcomeAiRevisionDocument = gql `
    mutation RevertLearningOutcomeAIRevision($input: RevertLearningOutcomeAIRevisionInput!) {
  revertLearningOutcomeAIRevision(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      sourceReferenceId
      sourceUrl
      sourceProvenance
      originalText
      extractionNotes
      aiPromptVersion
      aiModel
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useRevertLearningOutcomeAiRevisionMutation__
 *
 * To run a mutation, you first call `useRevertLearningOutcomeAiRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertLearningOutcomeAiRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertLearningOutcomeAiRevisionMutation, { data, loading, error }] = useRevertLearningOutcomeAiRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertLearningOutcomeAiRevisionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RevertLearningOutcomeAiRevisionDocument, options);
}
export const DeleteLearningOutcomeDocument = gql `
    mutation DeleteLearningOutcome($id: ID!) {
  deleteLearningOutcome(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteLearningOutcomeMutation__
 *
 * To run a mutation, you first call `useDeleteLearningOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLearningOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLearningOutcomeMutation, { data, loading, error }] = useDeleteLearningOutcomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLearningOutcomeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteLearningOutcomeDocument, options);
}
export const ReorderLearningOutcomesDocument = gql `
    mutation ReorderLearningOutcomes($input: ReorderLearningOutcomesInput!) {
  reorderLearningOutcomes(input: $input) {
    success
    message
    data {
      id
      text
      position
      revision
    }
    count
  }
}
    `;
/**
 * __useReorderLearningOutcomesMutation__
 *
 * To run a mutation, you first call `useReorderLearningOutcomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderLearningOutcomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderLearningOutcomesMutation, { data, loading, error }] = useReorderLearningOutcomesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderLearningOutcomesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReorderLearningOutcomesDocument, options);
}
export const ApproveLearningOutcomeSetDocument = gql `
    mutation ApproveLearningOutcomeSet($input: ApproveLearningOutcomeSetInput!) {
  approveLearningOutcomeSet(input: $input) {
    success
    message
    data {
      id
      learningOutcomeApprovalStatus
      learningOutcomeSetRevision
      learningOutcomeApprovedAt
    }
    count
  }
}
    `;
/**
 * __useApproveLearningOutcomeSetMutation__
 *
 * To run a mutation, you first call `useApproveLearningOutcomeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLearningOutcomeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLearningOutcomeSetMutation, { data, loading, error }] = useApproveLearningOutcomeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveLearningOutcomeSetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ApproveLearningOutcomeSetDocument, options);
}
export const SaveCourseModernizerIntakeDraftDocument = gql `
    mutation SaveCourseModernizerIntakeDraft($input: SaveCourseModernizerIntakeDraftInput!) {
  saveCourseModernizerIntakeDraft(input: $input) {
    success
    message
    data {
      id
      visionIntent
      audienceNotes
      signatureStyleTags
      signatureStyleOther
      intakeMaterials {
        id
        created
        lastModified
        revision
        position
        modernizerInstructions
        summary
        retentionPolicy
        file {
          id
          fileName
          fileURL
          status
          externalSourceProvenance {
            connectorType
          }
        }
      }
      updatedAt
    }
    count
  }
}
    `;
/**
 * __useSaveCourseModernizerIntakeDraftMutation__
 *
 * To run a mutation, you first call `useSaveCourseModernizerIntakeDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCourseModernizerIntakeDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCourseModernizerIntakeDraftMutation, { data, loading, error }] = useSaveCourseModernizerIntakeDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCourseModernizerIntakeDraftMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SaveCourseModernizerIntakeDraftDocument, options);
}
export const AnalyzeExternalCourseSyllabusFileDocument = gql `
    mutation AnalyzeExternalCourseSyllabusFile($input: AnalyzeExternalCourseSyllabusFileInput!) {
  analyzeExternalCourseSyllabusFile(input: $input) {
    success
    message
    data {
      summary
      parsedText
      extractionOutput
      fileId
      documentId
      provenance
    }
    count
  }
}
    `;
/**
 * __useAnalyzeExternalCourseSyllabusFileMutation__
 *
 * To run a mutation, you first call `useAnalyzeExternalCourseSyllabusFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeExternalCourseSyllabusFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeExternalCourseSyllabusFileMutation, { data, loading, error }] = useAnalyzeExternalCourseSyllabusFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyzeExternalCourseSyllabusFileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AnalyzeExternalCourseSyllabusFileDocument, options);
}
export const GenerateLearningOutcomeCandidatesFromIntakeSignalsDocument = gql `
    mutation GenerateLearningOutcomeCandidatesFromIntakeSignals($input: GenerateLearningOutcomeCandidatesFromIntakeSignalsInput!) {
  generateLearningOutcomeCandidatesFromIntakeSignals(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useGenerateLearningOutcomeCandidatesFromIntakeSignalsMutation__
 *
 * To run a mutation, you first call `useGenerateLearningOutcomeCandidatesFromIntakeSignalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLearningOutcomeCandidatesFromIntakeSignalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLearningOutcomeCandidatesFromIntakeSignalsMutation, { data, loading, error }] = useGenerateLearningOutcomeCandidatesFromIntakeSignalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLearningOutcomeCandidatesFromIntakeSignalsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateLearningOutcomeCandidatesFromIntakeSignalsDocument, options);
}
export const ExtractLearningOutcomesFromCourseContentDocument = gql `
    mutation ExtractLearningOutcomesFromCourseContent($input: ExtractLearningOutcomesFromCourseContentInput!) {
  extractLearningOutcomesFromCourseContent(input: $input) {
    success
    message
    data {
      id
      text
      position
      isAIDrafted
      sourceKind
      revision
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useExtractLearningOutcomesFromCourseContentMutation__
 *
 * To run a mutation, you first call `useExtractLearningOutcomesFromCourseContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractLearningOutcomesFromCourseContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractLearningOutcomesFromCourseContentMutation, { data, loading, error }] = useExtractLearningOutcomesFromCourseContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractLearningOutcomesFromCourseContentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ExtractLearningOutcomesFromCourseContentDocument, options);
}
export const StartLearningOutcomeCourseContentExtractionDocument = gql `
    mutation StartLearningOutcomeCourseContentExtraction($input: ExtractLearningOutcomesFromCourseContentInput!) {
  startLearningOutcomeCourseContentExtraction(input: $input) {
    success
    message
    status
    jobId
  }
}
    `;
/**
 * __useStartLearningOutcomeCourseContentExtractionMutation__
 *
 * To run a mutation, you first call `useStartLearningOutcomeCourseContentExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLearningOutcomeCourseContentExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLearningOutcomeCourseContentExtractionMutation, { data, loading, error }] = useStartLearningOutcomeCourseContentExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartLearningOutcomeCourseContentExtractionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(StartLearningOutcomeCourseContentExtractionDocument, options);
}
export const GetLearningOutcomeCourseContentExtractionStatusDocument = gql `
    query GetLearningOutcomeCourseContentExtractionStatus($jobId: String!) {
  getLearningOutcomeCourseContentExtractionStatus(jobId: $jobId) {
    success
    message
    status
    jobId
    count
  }
}
    `;
/**
 * __useGetLearningOutcomeCourseContentExtractionStatusQuery__
 *
 * To run a query within a React component, call `useGetLearningOutcomeCourseContentExtractionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningOutcomeCourseContentExtractionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningOutcomeCourseContentExtractionStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetLearningOutcomeCourseContentExtractionStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLearningOutcomeCourseContentExtractionStatusDocument, options);
}
export function useGetLearningOutcomeCourseContentExtractionStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLearningOutcomeCourseContentExtractionStatusDocument, options);
}
export function useGetLearningOutcomeCourseContentExtractionStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLearningOutcomeCourseContentExtractionStatusDocument, options);
}
export const CreateAnnouncementDocument = gql `
    mutation CreateAnnouncement($input: CreateAnnouncementInput!) {
  createAnnouncement(input: $input) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      scope
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
/**
 * __useCreateAnnouncementMutation__
 *
 * To run a mutation, you first call `useCreateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnouncementMutation, { data, loading, error }] = useCreateAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAnnouncementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAnnouncementDocument, options);
}
export const CreateAxioResourceDocument = gql `
    mutation CreateAxioResource($resource: CreateAxioResourceInput!) {
  createAxioResource(resource: $resource) {
    success
    message
    data {
      id
      name
      description
      descriptionFormat
      videoUrl
      order
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useCreateAxioResourceMutation__
 *
 * To run a mutation, you first call `useCreateAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAxioResourceMutation, { data, loading, error }] = useCreateAxioResourceMutation({
 *   variables: {
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useCreateAxioResourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAxioResourceDocument, options);
}
export const CreateCoursePlaceholderDocument = gql `
    mutation CreateCoursePlaceholder($name: String!, $courseCode: String, $schoolId: ID!, $description: String, $objectives: String, $targetAudience: String, $cost: Float, $degreeIds: [ID!]) {
  createCoursePlaceholder(
    course: {name: $name, course_code: $courseCode, schoolId: $schoolId, description: $description, objectives: $objectives, targetAudience: $targetAudience, cost: $cost, degreeIds: $degreeIds}
  ) {
    success
    data {
      id
      name
      course_code
      description
      objectives
      targetAudience
      cost
      degreesHasCourse {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useCreateCoursePlaceholderMutation__
 *
 * To run a mutation, you first call `useCreateCoursePlaceholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoursePlaceholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoursePlaceholderMutation, { data, loading, error }] = useCreateCoursePlaceholderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      courseCode: // value for 'courseCode'
 *      schoolId: // value for 'schoolId'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *      targetAudience: // value for 'targetAudience'
 *      cost: // value for 'cost'
 *      degreeIds: // value for 'degreeIds'
 *   },
 * });
 */
export function useCreateCoursePlaceholderMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateCoursePlaceholderDocument, options);
}
export const CreateNoteDocument = gql `
    mutation CreateNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateNoteDocument, options);
}
export const CreatePostDocument = gql `
    mutation CreatePost($input: CreatePostInput!) {
  createPost(input: $input) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
        forum {
          course {
            id
            name
          }
        }
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreatePostDocument, options);
}
export const CreateReviewDocument = gql `
    mutation CreateReview($review: CreateReviewInput!) {
  createReview(review: $review) {
    success
    message
    data {
      id
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *   },
 * });
 */
export function useCreateReviewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateReviewDocument, options);
}
export const CreateThreadDocument = gql `
    mutation CreateThread($input: CreateThreadInput!) {
  createThread(input: $input) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        threadId
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;
/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateThreadDocument, options);
}
export const DeleteAnnouncementDocument = gql `
    mutation DeleteAnnouncement($id: ID!) {
  deleteAnnouncement(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteAnnouncementMutation__
 *
 * To run a mutation, you first call `useDeleteAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnouncementMutation, { data, loading, error }] = useDeleteAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAnnouncementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAnnouncementDocument, options);
}
export const DeleteAxioResourceDocument = gql `
    mutation DeleteAxioResource($id: ID!) {
  deleteAxioResource(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteAxioResourceMutation__
 *
 * To run a mutation, you first call `useDeleteAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAxioResourceMutation, { data, loading, error }] = useDeleteAxioResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAxioResourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAxioResourceDocument, options);
}
export const DeleteNoteDocument = gql `
    mutation DeleteNote($noteId: ID!) {
  deleteNote(noteId: $noteId) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteNoteDocument, options);
}
export const DeletePostDocument = gql `
    mutation DeletePost($postId: ID!) {
  deletePost(postId: $postId) {
    success
    message
    data {
      id
      message
      author {
        id
        name
      }
      thread {
        id
        title
      }
    }
    count
  }
}
    `;
/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeletePostDocument, options);
}
export const DeleteReviewDocument = gql `
    mutation DeleteReview($id: ID!) {
  deleteReview(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteReviewMutation__
 *
 * To run a mutation, you first call `useDeleteReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReviewMutation, { data, loading, error }] = useDeleteReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReviewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteReviewDocument, options);
}
export const DeleteThreadDocument = gql `
    mutation DeleteThread($threadId: ID!) {
  deleteThread(threadId: $threadId) {
    success
    message
    data {
      id
      title
      created
      lastModified
      posts {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
/**
 * __useDeleteThreadMutation__
 *
 * To run a mutation, you first call `useDeleteThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreadMutation, { data, loading, error }] = useDeleteThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useDeleteThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteThreadDocument, options);
}
export const DownloadLessonPlanDocument = gql `
    mutation DownloadLessonPlan($moduleId: ID!) {
  downloadLessonPlan(moduleId: $moduleId) {
    success
    message
    data
  }
}
    `;
/**
 * __useDownloadLessonPlanMutation__
 *
 * To run a mutation, you first call `useDownloadLessonPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadLessonPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadLessonPlanMutation, { data, loading, error }] = useDownloadLessonPlanMutation({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useDownloadLessonPlanMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DownloadLessonPlanDocument, options);
}
export const GenerateAiTutorFromTitleDocument = gql `
    mutation GenerateAiTutorFromTitle($title: String!, $targetAudience: String) {
  generateAiTutorFromTitle(title: $title, targetAudience: $targetAudience) {
    message
    success
    data {
      description
      objectives {
        objective
        sequence
      }
    }
  }
}
    `;
/**
 * __useGenerateAiTutorFromTitleMutation__
 *
 * To run a mutation, you first call `useGenerateAiTutorFromTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAiTutorFromTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAiTutorFromTitleMutation, { data, loading, error }] = useGenerateAiTutorFromTitleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      targetAudience: // value for 'targetAudience'
 *   },
 * });
 */
export function useGenerateAiTutorFromTitleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateAiTutorFromTitleDocument, options);
}
export const GenerateCourseContentDocument = gql `
    mutation GenerateCourseContent($courseId: ID!, $numberOfModules: Int!, $numberOfActivities: Int!, $courseDescription: String) {
  generateCourseContent(
    courseId: $courseId
    numberOfModules: $numberOfModules
    numberOfActivities: $numberOfActivities
    courseDescription: $courseDescription
  ) {
    count
    data {
      id
    }
    message
    success
  }
}
    `;
/**
 * __useGenerateCourseContentMutation__
 *
 * To run a mutation, you first call `useGenerateCourseContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCourseContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCourseContentMutation, { data, loading, error }] = useGenerateCourseContentMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      numberOfModules: // value for 'numberOfModules'
 *      numberOfActivities: // value for 'numberOfActivities'
 *      courseDescription: // value for 'courseDescription'
 *   },
 * });
 */
export function useGenerateCourseContentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateCourseContentDocument, options);
}
export const GenerateEvalCriteriaDocument = gql `
    mutation GenerateEvalCriteria($input: GenerateEvalCriteriaInput!) {
  generateEvalCriteria(input: $input) {
    message
    success
    data {
      objective
      evalCriteria
    }
  }
}
    `;
/**
 * __useGenerateEvalCriteriaMutation__
 *
 * To run a mutation, you first call `useGenerateEvalCriteriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEvalCriteriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEvalCriteriaMutation, { data, loading, error }] = useGenerateEvalCriteriaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEvalCriteriaMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateEvalCriteriaDocument, options);
}
export const GenerateLessonPlanDocument = gql `
    mutation GenerateLessonPlan($input: GenerateLessonPlanInput!) {
  generateLessonPlan(input: $input) {
    success
    message
    data
  }
}
    `;
/**
 * __useGenerateLessonPlanMutation__
 *
 * To run a mutation, you first call `useGenerateLessonPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLessonPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLessonPlanMutation, { data, loading, error }] = useGenerateLessonPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateLessonPlanMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateLessonPlanDocument, options);
}
export const GetRosterExportFileDocument = gql `
    query GetRosterExportFile($courseId: ID!) {
  getRosterExportFile(courseId: $courseId) {
    success
    message
    count
    data {
      id
      fileName
      fileURL
    }
  }
}
    `;
/**
 * __useGetRosterExportFileQuery__
 *
 * To run a query within a React component, call `useGetRosterExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRosterExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRosterExportFileQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetRosterExportFileQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetRosterExportFileDocument, options);
}
export function useGetRosterExportFileLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetRosterExportFileDocument, options);
}
export function useGetRosterExportFileSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetRosterExportFileDocument, options);
}
export const GetSubmissionExportFileDocument = gql `
    query GetSubmissionExportFile {
  getSubmissionExportFile {
    success
    message
    count
    data {
      id
      fileName
      fileURL
    }
  }
}
    `;
/**
 * __useGetSubmissionExportFileQuery__
 *
 * To run a query within a React component, call `useGetSubmissionExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionExportFileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubmissionExportFileQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSubmissionExportFileDocument, options);
}
export function useGetSubmissionExportFileLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSubmissionExportFileDocument, options);
}
export function useGetSubmissionExportFileSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSubmissionExportFileDocument, options);
}
export const MarkAnnouncementAsSeenDocument = gql `
    mutation MarkAnnouncementAsSeen($announcementId: ID!) {
  markAnnouncementAsSeen(announcementId: $announcementId) {
    success
    message
  }
}
    `;
/**
 * __useMarkAnnouncementAsSeenMutation__
 *
 * To run a mutation, you first call `useMarkAnnouncementAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAnnouncementAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAnnouncementAsSeenMutation, { data, loading, error }] = useMarkAnnouncementAsSeenMutation({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useMarkAnnouncementAsSeenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkAnnouncementAsSeenDocument, options);
}
export const ModernizeExternalCourseDocument = gql `
    mutation ModernizeExternalCourse($input: ModernizeExternalCourseInput!) {
  modernizeExternalCourse(input: $input) {
    success
    message
    jobId
  }
}
    `;
/**
 * __useModernizeExternalCourseMutation__
 *
 * To run a mutation, you first call `useModernizeExternalCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModernizeExternalCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modernizeExternalCourseMutation, { data, loading, error }] = useModernizeExternalCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModernizeExternalCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ModernizeExternalCourseDocument, options);
}
export const SubmitCourseModernizerIntakeDocument = gql `
    mutation SubmitCourseModernizerIntake($input: SubmitCourseModernizerIntakeInput!) {
  submitCourseModernizerIntake(input: $input) {
    success
    message
    jobId
  }
}
    `;
/**
 * __useSubmitCourseModernizerIntakeMutation__
 *
 * To run a mutation, you first call `useSubmitCourseModernizerIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCourseModernizerIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCourseModernizerIntakeMutation, { data, loading, error }] = useSubmitCourseModernizerIntakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCourseModernizerIntakeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitCourseModernizerIntakeDocument, options);
}
export const CancelModernizeExternalCourseDocument = gql `
    mutation CancelModernizeExternalCourse($jobId: String!) {
  cancelModernizeExternalCourse(jobId: $jobId) {
    success
    message
  }
}
    `;
/**
 * __useCancelModernizeExternalCourseMutation__
 *
 * To run a mutation, you first call `useCancelModernizeExternalCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelModernizeExternalCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelModernizeExternalCourseMutation, { data, loading, error }] = useCancelModernizeExternalCourseMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelModernizeExternalCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CancelModernizeExternalCourseDocument, options);
}
export const ResetCourseModernizerIntakeDocument = gql `
    mutation ResetCourseModernizerIntake($input: ResetCourseModernizerIntakeInput!) {
  resetCourseModernizerIntake(input: $input) {
    success
    message
    count
  }
}
    `;
/**
 * __useResetCourseModernizerIntakeMutation__
 *
 * To run a mutation, you first call `useResetCourseModernizerIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCourseModernizerIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCourseModernizerIntakeMutation, { data, loading, error }] = useResetCourseModernizerIntakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetCourseModernizerIntakeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetCourseModernizerIntakeDocument, options);
}
export const SaveCourseModernizerSetupDocument = gql `
    mutation SaveCourseModernizerSetup($input: SaveCourseModernizerSetupInput!) {
  saveCourseModernizerSetup(input: $input) {
    success
    message
    count
    data {
      id
      name
      courseCode
      description
      courseType
      term
      modality
      educationLevel
      yearLevel
      credits
      lengthInWeeks
      sourceType
      sourceId
      sourceKey
      sourceUrl
      sourceProvenance
      status
      createdAt
      updatedAt
      intakeMaterials {
        id
        created
        lastModified
        revision
        position
        modernizerInstructions
        summary
        retentionPolicy
        file {
          id
          fileName
          fileURL
          status
        }
      }
      externalCourse {
        id
      }
      architect {
        id
        name
        email
      }
      editingTeamConnection {
        edges {
          properties {
            role
          }
          node {
            id
            name
            email
          }
        }
      }
      qualityFramework {
        id
        name
      }
      accreditingBody {
        id
        name
      }
      degreeProgram {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useSaveCourseModernizerSetupMutation__
 *
 * To run a mutation, you first call `useSaveCourseModernizerSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCourseModernizerSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCourseModernizerSetupMutation, { data, loading, error }] = useSaveCourseModernizerSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCourseModernizerSetupMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SaveCourseModernizerSetupDocument, options);
}
export const SetExternalCourseTermDocument = gql `
    mutation SetExternalCourseTerm($input: SetExternalCourseTermInput!) {
  setExternalCourseTerm(input: $input) {
    success
    message
    count
    data {
      id
      term {
        id
        label
        season
        year
      }
    }
  }
}
    `;
/**
 * __useSetExternalCourseTermMutation__
 *
 * To run a mutation, you first call `useSetExternalCourseTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetExternalCourseTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setExternalCourseTermMutation, { data, loading, error }] = useSetExternalCourseTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetExternalCourseTermMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetExternalCourseTermDocument, options);
}
export const StartCourseModernizerIntakeDocument = gql `
    mutation StartCourseModernizerIntake($input: StartCourseModernizerIntakeInput!) {
  startCourseModernizerIntake(input: $input) {
    success
    message
    count
    data {
      id
      name
      courseCode
      description
      courseType
      term
      modality
      educationLevel
      yearLevel
      credits
      lengthInWeeks
      sourceType
      sourceId
      sourceKey
      sourceUrl
      sourceProvenance
      status
      createdAt
      updatedAt
      intakeMaterials {
        id
        created
        lastModified
        revision
        position
        modernizerInstructions
        summary
        retentionPolicy
        file {
          id
          fileName
          fileURL
          status
        }
      }
      externalCourse {
        id
      }
      architect {
        id
        name
        email
      }
      editingTeamConnection {
        edges {
          properties {
            role
          }
          node {
            id
            name
            email
          }
        }
      }
      qualityFramework {
        id
        name
      }
      accreditingBody {
        id
        name
      }
      degreeProgram {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useStartCourseModernizerIntakeMutation__
 *
 * To run a mutation, you first call `useStartCourseModernizerIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCourseModernizerIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCourseModernizerIntakeMutation, { data, loading, error }] = useStartCourseModernizerIntakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCourseModernizerIntakeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(StartCourseModernizerIntakeDocument, options);
}
export const UpdateAnnouncementDocument = gql `
    mutation UpdateAnnouncement($id: ID!, $input: UpdateAnnouncementInput!) {
  updateAnnouncement(id: $id, input: $input) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      scope
      audienceType
      activityState
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
/**
 * __useUpdateAnnouncementMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementMutation, { data, loading, error }] = useUpdateAnnouncementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnnouncementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAnnouncementDocument, options);
}
export const UpdateAxioResourceDocument = gql `
    mutation UpdateAxioResource($id: ID!, $resource: UpdateAxioResourceInput!) {
  updateAxioResource(id: $id, resource: $resource) {
    success
    message
    data {
      id
      name
      description
      descriptionFormat
      videoUrl
      order
    }
  }
}
    `;
/**
 * __useUpdateAxioResourceMutation__
 *
 * To run a mutation, you first call `useUpdateAxioResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAxioResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAxioResourceMutation, { data, loading, error }] = useUpdateAxioResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resource: // value for 'resource'
 *   },
 * });
 */
export function useUpdateAxioResourceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAxioResourceDocument, options);
}
export const UpdateLastSeenPostDocument = gql `
    mutation UpdateLastSeenPost($input: UpdateLastSeenPostInput!) {
  updateLastSeenPost(input: $input) {
    success
    message
    data {
      id
      message
      threadId
      created
    }
    count
  }
}
    `;
/**
 * __useUpdateLastSeenPostMutation__
 *
 * To run a mutation, you first call `useUpdateLastSeenPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastSeenPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastSeenPostMutation, { data, loading, error }] = useUpdateLastSeenPostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLastSeenPostMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateLastSeenPostDocument, options);
}
export const UpdateNoteDocument = gql `
    mutation UpdateNote($noteId: ID!, $input: UpdateNoteInput!) {
  updateNote(noteId: $noteId, input: $input) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateNoteDocument, options);
}
export const UpdatePostDocument = gql `
    mutation UpdatePost($postId: ID!, $input: UpdatePostInput!) {
  updatePost(postId: $postId, input: $input) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdatePostDocument, options);
}
export const UpdateReviewDocument = gql `
    mutation UpdateReview($id: ID!, $review: UpdateReviewInput!) {
  updateReview(id: $id, review: $review) {
    success
    message
    data {
      id
      activityState
      scheduledDate
      lastModified
    }
    count
  }
}
    `;
/**
 * __useUpdateReviewMutation__
 *
 * To run a mutation, you first call `useUpdateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReviewMutation, { data, loading, error }] = useUpdateReviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      review: // value for 'review'
 *   },
 * });
 */
export function useUpdateReviewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateReviewDocument, options);
}
export const UpdateThreadDocument = gql `
    mutation UpdateThread($threadId: ID!, $input: UpdateThreadInput!) {
  updateThread(threadId: $threadId, input: $input) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        threadId
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;
/**
 * __useUpdateThreadMutation__
 *
 * To run a mutation, you first call `useUpdateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreadMutation, { data, loading, error }] = useUpdateThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThreadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateThreadDocument, options);
}
export const UploadExternalCourseDocumentAndModernizeDocument = gql `
    mutation UploadExternalCourseDocumentAndModernize($input: UploadExternalCourseDocumentAndModernizeInput!) {
  uploadExternalCourseDocumentAndModernize(input: $input) {
    success
    message
    jobId
    externalCourseId
    modernizerIntakeId
    sourceSystem
    requiresIntakeWizard
  }
}
    `;
/**
 * __useUploadExternalCourseDocumentAndModernizeMutation__
 *
 * To run a mutation, you first call `useUploadExternalCourseDocumentAndModernizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadExternalCourseDocumentAndModernizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadExternalCourseDocumentAndModernizeMutation, { data, loading, error }] = useUploadExternalCourseDocumentAndModernizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadExternalCourseDocumentAndModernizeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UploadExternalCourseDocumentAndModernizeDocument, options);
}
export const CreateVideoPoolDocument = gql `
    mutation CreateVideoPool($title: String!, $description: String!, $objectives: [ObjectiveForVideoInput!]!) {
  createVideoPool(
    title: $title
    description: $description
    objectives: $objectives
  ) {
    success
    message
    data {
      videoId
      url
      title
      description
      thumbnailUrl
      objectiveText
      objectiveSequence
    }
    count
  }
}
    `;
/**
 * __useCreateVideoPoolMutation__
 *
 * To run a mutation, you first call `useCreateVideoPoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoPoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoPoolMutation, { data, loading, error }] = useCreateVideoPoolMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useCreateVideoPoolMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateVideoPoolDocument, options);
}
export const AddPreRequisitesToCourseDocument = gql `
    mutation AddPreRequisitesToCourse($courseId: ID!, $preRequisiteIds: [ID!]!) {
  addPreRequisitesToCourse(courseId: $courseId, preRequisiteIds: $preRequisiteIds) {
    success
    data {
      id
    }
    count
  }
}
    `;
/**
 * __useAddPreRequisitesToCourseMutation__
 *
 * To run a mutation, you first call `useAddPreRequisitesToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPreRequisitesToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPreRequisitesToCourseMutation, { data, loading, error }] = useAddPreRequisitesToCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      preRequisiteIds: // value for 'preRequisiteIds'
 *   },
 * });
 */
export function useAddPreRequisitesToCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddPreRequisitesToCourseDocument, options);
}
export const AllowLateAssessmentSubmissionDocument = gql `
    mutation AllowLateAssessmentSubmission($submissionId: ID!) {
  allowLateAssessmentSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isLateAllowed
      isMissing
    }
  }
}
    `;
/**
 * __useAllowLateAssessmentSubmissionMutation__
 *
 * To run a mutation, you first call `useAllowLateAssessmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowLateAssessmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowLateAssessmentSubmissionMutation, { data, loading, error }] = useAllowLateAssessmentSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useAllowLateAssessmentSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AllowLateAssessmentSubmissionDocument, options);
}
export const AllowLateAssignmentSubmissionDocument = gql `
    mutation AllowLateAssignmentSubmission($submissionId: ID!) {
  allowLateAssignmentSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isLateAllowed
      isMissing
    }
  }
}
    `;
/**
 * __useAllowLateAssignmentSubmissionMutation__
 *
 * To run a mutation, you first call `useAllowLateAssignmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowLateAssignmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowLateAssignmentSubmissionMutation, { data, loading, error }] = useAllowLateAssignmentSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useAllowLateAssignmentSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AllowLateAssignmentSubmissionDocument, options);
}
export const BulkApproveAssessmentGradesDocument = gql `
    mutation BulkApproveAssessmentGrades($submissionIds: [ID!]!) {
  bulkApproveAssessmentGrades(submissionIds: $submissionIds) {
    success
    message
    data {
      successCount
      failedCount
      errors
    }
  }
}
    `;
/**
 * __useBulkApproveAssessmentGradesMutation__
 *
 * To run a mutation, you first call `useBulkApproveAssessmentGradesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkApproveAssessmentGradesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkApproveAssessmentGradesMutation, { data, loading, error }] = useBulkApproveAssessmentGradesMutation({
 *   variables: {
 *      submissionIds: // value for 'submissionIds'
 *   },
 * });
 */
export function useBulkApproveAssessmentGradesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(BulkApproveAssessmentGradesDocument, options);
}
export const ClearAssessmentSubmissionStatusDocument = gql `
    mutation ClearAssessmentSubmissionStatus($submissionId: ID!) {
  clearAssessmentSubmissionStatus(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useClearAssessmentSubmissionStatusMutation__
 *
 * To run a mutation, you first call `useClearAssessmentSubmissionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAssessmentSubmissionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAssessmentSubmissionStatusMutation, { data, loading, error }] = useClearAssessmentSubmissionStatusMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useClearAssessmentSubmissionStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ClearAssessmentSubmissionStatusDocument, options);
}
export const ClearAssignmentSubmissionStatusDocument = gql `
    mutation ClearAssignmentSubmissionStatus($submissionId: ID!) {
  clearAssignmentSubmissionStatus(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useClearAssignmentSubmissionStatusMutation__
 *
 * To run a mutation, you first call `useClearAssignmentSubmissionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearAssignmentSubmissionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearAssignmentSubmissionStatusMutation, { data, loading, error }] = useClearAssignmentSubmissionStatusMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useClearAssignmentSubmissionStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ClearAssignmentSubmissionStatusDocument, options);
}
export const CloneCourseDocument = gql `
    mutation CloneCourse($courseId: ID!) {
  cloneCourse(courseId: $courseId) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
/**
 * __useCloneCourseMutation__
 *
 * To run a mutation, you first call `useCloneCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneCourseMutation, { data, loading, error }] = useCloneCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCloneCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CloneCourseDocument, options);
}
export const CreateAssessmentDocument = gql `
    mutation CreateAssessment($input: CreateOrUpdateAssessmentInput!) {
  createAssessment(input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useCreateAssessmentMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentMutation, { data, loading, error }] = useCreateAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAssessmentDocument, options);
}
export const CreateAssignmentDocument = gql `
    mutation CreateAssignment($assignment: CreateAssignmentInput!) {
  createAssignment(assignment: $assignment) {
    success
    message
  }
}
    `;
/**
 * __useCreateAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssignmentMutation, { data, loading, error }] = useCreateAssignmentMutation({
 *   variables: {
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useCreateAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAssignmentDocument, options);
}
export const CreateWorksheetDocument = gql `
    mutation CreateWorksheet($worksheet: CreateWorksheetInput!, $existingWorksheetId: ID) {
  createWorksheet(
    worksheet: $worksheet
    existingWorksheetId: $existingWorksheetId
  ) {
    success
    message
    data {
      worksheetId
      pdfUrl
      generationStatus
    }
  }
}
    `;
/**
 * __useCreateWorksheetMutation__
 *
 * To run a mutation, you first call `useCreateWorksheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorksheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorksheetMutation, { data, loading, error }] = useCreateWorksheetMutation({
 *   variables: {
 *      worksheet: // value for 'worksheet'
 *      existingWorksheetId: // value for 'existingWorksheetId'
 *   },
 * });
 */
export function useCreateWorksheetMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateWorksheetDocument, options);
}
export const DeleteCourseCascadeDocument = gql `
    mutation DeleteCourseCascade($id: ID!) {
  deleteCourseCascade(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteCourseCascadeMutation__
 *
 * To run a mutation, you first call `useDeleteCourseCascadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCourseCascadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCourseCascadeMutation, { data, loading, error }] = useDeleteCourseCascadeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCourseCascadeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteCourseCascadeDocument, options);
}
export const CreateCourseDocument = gql `
    mutation CreateCourse($name: String!, $learningStandards: String, $lengthInWeeks: Float, $objectives: [String!], $parentSchoolId: String!, $cost: Float) {
  createCourse(
    course: {name: $name, learningStandards: $learningStandards, lengthInWeeks: $lengthInWeeks, objectives: $objectives, parentSchoolId: $parentSchoolId, cost: $cost}
  ) {
    success
    message
    data {
      name
      learningStandards
      lengthInWeeks
      objectives
      cost
    }
  }
}
    `;
/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      name: // value for 'name'
 *      learningStandards: // value for 'learningStandards'
 *      lengthInWeeks: // value for 'lengthInWeeks'
 *      objectives: // value for 'objectives'
 *      parentSchoolId: // value for 'parentSchoolId'
 *      cost: // value for 'cost'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateCourseDocument, options);
}
export const UpdateCourseDocument = gql `
    mutation UpdateCourse($id: ID!, $course: UpdateCourseInput!) {
  updateCourse(id: $id, course: $course) {
    success
    message
    data {
      name
      course_code
      isDraft
      isEnrollmentAvailable
    }
  }
}
    `;
/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      course: // value for 'course'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateCourseDocument, options);
}
export const DeleteModuleCascadeDocument = gql `
    mutation DeleteModuleCascade($id: ID!) {
  deleteModuleCascade(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteModuleCascadeMutation__
 *
 * To run a mutation, you first call `useDeleteModuleCascadeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModuleCascadeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModuleCascadeMutation, { data, loading, error }] = useDeleteModuleCascadeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteModuleCascadeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteModuleCascadeDocument, options);
}
export const CreateModuleDocument = gql `
    mutation CreateModule($title: String!, $parentCourseId: ID!, $description: String, $thumbnail: String) {
  createModule(
    module: {title: $title, parentCourseId: $parentCourseId, description: $description, thumbnail: $thumbnail}
  ) {
    success
    message
    data {
      title
      description
      thumbnail
    }
  }
}
    `;
/**
 * __useCreateModuleMutation__
 *
 * To run a mutation, you first call `useCreateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createModuleMutation, { data, loading, error }] = useCreateModuleMutation({
 *   variables: {
 *      title: // value for 'title'
 *      parentCourseId: // value for 'parentCourseId'
 *      description: // value for 'description'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useCreateModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateModuleDocument, options);
}
export const UpdateModuleDocument = gql `
    mutation UpdateModule($id: ID!, $title: String, $description: String, $thumbnail: String) {
  updateModule(
    id: $id
    module: {title: $title, description: $description, thumbnail: $thumbnail}
  ) {
    success
    message
    data {
      title
      description
      thumbnail
    }
  }
}
    `;
/**
 * __useUpdateModuleMutation__
 *
 * To run a mutation, you first call `useUpdateModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModuleMutation, { data, loading, error }] = useUpdateModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useUpdateModuleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateModuleDocument, options);
}
export const CreatePageDocument = gql `
    mutation CreatePage($title: String!, $body: String, $parentModuleId: ID!) {
  createPage(page: {title: $title, body: $body, parentModuleId: $parentModuleId}) {
    success
    message
    data {
      title
      body
    }
  }
}
    `;
/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      parentModuleId: // value for 'parentModuleId'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreatePageDocument, options);
}
export const DeletePageDocument = gql `
    mutation DeletePage($id: ID!) {
  deletePage(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeletePageDocument, options);
}
export const UpdatePageDocument = gql `
    mutation UpdatePage($id: ID!, $title: String, $body: String) {
  updatePage(id: $id, page: {title: $title, body: $body}) {
    success
    message
    data {
      title
      body
    }
  }
}
    `;
/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdatePageDocument, options);
}
export const DeleteAssessmentDocument = gql `
    mutation DeleteAssessment($id: ID!) {
  deleteAssessment(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssessmentMutation, { data, loading, error }] = useDeleteAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssessmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAssessmentDocument, options);
}
export const DeleteAssignmentDocument = gql `
    mutation DeleteAssignment($id: ID!) {
  deleteAssignment(id: $id) {
    success
    data {
      id
    }
    count
  }
}
    `;
/**
 * __useDeleteAssignmentMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentMutation, { data, loading, error }] = useDeleteAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAssignmentDocument, options);
}
export const EditAssignmentDocument = gql `
    mutation EditAssignment($id: ID!, $assignment: EditAssignmentInput!) {
  editAssignment(id: $id, assignment: $assignment) {
    success
    data {
      id
      name
      due_date
      description
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      enableStudentFileUpload
    }
    message
  }
}
    `;
/**
 * __useEditAssignmentMutation__
 *
 * To run a mutation, you first call `useEditAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAssignmentMutation, { data, loading, error }] = useEditAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignment: // value for 'assignment'
 *   },
 * });
 */
export function useEditAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EditAssignmentDocument, options);
}
export const EditCourseDocument = gql `
    mutation EditCourse($id: ID!, $course: EditCourseInput!) {
  editCourse(id: $id, course: $course) {
    success
    message
    data {
      id
      name
      course_code
      learningStandards
      lengthInWeeks
      objectives
      is_elective
      cost
      isDraft
      description
      targetAudience
      thumbnail
    }
  }
}
    `;
/**
 * __useEditCourseMutation__
 *
 * To run a mutation, you first call `useEditCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCourseMutation, { data, loading, error }] = useEditCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      course: // value for 'course'
 *   },
 * });
 */
export function useEditCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EditCourseDocument, options);
}
export const EndOralAssessmentSessionDocument = gql `
    mutation EndOralAssessmentSession($submissionId: ID!) {
  endOralAssessmentSession(submissionId: $submissionId) {
    success
    message
    data {
      submissionId
      assessmentId
      status
      serverTimeMs
      remainingSec
      totalDurationSec
      introText
      introAudioUrl
      introAudioFileId
      currentTurn {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
      questions {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
    }
  }
}
    `;
/**
 * __useEndOralAssessmentSessionMutation__
 *
 * To run a mutation, you first call `useEndOralAssessmentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndOralAssessmentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endOralAssessmentSessionMutation, { data, loading, error }] = useEndOralAssessmentSessionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useEndOralAssessmentSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EndOralAssessmentSessionDocument, options);
}
export const ExcuseAssessmentSubmissionDocument = gql `
    mutation ExcuseAssessmentSubmission($submissionId: ID!) {
  excuseAssessmentSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useExcuseAssessmentSubmissionMutation__
 *
 * To run a mutation, you first call `useExcuseAssessmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcuseAssessmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excuseAssessmentSubmissionMutation, { data, loading, error }] = useExcuseAssessmentSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useExcuseAssessmentSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ExcuseAssessmentSubmissionDocument, options);
}
export const ExcuseAssignmentSubmissionDocument = gql `
    mutation ExcuseAssignmentSubmission($submissionId: ID!) {
  excuseAssignmentSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useExcuseAssignmentSubmissionMutation__
 *
 * To run a mutation, you first call `useExcuseAssignmentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcuseAssignmentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excuseAssignmentSubmissionMutation, { data, loading, error }] = useExcuseAssignmentSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useExcuseAssignmentSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ExcuseAssignmentSubmissionDocument, options);
}
export const GenerateAssessmentQuestionBankDocument = gql `
    mutation GenerateAssessmentQuestionBank($input: GenerateAssessmentQuestionBankInput!) {
  generateAssessmentQuestionBank(input: $input) {
    success
    message
    status
    jobId
    assessmentId
  }
}
    `;
/**
 * __useGenerateAssessmentQuestionBankMutation__
 *
 * To run a mutation, you first call `useGenerateAssessmentQuestionBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAssessmentQuestionBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAssessmentQuestionBankMutation, { data, loading, error }] = useGenerateAssessmentQuestionBankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAssessmentQuestionBankMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateAssessmentQuestionBankDocument, options);
}
export const GenerateCourseExportDocument = gql `
    mutation GenerateCourseExport($courseId: ID!) {
  generateCourseExport(courseId: $courseId) {
    success
    message
    data {
      jobId
    }
  }
}
    `;
/**
 * __useGenerateCourseExportMutation__
 *
 * To run a mutation, you first call `useGenerateCourseExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCourseExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCourseExportMutation, { data, loading, error }] = useGenerateCourseExportMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateCourseExportMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateCourseExportDocument, options);
}
export const GenerateDueDatesForActivitiesDocument = gql `
    mutation GenerateDueDatesForActivities($courseId: ID!) {
  generateDueDatesForActivities(courseId: $courseId) {
    success
    data {
      id
    }
  }
}
    `;
/**
 * __useGenerateDueDatesForActivitiesMutation__
 *
 * To run a mutation, you first call `useGenerateDueDatesForActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDueDatesForActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDueDatesForActivitiesMutation, { data, loading, error }] = useGenerateDueDatesForActivitiesMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateDueDatesForActivitiesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateDueDatesForActivitiesDocument, options);
}
export const GenerateModuleThumbnailsDocument = gql `
    mutation GenerateModuleThumbnails($courseId: ID!) {
  generateModuleThumbnails(courseId: $courseId) {
    success
    message
    data {
      id
      title
      thumbnail
    }
    count
  }
}
    `;
/**
 * __useGenerateModuleThumbnailsMutation__
 *
 * To run a mutation, you first call `useGenerateModuleThumbnailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateModuleThumbnailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateModuleThumbnailsMutation, { data, loading, error }] = useGenerateModuleThumbnailsMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGenerateModuleThumbnailsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateModuleThumbnailsDocument, options);
}
export const GenerateObjectiveImageDocument = gql `
    mutation GenerateObjectiveImage($objectiveText: String!, $objectiveSequence: Float, $activityTitle: String!, $prompt: String) {
  generateObjectiveImage(
    objectiveText: $objectiveText
    objectiveSequence: $objectiveSequence
    activityTitle: $activityTitle
    prompt: $prompt
  ) {
    success
    message
    imageGenerationJobId
    data {
      id
      url
      objectiveText
      objectiveSequence
      isTeacherUploaded
      description
      created
    }
    count
  }
}
    `;
/**
 * __useGenerateObjectiveImageMutation__
 *
 * To run a mutation, you first call `useGenerateObjectiveImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateObjectiveImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateObjectiveImageMutation, { data, loading, error }] = useGenerateObjectiveImageMutation({
 *   variables: {
 *      objectiveText: // value for 'objectiveText'
 *      objectiveSequence: // value for 'objectiveSequence'
 *      activityTitle: // value for 'activityTitle'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useGenerateObjectiveImageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateObjectiveImageDocument, options);
}
export const GenerateObjectiveImagePromptsDocument = gql `
    mutation GenerateObjectiveImagePrompts($objectiveText: String!, $objectiveSequence: Float, $activityTitle: String!, $targetAudience: String, $activityDescription: String) {
  generateObjectiveImagePrompts(
    objectiveText: $objectiveText
    objectiveSequence: $objectiveSequence
    activityTitle: $activityTitle
    targetAudience: $targetAudience
    activityDescription: $activityDescription
  ) {
    success
    message
    data
    count
  }
}
    `;
/**
 * __useGenerateObjectiveImagePromptsMutation__
 *
 * To run a mutation, you first call `useGenerateObjectiveImagePromptsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateObjectiveImagePromptsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateObjectiveImagePromptsMutation, { data, loading, error }] = useGenerateObjectiveImagePromptsMutation({
 *   variables: {
 *      objectiveText: // value for 'objectiveText'
 *      objectiveSequence: // value for 'objectiveSequence'
 *      activityTitle: // value for 'activityTitle'
 *      targetAudience: // value for 'targetAudience'
 *      activityDescription: // value for 'activityDescription'
 *   },
 * });
 */
export function useGenerateObjectiveImagePromptsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateObjectiveImagePromptsDocument, options);
}
export const InviteUsersToEnrollInCourseDocument = gql `
    mutation InviteUsersToEnrollInCourse($input: InviteUsersToEnrollInCourseInput!) {
  inviteUsersToEnrollInCourse(input: $input) {
    success
    data {
      email
      id
    }
    count
  }
}
    `;
/**
 * __useInviteUsersToEnrollInCourseMutation__
 *
 * To run a mutation, you first call `useInviteUsersToEnrollInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToEnrollInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToEnrollInCourseMutation, { data, loading, error }] = useInviteUsersToEnrollInCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersToEnrollInCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(InviteUsersToEnrollInCourseDocument, options);
}
export const MarkAssessmentSubmissionMissingDocument = gql `
    mutation MarkAssessmentSubmissionMissing($submissionId: ID!) {
  markAssessmentSubmissionMissing(submissionId: $submissionId) {
    success
    message
    data {
      id
      isMissing
      totalPoints
      isExcused
      isLateAllowed
    }
  }
}
    `;
/**
 * __useMarkAssessmentSubmissionMissingMutation__
 *
 * To run a mutation, you first call `useMarkAssessmentSubmissionMissingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAssessmentSubmissionMissingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAssessmentSubmissionMissingMutation, { data, loading, error }] = useMarkAssessmentSubmissionMissingMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useMarkAssessmentSubmissionMissingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkAssessmentSubmissionMissingDocument, options);
}
export const MarkAssignmentSubmissionMissingDocument = gql `
    mutation MarkAssignmentSubmissionMissing($submissionId: ID!) {
  markAssignmentSubmissionMissing(submissionId: $submissionId) {
    success
    message
    data {
      id
      isMissing
      grade
      isExcused
      isLateAllowed
    }
  }
}
    `;
/**
 * __useMarkAssignmentSubmissionMissingMutation__
 *
 * To run a mutation, you first call `useMarkAssignmentSubmissionMissingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAssignmentSubmissionMissingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAssignmentSubmissionMissingMutation, { data, loading, error }] = useMarkAssignmentSubmissionMissingMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useMarkAssignmentSubmissionMissingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkAssignmentSubmissionMissingDocument, options);
}
export const CreateMcqQuestionDocument = gql `
    mutation CreateMcqQuestion($input: CreateMcqQuestionInput!) {
  createMcqQuestion(input: $input) {
    success
    message
    data {
      id
      question
      choices
      correctChoiceIndices
      explanation
      totalScore
      order
    }
  }
}
    `;
/**
 * __useCreateMcqQuestionMutation__
 *
 * To run a mutation, you first call `useCreateMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMcqQuestionMutation, { data, loading, error }] = useCreateMcqQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMcqQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateMcqQuestionDocument, options);
}
export const UpdateMcqQuestionDocument = gql `
    mutation UpdateMcqQuestion($mcqQuestionId: ID!, $assessmentId: ID!, $input: UpdateMcqQuestionInput!) {
  updateMcqQuestion(
    mcqQuestionId: $mcqQuestionId
    assessmentId: $assessmentId
    input: $input
  ) {
    success
    message
    data {
      id
      question
      choices
      correctChoiceIndices
      explanation
      totalScore
      order
    }
  }
}
    `;
/**
 * __useUpdateMcqQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMcqQuestionMutation, { data, loading, error }] = useUpdateMcqQuestionMutation({
 *   variables: {
 *      mcqQuestionId: // value for 'mcqQuestionId'
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMcqQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateMcqQuestionDocument, options);
}
export const DeleteMcqQuestionDocument = gql `
    mutation DeleteMcqQuestion($mcqQuestionId: ID!, $assessmentId: ID!) {
  deleteMcqQuestion(mcqQuestionId: $mcqQuestionId, assessmentId: $assessmentId) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteMcqQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteMcqQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMcqQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMcqQuestionMutation, { data, loading, error }] = useDeleteMcqQuestionMutation({
 *   variables: {
 *      mcqQuestionId: // value for 'mcqQuestionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDeleteMcqQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteMcqQuestionDocument, options);
}
export const MoveActivityDocument = gql `
    mutation MoveActivity($activityId: ID!, $sourceModuleId: ID!, $targetModuleId: ID!, $activityType: String!) {
  moveActivity(
    input: {activityId: $activityId, sourceModuleId: $sourceModuleId, targetModuleId: $targetModuleId, activityType: $activityType}
  ) {
    success
    message
    data {
      id
      title
      resourceOrder
    }
    count
  }
}
    `;
/**
 * __useMoveActivityMutation__
 *
 * To run a mutation, you first call `useMoveActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveActivityMutation, { data, loading, error }] = useMoveActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      sourceModuleId: // value for 'sourceModuleId'
 *      targetModuleId: // value for 'targetModuleId'
 *      activityType: // value for 'activityType'
 *   },
 * });
 */
export function useMoveActivityMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MoveActivityDocument, options);
}
export const QueueOralAssessmentAudioBackfillDocument = gql `
    mutation QueueOralAssessmentAudioBackfill($assessmentId: ID!) {
  queueOralAssessmentAudioBackfill(assessmentId: $assessmentId) {
    success
    message
    queuedCount
    jobIds
  }
}
    `;
/**
 * __useQueueOralAssessmentAudioBackfillMutation__
 *
 * To run a mutation, you first call `useQueueOralAssessmentAudioBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueOralAssessmentAudioBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueOralAssessmentAudioBackfillMutation, { data, loading, error }] = useQueueOralAssessmentAudioBackfillMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useQueueOralAssessmentAudioBackfillMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(QueueOralAssessmentAudioBackfillDocument, options);
}
export const QueueCourseOralAssessmentAudioBackfillDocument = gql `
    mutation QueueCourseOralAssessmentAudioBackfill($courseId: ID!) {
  queueCourseOralAssessmentAudioBackfill(courseId: $courseId) {
    success
    message
    queuedCount
    jobIds
  }
}
    `;
/**
 * __useQueueCourseOralAssessmentAudioBackfillMutation__
 *
 * To run a mutation, you first call `useQueueCourseOralAssessmentAudioBackfillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueCourseOralAssessmentAudioBackfillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueCourseOralAssessmentAudioBackfillMutation, { data, loading, error }] = useQueueCourseOralAssessmentAudioBackfillMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useQueueCourseOralAssessmentAudioBackfillMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(QueueCourseOralAssessmentAudioBackfillDocument, options);
}
export const ReGenerateCourseImageDocument = gql `
    mutation ReGenerateCourseImage($courseId: ID!) {
  reGenerateCourseImage(courseId: $courseId) {
    success
    data {
      id
    }
  }
}
    `;
/**
 * __useReGenerateCourseImageMutation__
 *
 * To run a mutation, you first call `useReGenerateCourseImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReGenerateCourseImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reGenerateCourseImageMutation, { data, loading, error }] = useReGenerateCourseImageMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useReGenerateCourseImageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReGenerateCourseImageDocument, options);
}
export const RegenerateObjectiveImageDocument = gql `
    mutation RegenerateObjectiveImage($imageId: ID!, $feedback: String!, $objectiveText: String!) {
  regenerateObjectiveImage(
    imageId: $imageId
    feedback: $feedback
    objectiveText: $objectiveText
  ) {
    success
    message
    imageGenerationJobId
    data {
      id
      url
      objectiveText
      objectiveSequence
      isTeacherUploaded
      description
      created
    }
    count
  }
}
    `;
/**
 * __useRegenerateObjectiveImageMutation__
 *
 * To run a mutation, you first call `useRegenerateObjectiveImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateObjectiveImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateObjectiveImageMutation, { data, loading, error }] = useRegenerateObjectiveImageMutation({
 *   variables: {
 *      imageId: // value for 'imageId'
 *      feedback: // value for 'feedback'
 *      objectiveText: // value for 'objectiveText'
 *   },
 * });
 */
export function useRegenerateObjectiveImageMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RegenerateObjectiveImageDocument, options);
}
export const RemovePreRequisitesFromCourseDocument = gql `
    mutation RemovePreRequisitesFromCourse($courseId: ID!, $preRequisiteIds: [ID!]!) {
  removePreRequisitesFromCourse(
    courseId: $courseId
    preRequisiteIds: $preRequisiteIds
  ) {
    success
    data {
      id
    }
    count
  }
}
    `;
/**
 * __useRemovePreRequisitesFromCourseMutation__
 *
 * To run a mutation, you first call `useRemovePreRequisitesFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePreRequisitesFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePreRequisitesFromCourseMutation, { data, loading, error }] = useRemovePreRequisitesFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      preRequisiteIds: // value for 'preRequisiteIds'
 *   },
 * });
 */
export function useRemovePreRequisitesFromCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemovePreRequisitesFromCourseDocument, options);
}
export const RemoveStudentsFromCourseDocument = gql `
    mutation RemoveStudentsFromCourse($courseId: ID!, $studentIds: [ID!]!) {
  removeStudentsFromCourse(courseId: $courseId, studentIds: $studentIds) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
/**
 * __useRemoveStudentsFromCourseMutation__
 *
 * To run a mutation, you first call `useRemoveStudentsFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentsFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentsFromCourseMutation, { data, loading, error }] = useRemoveStudentsFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      studentIds: // value for 'studentIds'
 *   },
 * });
 */
export function useRemoveStudentsFromCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemoveStudentsFromCourseDocument, options);
}
export const RequestRosterExportDocument = gql `
    mutation RequestRosterExport($courseId: ID!) {
  requestRosterExport(courseId: $courseId) {
    success
    message
    data {
      jobId
    }
  }
}
    `;
/**
 * __useRequestRosterExportMutation__
 *
 * To run a mutation, you first call `useRequestRosterExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestRosterExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestRosterExportMutation, { data, loading, error }] = useRequestRosterExportMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRequestRosterExportMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestRosterExportDocument, options);
}
export const RequestSubmissionExportDocument = gql `
    mutation RequestSubmissionExport {
  requestSubmissionExport {
    success
    message
    data {
      jobId
    }
  }
}
    `;
/**
 * __useRequestSubmissionExportMutation__
 *
 * To run a mutation, you first call `useRequestSubmissionExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSubmissionExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSubmissionExportMutation, { data, loading, error }] = useRequestSubmissionExportMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestSubmissionExportMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestSubmissionExportDocument, options);
}
export const ResetAiTutorDocument = gql `
    mutation ResetAITutor($input: ResetAiTutorInput!) {
  resetAITutor(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useResetAiTutorMutation__
 *
 * To run a mutation, you first call `useResetAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAiTutorMutation, { data, loading, error }] = useResetAiTutorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetAiTutorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetAiTutorDocument, options);
}
export const SetAssessmentStatusForStudentDocument = gql `
    mutation SetAssessmentStatusForStudent($studentId: ID!, $assessmentId: ID!, $status: StudentActivityStatus!) {
  setAssessmentStatusForStudent(
    studentId: $studentId
    assessmentId: $assessmentId
    status: $status
  ) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useSetAssessmentStatusForStudentMutation__
 *
 * To run a mutation, you first call `useSetAssessmentStatusForStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssessmentStatusForStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssessmentStatusForStudentMutation, { data, loading, error }] = useSetAssessmentStatusForStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      assessmentId: // value for 'assessmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetAssessmentStatusForStudentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetAssessmentStatusForStudentDocument, options);
}
export const SetAssignmentStatusForStudentDocument = gql `
    mutation SetAssignmentStatusForStudent($studentId: ID!, $assignmentId: ID!, $status: StudentActivityStatus!) {
  setAssignmentStatusForStudent(
    studentId: $studentId
    assignmentId: $assignmentId
    status: $status
  ) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useSetAssignmentStatusForStudentMutation__
 *
 * To run a mutation, you first call `useSetAssignmentStatusForStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAssignmentStatusForStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAssignmentStatusForStudentMutation, { data, loading, error }] = useSetAssignmentStatusForStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      assignmentId: // value for 'assignmentId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetAssignmentStatusForStudentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetAssignmentStatusForStudentDocument, options);
}
export const CreateSocraticQuestionDocument = gql `
    mutation CreateSocraticQuestion($input: CreateSocraticQuestionInput!) {
  createSocraticQuestion(input: $input) {
    success
    message
    data {
      id
      question
      totalScore
      rubrics {
        id
        component
        points
      }
    }
  }
}
    `;
/**
 * __useCreateSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useCreateSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSocraticQuestionMutation, { data, loading, error }] = useCreateSocraticQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSocraticQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateSocraticQuestionDocument, options);
}
export const UpdateSocraticQuestionDocument = gql `
    mutation UpdateSocraticQuestion($questionId: ID!, $assessmentId: ID!, $input: UpdateSocraticQuestionInput!) {
  updateSocraticQuestion(
    questionId: $questionId
    assessmentId: $assessmentId
    input: $input
  ) {
    success
    message
    data {
      id
      question
      totalScore
      rubrics {
        id
        component
        points
      }
    }
  }
}
    `;
/**
 * __useUpdateSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSocraticQuestionMutation, { data, loading, error }] = useUpdateSocraticQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      assessmentId: // value for 'assessmentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSocraticQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateSocraticQuestionDocument, options);
}
export const DeleteSocraticQuestionDocument = gql `
    mutation DeleteSocraticQuestion($questionId: ID!, $assessmentId: ID!) {
  deleteSocraticQuestion(questionId: $questionId, assessmentId: $assessmentId) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteSocraticQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteSocraticQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSocraticQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSocraticQuestionMutation, { data, loading, error }] = useDeleteSocraticQuestionMutation({
 *   variables: {
 *      questionId: // value for 'questionId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDeleteSocraticQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSocraticQuestionDocument, options);
}
export const GenerateSocraticRubricForQuestionDocument = gql `
    mutation GenerateSocraticRubricForQuestion($input: GenerateSocraticRubricInput!) {
  generateSocraticRubricForQuestion(input: $input) {
    success
    message
    totalScore
    rubrics {
      component
      points
    }
  }
}
    `;
/**
 * __useGenerateSocraticRubricForQuestionMutation__
 *
 * To run a mutation, you first call `useGenerateSocraticRubricForQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSocraticRubricForQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSocraticRubricForQuestionMutation, { data, loading, error }] = useGenerateSocraticRubricForQuestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSocraticRubricForQuestionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateSocraticRubricForQuestionDocument, options);
}
export const StartOralAssessmentSessionDocument = gql `
    mutation StartOralAssessmentSession($assessmentId: ID!) {
  startOralAssessmentSession(assessmentId: $assessmentId) {
    success
    message
    data {
      submissionId
      assessmentId
      status
      serverTimeMs
      remainingSec
      totalDurationSec
      introText
      introAudioUrl
      introAudioFileId
      currentTurn {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
      questions {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
    }
  }
}
    `;
/**
 * __useStartOralAssessmentSessionMutation__
 *
 * To run a mutation, you first call `useStartOralAssessmentSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartOralAssessmentSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startOralAssessmentSessionMutation, { data, loading, error }] = useStartOralAssessmentSessionMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useStartOralAssessmentSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(StartOralAssessmentSessionDocument, options);
}
export const SubmitOralAssessmentAnswerDocument = gql `
    mutation SubmitOralAssessmentAnswer($input: SubmitOralAssessmentAnswerInput!) {
  submitOralAssessmentAnswer(input: $input) {
    success
    message
    transcriptionFailed
    data {
      submissionId
      assessmentId
      status
      serverTimeMs
      remainingSec
      totalDurationSec
      introText
      introAudioUrl
      introAudioFileId
      currentTurn {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
      questions {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
    }
  }
}
    `;
/**
 * __useSubmitOralAssessmentAnswerMutation__
 *
 * To run a mutation, you first call `useSubmitOralAssessmentAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOralAssessmentAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOralAssessmentAnswerMutation, { data, loading, error }] = useSubmitOralAssessmentAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitOralAssessmentAnswerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitOralAssessmentAnswerDocument, options);
}
export const SubmitStudentAssignmentDocument = gql `
    mutation submitStudentAssignment($assignmentId: ID!, $files: [FileInput!]!) {
  submitStudentAssignment(assignmentId: $assignmentId, files: $files) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useSubmitStudentAssignmentMutation__
 *
 * To run a mutation, you first call `useSubmitStudentAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitStudentAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitStudentAssignmentMutation, { data, loading, error }] = useSubmitStudentAssignmentMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitStudentAssignmentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitStudentAssignmentDocument, options);
}
export const UpdateAiTutorDocument = gql `
    mutation UpdateAITutor($id: ID!, $aiTutor: UpdateAITutorInput!) {
  updateAITutor(id: $id, aiTutor: $aiTutor) {
    success
    message
    data {
      id
      title
      description
      targetAudience
      dueDate
      objectives {
        objective
        sequence
        id
      }
    }
  }
}
    `;
/**
 * __useUpdateAiTutorMutation__
 *
 * To run a mutation, you first call `useUpdateAiTutorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiTutorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiTutorMutation, { data, loading, error }] = useUpdateAiTutorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      aiTutor: // value for 'aiTutor'
 *   },
 * });
 */
export function useUpdateAiTutorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAiTutorDocument, options);
}
export const UpdateAssessmentConfigDocument = gql `
    mutation UpdateAssessmentConfig($input: CreateOrUpdateAssessmentInput!) {
  updateAssessmentConfig(input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useUpdateAssessmentConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentConfigMutation, { data, loading, error }] = useUpdateAssessmentConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAssessmentConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAssessmentConfigDocument, options);
}
export const UpdateAssessmentSubmissionGradeDocument = gql `
    mutation updateAssessmentSubmissionGrade($assessmentSubmissionId: ID!, $updatedGradeEntry: UpdateAssessmentSubmissionUpdatedGrade!, $reviewWithoutAdjustment: Boolean) {
  updateAssessmentSubmissionGrade(
    assessmentSubmissionId: $assessmentSubmissionId
    updatedGradeEntry: $updatedGradeEntry
    reviewWithoutAdjustment: $reviewWithoutAdjustment
  ) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useUpdateAssessmentSubmissionGradeMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentSubmissionGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentSubmissionGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentSubmissionGradeMutation, { data, loading, error }] = useUpdateAssessmentSubmissionGradeMutation({
 *   variables: {
 *      assessmentSubmissionId: // value for 'assessmentSubmissionId'
 *      updatedGradeEntry: // value for 'updatedGradeEntry'
 *      reviewWithoutAdjustment: // value for 'reviewWithoutAdjustment'
 *   },
 * });
 */
export function useUpdateAssessmentSubmissionGradeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAssessmentSubmissionGradeDocument, options);
}
export const UpdateCourseDatesDocument = gql `
    mutation UpdateCourseDates($id: ID!, $input: UpdateCourseDatesInput!) {
  updateCourseDates(id: $id, input: $input) {
    success
    data {
      id
    }
  }
}
    `;
/**
 * __useUpdateCourseDatesMutation__
 *
 * To run a mutation, you first call `useUpdateCourseDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseDatesMutation, { data, loading, error }] = useUpdateCourseDatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseDatesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateCourseDatesDocument, options);
}
export const UpdateResourceOrderDocument = gql `
    mutation UpdateResourceOrder($input: UpdateResourceOrderInput!) {
  updateResourceOrder(input: $input) {
    success
    message
    data {
      id
      resourceOrder
    }
  }
}
    `;
/**
 * __useUpdateResourceOrderMutation__
 *
 * To run a mutation, you first call `useUpdateResourceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceOrderMutation, { data, loading, error }] = useUpdateResourceOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResourceOrderMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateResourceOrderDocument, options);
}
export const UpdateStudentAssignmentGradeDocument = gql `
    mutation updateStudentAssignmentGrade($submissionId: ID!, $updatePayload: UpdateStudentAssignmentGradeInput!) {
  updateStudentAssignmentGrade(
    submissionId: $submissionId
    updatePayload: $updatePayload
  ) {
    success
    message
    data {
      id
      feedbackFiles {
        id
        fileName
        fileURL
        filePath
        status
      }
    }
  }
}
    `;
/**
 * __useUpdateStudentAssignmentGradeMutation__
 *
 * To run a mutation, you first call `useUpdateStudentAssignmentGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStudentAssignmentGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStudentAssignmentGradeMutation, { data, loading, error }] = useUpdateStudentAssignmentGradeMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      updatePayload: // value for 'updatePayload'
 *   },
 * });
 */
export function useUpdateStudentAssignmentGradeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateStudentAssignmentGradeDocument, options);
}
export const AddCoursesToDegreeDocument = gql `
    mutation AddCoursesToDegree($input: AddCoursesToDegreeInput!) {
  addCoursesToDegree(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useAddCoursesToDegreeMutation__
 *
 * To run a mutation, you first call `useAddCoursesToDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCoursesToDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCoursesToDegreeMutation, { data, loading, error }] = useAddCoursesToDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCoursesToDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddCoursesToDegreeDocument, options);
}
export const CreateDegreeDocument = gql `
    mutation CreateDegree($name: String!, $schoolId: ID!) {
  createDegree(degree: {name: $name, schoolId: $schoolId}) {
    success
    message
    data {
      id
      name
    }
  }
}
    `;
/**
 * __useCreateDegreeMutation__
 *
 * To run a mutation, you first call `useCreateDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDegreeMutation, { data, loading, error }] = useCreateDegreeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useCreateDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateDegreeDocument, options);
}
export const DeleteDegreeDocument = gql `
    mutation DeleteDegree($id: ID!) {
  deleteDegree(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteDegreeMutation__
 *
 * To run a mutation, you first call `useDeleteDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDegreeMutation, { data, loading, error }] = useDeleteDegreeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteDegreeDocument, options);
}
export const EnrollUserInDegreeDocument = gql `
    mutation EnrollUserInDegree($degreeId: ID!) {
  enrollInDegree(degreeId: $degreeId) {
    success
    data {
      id
      name
      usersEnrolledIn {
        id
      }
    }
  }
}
    `;
/**
 * __useEnrollUserInDegreeMutation__
 *
 * To run a mutation, you first call `useEnrollUserInDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUserInDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollUserInDegreeMutation, { data, loading, error }] = useEnrollUserInDegreeMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useEnrollUserInDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EnrollUserInDegreeDocument, options);
}
export const InviteUsersToEnrollInDegreeDocument = gql `
    mutation InviteUsersToEnrollInDegree($input: InviteUsersToEnrollInDegreeInput!) {
  inviteUsersToEnrollInDegree(input: $input) {
    success
    data {
      email
      id
    }
    count
  }
}
    `;
/**
 * __useInviteUsersToEnrollInDegreeMutation__
 *
 * To run a mutation, you first call `useInviteUsersToEnrollInDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsersToEnrollInDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsersToEnrollInDegreeMutation, { data, loading, error }] = useInviteUsersToEnrollInDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUsersToEnrollInDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(InviteUsersToEnrollInDegreeDocument, options);
}
export const RemoveCoursesFromDegreeDocument = gql `
    mutation RemoveCoursesFromDegree($input: RemoveCoursesFromDegreeInput!) {
  removeCoursesFromDegree(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useRemoveCoursesFromDegreeMutation__
 *
 * To run a mutation, you first call `useRemoveCoursesFromDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCoursesFromDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCoursesFromDegreeMutation, { data, loading, error }] = useRemoveCoursesFromDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCoursesFromDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemoveCoursesFromDegreeDocument, options);
}
export const RemoveStudentsFromDegreeDocument = gql `
    mutation RemoveStudentsFromDegree($input: RemoveStudentsFromDegreeInput!) {
  removeStudentsFromDegree(input: $input) {
    success
    data {
      id
      name
    }
    count
  }
}
    `;
/**
 * __useRemoveStudentsFromDegreeMutation__
 *
 * To run a mutation, you first call `useRemoveStudentsFromDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStudentsFromDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStudentsFromDegreeMutation, { data, loading, error }] = useRemoveStudentsFromDegreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStudentsFromDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemoveStudentsFromDegreeDocument, options);
}
export const UpdateDegreeDocument = gql `
    mutation UpdateDegree($id: ID!, $degree: UpdateDegreeInput!) {
  updateDegree(id: $id, degree: $degree) {
    success
    message
    data {
      id
      name
      description
      usersEnrolledIn {
        id
        name
      }
      coursesHasCourse {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useUpdateDegreeMutation__
 *
 * To run a mutation, you first call `useUpdateDegreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDegreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDegreeMutation, { data, loading, error }] = useUpdateDegreeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      degree: // value for 'degree'
 *   },
 * });
 */
export function useUpdateDegreeMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateDegreeDocument, options);
}
export const CreateAdminDocumentDocument = gql `
    mutation CreateAdminDocument($fileId: ID!, $title: String!) {
  createAdminDocument(fileId: $fileId, title: $title) {
    success
    message
    data {
      id
      title
      status
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;
/**
 * __useCreateAdminDocumentMutation__
 *
 * To run a mutation, you first call `useCreateAdminDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminDocumentMutation, { data, loading, error }] = useCreateAdminDocumentMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateAdminDocumentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateAdminDocumentDocument, options);
}
export const DeleteAdminDocumentDocument = gql `
    mutation DeleteAdminDocument($id: ID!) {
  deleteAdminDocument(id: $id) {
    success
    message
    data {
      id
    }
    count
  }
}
    `;
/**
 * __useDeleteAdminDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteAdminDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminDocumentMutation, { data, loading, error }] = useDeleteAdminDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdminDocumentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAdminDocumentDocument, options);
}
export const UpdateAdminDocumentDocument = gql `
    mutation UpdateAdminDocument($id: ID!, $isPolicy: Boolean!) {
  updateAdminDocument(id: $id, isPolicy: $isPolicy) {
    success
    message
    data {
      id
      title
      status
      adminDoc
      isPolicy
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;
/**
 * __useUpdateAdminDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateAdminDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminDocumentMutation, { data, loading, error }] = useUpdateAdminDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPolicy: // value for 'isPolicy'
 *   },
 * });
 */
export function useUpdateAdminDocumentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateAdminDocumentDocument, options);
}
export const GenerateKeywordsDocument = gql `
    mutation GenerateKeywords($title: String!, $description: String!) {
  generateYoutubeKeywords(title: $title, description: $description)
}
    `;
/**
 * __useGenerateKeywordsMutation__
 *
 * To run a mutation, you first call `useGenerateKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateKeywordsMutation, { data, loading, error }] = useGenerateKeywordsMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useGenerateKeywordsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateKeywordsDocument, options);
}
export const CreateEnrollmentLinkDocument = gql `
    mutation CreateEnrollmentLink($input: CreateEnrollmentLinkInput!) {
  createEnrollmentLink(input: $input) {
    success
    message
    data {
      id
      lastModified
    }
    count
  }
}
    `;
/**
 * __useCreateEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useCreateEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnrollmentLinkMutation, { data, loading, error }] = useCreateEnrollmentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnrollmentLinkMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateEnrollmentLinkDocument, options);
}
export const DeleteEnrollmentLinkDocument = gql `
    mutation DeleteEnrollmentLink($id: ID!) {
  deleteEnrollmentLink(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useDeleteEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEnrollmentLinkMutation, { data, loading, error }] = useDeleteEnrollmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEnrollmentLinkMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteEnrollmentLinkDocument, options);
}
export const EnrollCourseWithTokenDocument = gql `
    mutation EnrollCourseWithToken($token: String!) {
  enrollCourseWithToken(token: $token) {
    success
    message
    data {
      id
      lastModified
      courseId
      courseName
    }
    count
  }
}
    `;
/**
 * __useEnrollCourseWithTokenMutation__
 *
 * To run a mutation, you first call `useEnrollCourseWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollCourseWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollCourseWithTokenMutation, { data, loading, error }] = useEnrollCourseWithTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useEnrollCourseWithTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EnrollCourseWithTokenDocument, options);
}
export const UpdateEnrollmentLinkDocument = gql `
    mutation UpdateEnrollmentLink($id: ID!, $input: UpdateEnrollmentLinkInput!) {
  updateEnrollmentLink(id: $id, input: $input) {
    success
    message
    data {
      id
      lastModified
    }
    count
  }
}
    `;
/**
 * __useUpdateEnrollmentLinkMutation__
 *
 * To run a mutation, you first call `useUpdateEnrollmentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnrollmentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEnrollmentLinkMutation, { data, loading, error }] = useUpdateEnrollmentLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnrollmentLinkMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateEnrollmentLinkDocument, options);
}
export const GenerateUploadUrlDocument = gql `
    mutation GenerateUploadUrl($fileName: String!, $storagePath: StoragePathType!) {
  generateUploadUrl(fileName: $fileName, storagePath: $storagePath) {
    data {
      file {
        id
        fileName
        fileURL
        filePath
        bucketName
        created
        status
      }
      signedUrl
      uniqueFileName
      uploadedFileMimeType
    }
    message
    success
  }
}
    `;
/**
 * __useGenerateUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadUrlMutation, { data, loading, error }] = useGenerateUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      storagePath: // value for 'storagePath'
 *   },
 * });
 */
export function useGenerateUploadUrlMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateUploadUrlDocument, options);
}
export const GetGcpSignedUrlForReadDocument = gql `
    query GetGcpSignedUrlForRead($fileId: ID!, $responseDisposition: String) {
  getGcpSignedUrlForRead(
    fileId: $fileId
    responseDisposition: $responseDisposition
  ) {
    data {
      signedUrl
    }
    message
    success
  }
}
    `;
/**
 * __useGetGcpSignedUrlForReadQuery__
 *
 * To run a query within a React component, call `useGetGcpSignedUrlForReadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGcpSignedUrlForReadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGcpSignedUrlForReadQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      responseDisposition: // value for 'responseDisposition'
 *   },
 * });
 */
export function useGetGcpSignedUrlForReadQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGcpSignedUrlForReadDocument, options);
}
export function useGetGcpSignedUrlForReadLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGcpSignedUrlForReadDocument, options);
}
export function useGetGcpSignedUrlForReadSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGcpSignedUrlForReadDocument, options);
}
export const MakeFilePublicDocument = gql `
    mutation MakeFilePublic($fileId: ID!) {
  makeFilePublic(fileId: $fileId) {
    success
    message
    data {
      id
      fileName
      fileURL
      filePath
      bucketName
      created
      status
    }
  }
}
    `;
/**
 * __useMakeFilePublicMutation__
 *
 * To run a mutation, you first call `useMakeFilePublicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeFilePublicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeFilePublicMutation, { data, loading, error }] = useMakeFilePublicMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useMakeFilePublicMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MakeFilePublicDocument, options);
}
export const UploadFileFromUrlDocument = gql `
    mutation UploadFileFromUrl($url: String!, $storagePath: StoragePathType!, $fileName: String) {
  uploadFileFromUrl(url: $url, storagePath: $storagePath, fileName: $fileName) {
    success
    message
    data {
      id
      fileName
      fileURL
      filePath
      status
    }
    count
  }
}
    `;
/**
 * __useUploadFileFromUrlMutation__
 *
 * To run a mutation, you first call `useUploadFileFromUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileFromUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileFromUrlMutation, { data, loading, error }] = useUploadFileFromUrlMutation({
 *   variables: {
 *      url: // value for 'url'
 *      storagePath: // value for 'storagePath'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useUploadFileFromUrlMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UploadFileFromUrlDocument, options);
}
export const AudioToggleUserDocument = gql `
    mutation AudioToggleUser($audioOn: Boolean!) {
  audioToggleUser(audioOn: $audioOn) {
    audioOn
  }
}
    `;
/**
 * __useAudioToggleUserMutation__
 *
 * To run a mutation, you first call `useAudioToggleUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAudioToggleUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [audioToggleUserMutation, { data, loading, error }] = useAudioToggleUserMutation({
 *   variables: {
 *      audioOn: // value for 'audioOn'
 *   },
 * });
 */
export function useAudioToggleUserMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AudioToggleUserDocument, options);
}
export const HideLearningActivityIntroDocument = gql `
    mutation HideLearningActivityIntro {
  hideLearningActivityIntro {
    success
    message
  }
}
    `;
/**
 * __useHideLearningActivityIntroMutation__
 *
 * To run a mutation, you first call `useHideLearningActivityIntroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideLearningActivityIntroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideLearningActivityIntroMutation, { data, loading, error }] = useHideLearningActivityIntroMutation({
 *   variables: {
 *   },
 * });
 */
export function useHideLearningActivityIntroMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(HideLearningActivityIntroDocument, options);
}
export const UpdateNotificationsSettingDocument = gql `
    mutation UpdateNotificationsSetting($dailyEmailOptIn: Boolean!) {
  updateNotificationsSetting(dailyEmailOptIn: $dailyEmailOptIn) {
    success
    message
  }
}
    `;
/**
 * __useUpdateNotificationsSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsSettingMutation, { data, loading, error }] = useUpdateNotificationsSettingMutation({
 *   variables: {
 *      dailyEmailOptIn: // value for 'dailyEmailOptIn'
 *   },
 * });
 */
export function useUpdateNotificationsSettingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateNotificationsSettingDocument, options);
}
export const UpdateNotificationsEmailSettingDocument = gql `
    mutation UpdateNotificationsEmailSetting($skipAllNotificationEmail: Boolean!) {
  updateNotificationsEmailSetting(
    skipAllNotificationEmail: $skipAllNotificationEmail
  ) {
    success
    message
  }
}
    `;
/**
 * __useUpdateNotificationsEmailSettingMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsEmailSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsEmailSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsEmailSettingMutation, { data, loading, error }] = useUpdateNotificationsEmailSettingMutation({
 *   variables: {
 *      skipAllNotificationEmail: // value for 'skipAllNotificationEmail'
 *   },
 * });
 */
export function useUpdateNotificationsEmailSettingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateNotificationsEmailSettingDocument, options);
}
export const CreateIleDocument = gql `
    mutation CreateILE($ile: CreateILEInput!) {
  createILE(ile: $ile) {
    success
    message
    count
    data {
      id
      title
      description
      created
      lastModified
      ileType
      kgTopicId
      context
      course {
        id
      }
      assignment {
        id
      }
      courseObjectives {
        id
        objective
        sequence
        evalCriteria
      }
      objectives {
        id
        objective
        sequence
        evalCriteria
      }
    }
  }
}
    `;
/**
 * __useCreateIleMutation__
 *
 * To run a mutation, you first call `useCreateIleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIleMutation, { data, loading, error }] = useCreateIleMutation({
 *   variables: {
 *      ile: // value for 'ile'
 *   },
 * });
 */
export function useCreateIleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateIleDocument, options);
}
export const CreateIleFromTopicDocument = gql `
    mutation CreateILEFromTopic($title: String!, $context: String) {
  createILEFromTopic(title: $title, context: $context) {
    success
    jobId
    message
  }
}
    `;
/**
 * __useCreateIleFromTopicMutation__
 *
 * To run a mutation, you first call `useCreateIleFromTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIleFromTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIleFromTopicMutation, { data, loading, error }] = useCreateIleFromTopicMutation({
 *   variables: {
 *      title: // value for 'title'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreateIleFromTopicMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateIleFromTopicDocument, options);
}
export const CreateStandaloneIleDocument = gql `
    mutation CreateStandaloneILE($ile: CreateILEInput!) {
  createILE(ile: $ile) {
    success
    message
    data {
      id
      title
    }
  }
}
    `;
/**
 * __useCreateStandaloneIleMutation__
 *
 * To run a mutation, you first call `useCreateStandaloneIleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStandaloneIleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStandaloneIleMutation, { data, loading, error }] = useCreateStandaloneIleMutation({
 *   variables: {
 *      ile: // value for 'ile'
 *   },
 * });
 */
export function useCreateStandaloneIleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateStandaloneIleDocument, options);
}
export const DeleteIleDocument = gql `
    mutation DeleteILE($id: ID!) {
  deleteILE(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteIleMutation__
 *
 * To run a mutation, you first call `useDeleteIleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIleMutation, { data, loading, error }] = useDeleteIleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIleMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteIleDocument, options);
}
export const AttachExternalContentDocument = gql `
    mutation AttachExternalContent($connectorType: ConnectorType!, $externalItemIds: [String!]!, $targetContext: AttachExternalContentTargetInput!) {
  attachExternalContent(
    connectorType: $connectorType
    externalItemIds: $externalItemIds
    targetContext: $targetContext
  ) {
    success
    message
    count
    data {
      requestedCount
      attachedCount
      failedCount
      failedExternalItemIds
      queuedJobIds
      itemResults {
        externalItemId
        jobId
        success
        message
      }
    }
  }
}
    `;
/**
 * __useAttachExternalContentMutation__
 *
 * To run a mutation, you first call `useAttachExternalContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachExternalContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachExternalContentMutation, { data, loading, error }] = useAttachExternalContentMutation({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *      externalItemIds: // value for 'externalItemIds'
 *      targetContext: // value for 'targetContext'
 *   },
 * });
 */
export function useAttachExternalContentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AttachExternalContentDocument, options);
}
export const ConnectUserAccountDocument = gql `
    mutation ConnectUserAccount($input: ConnectUserAccountInput!) {
  connectUserAccount(input: $input) {
    success
    message
    authorizationUrl
    data {
      id
      status
      healthStatus
      connectorType
      accountIdentifier
      accountEmail: accountIdentifier
      scopes
      permissions: scopes
      lastHealthCheckedAt
      lastHealthError
      lastSyncAt: lastHealthCheckedAt
      lastError
      tokenExpiresAt
      refreshTokenExpiresAt
      revokedAt
      created
      lastModified: last_modified
    }
    pageInfo {
      nextCursor
      hasNextPage
    }
  }
}
    `;
/**
 * __useConnectUserAccountMutation__
 *
 * To run a mutation, you first call `useConnectUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectUserAccountMutation, { data, loading, error }] = useConnectUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConnectUserAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ConnectUserAccountDocument, options);
}
export const DisableConnectorDocument = gql `
    mutation DisableConnector($input: DisableConnectorInput!) {
  disableConnector(input: $input) {
    success
    message
    data {
      id
      connectorType
      status
      enabledRoles
      configSummary
      created
      lastModified
      healthStatus {
        id
        status
        errorMessage
        userConnectionCount
        lastCheckedAt
        created
        lastModified
      }
    }
  }
}
    `;
/**
 * __useDisableConnectorMutation__
 *
 * To run a mutation, you first call `useDisableConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableConnectorMutation, { data, loading, error }] = useDisableConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableConnectorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DisableConnectorDocument, options);
}
export const DisconnectUserAccountDocument = gql `
    mutation DisconnectUserAccount($input: DisconnectUserAccountInput!) {
  disconnectUserAccount(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useDisconnectUserAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectUserAccountMutation, { data, loading, error }] = useDisconnectUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisconnectUserAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DisconnectUserAccountDocument, options);
}
export const EnableConnectorDocument = gql `
    mutation EnableConnector($input: EnableConnectorInput!) {
  enableConnector(input: $input) {
    success
    message
    data {
      id
      connectorType
      status
      enabledRoles
      configSummary
      created
      lastModified
      healthStatus {
        id
        status
        errorMessage
        userConnectionCount
        lastCheckedAt
        created
        lastModified
      }
    }
  }
}
    `;
/**
 * __useEnableConnectorMutation__
 *
 * To run a mutation, you first call `useEnableConnectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableConnectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableConnectorMutation, { data, loading, error }] = useEnableConnectorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableConnectorMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EnableConnectorDocument, options);
}
export const ReconnectUserAccountDocument = gql `
    mutation ReconnectUserAccount($input: ReconnectUserAccountInput!) {
  reconnectUserAccount(input: $input) {
    success
    message
    authorizationUrl
    data {
      id
      status
      healthStatus
      connectorType
      accountIdentifier
      accountEmail: accountIdentifier
      scopes
      permissions: scopes
      lastHealthCheckedAt
      lastHealthError
      lastSyncAt: lastHealthCheckedAt
      lastError
      tokenExpiresAt
      refreshTokenExpiresAt
      revokedAt
      created
      lastModified: last_modified
    }
    pageInfo {
      nextCursor
      hasNextPage
    }
  }
}
    `;
/**
 * __useReconnectUserAccountMutation__
 *
 * To run a mutation, you first call `useReconnectUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconnectUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconnectUserAccountMutation, { data, loading, error }] = useReconnectUserAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReconnectUserAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ReconnectUserAccountDocument, options);
}
export const SetConnectorRoleAccessDocument = gql `
    mutation SetConnectorRoleAccess($input: SetConnectorRoleAccessInput!) {
  setConnectorRoleAccess(input: $input) {
    success
    message
    data {
      id
      connectorType
      status
      enabledRoles
      configSummary
      created
      lastModified
      healthStatus {
        id
        status
        errorMessage
        userConnectionCount
        lastCheckedAt
        created
        lastModified
      }
    }
  }
}
    `;
/**
 * __useSetConnectorRoleAccessMutation__
 *
 * To run a mutation, you first call `useSetConnectorRoleAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConnectorRoleAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConnectorRoleAccessMutation, { data, loading, error }] = useSetConnectorRoleAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetConnectorRoleAccessMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetConnectorRoleAccessDocument, options);
}
export const TestConnectorConnectionDocument = gql `
    mutation TestConnectorConnection($input: TestConnectorConnectionInput!) {
  testConnectorConnection(input: $input) {
    success
    message
    authorizationUrl
  }
}
    `;
/**
 * __useTestConnectorConnectionMutation__
 *
 * To run a mutation, you first call `useTestConnectorConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestConnectorConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testConnectorConnectionMutation, { data, loading, error }] = useTestConnectorConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestConnectorConnectionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(TestConnectorConnectionDocument, options);
}
export const AddToWhitelistDocument = gql `
    mutation AddToWhitelist($email: String!) {
  addToWhitelist(email: $email) {
    email
  }
}
    `;
/**
 * __useAddToWhitelistMutation__
 *
 * To run a mutation, you first call `useAddToWhitelistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToWhitelistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToWhitelistMutation, { data, loading, error }] = useAddToWhitelistMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddToWhitelistMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddToWhitelistDocument, options);
}
export const CompleteCourseInvitationDocument = gql `
    mutation CompleteCourseInvitation($courseId: ID!) {
  completeCourseInvitation(courseId: $courseId) {
    message
    success
  }
}
    `;
/**
 * __useCompleteCourseInvitationMutation__
 *
 * To run a mutation, you first call `useCompleteCourseInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteCourseInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeCourseInvitationMutation, { data, loading, error }] = useCompleteCourseInvitationMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useCompleteCourseInvitationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CompleteCourseInvitationDocument, options);
}
export const CompleteDegreeInvitationDocument = gql `
    mutation CompleteDegreeInvitation($degreeId: ID!) {
  completeDegreeInvitation(degreeId: $degreeId) {
    message
    success
  }
}
    `;
/**
 * __useCompleteDegreeInvitationMutation__
 *
 * To run a mutation, you first call `useCompleteDegreeInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteDegreeInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeDegreeInvitationMutation, { data, loading, error }] = useCompleteDegreeInvitationMutation({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *   },
 * });
 */
export function useCompleteDegreeInvitationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CompleteDegreeInvitationDocument, options);
}
export const CompletePendingInviteDocument = gql `
    mutation CompletePendingInvite($token: String!, $newPassword: String!, $service: String!) {
  completePendingInvite(
    token: $token
    newPassword: $newPassword
    service: $service
  ) {
    message
    success
  }
}
    `;
/**
 * __useCompletePendingInviteMutation__
 *
 * To run a mutation, you first call `useCompletePendingInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePendingInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePendingInviteMutation, { data, loading, error }] = useCompletePendingInviteMutation({
 *   variables: {
 *      token: // value for 'token'
 *      newPassword: // value for 'newPassword'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCompletePendingInviteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CompletePendingInviteDocument, options);
}
export const EnrollUserInCourseDocument = gql `
    mutation EnrollUserInCourse($courseId: ID!) {
  enrollUserInCourse(courseId: $courseId) {
    success
    message
  }
}
    `;
/**
 * __useEnrollUserInCourseMutation__
 *
 * To run a mutation, you first call `useEnrollUserInCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollUserInCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollUserInCourseMutation, { data, loading, error }] = useEnrollUserInCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useEnrollUserInCourseMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EnrollUserInCourseDocument, options);
}
export const GetLearningTtsTokenDocument = gql `
    mutation GetLearningTtsToken {
  getLearningTtsToken {
    token
  }
}
    `;
/**
 * __useGetLearningTtsTokenMutation__
 *
 * To run a mutation, you first call `useGetLearningTtsTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLearningTtsTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLearningTtsTokenMutation, { data, loading, error }] = useGetLearningTtsTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningTtsTokenMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GetLearningTtsTokenDocument, options);
}
export const UpdateLearningObjectiveCompletionDocument = gql `
    mutation UpdateLearningObjectiveCompletion($id: ID!, $completed: Boolean!) {
  updateLearningObjectiveCompletion(id: $id, completed: $completed) {
    success
    message
  }
}
    `;
/**
 * __useUpdateLearningObjectiveCompletionMutation__
 *
 * To run a mutation, you first call `useUpdateLearningObjectiveCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLearningObjectiveCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLearningObjectiveCompletionMutation, { data, loading, error }] = useUpdateLearningObjectiveCompletionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useUpdateLearningObjectiveCompletionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateLearningObjectiveCompletionDocument, options);
}
export const CancelDeepResearchJobDocument = gql `
    mutation CancelDeepResearchJob($jobId: String!) {
  cancelDeepResearchJob(jobId: $jobId) {
    success
    status
    message
  }
}
    `;
/**
 * __useCancelDeepResearchJobMutation__
 *
 * To run a mutation, you first call `useCancelDeepResearchJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDeepResearchJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDeepResearchJobMutation, { data, loading, error }] = useCancelDeepResearchJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelDeepResearchJobMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CancelDeepResearchJobDocument, options);
}
export const MarkNotificationAsReadDocument = gql `
    mutation MarkNotificationAsRead($id: ID!) {
  markNotificationAsRead(id: $id) {
    success
    data {
      id
      title
      message
      created
      isRead
      readAt
      actionUrl
    }
    count
  }
}
    `;
/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkNotificationAsReadDocument, options);
}
export const CreateOAuthClientDocument = gql `
    mutation CreateOAuthClient($input: OAuthClientInput!) {
  createOAuthClient(input: $input) {
    success
    message
    data {
      id
      clientId
      clientSecret
      tenant {
        id
        tenantDomain
      }
      created
    }
    count
  }
}
    `;
/**
 * __useCreateOAuthClientMutation__
 *
 * To run a mutation, you first call `useCreateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuthClientMutation, { data, loading, error }] = useCreateOAuthClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOAuthClientMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateOAuthClientDocument, options);
}
export const DeleteOAuthClientDocument = gql `
    mutation DeleteOAuthClient($id: ID!) {
  deleteOAuthClient(id: $id) {
    success
    message
    count
  }
}
    `;
/**
 * __useDeleteOAuthClientMutation__
 *
 * To run a mutation, you first call `useDeleteOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOAuthClientMutation, { data, loading, error }] = useDeleteOAuthClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOAuthClientMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteOAuthClientDocument, options);
}
export const UpdateOAuthClientDocument = gql `
    mutation UpdateOAuthClient($id: ID!, $input: OAuthClientInput!) {
  updateOAuthClient(id: $id, input: $input) {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;
/**
 * __useUpdateOAuthClientMutation__
 *
 * To run a mutation, you first call `useUpdateOAuthClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOAuthClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOAuthClientMutation, { data, loading, error }] = useUpdateOAuthClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOAuthClientMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateOAuthClientDocument, options);
}
export const SetOnboardingStatusDocument = gql `
    mutation SetOnboardingStatus($isOnboarded: Boolean!) {
  setOnboardingStatus(isOnboarded: $isOnboarded) {
    message
    success
  }
}
    `;
/**
 * __useSetOnboardingStatusMutation__
 *
 * To run a mutation, you first call `useSetOnboardingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOnboardingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOnboardingStatusMutation, { data, loading, error }] = useSetOnboardingStatusMutation({
 *   variables: {
 *      isOnboarded: // value for 'isOnboarded'
 *   },
 * });
 */
export function useSetOnboardingStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetOnboardingStatusDocument, options);
}
export const UpdateUserModalOnboardingDocument = gql `
    mutation UpdateUserModalOnboarding($modalOnboarding: String!) {
  updateUserModalOnboarding(modalOnboarding: $modalOnboarding) {
    modalOnboarding
  }
}
    `;
/**
 * __useUpdateUserModalOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateUserModalOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserModalOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserModalOnboardingMutation, { data, loading, error }] = useUpdateUserModalOnboardingMutation({
 *   variables: {
 *      modalOnboarding: // value for 'modalOnboarding'
 *   },
 * });
 */
export function useUpdateUserModalOnboardingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateUserModalOnboardingDocument, options);
}
export const DeleteAccountDocument = gql `
    mutation deleteAccount {
  deleteAccount {
    success
    message
  }
}
    `;
/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteAccountDocument, options);
}
export const ResetAccountDocument = gql `
    mutation resetAccount {
  resetAccount {
    success
    message
  }
}
    `;
/**
 * __useResetAccountMutation__
 *
 * To run a mutation, you first call `useResetAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetAccountMutation, { data, loading, error }] = useResetAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetAccountMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResetAccountDocument, options);
}
export const AddTodoDocument = gql `
    mutation AddTodo($todo: AddTodoInput!) {
  addTodo(todo: $todo) {
    success
    message
    data {
      id
      name
      description
      date
      completed_date
    }
    count
  }
}
    `;
/**
 * __useAddTodoMutation__
 *
 * To run a mutation, you first call `useAddTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTodoMutation, { data, loading, error }] = useAddTodoMutation({
 *   variables: {
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useAddTodoMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AddTodoDocument, options);
}
export const UpdateTodoDocument = gql `
    mutation UpdateTodo($id: String!, $todo: UpdateTodoInput!) {
  updateTodo(id: $id, todo: $todo) {
    success
    message
    data {
      id
      name
      description
      date
      completed_date
      completed
    }
    count
  }
}
    `;
/**
 * __useUpdateTodoMutation__
 *
 * To run a mutation, you first call `useUpdateTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTodoMutation, { data, loading, error }] = useUpdateTodoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      todo: // value for 'todo'
 *   },
 * });
 */
export function useUpdateTodoMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateTodoDocument, options);
}
export const CreateSamlConfigDocument = gql `
    mutation CreateSamlConfig($input: SamlConfigCreateInput!) {
  createSamlConfig(input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useCreateSamlConfigMutation__
 *
 * To run a mutation, you first call `useCreateSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSamlConfigMutation, { data, loading, error }] = useCreateSamlConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSamlConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateSamlConfigDocument, options);
}
export const CreateTenantDocument = gql `
    mutation CreateTenant($tenant: TenantInput!) {
  createTenant(tenant: $tenant) {
    success
    message
    count
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      courseModernizerEnabled
      courseModernizerOnlyEnabled
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
    }
  }
}
    `;
/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateTenantDocument, options);
}
export const DeleteSamlConfigDocument = gql `
    mutation DeleteSamlConfig($id: ID!) {
  deleteSamlConfig(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteSamlConfigMutation__
 *
 * To run a mutation, you first call `useDeleteSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSamlConfigMutation, { data, loading, error }] = useDeleteSamlConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSamlConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteSamlConfigDocument, options);
}
export const ParseAndSaveSamlMetadataDocument = gql `
    mutation ParseAndSaveSamlMetadata($metadataUrl: String!) {
  parseAndSaveSamlMetadata(metadataUrl: $metadataUrl) {
    success
    message
    data {
      id
      entryPoint
      issuer
      cert
      callbackUrl
      emailAttribute
      firstNameAttribute
      lastNameAttribute
      signRequest
      signatureAlgorithm
      expiry
      tenant {
        id
        tenantDomain
      }
    }
  }
}
    `;
/**
 * __useParseAndSaveSamlMetadataMutation__
 *
 * To run a mutation, you first call `useParseAndSaveSamlMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParseAndSaveSamlMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [parseAndSaveSamlMetadataMutation, { data, loading, error }] = useParseAndSaveSamlMetadataMutation({
 *   variables: {
 *      metadataUrl: // value for 'metadataUrl'
 *   },
 * });
 */
export function useParseAndSaveSamlMetadataMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ParseAndSaveSamlMetadataDocument, options);
}
export const SetNudgeTypeEnabledDocument = gql `
    mutation SetNudgeTypeEnabled($nudgeType: NudgeType!, $enabled: Boolean!) {
  setNudgeTypeEnabled(nudgeType: $nudgeType, enabled: $enabled) {
    success
    message
    count
    data {
      id
      key
      nudgeType
      enabled
      lastModified
    }
  }
}
    `;
/**
 * __useSetNudgeTypeEnabledMutation__
 *
 * To run a mutation, you first call `useSetNudgeTypeEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNudgeTypeEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNudgeTypeEnabledMutation, { data, loading, error }] = useSetNudgeTypeEnabledMutation({
 *   variables: {
 *      nudgeType: // value for 'nudgeType'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetNudgeTypeEnabledMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetNudgeTypeEnabledDocument, options);
}
export const UpdateSamlConfigDocument = gql `
    mutation UpdateSamlConfig($id: ID!, $input: SamlConfigUpdateInput!) {
  updateSamlConfig(id: $id, input: $input) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useUpdateSamlConfigMutation__
 *
 * To run a mutation, you first call `useUpdateSamlConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSamlConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSamlConfigMutation, { data, loading, error }] = useUpdateSamlConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSamlConfigMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateSamlConfigDocument, options);
}
export const UpdateTenantDocument = gql `
    mutation UpdateTenant($id: ID!, $tenant: TenantInput!) {
  updateTenant(id: $id, tenant: $tenant) {
    count
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      deepResearchSupportFlag
      courseModernizerEnabled
      courseModernizerOnlyEnabled
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
      adminEmails
    }
  }
}
    `;
/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateTenantDocument, options);
}
export const UpdateTenantSettingsDocument = gql `
    mutation UpdateTenantSettings($settings: TenantSettingsInput!) {
  updateTenantSettings(settings: $settings) {
    count
    success
    message
    data {
      id
      primaryColor
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      officialTranscriptsUrl
      logo
      htmlEmbedAllowedDomains
      ltiActivitiesEnabled
      termsOfServiceLink
      aiDisclaimerText
    }
  }
}
    `;
/**
 * __useUpdateTenantSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSettingsMutation, { data, loading, error }] = useUpdateTenantSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateTenantSettingsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateTenantSettingsDocument, options);
}
export const UploadFaviconDocument = gql `
    mutation UploadFavicon($favicon: String!, $contentType: String!, $size: Int!) {
  uploadFavicon(favicon: $favicon, contentType: $contentType, size: $size) {
    success
    message
    data
  }
}
    `;
/**
 * __useUploadFaviconMutation__
 *
 * To run a mutation, you first call `useUploadFaviconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFaviconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFaviconMutation, { data, loading, error }] = useUploadFaviconMutation({
 *   variables: {
 *      favicon: // value for 'favicon'
 *      contentType: // value for 'contentType'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadFaviconMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UploadFaviconDocument, options);
}
export const UpdateContentSafetySettingsDocument = gql `
    mutation UpdateContentSafetySettings($settings: ContentSafetySettingsInput!) {
  updateContentSafetySettings(settings: $settings) {
    count
    success
    message
    data {
      sexual
      hate
      harassment
      selfHarm
      violence
      withdrawal
      ada
      sexualEmails
      hateEmails
      harassmentEmails
      selfHarmEmails
      violenceEmails
      withdrawalEmails
      adaEmails
    }
  }
}
    `;
/**
 * __useUpdateContentSafetySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateContentSafetySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSafetySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSafetySettingsMutation, { data, loading, error }] = useUpdateContentSafetySettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateContentSafetySettingsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateContentSafetySettingsDocument, options);
}
export const AcceptAiDisclaimerDocument = gql `
    mutation AcceptAiDisclaimer {
  acceptAiDisclaimer {
    hasAcceptedAiDisclaimer
  }
}
    `;
/**
 * __useAcceptAiDisclaimerMutation__
 *
 * To run a mutation, you first call `useAcceptAiDisclaimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAiDisclaimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAiDisclaimerMutation, { data, loading, error }] = useAcceptAiDisclaimerMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptAiDisclaimerMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AcceptAiDisclaimerDocument, options);
}
export const AssignCourseToFacultyDocument = gql `
    mutation AssignCourseToFaculty($userIds: [ID!]!, $courseId: ID!) {
  assignCourseToFaculty(userIds: $userIds, courseId: $courseId) {
    success
    message
  }
}
    `;
/**
 * __useAssignCourseToFacultyMutation__
 *
 * To run a mutation, you first call `useAssignCourseToFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCourseToFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCourseToFacultyMutation, { data, loading, error }] = useAssignCourseToFacultyMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useAssignCourseToFacultyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AssignCourseToFacultyDocument, options);
}
export const InviteUserToSchoolDocument = gql `
    mutation InviteUserToSchool($input: InviteUserToSchoolInput!) {
  inviteUserToSchool(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useInviteUserToSchoolMutation__
 *
 * To run a mutation, you first call `useInviteUserToSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserToSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserToSchoolMutation, { data, loading, error }] = useInviteUserToSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserToSchoolMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(InviteUserToSchoolDocument, options);
}
export const RemoveCourseAssignmentFromFacultyDocument = gql `
    mutation RemoveCourseAssignmentFromFaculty($userIds: [ID!]!, $courseId: ID!) {
  removeCourseAssignmentFromFaculty(userIds: $userIds, courseId: $courseId) {
    success
    message
  }
}
    `;
/**
 * __useRemoveCourseAssignmentFromFacultyMutation__
 *
 * To run a mutation, you first call `useRemoveCourseAssignmentFromFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCourseAssignmentFromFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCourseAssignmentFromFacultyMutation, { data, loading, error }] = useRemoveCourseAssignmentFromFacultyMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useRemoveCourseAssignmentFromFacultyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RemoveCourseAssignmentFromFacultyDocument, options);
}
export const RevokeFacultyDocument = gql `
    mutation RevokeFaculty($userId: ID!) {
  revokeFaculty(userId: $userId) {
    success
    message
  }
}
    `;
/**
 * __useRevokeFacultyMutation__
 *
 * To run a mutation, you first call `useRevokeFacultyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeFacultyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeFacultyMutation, { data, loading, error }] = useRevokeFacultyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRevokeFacultyMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RevokeFacultyDocument, options);
}
export const UpdateCourseNudgePreferenceDocument = gql `
    mutation UpdateCourseNudgePreference($input: UpdateCourseNudgePreferenceInput!) {
  updateCourseNudgePreference(input: $input) {
    success
    message
    data {
      id
      key
      userId
      courseId
      courseRefType
      enabled
      courseUpdatesEnabled
      facultyUpdatesEnabled
      courseName
      courseCode
      instructorName
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useUpdateCourseNudgePreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateCourseNudgePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseNudgePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseNudgePreferenceMutation, { data, loading, error }] = useUpdateCourseNudgePreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseNudgePreferenceMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateCourseNudgePreferenceDocument, options);
}
export const UpdateFacultyProfileDocument = gql `
    mutation UpdateFacultyProfile($input: UpdateFacultyProfileInput!) {
  updateFacultyProfile(input: $input) {
    success
    message
  }
}
    `;
/**
 * __useUpdateFacultyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateFacultyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFacultyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFacultyProfileMutation, { data, loading, error }] = useUpdateFacultyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFacultyProfileMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateFacultyProfileDocument, options);
}
export const UpdateUserNudgePreferencesDocument = gql `
    mutation UpdateUserNudgePreferences($input: UpdateNudgePreferencesInput!) {
  updateUserNudgePreferences(input: $input) {
    success
    message
    data {
      id
      emailEnabled
      smsEnabled
      smsConsent
      frequency
      preferredSendTime
      timezone
      snoozeAllUntil
      maxEmailPerDay
      maxSmsPerDay
    }
    count
  }
}
    `;
/**
 * __useUpdateUserNudgePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserNudgePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNudgePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNudgePreferencesMutation, { data, loading, error }] = useUpdateUserNudgePreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNudgePreferencesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateUserNudgePreferencesDocument, options);
}
export const UpdateUserLearningPreferencesDocument = gql `
    mutation UpdateUserLearningPreferences($input: UpdateUserLearningPreferencesInput!) {
  updateUserLearningPreferences(input: $input) {
    id
    interests
    careerInterests
    continuingEducation
    skillsToImprove
    learningStyles
    motivations
    semesterGoal
    studyTimePreference
    checkInFrequency
    assignmentReminders
    textReminders
  }
}
    `;
/**
 * __useUpdateUserLearningPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserLearningPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLearningPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLearningPreferencesMutation, { data, loading, error }] = useUpdateUserLearningPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLearningPreferencesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateUserLearningPreferencesDocument, options);
}
export const UpsertCompanionOnboardingStateDocument = gql `
    mutation UpsertCompanionOnboardingState($input: CompanionOnboardingStateInput!) {
  upsertCompanionOnboardingState(input: $input) {
    success
    message
    state {
      status
      step
      deferredUntil
      last_modified
      payload {
        interests
        careerInterests
        continuingEducation
        skillsToImprove
        learningStyles
        motivations
        semesterGoal
        studyTimePreference
        checkInFrequency
        assignmentReminders
        textReminders
      }
    }
  }
}
    `;
/**
 * __useUpsertCompanionOnboardingStateMutation__
 *
 * To run a mutation, you first call `useUpsertCompanionOnboardingStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanionOnboardingStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanionOnboardingStateMutation, { data, loading, error }] = useUpsertCompanionOnboardingStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCompanionOnboardingStateMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpsertCompanionOnboardingStateDocument, options);
}
export const EndVisitSessionDocument = gql `
    mutation EndVisitSession($sessionId: ID!) {
  endVisitSession(sessionId: $sessionId) {
    id
    startTime
    lastActiveTime
    ended
  }
}
    `;
/**
 * __useEndVisitSessionMutation__
 *
 * To run a mutation, you first call `useEndVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endVisitSessionMutation, { data, loading, error }] = useEndVisitSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEndVisitSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(EndVisitSessionDocument, options);
}
export const StartVisitSessionDocument = gql `
    mutation StartVisitSession {
  startVisitSession {
    id
    startTime
    lastActiveTime
  }
}
    `;
/**
 * __useStartVisitSessionMutation__
 *
 * To run a mutation, you first call `useStartVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startVisitSessionMutation, { data, loading, error }] = useStartVisitSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartVisitSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(StartVisitSessionDocument, options);
}
export const TrackPageVisitDocument = gql `
    mutation TrackPageVisit($sessionId: ID!, $path: String!) {
  trackPageVisit(sessionId: $sessionId, path: $path) {
    id
    path
    timestamp
  }
}
    `;
/**
 * __useTrackPageVisitMutation__
 *
 * To run a mutation, you first call `useTrackPageVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackPageVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackPageVisitMutation, { data, loading, error }] = useTrackPageVisitMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useTrackPageVisitMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(TrackPageVisitDocument, options);
}
export const UpdateVisitSessionDocument = gql `
    mutation UpdateVisitSession($sessionId: ID!) {
  updateVisitSession(sessionId: $sessionId) {
    id
    lastActiveTime
  }
}
    `;
/**
 * __useUpdateVisitSessionMutation__
 *
 * To run a mutation, you first call `useUpdateVisitSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitSessionMutation, { data, loading, error }] = useUpdateVisitSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useUpdateVisitSessionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateVisitSessionDocument, options);
}
export const CreateVisualizationFromContentDocument = gql `
    mutation CreateVisualizationFromContent($title: String!, $description: String!, $objectives: [ObjectiveInput!]!) {
  createVisualizationFromContent(
    content: {title: $title, description: $description, objectives: $objectives}
  ) {
    success
    message
    data {
      id
      code
      visualizationType
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useCreateVisualizationFromContentMutation__
 *
 * To run a mutation, you first call `useCreateVisualizationFromContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisualizationFromContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisualizationFromContentMutation, { data, loading, error }] = useCreateVisualizationFromContentMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useCreateVisualizationFromContentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateVisualizationFromContentDocument, options);
}
export const DeleteVisualizationDocument = gql `
    mutation DeleteVisualization($id: ID!) {
  deleteVisualization(id: $id) {
    count
    message
    success
  }
}
    `;
/**
 * __useDeleteVisualizationMutation__
 *
 * To run a mutation, you first call `useDeleteVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisualizationMutation, { data, loading, error }] = useDeleteVisualizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisualizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteVisualizationDocument, options);
}
export const UpdateVisualizationDocument = gql `
    mutation UpdateVisualization($id: ID!, $title: String!, $description: String!, $objectives: [ObjectiveInput!]!) {
  updateVisualization(
    id: $id
    content: {title: $title, description: $description, objectives: $objectives}
  ) {
    success
    message
    data {
      id
      code
      visualizationType
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useUpdateVisualizationMutation__
 *
 * To run a mutation, you first call `useUpdateVisualizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisualizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisualizationMutation, { data, loading, error }] = useUpdateVisualizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *   },
 * });
 */
export function useUpdateVisualizationMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateVisualizationDocument, options);
}
export const GetUserChatMessageAnalyticsDocument = gql `
    query GetUserChatMessageAnalytics($input: UserChatMessageAnalyticsInput!) {
  getUserChatMessageAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      email
      studentMessagesCount
      aiMessagesCount
      totalMessages
    }
    count
    totalCount
    availableCourses {
      id
      name
    }
  }
}
    `;
/**
 * __useGetUserChatMessageAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetUserChatMessageAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChatMessageAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChatMessageAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserChatMessageAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserChatMessageAnalyticsDocument, options);
}
export function useGetUserChatMessageAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserChatMessageAnalyticsDocument, options);
}
export function useGetUserChatMessageAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserChatMessageAnalyticsDocument, options);
}
export const GetGradeWeightingConfigDocument = gql `
    query GetGradeWeightingConfig($courseId: ID!) {
  getGradeWeightingConfig(courseId: $courseId) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useGetGradeWeightingConfigQuery__
 *
 * To run a query within a React component, call `useGetGradeWeightingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradeWeightingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradeWeightingConfigQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetGradeWeightingConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGradeWeightingConfigDocument, options);
}
export function useGetGradeWeightingConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGradeWeightingConfigDocument, options);
}
export function useGetGradeWeightingConfigSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGradeWeightingConfigDocument, options);
}
export const GetGradebookDocument = gql `
    query GetGradebook($input: GetGradebookInput!) {
  getGradebook(input: $input) {
    success
    message
    data {
      totalStudents
      columns {
        activityId
        activityName
        activityType
        moduleName
        moduleId
        maxPoints
        dueDate
      }
      rows {
        percentageScore
        student {
          id
          name
          email
          initials
        }
        cells {
          activityId
          activityName
          activityType
          moduleName
          moduleId
          submissionId
          percentageScore
          status
          dueDate
          submittedOn
          isRetake
          isLate
        }
      }
    }
  }
}
    `;
/**
 * __useGetGradebookQuery__
 *
 * To run a query within a React component, call `useGetGradebookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradebookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradebookQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGradebookQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGradebookDocument, options);
}
export function useGetGradebookLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGradebookDocument, options);
}
export function useGetGradebookSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGradebookDocument, options);
}
export const GetGradebookExportFileDocument = gql `
    query GetGradebookExportFile($courseId: ID!) {
  getGradebookExportFile(courseId: $courseId) {
    success
    message
    data {
      id
      fileURL
    }
  }
}
    `;
/**
 * __useGetGradebookExportFileQuery__
 *
 * To run a query within a React component, call `useGetGradebookExportFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradebookExportFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradebookExportFileQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetGradebookExportFileQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGradebookExportFileDocument, options);
}
export function useGetGradebookExportFileLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGradebookExportFileDocument, options);
}
export function useGetGradebookExportFileSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGradebookExportFileDocument, options);
}
export const SetGradeWeightingEnabledDocument = gql `
    mutation SetGradeWeightingEnabled($courseId: ID!, $enabled: Boolean!) {
  setGradeWeightingEnabled(courseId: $courseId, enabled: $enabled) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useSetGradeWeightingEnabledMutation__
 *
 * To run a mutation, you first call `useSetGradeWeightingEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGradeWeightingEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGradeWeightingEnabledMutation, { data, loading, error }] = useSetGradeWeightingEnabledMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetGradeWeightingEnabledMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetGradeWeightingEnabledDocument, options);
}
export const CreateGradeWeightingCategoryDocument = gql `
    mutation CreateGradeWeightingCategory($input: CreateGradeWeightingCategoryInput!) {
  createGradeWeightingCategory(input: $input) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useCreateGradeWeightingCategoryMutation__
 *
 * To run a mutation, you first call `useCreateGradeWeightingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGradeWeightingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGradeWeightingCategoryMutation, { data, loading, error }] = useCreateGradeWeightingCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGradeWeightingCategoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateGradeWeightingCategoryDocument, options);
}
export const UpdateGradeWeightingCategoryDocument = gql `
    mutation UpdateGradeWeightingCategory($input: UpdateGradeWeightingCategoryInput!) {
  updateGradeWeightingCategory(input: $input) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useUpdateGradeWeightingCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateGradeWeightingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGradeWeightingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGradeWeightingCategoryMutation, { data, loading, error }] = useUpdateGradeWeightingCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGradeWeightingCategoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateGradeWeightingCategoryDocument, options);
}
export const DeleteGradeWeightingCategoryDocument = gql `
    mutation DeleteGradeWeightingCategory($categoryId: ID!) {
  deleteGradeWeightingCategory(categoryId: $categoryId) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useDeleteGradeWeightingCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteGradeWeightingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGradeWeightingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGradeWeightingCategoryMutation, { data, loading, error }] = useDeleteGradeWeightingCategoryMutation({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useDeleteGradeWeightingCategoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteGradeWeightingCategoryDocument, options);
}
export const AssignActivityToGradeWeightingCategoryDocument = gql `
    mutation AssignActivityToGradeWeightingCategory($input: AssignActivityToGradeWeightingCategoryInput!) {
  assignActivityToGradeWeightingCategory(input: $input) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useAssignActivityToGradeWeightingCategoryMutation__
 *
 * To run a mutation, you first call `useAssignActivityToGradeWeightingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignActivityToGradeWeightingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignActivityToGradeWeightingCategoryMutation, { data, loading, error }] = useAssignActivityToGradeWeightingCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignActivityToGradeWeightingCategoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AssignActivityToGradeWeightingCategoryDocument, options);
}
export const UnassignActivityFromGradeWeightingCategoryDocument = gql `
    mutation UnassignActivityFromGradeWeightingCategory($input: UnassignActivityFromGradeWeightingCategoryInput!) {
  unassignActivityFromGradeWeightingCategory(input: $input) {
    success
    message
    count
    data {
      id
      enabled
      courseId
      facultyId
      categories {
        id
        name
        weight
        sortOrder
        assignmentIds
        assessmentIds
        projectIds
      }
    }
  }
}
    `;
/**
 * __useUnassignActivityFromGradeWeightingCategoryMutation__
 *
 * To run a mutation, you first call `useUnassignActivityFromGradeWeightingCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignActivityFromGradeWeightingCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignActivityFromGradeWeightingCategoryMutation, { data, loading, error }] = useUnassignActivityFromGradeWeightingCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignActivityFromGradeWeightingCategoryMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UnassignActivityFromGradeWeightingCategoryDocument, options);
}
export const RequestGradebookExportDocument = gql `
    mutation RequestGradebookExport($input: RequestGradebookExportInput!) {
  requestGradebookExport(input: $input) {
    success
    message
    data {
      jobId
    }
  }
}
    `;
/**
 * __useRequestGradebookExportMutation__
 *
 * To run a mutation, you first call `useRequestGradebookExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestGradebookExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestGradebookExportMutation, { data, loading, error }] = useRequestGradebookExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestGradebookExportMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RequestGradebookExportDocument, options);
}
export const SetGradebookActivityMaxPointsDocument = gql `
    mutation SetGradebookActivityMaxPoints($activityId: ID!, $activityType: GradebookActivityType!, $maxPoints: Float!) {
  setGradebookActivityMaxPoints(
    activityId: $activityId
    activityType: $activityType
    maxPoints: $maxPoints
  ) {
    success
    message
  }
}
    `;
/**
 * __useSetGradebookActivityMaxPointsMutation__
 *
 * To run a mutation, you first call `useSetGradebookActivityMaxPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGradebookActivityMaxPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGradebookActivityMaxPointsMutation, { data, loading, error }] = useSetGradebookActivityMaxPointsMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityType: // value for 'activityType'
 *      maxPoints: // value for 'maxPoints'
 *   },
 * });
 */
export function useSetGradebookActivityMaxPointsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetGradebookActivityMaxPointsDocument, options);
}
export const GetAdminDashboardMetricsDocument = gql `
    query GetAdminDashboardMetrics($schoolId: ID!) {
  getAdminDashboardMetrics(schoolId: $schoolId) {
    success
    message
    data {
      totalStudents
      activeCourses
    }
  }
}
    `;
/**
 * __useGetAdminDashboardMetricsQuery__
 *
 * To run a query within a React component, call `useGetAdminDashboardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDashboardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDashboardMetricsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetAdminDashboardMetricsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAdminDashboardMetricsDocument, options);
}
export function useGetAdminDashboardMetricsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAdminDashboardMetricsDocument, options);
}
export function useGetAdminDashboardMetricsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAdminDashboardMetricsDocument, options);
}
export const GetActivityCompletionDetailsDocument = gql `
    query GetActivityCompletionDetails($aiTutorId: ID!) {
  getActivityCompletionDetails(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      module_id
      module_name
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        objectives {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetActivityCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetActivityCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityCompletionDetailsQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetActivityCompletionDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetActivityCompletionDetailsDocument, options);
}
export function useGetActivityCompletionDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetActivityCompletionDetailsDocument, options);
}
export function useGetActivityCompletionDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetActivityCompletionDetailsDocument, options);
}
export const GetCourseCompletionDetailsDocument = gql `
    query GetCourseCompletionDetails($courseId: ID!) {
  getCourseCompletionDetails(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        modules {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            activities {
              id
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
              details {
                objectives {
                  id
                  label
                  completionStats {
                    completed
                    inProgress
                    notStarted
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetCourseCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCompletionDetailsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseCompletionDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseCompletionDetailsDocument, options);
}
export function useGetCourseCompletionDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseCompletionDetailsDocument, options);
}
export function useGetCourseCompletionDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseCompletionDetailsDocument, options);
}
export const GetCourseCompletionSummaryBySchoolDocument = gql `
    query GetCourseCompletionSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCourseCompletionSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
    }
  }
}
    `;
/**
 * __useGetCourseCompletionSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCourseCompletionSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCompletionSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCompletionSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCourseCompletionSummaryBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseCompletionSummaryBySchoolDocument, options);
}
export function useGetCourseCompletionSummaryBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseCompletionSummaryBySchoolDocument, options);
}
export function useGetCourseCompletionSummaryBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseCompletionSummaryBySchoolDocument, options);
}
export const GetModuleCompletionDetailsDocument = gql `
    query GetModuleCompletionDetails($moduleId: ID!) {
  getModuleCompletionDetails(moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        activities {
          id
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            objectives {
              id
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetModuleCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetModuleCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleCompletionDetailsQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetModuleCompletionDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModuleCompletionDetailsDocument, options);
}
export function useGetModuleCompletionDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModuleCompletionDetailsDocument, options);
}
export function useGetModuleCompletionDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModuleCompletionDetailsDocument, options);
}
export const GetObjectiveCompletionDetailsDocument = gql `
    query GetObjectiveCompletionDetails($objectiveId: ID!) {
  getObjectiveCompletionDetails(objectiveId: $objectiveId) {
    success
    message
    data {
      id
      label
      aiTutor_id
      aiTutor_name
      module_id
      module_name
      course_id
      course_name
      completionStats {
        completed
        inProgress
        notStarted
      }
    }
    count
  }
}
    `;
/**
 * __useGetObjectiveCompletionDetailsQuery__
 *
 * To run a query within a React component, call `useGetObjectiveCompletionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveCompletionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveCompletionDetailsQuery({
 *   variables: {
 *      objectiveId: // value for 'objectiveId'
 *   },
 * });
 */
export function useGetObjectiveCompletionDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetObjectiveCompletionDetailsDocument, options);
}
export function useGetObjectiveCompletionDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetObjectiveCompletionDetailsDocument, options);
}
export function useGetObjectiveCompletionDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetObjectiveCompletionDetailsDocument, options);
}
export const GetActivityAnalyticsByModuleDocument = gql `
    query GetActivityAnalyticsByModule($moduleId: ID!) {
  getActivityAnalyticsByModule(moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      summaries
      success_points_details
      confusion_points_details
      further_recommendations
      details {
        objectives {
          id
          label
          success_points
          confusion_points
          average_time_taken
        }
      }
    }
  }
}
    `;
/**
 * __useGetActivityAnalyticsByModuleQuery__
 *
 * To run a query within a React component, call `useGetActivityAnalyticsByModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityAnalyticsByModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityAnalyticsByModuleQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetActivityAnalyticsByModuleQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetActivityAnalyticsByModuleDocument, options);
}
export function useGetActivityAnalyticsByModuleLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetActivityAnalyticsByModuleDocument, options);
}
export function useGetActivityAnalyticsByModuleSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetActivityAnalyticsByModuleDocument, options);
}
export const GetCourseAnalyticsByIdDocument = gql `
    query GetCourseAnalyticsById($courseId: ID!) {
  getCourseAnalyticsById(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  average_time_taken
                  progress_details {
                    level
                    confusion_points
                    success_points
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    total_time_taken
                  }
                }
              }
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseAnalyticsByIdQuery__
 *
 * To run a query within a React component, call `useGetCourseAnalyticsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAnalyticsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAnalyticsByIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseAnalyticsByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseAnalyticsByIdDocument, options);
}
export function useGetCourseAnalyticsByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseAnalyticsByIdDocument, options);
}
export function useGetCourseAnalyticsByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseAnalyticsByIdDocument, options);
}
export const GetCourseHierarchyDocument = gql `
    query GetCourseHierarchy($schoolId: ID!) {
  getCourseHierarchy(schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      level
      details {
        modules {
          id
          label
          level
          parentCourse {
            id
            label
          }
          details {
            activities {
              id
              label
              level
              parentModule {
                id
                label
              }
              parentCourse {
                id
                label
              }
              details {
                objectives {
                  id
                  label
                  level
                  parentActivity {
                    id
                    label
                  }
                  parentModule {
                    id
                    label
                  }
                  parentCourse {
                    id
                    label
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseHierarchyQuery__
 *
 * To run a query within a React component, call `useGetCourseHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseHierarchyQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCourseHierarchyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseHierarchyDocument, options);
}
export function useGetCourseHierarchyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseHierarchyDocument, options);
}
export function useGetCourseHierarchySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseHierarchyDocument, options);
}
export const GetCoursesSummaryBySchoolDocument = gql `
    query GetCoursesSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  average_time_taken
                  progress_details {
                    level
                    confusion_points
                    success_points
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    total_time_taken
                  }
                }
              }
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCoursesSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCoursesSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesSummaryBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesSummaryBySchoolDocument, options);
}
export function useGetCoursesSummaryBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesSummaryBySchoolDocument, options);
}
export function useGetCoursesSummaryBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesSummaryBySchoolDocument, options);
}
export const GetFacultyTopQuestionsDocument = gql `
    query GetFacultyTopQuestions($courseId: String, $page: Int!, $pageSize: Int!, $scope: TopQuestionScopeFilter) {
  getFacultyTopQuestions(
    courseId: $courseId
    page: $page
    pageSize: $pageSize
    scope: $scope
  ) {
    success
    message
    count
    totalCount
    assignmentCount
    courseCount
    assignmentQuestionCount
    courseQuestionCount
    data {
      questionText
      frequency
      scope
      questionType
      courseId
      courseName
      assignmentId
      assignmentName
    }
  }
}
    `;
/**
 * __useGetFacultyTopQuestionsQuery__
 *
 * To run a query within a React component, call `useGetFacultyTopQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyTopQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyTopQuestionsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetFacultyTopQuestionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFacultyTopQuestionsDocument, options);
}
export function useGetFacultyTopQuestionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFacultyTopQuestionsDocument, options);
}
export function useGetFacultyTopQuestionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFacultyTopQuestionsDocument, options);
}
export const GetModuleAnalyticsByCourseDocument = gql `
    query GetModuleAnalyticsByCourse($courseId: ID!) {
  getModuleAnalyticsByCourse(courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        activities {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
        }
      }
    }
  }
}
    `;
/**
 * __useGetModuleAnalyticsByCourseQuery__
 *
 * To run a query within a React component, call `useGetModuleAnalyticsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleAnalyticsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleAnalyticsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModuleAnalyticsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModuleAnalyticsByCourseDocument, options);
}
export function useGetModuleAnalyticsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModuleAnalyticsByCourseDocument, options);
}
export function useGetModuleAnalyticsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModuleAnalyticsByCourseDocument, options);
}
export const GetObjectiveAnalyticsByActivityDocument = gql `
    query GetObjectiveAnalyticsByActivity($aiTutorId: ID!) {
  getObjectiveAnalyticsByActivity(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      average_time_taken
    }
  }
}
    `;
/**
 * __useGetObjectiveAnalyticsByActivityQuery__
 *
 * To run a query within a React component, call `useGetObjectiveAnalyticsByActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveAnalyticsByActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveAnalyticsByActivityQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetObjectiveAnalyticsByActivityQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetObjectiveAnalyticsByActivityDocument, options);
}
export function useGetObjectiveAnalyticsByActivityLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetObjectiveAnalyticsByActivityDocument, options);
}
export function useGetObjectiveAnalyticsByActivitySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetObjectiveAnalyticsByActivityDocument, options);
}
export const GetCourseInsightsOverviewDocument = gql `
    query GetCourseInsightsOverview($input: GetCourseInsightsOverviewInput!) {
  getCourseInsightsOverview(input: $input) {
    success
    message
    count
    data {
      courseId
      snapshotDate
      courseSnapshot {
        id
        scope
        scopeId
        studentId
        snapshotDate
        progressPct
        totalActivities
        completedActivities
        totalStudents
        assessmentTakenPct
        totalAssessments
        completedAssessments
        aggregateGradePct
        sentiment
        lastActiveAt
        inactivityRisk
        baseRiskScore
        riskScore
        riskLevel
        lastComputedAt
      }
      moduleSnapshots {
        moduleId
        moduleTitle
        moduleDescription
        moduleThumbnail
        snapshot {
          id
          scope
          scopeId
          studentId
          snapshotDate
          progressPct
          totalActivities
          completedActivities
          totalStudents
          assessmentTakenPct
          totalAssessments
          completedAssessments
          aggregateGradePct
          sentiment
          lastActiveAt
          inactivityRisk
          baseRiskScore
          riskScore
          riskLevel
          lastComputedAt
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseInsightsOverviewQuery__
 *
 * To run a query within a React component, call `useGetCourseInsightsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseInsightsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseInsightsOverviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseInsightsOverviewQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseInsightsOverviewDocument, options);
}
export function useGetCourseInsightsOverviewLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseInsightsOverviewDocument, options);
}
export function useGetCourseInsightsOverviewSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseInsightsOverviewDocument, options);
}
export const GetCourseModuleInsightsDocument = gql `
    query GetCourseModuleInsights($courseId: ID!, $snapshotDate: String, $moduleId: ID, $searchQuery: String) {
  getCourseModuleInsights(
    courseId: $courseId
    snapshotDate: $snapshotDate
    moduleId: $moduleId
    searchQuery: $searchQuery
  ) {
    success
    message
    count
    data {
      courseId
      snapshotDate
      summaryCards {
        totalModules
        totalActivities
        avgCompletionPct
        estimatedTotalTimeMinutes
      }
      moduleCards {
        moduleId
        moduleTitle
        moduleDescription
        completionPct
        assessmentTakenPct
        aggregateGradePct
        sentiment
        strugglingStudents {
          userId
          studentName
          progressPct
          assessmentTakenPct
          aggregateGradePct
          sentiment
          riskScore
          riskLevel
          lastActiveAt
          statusSummary
          latestActionLabel
        }
        confusionTopics {
          topicId
          title
          summary
          count
          moduleId
          moduleTitle
        }
        activities {
          id
          title
          activityType
          assessmentType
          assessmentId
          completionPct
          averageScorePct
          averageTimeSeconds
          questionsCount
          assessmentSegment {
            assessmentId
            moduleId
            moduleTitle
            assessmentType
            averageScorePct
            averageTimePerQuestionSeconds
            topBadQuestions {
              questionId
              questionLabel
              attempts
              averageScorePct
            }
            topGoodQuestions {
              questionId
              questionLabel
              attempts
              averageScorePct
            }
          }
          analytics {
            id
            label
            success_points
            confusion_points
            questions_asked
            active_interaction_count
            distractions
            sentiment
            enrollment
            average_time_taken
            summaries
            success_points_details
            confusion_points_details
            further_recommendations
            details {
              objectives {
                id
                label
                success_points
                confusion_points
                average_time_taken
                progress_details {
                  level
                  confusion_points
                  success_points
                  further_recommendations
                  questions_asked
                  distractions
                  sentiment_analysis
                  summary
                  num_messages
                  student_messages_count
                  ai_messages_count
                  average_student_response_time
                  total_time_taken
                }
              }
            }
          }
        }
      }
      courseStrugglingStudents {
        userId
        studentName
        progressPct
        assessmentTakenPct
        aggregateGradePct
        sentiment
        riskScore
        riskLevel
        lastActiveAt
        statusSummary
        latestActionLabel
      }
      courseConfusionTopics {
        topicId
        title
        summary
        count
        moduleId
        moduleTitle
      }
      objectivesNeedingIntervention {
        objectiveId
        objectiveLabel
        moduleId
        moduleTitle
        activityId
        activityTitle
        confusionPoints
      }
      modulesNeedingReview {
        moduleId
        moduleTitle
        confusionPoints
        impactedObjectives
      }
      assessmentSegments {
        assessmentId
        moduleId
        moduleTitle
        assessmentType
        averageScorePct
        averageTimePerQuestionSeconds
        topBadQuestions {
          questionId
          questionLabel
          attempts
          averageScorePct
        }
        topGoodQuestions {
          questionId
          questionLabel
          attempts
          averageScorePct
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseModuleInsightsQuery__
 *
 * To run a query within a React component, call `useGetCourseModuleInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModuleInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModuleInsightsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      snapshotDate: // value for 'snapshotDate'
 *      moduleId: // value for 'moduleId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetCourseModuleInsightsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseModuleInsightsDocument, options);
}
export function useGetCourseModuleInsightsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseModuleInsightsDocument, options);
}
export function useGetCourseModuleInsightsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseModuleInsightsDocument, options);
}
export const GetCourseRosterInsightsDocument = gql `
    query GetCourseRosterInsights($courseId: ID!, $snapshotDate: String, $riskFilter: CourseInsightsRiskLevel, $inactiveOnly: Boolean, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCourseRosterInsights(
    courseId: $courseId
    snapshotDate: $snapshotDate
    riskFilter: $riskFilter
    inactiveOnly: $inactiveOnly
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      courseId
      snapshotDate
      cohortSummary {
        avgCompletionPct
        avgGradePct
        negativeSentimentPct
      }
      needsAttention {
        atRiskStudents {
          userId
          studentName
          progressPct
          assessmentTakenPct
          aggregateGradePct
          sentiment
          riskScore
          riskLevel
          lastActiveAt
          statusSummary
          latestActionLabel
        }
        commonConfusionTopics {
          topicId
          title
          summary
          count
          moduleId
          moduleTitle
        }
        summary {
          atRiskCount
          watchCount
          onTrackCount
        }
      }
      students {
        userId
        studentName
        progressPct
        assessmentTakenPct
        aggregateGradePct
        sentiment
        riskScore
        riskLevel
        lastActiveAt
        statusSummary
        latestActionLabel
      }
      totalCount
    }
  }
}
    `;
/**
 * __useGetCourseRosterInsightsQuery__
 *
 * To run a query within a React component, call `useGetCourseRosterInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseRosterInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseRosterInsightsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      snapshotDate: // value for 'snapshotDate'
 *      riskFilter: // value for 'riskFilter'
 *      inactiveOnly: // value for 'inactiveOnly'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCourseRosterInsightsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseRosterInsightsDocument, options);
}
export function useGetCourseRosterInsightsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseRosterInsightsDocument, options);
}
export function useGetCourseRosterInsightsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseRosterInsightsDocument, options);
}
export const GetCourseStudentInsightsDocument = gql `
    query GetCourseStudentInsights($courseId: ID!, $studentId: ID!, $snapshotDate: String) {
  getCourseStudentInsights(
    courseId: $courseId
    studentId: $studentId
    snapshotDate: $snapshotDate
  ) {
    success
    message
    data {
      courseId
      studentId
      snapshotDate
      student {
        userId
        studentName
        progressPct
        assessmentTakenPct
        aggregateGradePct
        sentiment
        riskScore
        riskLevel
        lastActiveAt
        statusSummary
        latestActionLabel
      }
      email
      enrolledDate
      courseSnapshot {
        id
        scope
        scopeId
        studentId
        snapshotDate
        progressPct
        totalActivities
        completedActivities
        totalStudents
        assessmentTakenPct
        totalAssessments
        completedAssessments
        aggregateGradePct
        sentiment
        lastActiveAt
        inactivityRisk
        baseRiskScore
        riskScore
        riskLevel
        aiAssessmentSummary
        aiRecommendations
        aiNeedsIntervention
        aiGeneratedAt
        lastComputedAt
      }
      confusionTopics {
        topicId
        title
        summary
        count
        activityCount
        moduleId
        moduleTitle
      }
      moduleInsights {
        courseId
        snapshotDate
        summaryCards {
          totalModules
          totalActivities
          avgCompletionPct
          estimatedTotalTimeMinutes
        }
        moduleCards {
          moduleId
          moduleTitle
          moduleDescription
          completionPct
          assessmentTakenPct
          aggregateGradePct
          sentiment
          aiAssessmentSummary
          aiRecommendations
          aiNeedsIntervention
          aiGeneratedAt
          strugglingStudents {
            userId
            studentName
            progressPct
            assessmentTakenPct
            aggregateGradePct
            sentiment
            riskScore
            riskLevel
            lastActiveAt
            statusSummary
            latestActionLabel
          }
          confusionTopics {
            topicId
            title
            summary
            count
            moduleId
            moduleTitle
          }
          activities {
            id
            title
            activityType
            assessmentType
            assessmentId
            status
            completionPct
            averageScorePct
            averageTimeSeconds
            questionsCount
            assessmentSegment {
              assessmentId
              moduleId
              moduleTitle
              assessmentType
              averageScorePct
              averageTimePerQuestionSeconds
              scorePct
              timeSpentSeconds
              correctCount
              totalQuestions
              questionResults {
                questionId
                questionText
                studentAnswer
                correctAnswer
                isCorrect
                scorePct
              }
              topBadQuestions {
                questionId
                questionLabel
                attempts
                averageScorePct
              }
              topGoodQuestions {
                questionId
                questionLabel
                attempts
                averageScorePct
              }
            }
            analytics {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  average_time_taken
                  progress_details {
                    level
                    confusion_points
                    success_points
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    total_time_taken
                  }
                }
              }
            }
          }
        }
        courseStrugglingStudents {
          userId
          studentName
          progressPct
          assessmentTakenPct
          aggregateGradePct
          sentiment
          riskScore
          riskLevel
          lastActiveAt
          statusSummary
          latestActionLabel
        }
        courseConfusionTopics {
          topicId
          title
          summary
          count
          moduleId
          moduleTitle
        }
        objectivesNeedingIntervention {
          objectiveId
          objectiveLabel
          moduleId
          moduleTitle
          activityId
          activityTitle
          confusionPoints
        }
        modulesNeedingReview {
          moduleId
          moduleTitle
          confusionPoints
          impactedObjectives
        }
        assessmentSegments {
          assessmentId
          moduleId
          moduleTitle
          assessmentType
          averageScorePct
          averageTimePerQuestionSeconds
          scorePct
          timeSpentSeconds
          correctCount
          totalQuestions
          questionResults {
            questionId
            questionText
            studentAnswer
            correctAnswer
            isCorrect
            scorePct
          }
          topBadQuestions {
            questionId
            questionLabel
            attempts
            averageScorePct
          }
          topGoodQuestions {
            questionId
            questionLabel
            attempts
            averageScorePct
          }
        }
      }
      recentActivity {
        activityId
        activityTitle
        activityType
        moduleId
        moduleTitle
        status
        lastModified
        created
        totalTimeTaken
      }
    }
  }
}
    `;
/**
 * __useGetCourseStudentInsightsQuery__
 *
 * To run a query within a React component, call `useGetCourseStudentInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseStudentInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseStudentInsightsQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      studentId: // value for 'studentId'
 *      snapshotDate: // value for 'snapshotDate'
 *   },
 * });
 */
export function useGetCourseStudentInsightsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseStudentInsightsDocument, options);
}
export function useGetCourseStudentInsightsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseStudentInsightsDocument, options);
}
export function useGetCourseStudentInsightsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseStudentInsightsDocument, options);
}
export const GetActivityInsightsDataDocument = gql `
    query GetActivityInsightsData($aiTutorId: ID!) {
  getActivityInsightsData(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      success_points_details
      confusion_points_details
      further_recommendations
      average_time_taken
      completion_rate
      student_engagement
      overall_sentiment
    }
  }
}
    `;
/**
 * __useGetActivityInsightsDataQuery__
 *
 * To run a query within a React component, call `useGetActivityInsightsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityInsightsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityInsightsDataQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetActivityInsightsDataQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetActivityInsightsDataDocument, options);
}
export function useGetActivityInsightsDataLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetActivityInsightsDataDocument, options);
}
export function useGetActivityInsightsDataSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetActivityInsightsDataDocument, options);
}
export const GetStudentChatAnalyticsDocument = gql `
    query GetStudentChatAnalytics($studentId: ID!, $schoolId: ID!) {
  getStudentChatAnalytics(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      courseId
      courseName
      moduleId
      moduleName
      activityId
      activityName
      sentiment_analysis
      num_messages
      student_messages_count
      ai_messages_count
      average_student_response_time
      total_time_taken
    }
  }
}
    `;
/**
 * __useGetStudentChatAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetStudentChatAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentChatAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentChatAnalyticsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentChatAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentChatAnalyticsDocument, options);
}
export function useGetStudentChatAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentChatAnalyticsDocument, options);
}
export function useGetStudentChatAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentChatAnalyticsDocument, options);
}
export const GetStudentLearningInsightsDocument = gql `
    query GetStudentLearningInsights($studentId: ID!, $schoolId: ID!) {
  getStudentLearningInsights(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      success_points_details
      confusion_points_details
      further_recommendations
      total_time_taken
      active_interaction_count
      total_sessions
      questions_asked
    }
  }
}
    `;
/**
 * __useGetStudentLearningInsightsQuery__
 *
 * To run a query within a React component, call `useGetStudentLearningInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentLearningInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentLearningInsightsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentLearningInsightsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentLearningInsightsDocument, options);
}
export function useGetStudentLearningInsightsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentLearningInsightsDocument, options);
}
export function useGetStudentLearningInsightsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentLearningInsightsDocument, options);
}
export const GetAiTutorLtiAnalyticsDocument = gql `
    query GetAITutorLtiAnalytics($aiTutorId: ID!) {
  getAITutorLtiAnalytics(aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      aiTutor_id
      aiTutor_name
      aiTutor_description
      dueDate
      context
      created
      lastModified
      student_count
      completion_rate
      average_progress
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      enrollment
      sentimentScore
      sentimentCount
      totalTimeTaken
      average_time_taken
      further_recommendations
      sentiment
      summaries
      success_points_details
      confusion_points_details
      recent_activity {
        student_id
        student_name
        student_email
        objective_id
        objective_label
        status
        sentiment
        questions_asked
        student_messages_count
        ai_messages_count
        average_student_response_time
        total_time_taken
        success_points_count
        confusion_points_count
        last_modified
      }
      students {
        student_id
        student_name
        student_email
        status
        time_spent
        questions_asked
        success_points_count
        confusion_points_count
        sentiment
        ai_messages_count
        average_student_response_time
      }
    }
  }
}
    `;
/**
 * __useGetAiTutorLtiAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAiTutorLtiAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiTutorLtiAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiTutorLtiAnalyticsQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetAiTutorLtiAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAiTutorLtiAnalyticsDocument, options);
}
export function useGetAiTutorLtiAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAiTutorLtiAnalyticsDocument, options);
}
export function useGetAiTutorLtiAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAiTutorLtiAnalyticsDocument, options);
}
export const GetStudentActivityProgressDocument = gql `
    query GetStudentActivityProgress($studentId: ID!, $aiTutorId: ID!) {
  getStudentActivityProgress(studentId: $studentId, aiTutorId: $aiTutorId) {
    success
    message
    count
    data {
      id
      label
      module_id
      module_name
      course_id
      course_name
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      chatAnalytics {
        id
        level
        confusion_points
        success_points
        further_recommendations
        questions_asked
        distractions
        sentiment_analysis
        summary
        num_messages
        student_messages_count
        ai_messages_count
        average_student_response_time
        total_time_taken
      }
      details {
        objectives {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          status
          progress_details {
            level
            confusion_points
            success_points
            further_recommendations
            questions_asked
            distractions
            sentiment_analysis
            summary
            num_messages
            student_messages_count
            ai_messages_count
            average_student_response_time
            total_time_taken
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentActivityProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentActivityProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentActivityProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentActivityProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetStudentActivityProgressQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentActivityProgressDocument, options);
}
export function useGetStudentActivityProgressLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentActivityProgressDocument, options);
}
export function useGetStudentActivityProgressSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentActivityProgressDocument, options);
}
export const GetStudentCourseProgressDocument = gql `
    query GetStudentCourseProgress($studentId: ID!, $courseId: ID!) {
  getStudentCourseProgress(studentId: $studentId, courseId: $courseId) {
    success
    message
    count
    data {
      id
      label
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        modules {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            activities {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                objectives {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  status
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentCourseProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetStudentCourseProgressQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentCourseProgressDocument, options);
}
export function useGetStudentCourseProgressLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentCourseProgressDocument, options);
}
export function useGetStudentCourseProgressSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentCourseProgressDocument, options);
}
export const GetStudentDetailedAnalyticsDocument = gql `
    query GetStudentDetailedAnalytics($studentId: ID!, $schoolId: ID!) {
  getStudentDetailedAnalytics(studentId: $studentId, schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      status
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        courses {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            modules {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                activities {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  completion_percentage
                  total_time_taken
                  chatAnalytics {
                    id
                    level
                    confusion_points
                    success_points
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    total_time_taken
                  }
                  details {
                    objectives {
                      id
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                      status
                      progress_details {
                        level
                        confusion_points
                        success_points
                        further_recommendations
                        questions_asked
                        distractions
                        sentiment_analysis
                        summary
                        num_messages
                        student_messages_count
                        ai_messages_count
                        average_student_response_time
                        total_time_taken
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentDetailedAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetStudentDetailedAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentDetailedAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentDetailedAnalyticsQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentDetailedAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentDetailedAnalyticsDocument, options);
}
export function useGetStudentDetailedAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentDetailedAnalyticsDocument, options);
}
export function useGetStudentDetailedAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentDetailedAnalyticsDocument, options);
}
export const GetStudentModuleProgressDocument = gql `
    query GetStudentModuleProgress($studentId: ID!, $moduleId: ID!) {
  getStudentModuleProgress(studentId: $studentId, moduleId: $moduleId) {
    success
    message
    count
    data {
      id
      label
      course_id
      course_name
      student_id
      student_name
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        activities {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            objectives {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              status
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentModuleProgressQuery__
 *
 * To run a query within a React component, call `useGetStudentModuleProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentModuleProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentModuleProgressQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetStudentModuleProgressQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentModuleProgressDocument, options);
}
export function useGetStudentModuleProgressLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentModuleProgressDocument, options);
}
export function useGetStudentModuleProgressSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentModuleProgressDocument, options);
}
export const GetStudentsSummaryBySchoolDocument = gql `
    query GetStudentsSummaryBySchool($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsSummaryBySchool(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      total_time_taken
      schoolEnrollmentDate
    }
  }
}
    `;
/**
 * __useGetStudentsSummaryBySchoolQuery__
 *
 * To run a query within a React component, call `useGetStudentsSummaryBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsSummaryBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsSummaryBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsSummaryBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentsSummaryBySchoolDocument, options);
}
export function useGetStudentsSummaryBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentsSummaryBySchoolDocument, options);
}
export function useGetStudentsSummaryBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentsSummaryBySchoolDocument, options);
}
export const GetAuditEventsDocument = gql `
    query GetAuditEvents($filter: AuditEventFilter) {
  getAuditEvents(filter: $filter) {
    success
    message
    data {
      id
      type
      occurredAt
      tenantId
      actorId
      subjectType
      subjectId
      relatedUserId
      diffKeys
      diffBefore
      diffAfter
      connectorType
      connectorInstanceId
      externalItemId
      durationMs
      errorContext
      actor {
        id
        name
        email
      }
      subjectCourse {
        id
        name
      }
      subjectDegree {
        id
        name
      }
      subjectUser {
        id
        name
        email
      }
      subjectConnectorInstance {
        id
        connectorType
        status
      }
    }
    count
  }
}
    `;
/**
 * __useGetAuditEventsQuery__
 *
 * To run a query within a React component, call `useGetAuditEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAuditEventsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAuditEventsDocument, options);
}
export function useGetAuditEventsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAuditEventsDocument, options);
}
export function useGetAuditEventsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAuditEventsDocument, options);
}
export const GetUserPermissionsDocument = gql `
    query GetUserPermissions {
  getUserPermissions
}
    `;
/**
 * __useGetUserPermissionsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPermissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserPermissionsDocument, options);
}
export function useGetUserPermissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserPermissionsDocument, options);
}
export function useGetUserPermissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserPermissionsDocument, options);
}
export const ValidateSessionDocument = gql `
    query ValidateSession {
  validateSession {
    isValid
  }
}
    `;
/**
 * __useValidateSessionQuery__
 *
 * To run a query within a React component, call `useValidateSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useValidateSessionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ValidateSessionDocument, options);
}
export function useValidateSessionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ValidateSessionDocument, options);
}
export function useValidateSessionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ValidateSessionDocument, options);
}
export const CareerByIdDocument = gql `
    query CareerById($id: ID!) {
  getCareerById(id: $id) {
    id
    name
    brief_description
    description
    created
    last_modified
    path
    trends
    pros
    cons
    skills
    core_skills
    growth
    salary
    url
  }
}
    `;
/**
 * __useCareerByIdQuery__
 *
 * To run a query within a React component, call `useCareerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCareerByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CareerByIdDocument, options);
}
export function useCareerByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CareerByIdDocument, options);
}
export function useCareerByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CareerByIdDocument, options);
}
export const GetCareerHeaderDocument = gql `
    query GetCareerHeader {
  getCareerHeader {
    jobTitle
    careerGoal
    careerName
    careerId
  }
}
    `;
/**
 * __useGetCareerHeaderQuery__
 *
 * To run a query within a React component, call `useGetCareerHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCareerHeaderQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCareerHeaderDocument, options);
}
export function useGetCareerHeaderLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCareerHeaderDocument, options);
}
export function useGetCareerHeaderSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCareerHeaderDocument, options);
}
export const GetCareerTopicsDocument = gql `
    query getCareerTopics($careerId: ID!) {
  getCareerTopics(careerId: $careerId) {
    name
    description
    mastery
  }
}
    `;
/**
 * __useGetCareerTopicsQuery__
 *
 * To run a query within a React component, call `useGetCareerTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerTopicsQuery({
 *   variables: {
 *      careerId: // value for 'careerId'
 *   },
 * });
 */
export function useGetCareerTopicsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCareerTopicsDocument, options);
}
export function useGetCareerTopicsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCareerTopicsDocument, options);
}
export function useGetCareerTopicsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCareerTopicsDocument, options);
}
export const GetCareersDocument = gql `
    query GetCareers {
  getCareers {
    id
    name
    brief_description
    description
    created
    last_modified
    path
    trends
    pros
    cons
    skills
    core_skills
    growth
    salary
    url
  }
}
    `;
/**
 * __useGetCareersQuery__
 *
 * To run a query within a React component, call `useGetCareersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCareersQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCareersDocument, options);
}
export function useGetCareersLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCareersDocument, options);
}
export function useGetCareersSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCareersDocument, options);
}
export const DailyLimitDocument = gql `
    query DailyLimit {
  getDailyLimit {
    dailyRequests
    result
  }
}
    `;
/**
 * __useDailyLimitQuery__
 *
 * To run a query within a React component, call `useDailyLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyLimitQuery({
 *   variables: {
 *   },
 * });
 */
export function useDailyLimitQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(DailyLimitDocument, options);
}
export function useDailyLimitLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(DailyLimitDocument, options);
}
export function useDailyLimitSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DailyLimitDocument, options);
}
export const GetChatByContextAndParamsDocument = gql `
    query GetChatByContextAndParams($context: String!, $params: JSON) {
  getChatByContextAndParams(context: $context, params: $params) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;
/**
 * __useGetChatByContextAndParamsQuery__
 *
 * To run a query within a React component, call `useGetChatByContextAndParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByContextAndParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByContextAndParamsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetChatByContextAndParamsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetChatByContextAndParamsDocument, options);
}
export function useGetChatByContextAndParamsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetChatByContextAndParamsDocument, options);
}
export function useGetChatByContextAndParamsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetChatByContextAndParamsDocument, options);
}
export const GetChatByIdDocument = gql `
    query GetChatById($id: ID!) {
  getChatById(id: $id) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;
/**
 * __useGetChatByIdQuery__
 *
 * To run a query within a React component, call `useGetChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetChatByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetChatByIdDocument, options);
}
export function useGetChatByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetChatByIdDocument, options);
}
export function useGetChatByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetChatByIdDocument, options);
}
export const GetChatByObjectIdDocument = gql `
    query GetChatByObjectId($objectId: ID!, $context: String!) {
  getChatByObjectId(objectId: $objectId, context: $context) {
    id
    date
    name
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;
/**
 * __useGetChatByObjectIdQuery__
 *
 * To run a query within a React component, call `useGetChatByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatByObjectIdQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetChatByObjectIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetChatByObjectIdDocument, options);
}
export function useGetChatByObjectIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetChatByObjectIdDocument, options);
}
export function useGetChatByObjectIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetChatByObjectIdDocument, options);
}
export const GetChatsDocument = gql `
    query GetChats {
  getChats {
    id
    date
    name
    objectId
    context
    params
    url
  }
}
    `;
/**
 * __useGetChatsQuery__
 *
 * To run a query within a React component, call `useGetChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChatsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetChatsDocument, options);
}
export function useGetChatsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetChatsDocument, options);
}
export function useGetChatsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetChatsDocument, options);
}
export const GetCompanionChatByAiTutorIdDocument = gql `
    query GetCompanionChatByAiTutorId($aiTutorId: ID!) {
  getCompanionChatByAiTutorId(aiTutorId: $aiTutorId) {
    success
    message
    data {
      id
      date
      name
      objectId
      params
      url
      last_modified
      created
      workspacesHasChat {
        id
        name
        created
        lastModified
        type
      }
      conversation {
        id
        sender
        content
        aspectDetails {
          type
          text
        }
        created
        feedback
        metadata
        createdILE {
          id
          title
          description
          objectives {
            id
            objective
            sequence
            evalCriteria
          }
        }
        todos {
          id
          name
          priority
          completed
          date
        }
        assignments {
          id
          name
          course_id
          due_date
        }
        files {
          id
          fileName
        }
        visualizationBlocks {
          id
          visualizationId
          visualizationType
          visualizationDescription
          content
          mediaChat {
            id
          }
        }
        mcqQuestionBlocks {
          id
          questionId
          question
          choices
          selectedChoiceIndex
          answerSubmitted
        }
        subjectiveQuestionBlocks {
          id
          questionId
          question
        }
        imageBlocks {
          id
          status
          url
          description
        }
        videoBlocks {
          id
          videoId
          title
          url
          thumbnailUrl
          startTime
          endTime
          segmentSummary
          mediaChat {
            id
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCompanionChatByAiTutorIdQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatByAiTutorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatByAiTutorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatByAiTutorIdQuery({
 *   variables: {
 *      aiTutorId: // value for 'aiTutorId'
 *   },
 * });
 */
export function useGetCompanionChatByAiTutorIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCompanionChatByAiTutorIdDocument, options);
}
export function useGetCompanionChatByAiTutorIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCompanionChatByAiTutorIdDocument, options);
}
export function useGetCompanionChatByAiTutorIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCompanionChatByAiTutorIdDocument, options);
}
export const GetCompanionChatByIdDocument = gql `
    query GetCompanionChatById($id: ID!) {
  getCompanionChatById(id: $id) {
    success
    message
    data {
      id
      date
      name
      objectId
      params
      url
      last_modified
      created
      workspacesHasChat {
        id
        name
        created
        lastModified
        type
      }
      conversation {
        id
        index
        sender
        content
        aspectDetails {
          type
          text
        }
        created
        feedback
        selectedBranchId
        branches {
          id
          created
          anchorMessageId
        }
        metadata
        createdILE {
          id
          title
          description
          objectives {
            id
            objective
            sequence
            evalCriteria
          }
        }
        todos {
          id
          name
          priority
          completed
          date
        }
        assignments {
          id
          name
          course_id
          due_date
        }
        files {
          id
          fileName
        }
        imageBlocks {
          id
          status
          url
          jobId
          description
        }
        mcqQuestionBlocks {
          id
          questionId
          question
          choices
          selectedChoiceIndex
          answerSubmitted
        }
        subjectiveQuestionBlocks {
          id
          questionId
          question
        }
        videoBlocks {
          id
          videoId
          title
          url
          thumbnailUrl
          startTime
          endTime
          segmentSummary
          mediaChat {
            id
          }
        }
        visualizationBlocks {
          id
          visualizationId
          visualizationType
          visualizationDescription
          content
          mediaChat {
            id
          }
        }
        deepResearchDurationSeconds
        deepResearchSources {
          id
          url
          title
        }
      }
    }
  }
}
    `;
/**
 * __useGetCompanionChatByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanionChatByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCompanionChatByIdDocument, options);
}
export function useGetCompanionChatByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCompanionChatByIdDocument, options);
}
export function useGetCompanionChatByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCompanionChatByIdDocument, options);
}
export const GetFlaggedMessagesDocument = gql `
    query GetFlaggedMessages($page: Int!, $pageSize: Int!) {
  getFlaggedMessages(page: $page, pageSize: $pageSize) {
    success
    message
    count
    data {
      messageId
      studentName
      studentEmail
      categories
      severity
      time
      caseDetails
    }
  }
}
    `;
/**
 * __useGetFlaggedMessagesQuery__
 *
 * To run a query within a React component, call `useGetFlaggedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlaggedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlaggedMessagesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetFlaggedMessagesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFlaggedMessagesDocument, options);
}
export function useGetFlaggedMessagesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFlaggedMessagesDocument, options);
}
export function useGetFlaggedMessagesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFlaggedMessagesDocument, options);
}
export const TodayChatDocument = gql `
    query TodayChat($timezone: String!) {
  getTodayChat(timezone: $timezone) {
    id
    date
    name
    timezone
    objectId
    context
    params
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;
/**
 * __useTodayChatQuery__
 *
 * To run a query within a React component, call `useTodayChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodayChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodayChatQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useTodayChatQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(TodayChatDocument, options);
}
export function useTodayChatLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(TodayChatDocument, options);
}
export function useTodayChatSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(TodayChatDocument, options);
}
export const GetAllCompanionChatsForUserDocument = gql `
    query getAllCompanionChatsForUser {
  getAllCompanionChatsForUser {
    success
    message
    data {
      generalChats {
        id
        name
        last_modified
        created
      }
      generalChatsCount
      courseWorkspaces {
        id
        name
        created
        lastModified
        key
        chats {
          id
          name
          last_modified
          created
        }
      }
    }
  }
}
    `;
/**
 * __useGetAllCompanionChatsForUserQuery__
 *
 * To run a query within a React component, call `useGetAllCompanionChatsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompanionChatsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompanionChatsForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCompanionChatsForUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllCompanionChatsForUserDocument, options);
}
export function useGetAllCompanionChatsForUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllCompanionChatsForUserDocument, options);
}
export function useGetAllCompanionChatsForUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllCompanionChatsForUserDocument, options);
}
export const GetCompanionChatsForUserPreviewDocument = gql `
    query getCompanionChatsForUserPreview($limit: Int!) {
  getCompanionChatsForUserPreview(limit: $limit) {
    success
    message
    data {
      generalChats {
        id
        name
        last_modified
        created
      }
      generalChatsCount
      courseWorkspaces {
        id
        name
        created
        lastModified
        key
        totalCount
        chats {
          id
          name
          last_modified
          created
        }
      }
    }
  }
}
    `;
/**
 * __useGetCompanionChatsForUserPreviewQuery__
 *
 * To run a query within a React component, call `useGetCompanionChatsForUserPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionChatsForUserPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionChatsForUserPreviewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanionChatsForUserPreviewQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCompanionChatsForUserPreviewDocument, options);
}
export function useGetCompanionChatsForUserPreviewLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCompanionChatsForUserPreviewDocument, options);
}
export function useGetCompanionChatsForUserPreviewSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCompanionChatsForUserPreviewDocument, options);
}
export const GetCompanionWorkspaceChatsDocument = gql `
    query getCompanionWorkspaceChats($workspaceId: ID!, $offset: Int!, $limit: Int!) {
  getCompanionWorkspaceChats(
    workspaceId: $workspaceId
    offset: $offset
    limit: $limit
  ) {
    totalCount
    chats {
      id
      name
      last_modified
      created
    }
  }
}
    `;
/**
 * __useGetCompanionWorkspaceChatsQuery__
 *
 * To run a query within a React component, call `useGetCompanionWorkspaceChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanionWorkspaceChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanionWorkspaceChatsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanionWorkspaceChatsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCompanionWorkspaceChatsDocument, options);
}
export function useGetCompanionWorkspaceChatsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCompanionWorkspaceChatsDocument, options);
}
export function useGetCompanionWorkspaceChatsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCompanionWorkspaceChatsDocument, options);
}
export const GetGeneralCompanionChatsForUserDocument = gql `
    query getGeneralCompanionChatsForUser($offset: Int!, $limit: Int!) {
  getGeneralCompanionChatsForUser(offset: $offset, limit: $limit) {
    totalCount
    chats {
      id
      name
      last_modified
      created
    }
  }
}
    `;
/**
 * __useGetGeneralCompanionChatsForUserQuery__
 *
 * To run a query within a React component, call `useGetGeneralCompanionChatsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralCompanionChatsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralCompanionChatsForUserQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGeneralCompanionChatsForUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGeneralCompanionChatsForUserDocument, options);
}
export function useGetGeneralCompanionChatsForUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGeneralCompanionChatsForUserDocument, options);
}
export function useGetGeneralCompanionChatsForUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGeneralCompanionChatsForUserDocument, options);
}
export const GetContentByIdDocument = gql `
    query GetContentById($id: ID!) {
  getContentById(id: $id) {
    id
    name
    standard
    weeks
    objectives
    modules {
      module_name
      assignments {
        assignment_name
        html
      }
    }
    created
    last_modified
  }
}
    `;
/**
 * __useGetContentByIdQuery__
 *
 * To run a query within a React component, call `useGetContentByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContentByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetContentByIdDocument, options);
}
export function useGetContentByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetContentByIdDocument, options);
}
export function useGetContentByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetContentByIdDocument, options);
}
export const GetGeneratedContentDocument = gql `
    query GetGeneratedContent {
  getGeneratedContent {
    id
    name
    standard
    weeks
    objectives
    modules {
      module_name
      assignments {
        assignment_name
        html
      }
    }
    created
    last_modified
  }
}
    `;
/**
 * __useGetGeneratedContentQuery__
 *
 * To run a query within a React component, call `useGetGeneratedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneratedContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneratedContentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGeneratedContentDocument, options);
}
export function useGetGeneratedContentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGeneratedContentDocument, options);
}
export function useGetGeneratedContentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGeneratedContentDocument, options);
}
export const ActiveRubricSetDocument = gql `
    query ActiveRubricSet {
  activeRubricSet {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
        title
        description
        originalTitle
        originalDescription
        isEdited
        displayOrder
        sourceLocator
        criteria {
          id
          code
          title
          description
          originalTitle
          originalDescription
          originalSectionId
          isEdited
          isDeleted
          scoringGuidance
          maxScore
          category
          confidence
          displayOrder
          sourceExcerpt
        }
      }
    }
  }
}
    `;
/**
 * __useActiveRubricSetQuery__
 *
 * To run a query within a React component, call `useActiveRubricSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveRubricSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveRubricSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveRubricSetQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ActiveRubricSetDocument, options);
}
export function useActiveRubricSetLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ActiveRubricSetDocument, options);
}
export function useActiveRubricSetSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ActiveRubricSetDocument, options);
}
export const InstitutionalGuidelineDocument = gql `
    query InstitutionalGuideline($id: ID!) {
  institutionalGuideline(id: $id) {
    success
    message
    count
    data {
      id
      name
      summary
      processingStatus
      processingError
      created
      lastModified
      sourceFile {
        id
        fileName
      }
    }
  }
}
    `;
/**
 * __useInstitutionalGuidelineQuery__
 *
 * To run a query within a React component, call `useInstitutionalGuidelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstitutionalGuidelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstitutionalGuidelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstitutionalGuidelineQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InstitutionalGuidelineDocument, options);
}
export function useInstitutionalGuidelineLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InstitutionalGuidelineDocument, options);
}
export function useInstitutionalGuidelineSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InstitutionalGuidelineDocument, options);
}
export const InstitutionalGuidelinesBySchoolDocument = gql `
    query InstitutionalGuidelinesBySchool {
  institutionalGuidelinesBySchool {
    success
    message
    count
    data {
      id
      name
      summary
      processingStatus
      processingError
      created
      lastModified
      sourceFile {
        id
        fileName
      }
    }
  }
}
    `;
/**
 * __useInstitutionalGuidelinesBySchoolQuery__
 *
 * To run a query within a React component, call `useInstitutionalGuidelinesBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstitutionalGuidelinesBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstitutionalGuidelinesBySchoolQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstitutionalGuidelinesBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InstitutionalGuidelinesBySchoolDocument, options);
}
export function useInstitutionalGuidelinesBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InstitutionalGuidelinesBySchoolDocument, options);
}
export function useInstitutionalGuidelinesBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InstitutionalGuidelinesBySchoolDocument, options);
}
export const RubricSetDocument = gql `
    query RubricSet($id: ID!) {
  rubricSet(id: $id) {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
        title
        description
        originalTitle
        originalDescription
        isEdited
        displayOrder
        sourceLocator
        criteria {
          id
          code
          title
          description
          originalTitle
          originalDescription
          originalSectionId
          isEdited
          isDeleted
          scoringGuidance
          maxScore
          category
          confidence
          displayOrder
          sourceExcerpt
        }
      }
    }
  }
}
    `;
/**
 * __useRubricSetQuery__
 *
 * To run a query within a React component, call `useRubricSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubricSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubricSetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRubricSetQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(RubricSetDocument, options);
}
export function useRubricSetLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(RubricSetDocument, options);
}
export function useRubricSetSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(RubricSetDocument, options);
}
export const RubricSetParseStatusDocument = gql `
    query RubricSetParseStatus($id: ID!) {
  rubricSet(id: $id) {
    success
    message
    count
    data {
      id
      name
      detectedFrameworkType
      parseStatus
      parseError
      lastModified
    }
  }
}
    `;
/**
 * __useRubricSetParseStatusQuery__
 *
 * To run a query within a React component, call `useRubricSetParseStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubricSetParseStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubricSetParseStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRubricSetParseStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(RubricSetParseStatusDocument, options);
}
export function useRubricSetParseStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(RubricSetParseStatusDocument, options);
}
export function useRubricSetParseStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(RubricSetParseStatusDocument, options);
}
export const RubricSetsBySchoolDocument = gql `
    query RubricSetsBySchool {
  rubricSetsBySchool {
    success
    message
    count
    data {
      id
      name
      frameworkTypeHint
      detectedFrameworkType
      parseStatus
      isActive
      isArchived
      parserVersion
      parseWarnings
      parseError
      confidence
      created
      lastModified
      sourceFile {
        id
        fileName
      }
      sections {
        id
      }
    }
  }
}
    `;
/**
 * __useRubricSetsBySchoolQuery__
 *
 * To run a query within a React component, call `useRubricSetsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubricSetsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubricSetsBySchoolQuery({
 *   variables: {
 *   },
 * });
 */
export function useRubricSetsBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(RubricSetsBySchoolDocument, options);
}
export function useRubricSetsBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(RubricSetsBySchoolDocument, options);
}
export function useRubricSetsBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(RubricSetsBySchoolDocument, options);
}
export const GetCommentThreadsByEntityIdsDocument = gql `
    query GetCommentThreadsByEntityIds($entityIds: [ID!]!, $courseId: ID) {
  getCommentThreadsByEntityIds(entityIds: $entityIds, courseId: $courseId) {
    success
    threads {
      id
      created
      lastModified
      status
      entityId
      entityType
      entityTitle
      isDeleted
      assignee {
        id
        name
        username
      }
      comments {
        id
        created
        text
        author {
          id
          name
          username
        }
        mentionedUsers {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetCommentThreadsByEntityIdsQuery__
 *
 * To run a query within a React component, call `useGetCommentThreadsByEntityIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentThreadsByEntityIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentThreadsByEntityIdsQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCommentThreadsByEntityIdsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCommentThreadsByEntityIdsDocument, options);
}
export function useGetCommentThreadsByEntityIdsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCommentThreadsByEntityIdsDocument, options);
}
export function useGetCommentThreadsByEntityIdsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCommentThreadsByEntityIdsDocument, options);
}
export const GetCourseSnapshotReviewDocument = gql `
    query GetCourseSnapshotReview($courseId: ID!, $snapshotId: ID!) {
  getCourseSnapshotReview(courseId: $courseId, snapshotId: $snapshotId) {
    success
    message
    snapshot {
      id
      courseId
      versionNumber
      timestamp
      authorId
      authorName
      description
      sourceTag
      isCurrent
    }
    data {
      schemaVersion
      courseId
      capturedAt
      course {
        status
        title
        descriptionText
        descriptionHtml
        moduleOrder
        qualityRating
        totalScore
        itemsToImprove
        strengths
      }
      modules {
        id
        title
        description
        recommendedTitle
        recommendedDescription
        status
        activityOrder
      }
      activities {
        id
        type
        moduleId
        title
        recommendedTitle
        recommendedDescription
        status
        recommendedPointsPossible
        recommendedDueDate
        recommendedDueDateCleared
        aiTutorId
        aiTutorTitle
        aiTutorDescription
        aiTutorDueDate
      }
      contentSections {
        id
        sectionType
        status
        valueHtml
        valueText
        recommendedValue
      }
    }
  }
}
    `;
/**
 * __useGetCourseSnapshotReviewQuery__
 *
 * To run a query within a React component, call `useGetCourseSnapshotReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseSnapshotReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseSnapshotReviewQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      snapshotId: // value for 'snapshotId'
 *   },
 * });
 */
export function useGetCourseSnapshotReviewQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseSnapshotReviewDocument, options);
}
export function useGetCourseSnapshotReviewLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseSnapshotReviewDocument, options);
}
export function useGetCourseSnapshotReviewSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseSnapshotReviewDocument, options);
}
export const GetCourseVersionHistoryDocument = gql `
    query GetCourseVersionHistory($courseId: ID!) {
  getCourseVersionHistory(courseId: $courseId) {
    success
    currentVersionNumber
    groups {
      date
      snapshots {
        id
        courseId
        versionNumber
        timestamp
        authorId
        authorName
        description
        sourceTag
        isCurrent
      }
    }
  }
}
    `;
/**
 * __useGetCourseVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetCourseVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseVersionHistoryQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseVersionHistoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseVersionHistoryDocument, options);
}
export function useGetCourseVersionHistoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseVersionHistoryDocument, options);
}
export function useGetCourseVersionHistorySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseVersionHistoryDocument, options);
}
export const GetModernizedAssessmentDetailDocument = gql `
    query GetModernizedAssessmentDetail($entityId: ID!) {
  getModernizedAssessmentDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      qualityIndicator
      isNew
      dueDate
      availableFrom
      availableUntil
      pointsPossible
      recommendedPointsPossible
      timeLimitMinutes
      attemptsAllowed
      numberOfQuestions
      aiTutorIds
      scheduledDate
      assessmentType
      externalName
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedAssessmentDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedAssessmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedAssessmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedAssessmentDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedAssessmentDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedAssessmentDetailDocument, options);
}
export function useGetModernizedAssessmentDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedAssessmentDetailDocument, options);
}
export function useGetModernizedAssessmentDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedAssessmentDetailDocument, options);
}
export const GetModernizedAssignmentDetailDocument = gql `
    query GetModernizedAssignmentDetail($entityId: ID!) {
  getModernizedAssignmentDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      qualityIndicator
      isNew
      dueDate
      scheduledDate
      recommendedDueDate
      recommendedDueDateCleared
      pointsPossible
      recommendedPointsPossible
      gradingType
      videoUrl
      enableFileUpload
      worksheetId
      externalName
      externalUrl
      submissionKinds
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedAssignmentDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedAssignmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedAssignmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedAssignmentDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedAssignmentDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedAssignmentDetailDocument, options);
}
export function useGetModernizedAssignmentDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedAssignmentDetailDocument, options);
}
export function useGetModernizedAssignmentDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedAssignmentDetailDocument, options);
}
export const GetModernizedAxioResourceDetailDocument = gql `
    query GetModernizedAxioResourceDetail($entityId: ID!) {
  getModernizedAxioResourceDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      isNew
      title
      descriptionText
      descriptionHtml
      descriptionFormat
      recommendedTitle
      recommendedDescription
      status
      videoUrl
      scheduledDate
      externalVisibility
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedAxioResourceDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedAxioResourceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedAxioResourceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedAxioResourceDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedAxioResourceDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedAxioResourceDetailDocument, options);
}
export function useGetModernizedAxioResourceDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedAxioResourceDetailDocument, options);
}
export function useGetModernizedAxioResourceDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedAxioResourceDetailDocument, options);
}
export const GetModernizedCourseDocument = gql `
    query GetModernizedCourse($courseId: ID!) {
  getModernizedCourse(courseId: $courseId) {
    id
    status
    title
    descriptionText
    descriptionHtml
    itemsToImprove
    strengths
    qualityRating
    totalScore
    totalMaxScore
    term
    externalSource
    targetAudience
    courseCode
    modernizerIntake {
      architect {
        id
        name
        email
      }
      editingTeamConnection {
        edges {
          properties {
            role
          }
          node {
            id
            name
            email
          }
        }
      }
    }
    externalCourse {
      id
      school {
        id
      }
    }
    syllabusFile {
      id
      fileName
      fileURL
      bucketName
    }
    categoryScores {
      id
      category
      score
      maxScore
    }
    inaccessibleDocuments {
      id
      title
      errorReason
      externalUrl
    }
    evaluatorIssues {
      id
      created
      lastModified
      runId
      dimension
      dimensionLabel
      entityId
      entityType
      title
      description
      evidence
      confidence
      status
      statusUpdatedAt
      statusUpdatedBy
    }
    evaluatorDimensionScores {
      id
      created
      lastModified
      runId
      dimension
      score
      maxScore
      evaluatedEntities
      failedEntities
      goodEntities
      issueCount
      confidenceThreshold
      scoringVersion
      summary
      detailedFindings
    }
    contentSections {
      id
      created
      lastModified
      type
      isNew
      status
      valueHtml
      valueText
      recommendedValue
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
    modules {
      id
      created
      lastModified
      isNew
      title
      description
      recommendedTitle
      recommendedDescription
      qualityIndicator
      issueFindings
      issueFindingDimensions
      issueFindingDimensionLabels
      status
      pendingDelete
      activityOrder
      externalVisibility
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
      assignments {
        id
        created
        lastModified
        isNew
        creationSource
        qualityIndicator
        issueFindings
        issueFindingDimensions
        issueFindingDimensionLabels
        title
        descriptionText
        descriptionHtml
        recommendedTitle
        recommendedDescription
        status
        pendingDelete
        externalVisibility
        dueDate
        scheduledDate
        recommendedDueDate
        recommendedDueDateCleared
        pointsPossible
        recommendedPointsPossible
        gradingType
        videoUrl
        enableFileUpload
        worksheetId
        externalUrl
        generatedAssets {
          id
          fileName
          fileURL
          bucketName
        }
        originalFiles {
          id
          fileName
          fileURL
          bucketName
        }
        recommendations {
          id
          recommendation
          rationale
          sourceType
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
      assessments {
        id
        created
        lastModified
        isNew
        qualityIndicator
        issueFindings
        issueFindingDimensions
        issueFindingDimensionLabels
        title
        descriptionText
        descriptionHtml
        recommendedTitle
        recommendedDescription
        status
        pendingDelete
        externalVisibility
        dueDate
        recommendedDueDate
        recommendedDueDateCleared
        pointsPossible
        recommendedPointsPossible
        timeLimitMinutes
        numberOfQuestions
        aiTutorIds
        scheduledDate
        assessmentType
        externalUrl
        generatedAssets {
          id
          fileName
          fileURL
          bucketName
        }
        originalFiles {
          id
          fileName
          fileURL
          bucketName
        }
        recommendations {
          id
          recommendation
          rationale
          sourceType
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
      axioResources {
        id
        created
        lastModified
        isNew
        title
        externalUrl
        descriptionText
        descriptionHtml
        descriptionFormat
        recommendedTitle
        recommendedDescription
        status
        pendingDelete
        videoUrl
        scheduledDate
        externalVisibility
        generatedAssets {
          id
          fileName
          fileURL
          bucketName
        }
        originalFiles {
          id
          fileName
          fileURL
          bucketName
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
      ileRecommendations {
        id
        created
        lastModified
        isNew
        creationSource
        title
        description
        status
        pendingDelete
        aiTutor {
          id
          title
          description
          context
          dueDate
          targetAudience
          activityState
          scheduledDate
          objectives {
            id
            objective
            sequence
            evalCriteria
          }
        }
        recommendations {
          id
          recommendation
          rationale
          sourceType
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
      projects {
        id
        created
        lastModified
        isNew
        creationSource
        qualityIndicator
        issueFindings
        issueFindingDimensions
        issueFindingDimensionLabels
        title
        descriptionText
        descriptionHtml
        recommendedTitle
        recommendedDescription
        status
        pendingDelete
        externalVisibility
        dueDate
        scheduledDate
        recommendedDueDate
        recommendedDueDateCleared
        externalUrl
        generatedAssets {
          id
          fileName
          fileURL
          bucketName
        }
        originalFiles {
          id
          fileName
          fileURL
          bucketName
        }
        recommendations {
          id
          recommendation
          rationale
          sourceType
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
      otherActivities {
        id
        created
        lastModified
        isNew
        creationSource
        qualityIndicator
        issueFindings
        issueFindingDimensions
        issueFindingDimensionLabels
        activityType
        title
        descriptionText
        descriptionHtml
        recommendedTitle
        recommendedDescription
        dueDate
        recommendedDueDate
        recommendedDueDateCleared
        status
        pendingDelete
        externalVisibility
        externalUrl
        otherProperties
        generatedAssets {
          id
          fileName
          fileURL
          bucketName
        }
        originalFiles {
          id
          fileName
          fileURL
          bucketName
        }
        recommendations {
          id
          recommendation
          rationale
          sourceType
        }
        editLogs {
          id
          created
          fieldName
          beforeValue
          afterValue
          actor {
            id
            name
            username
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedCourseQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseDocument, options);
}
export function useGetModernizedCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseDocument, options);
}
export function useGetModernizedCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseDocument, options);
}
export const GetModernizedCourseAddCapabilitiesDocument = gql `
    query GetModernizedCourseAddCapabilities($courseId: ID!) {
  getModernizedCourseAddCapabilities(courseId: $courseId) {
    success
    message
    lmsSource
    canAddModule
    allowedActivityTypes
  }
}
    `;
/**
 * __useGetModernizedCourseAddCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseAddCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseAddCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseAddCapabilitiesQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCourseAddCapabilitiesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseAddCapabilitiesDocument, options);
}
export function useGetModernizedCourseAddCapabilitiesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseAddCapabilitiesDocument, options);
}
export function useGetModernizedCourseAddCapabilitiesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseAddCapabilitiesDocument, options);
}
export const GetModernizedCourseContentSectionDetailDocument = gql `
    query GetModernizedCourseContentSectionDetail($entityId: ID!) {
  getModernizedCourseContentSectionDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      type
      isNew
      valueHtml
      valueText
      recommendedValue
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedCourseContentSectionDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseContentSectionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseContentSectionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseContentSectionDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedCourseContentSectionDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseContentSectionDetailDocument, options);
}
export function useGetModernizedCourseContentSectionDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseContentSectionDetailDocument, options);
}
export function useGetModernizedCourseContentSectionDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseContentSectionDetailDocument, options);
}
export const GetModernizedCourseEditingTeamDocument = gql `
    query GetModernizedCourseEditingTeam($courseId: ID!) {
  getModernizedCourseEditingTeam(courseId: $courseId) {
    success
    members {
      userId
      name
      email
      role
    }
    schoolId
    architectId
  }
}
    `;
/**
 * __useGetModernizedCourseEditingTeamQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseEditingTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseEditingTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseEditingTeamQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCourseEditingTeamQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseEditingTeamDocument, options);
}
export function useGetModernizedCourseEditingTeamLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseEditingTeamDocument, options);
}
export function useGetModernizedCourseEditingTeamSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseEditingTeamDocument, options);
}
export const GetModernizedCourseEvaluatorIssuesDocument = gql `
    query GetModernizedCourseEvaluatorIssues($courseId: ID!) {
  getModernizedCourse(courseId: $courseId) {
    id
    evaluatorIssues {
      id
      created
      lastModified
      runId
      dimension
      dimensionLabel
      entityId
      entityType
      title
      description
      evidence
      confidence
      status
      statusUpdatedAt
      statusUpdatedBy
    }
  }
}
    `;
/**
 * __useGetModernizedCourseEvaluatorIssuesQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseEvaluatorIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseEvaluatorIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseEvaluatorIssuesQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCourseEvaluatorIssuesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseEvaluatorIssuesDocument, options);
}
export function useGetModernizedCourseEvaluatorIssuesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseEvaluatorIssuesDocument, options);
}
export function useGetModernizedCourseEvaluatorIssuesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseEvaluatorIssuesDocument, options);
}
export const GetModernizedCoursePublishHistoryDocument = gql `
    query GetModernizedCoursePublishHistory($courseId: ID!) {
  getModernizedCoursePublishHistory(courseId: $courseId) {
    success
    records {
      id
      publishedAt
      autoPublishedCount
      manualStepCount
      completedManualStepCount
      autoPublishedItems {
        id
        title
        category
        moduleName
      }
      manualSteps {
        id
        title
        category
        moduleName
        action
        detail
        completed
        externalUrl
        downloadUrl
      }
    }
  }
}
    `;
/**
 * __useGetModernizedCoursePublishHistoryQuery__
 *
 * To run a query within a React component, call `useGetModernizedCoursePublishHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCoursePublishHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCoursePublishHistoryQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCoursePublishHistoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCoursePublishHistoryDocument, options);
}
export function useGetModernizedCoursePublishHistoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCoursePublishHistoryDocument, options);
}
export function useGetModernizedCoursePublishHistorySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCoursePublishHistoryDocument, options);
}
export const GetModernizedModuleDetailDocument = gql `
    query GetModernizedModuleDetail($entityId: ID!) {
  getModernizedModuleDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      title
      description
      recommendedTitle
      recommendedDescription
      status
      externalName
      externalUrl
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedModuleDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedModuleDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedModuleDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedModuleDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedModuleDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedModuleDetailDocument, options);
}
export function useGetModernizedModuleDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedModuleDetailDocument, options);
}
export function useGetModernizedModuleDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedModuleDetailDocument, options);
}
export const GetModernizedOtherActivityDetailDocument = gql `
    query GetModernizedOtherActivityDetail($entityId: ID!) {
  getModernizedOtherActivityDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      qualityIndicator
      isNew
      activityType
      externalName
      externalUrl
      otherProperties
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedOtherActivityDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedOtherActivityDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedOtherActivityDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedOtherActivityDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedOtherActivityDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedOtherActivityDetailDocument, options);
}
export function useGetModernizedOtherActivityDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedOtherActivityDetailDocument, options);
}
export function useGetModernizedOtherActivityDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedOtherActivityDetailDocument, options);
}
export const GetModernizedProjectDetailDocument = gql `
    query GetModernizedProjectDetail($entityId: ID!) {
  getModernizedProjectDetail(entityId: $entityId) {
    success
    activity {
      id
      created
      lastModified
      title
      descriptionText
      descriptionHtml
      recommendedTitle
      recommendedDescription
      status
      qualityIndicator
      isNew
      dueDate
      scheduledDate
      recommendedDueDate
      recommendedDueDateCleared
      externalName
      externalUrl
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      generatedAssets {
        id
        fileName
        fileURL
        bucketName
      }
      originalFiles {
        id
        fileName
        fileURL
        bucketName
      }
      recommendations {
        id
        recommendation
        rationale
        sourceType
      }
      editLogs {
        id
        created
        fieldName
        beforeValue
        afterValue
        actor {
          id
          name
          username
        }
      }
    }
  }
}
    `;
/**
 * __useGetModernizedProjectDetailQuery__
 *
 * To run a query within a React component, call `useGetModernizedProjectDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedProjectDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedProjectDetailQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetModernizedProjectDetailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedProjectDetailDocument, options);
}
export function useGetModernizedProjectDetailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedProjectDetailDocument, options);
}
export function useGetModernizedProjectDetailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedProjectDetailDocument, options);
}
export const GetSnapshotDiffDocument = gql `
    query GetSnapshotDiff($snapshotIdA: ID!, $snapshotIdB: ID!) {
  getSnapshotDiff(snapshotIdA: $snapshotIdA, snapshotIdB: $snapshotIdB) {
    success
    snapshotIdA
    snapshotIdB
    courseFieldChanges {
      field
      before
      after
    }
    moduleDiffs {
      moduleId
      moduleTitle
      changeType
      fields {
        field
        before
        after
      }
      activityDiffs {
        activityId
        activityType
        activityTitle
        changeType
        fields {
          field
          before
          after
        }
      }
    }
  }
}
    `;
/**
 * __useGetSnapshotDiffQuery__
 *
 * To run a query within a React component, call `useGetSnapshotDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapshotDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapshotDiffQuery({
 *   variables: {
 *      snapshotIdA: // value for 'snapshotIdA'
 *      snapshotIdB: // value for 'snapshotIdB'
 *   },
 * });
 */
export function useGetSnapshotDiffQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSnapshotDiffDocument, options);
}
export function useGetSnapshotDiffLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSnapshotDiffDocument, options);
}
export function useGetSnapshotDiffSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSnapshotDiffDocument, options);
}
export const GetActiveModernizeCourseJobDocument = gql `
    query GetActiveModernizeCourseJob {
  getActiveModernizeCourseJob {
    externalCourseId
    jobId
    generationStatus
  }
}
    `;
/**
 * __useGetActiveModernizeCourseJobQuery__
 *
 * To run a query within a React component, call `useGetActiveModernizeCourseJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveModernizeCourseJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveModernizeCourseJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveModernizeCourseJobQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetActiveModernizeCourseJobDocument, options);
}
export function useGetActiveModernizeCourseJobLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetActiveModernizeCourseJobDocument, options);
}
export function useGetActiveModernizeCourseJobSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetActiveModernizeCourseJobDocument, options);
}
export const GetAllAxioResourcesByCourseDocument = gql `
    query GetAllAxioResourcesByCourse($courseId: ID!) {
  getAllAxioResourcesByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
    }
  }
}
    `;
/**
 * __useGetAllAxioResourcesByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAxioResourcesByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAxioResourcesByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAxioResourcesByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllAxioResourcesByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllAxioResourcesByCourseDocument, options);
}
export function useGetAllAxioResourcesByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllAxioResourcesByCourseDocument, options);
}
export function useGetAllAxioResourcesByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllAxioResourcesByCourseDocument, options);
}
export const GetAllCoursesBySchoolDocument = gql `
    query GetAllCoursesBySchool($schoolId: ID!, $page: Int, $pageSize: Int) {
  getAllCoursesBySchool(schoolId: $schoolId, page: $page, pageSize: $pageSize) {
    success
    data {
      courses {
        id
        name
        isDraft
        learningStandards
        lengthInWeeks
        objectives
        last_modified
        thumbnail
        cost
        startDate
        description
        targetAudience
        course_code
        enrolledStudents {
          id
        }
        hasAssignmentAssignments {
          id
          title
          description
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetAllCoursesBySchoolQuery__
 *
 * To run a query within a React component, call `useGetAllCoursesBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCoursesBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCoursesBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAllCoursesBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllCoursesBySchoolDocument, options);
}
export function useGetAllCoursesBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllCoursesBySchoolDocument, options);
}
export function useGetAllCoursesBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllCoursesBySchoolDocument, options);
}
export const GetAllReviewsByCourseDocument = gql `
    query GetAllReviewsByCourse($courseId: ID!) {
  getAllReviewsByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      hasReviewFor {
        id
      }
      hasAITutors {
        id
        title
      }
      moduleHasReviews {
        id
      }
    }
    count
  }
}
    `;
/**
 * __useGetAllReviewsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllReviewsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReviewsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReviewsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllReviewsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllReviewsByCourseDocument, options);
}
export function useGetAllReviewsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllReviewsByCourseDocument, options);
}
export function useGetAllReviewsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllReviewsByCourseDocument, options);
}
export const GetAnnouncementsByCourseDocument = gql `
    query GetAnnouncementsByCourse($courseId: ID!, $includeInactive: Boolean) {
  getAnnouncementsByCourse(courseId: $courseId, includeInactive: $includeInactive) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      activityState
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
/**
 * __useGetAnnouncementsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAnnouncementsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAnnouncementsByCourseDocument, options);
}
export function useGetAnnouncementsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAnnouncementsByCourseDocument, options);
}
export function useGetAnnouncementsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAnnouncementsByCourseDocument, options);
}
export const GetAnnouncementsBySchoolDocument = gql `
    query GetAnnouncementsBySchool($schoolId: ID!, $includeInactive: Boolean) {
  getAnnouncementsBySchool(schoolId: $schoolId, includeInactive: $includeInactive) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      activityState
      audienceType
      author {
        id
        name
        email
      }
      school {
        id
        provider_name
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useGetAnnouncementsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAnnouncementsBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAnnouncementsBySchoolDocument, options);
}
export function useGetAnnouncementsBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAnnouncementsBySchoolDocument, options);
}
export function useGetAnnouncementsBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAnnouncementsBySchoolDocument, options);
}
export const GetAnnouncementsForStudentDocument = gql `
    query GetAnnouncementsForStudent($courseId: ID!) {
  getAnnouncementsForStudent(courseId: $courseId) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      activityState
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
/**
 * __useGetAnnouncementsForStudentQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsForStudentQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAnnouncementsForStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAnnouncementsForStudentDocument, options);
}
export function useGetAnnouncementsForStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAnnouncementsForStudentDocument, options);
}
export function useGetAnnouncementsForStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAnnouncementsForStudentDocument, options);
}
export const GetAnnouncementsForUserDocument = gql `
    query GetAnnouncementsForUser($schoolId: ID!, $audienceType: AudienceType) {
  getAnnouncementsForUser(schoolId: $schoolId, audienceType: $audienceType) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      activityState
      audienceType
      author {
        id
        name
        email
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        team_name
      }
    }
    count
  }
}
    `;
/**
 * __useGetAnnouncementsForUserQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsForUserQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      audienceType: // value for 'audienceType'
 *   },
 * });
 */
export function useGetAnnouncementsForUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAnnouncementsForUserDocument, options);
}
export function useGetAnnouncementsForUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAnnouncementsForUserDocument, options);
}
export function useGetAnnouncementsForUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAnnouncementsForUserDocument, options);
}
export const GetAssignmentsWithCourseDocument = gql `
    query GetAssignmentsWithCourse($schoolId: ID!, $searchQuery: String, $courseId: ID) {
  getAssignmentsWithCourse(
    schoolId: $schoolId
    searchQuery: $searchQuery
    courseId: $courseId
  ) {
    success
    message
    data {
      id
      title
      due_date
      points_possible
      courseName
      courseCode
      courseId
    }
    count
  }
}
    `;
/**
 * __useGetAssignmentsWithCourseQuery__
 *
 * To run a query within a React component, call `useGetAssignmentsWithCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentsWithCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentsWithCourseQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAssignmentsWithCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssignmentsWithCourseDocument, options);
}
export function useGetAssignmentsWithCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssignmentsWithCourseDocument, options);
}
export function useGetAssignmentsWithCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssignmentsWithCourseDocument, options);
}
export const GetAvailableCoursesForStudentDocument = gql `
    query GetAvailableCoursesForStudent($schoolId: ID!, $degreeId: ID, $page: Int, $pageSize: Int) {
  getAvailableCoursesForStudent(
    schoolId: $schoolId
    degreeId: $degreeId
    page: $page
    pageSize: $pageSize
  ) {
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetAvailableCoursesForStudentQuery__
 *
 * To run a query within a React component, call `useGetAvailableCoursesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCoursesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCoursesForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      degreeId: // value for 'degreeId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetAvailableCoursesForStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAvailableCoursesForStudentDocument, options);
}
export function useGetAvailableCoursesForStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAvailableCoursesForStudentDocument, options);
}
export function useGetAvailableCoursesForStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAvailableCoursesForStudentDocument, options);
}
export const GetAxioResourceDocument = gql `
    query GetAxioResource($id: ID!) {
  getAxioResource(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      descriptionFormat
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
    }
  }
}
    `;
/**
 * __useGetAxioResourceQuery__
 *
 * To run a query within a React component, call `useGetAxioResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAxioResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAxioResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAxioResourceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAxioResourceDocument, options);
}
export function useGetAxioResourceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAxioResourceDocument, options);
}
export function useGetAxioResourceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAxioResourceDocument, options);
}
export const GetCompletionAnalyticsBySchoolDocument = gql `
    query GetCompletionAnalyticsBySchool($schoolId: ID!) {
  getCompletionAnalyticsBySchool(schoolId: $schoolId) {
    success
    message
    count
    data {
      label
      completionStats {
        completed
        inProgress
        notStarted
      }
      details {
        modules {
          label
          completionStats {
            completed
            inProgress
            notStarted
          }
          details {
            activities {
              label
              completionStats {
                completed
                inProgress
                notStarted
              }
              details {
                objectives {
                  label
                  completionStats {
                    completed
                    inProgress
                    notStarted
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCompletionAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCompletionAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletionAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletionAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCompletionAnalyticsBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCompletionAnalyticsBySchoolDocument, options);
}
export function useGetCompletionAnalyticsBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCompletionAnalyticsBySchoolDocument, options);
}
export function useGetCompletionAnalyticsBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCompletionAnalyticsBySchoolDocument, options);
}
export const GetCourseModernizerIntakeDocument = gql `
    query GetCourseModernizerIntake($input: GetCourseModernizerIntakeInput!) {
  getCourseModernizerIntake(input: $input) {
    success
    message
    count
    readiness {
      ready
      materialBehavior
      reasons {
        code
        message
        blocking
      }
      warnings {
        code
        message
        blocking
      }
    }
    data {
      id
      name
      courseCode
      description
      courseType
      term
      modality
      educationLevel
      yearLevel
      credits
      lengthInWeeks
      dueDateEndDate
      visionIntent
      audienceNotes
      signatureStyleTags
      signatureStyleOther
      intakeMaterials {
        id
        created
        lastModified
        revision
        position
        modernizerInstructions
        summary
        analysisStatus
        analysisError
        analysisUpdatedAt
        analysisPromptVersion
        analysisModel
        summaryUpdatedAt
        summaryPromptVersion
        summaryModel
        extractionOutput
        retentionPolicy
        file {
          id
          fileName
          fileURL
          status
          externalSourceProvenance {
            connectorType
          }
        }
      }
      sourceType
      sourceId
      sourceKey
      sourceUrl
      sourceProvenance
      status
      createdAt
      updatedAt
      externalCourse {
        id
      }
      architect {
        id
        name
        email
      }
      editingTeamConnection {
        edges {
          properties {
            role
          }
          node {
            id
            name
            email
          }
        }
      }
      qualityFramework {
        id
        name
      }
      accreditingBody {
        id
        name
      }
      degreeProgram {
        id
        name
      }
      learningOutcomeApprovalStatus
      learningOutcomeSetRevision
      learningOutcomeApprovedAt
      learningOutcomes {
        id
        text
        position
        isAIDrafted
        sourceKind
        sourceReferenceId
        sourceUrl
        sourceProvenance
        originalText
        extractionNotes
        aiPromptVersion
        aiModel
        revision
        created
        lastModified
      }
    }
  }
}
    `;
/**
 * __useGetCourseModernizerIntakeQuery__
 *
 * To run a query within a React component, call `useGetCourseModernizerIntakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModernizerIntakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModernizerIntakeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseModernizerIntakeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseModernizerIntakeDocument, options);
}
export function useGetCourseModernizerIntakeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseModernizerIntakeDocument, options);
}
export function useGetCourseModernizerIntakeSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseModernizerIntakeDocument, options);
}
export const GetCoursesAnalyticsBySchoolDocument = gql `
    query GetCoursesAnalyticsBySchool($schoolId: ID!) {
  getCoursesAnalyticsBySchool(schoolId: $schoolId) {
    count
    data {
      label
      id
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      enrollment
      average_time_taken
      details {
        modules {
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          enrollment
          average_time_taken
          details {
            activities {
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              enrollment
              average_time_taken
              summaries
              success_points_details
              confusion_points_details
              further_recommendations
              distractions_details
              details {
                objectives {
                  label
                  success_points
                  confusion_points
                  average_time_taken
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCoursesAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetCoursesAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCoursesAnalyticsBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesAnalyticsBySchoolDocument, options);
}
export function useGetCoursesAnalyticsBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesAnalyticsBySchoolDocument, options);
}
export function useGetCoursesAnalyticsBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesAnalyticsBySchoolDocument, options);
}
export const GetCoursesByDegreeByQueryDocument = gql `
    query GetCoursesByDegreeByQuery($degreeId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesByDegreeByQuery(
    degreeId: $degreeId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        learningStandards
        lengthInWeeks
        objectives
        thumbnail
        last_modified
        generationStatus
        teachingFaculty {
          id
          name
        }
        enrolledStudents {
          id
          name
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetCoursesByDegreeByQueryQuery__
 *
 * To run a query within a React component, call `useGetCoursesByDegreeByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByDegreeByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByDegreeByQueryQuery({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesByDegreeByQueryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesByDegreeByQueryDocument, options);
}
export function useGetCoursesByDegreeByQueryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesByDegreeByQueryDocument, options);
}
export function useGetCoursesByDegreeByQuerySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesByDegreeByQueryDocument, options);
}
export const GetCoursesByFacultyDocument = gql `
    query GetCoursesByFaculty($schoolId: ID!, $userId: ID!, $searchQuery: String) {
  getCoursesByFaculty(
    schoolId: $schoolId
    userId: $userId
    searchQuery: $searchQuery
  ) {
    data {
      id
      name
      created
      course_code
      isDraft
      learningStandards
      lengthInWeeks
      objectives
      last_modified
      thumbnail
      cost
      startDate
      description
      targetAudience
      generationStatus
      enrolledStudents {
        id
        name
      }
      teachingFaculty {
        id
        name
      }
      degreesHasCourse {
        id
        name
      }
      modules {
        id
        title
        aiTutors {
          id
          title
        }
        assignments {
          id
          name
        }
        axioResources {
          id
          name
        }
        reviews {
          id
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetCoursesByFacultyQuery__
 *
 * To run a query within a React component, call `useGetCoursesByFacultyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesByFacultyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesByFacultyQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetCoursesByFacultyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesByFacultyDocument, options);
}
export function useGetCoursesByFacultyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesByFacultyDocument, options);
}
export function useGetCoursesByFacultySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesByFacultyDocument, options);
}
export const GetCoursesBySchoolByQueryDocument = gql `
    query GetCoursesBySchoolByQuery($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getCoursesBySchoolByQuery(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        description
        cost
        startDate
        targetAudience
        learningStandards
        lengthInWeeks
        objectives
        thumbnail
        last_modified
        generationStatus
        isDraft
        isEnrollmentAvailable
        teachingFaculty {
          id
          name
        }
        enrolledStudents {
          id
          name
        }
        degreesHasCourse {
          id
          name
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetCoursesBySchoolByQueryQuery__
 *
 * To run a query within a React component, call `useGetCoursesBySchoolByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesBySchoolByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesBySchoolByQueryQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetCoursesBySchoolByQueryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesBySchoolByQueryDocument, options);
}
export function useGetCoursesBySchoolByQueryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesBySchoolByQueryDocument, options);
}
export function useGetCoursesBySchoolByQuerySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesBySchoolByQueryDocument, options);
}
export const GetEnrolledStudentCoursesByAdminDocument = gql `
    query GetEnrolledStudentCoursesByAdmin($schoolId: ID!, $studentId: ID!, $query: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getEnrolledStudentCoursesByAdmin(
    schoolId: $schoolId
    studentId: $studentId
    query: $query
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetEnrolledStudentCoursesByAdminQuery__
 *
 * To run a query within a React component, call `useGetEnrolledStudentCoursesByAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrolledStudentCoursesByAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrolledStudentCoursesByAdminQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetEnrolledStudentCoursesByAdminQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEnrolledStudentCoursesByAdminDocument, options);
}
export function useGetEnrolledStudentCoursesByAdminLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEnrolledStudentCoursesByAdminDocument, options);
}
export function useGetEnrolledStudentCoursesByAdminSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetEnrolledStudentCoursesByAdminDocument, options);
}
export const GetFacultyByCourseIdDocument = gql `
    query GetFacultyByCourseId($courseId: ID!, $searchQuery: String) {
  getFacultyByCourseId(courseId: $courseId, searchQuery: $searchQuery) {
    data {
      faculties {
        id
        name
        profilePicture
        email
        meetingLink
        biography
      }
      totalCount
    }
  }
}
    `;
/**
 * __useGetFacultyByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetFacultyByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetFacultyByCourseIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFacultyByCourseIdDocument, options);
}
export function useGetFacultyByCourseIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFacultyByCourseIdDocument, options);
}
export function useGetFacultyByCourseIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFacultyByCourseIdDocument, options);
}
export const GetForumByCourseDocument = gql `
    query GetForumByCourse($courseId: ID!) {
  getForumByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      course {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useGetForumByCourseQuery__
 *
 * To run a query within a React component, call `useGetForumByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetForumByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetForumByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetForumByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetForumByCourseDocument, options);
}
export function useGetForumByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetForumByCourseDocument, options);
}
export function useGetForumByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetForumByCourseDocument, options);
}
export const GetLastSeenPostDocument = gql `
    query GetLastSeenPost($threadId: ID!) {
  getLastSeenPost(threadId: $threadId) {
    success
    message
    data {
      threadId
      lastSeenPostId
      lastSeenAt
    }
  }
}
    `;
/**
 * __useGetLastSeenPostQuery__
 *
 * To run a query within a React component, call `useGetLastSeenPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSeenPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSeenPostQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useGetLastSeenPostQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLastSeenPostDocument, options);
}
export function useGetLastSeenPostLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLastSeenPostDocument, options);
}
export function useGetLastSeenPostSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLastSeenPostDocument, options);
}
export const GetLessonPlanStatusDocument = gql `
    query GetLessonPlanStatus($moduleId: ID!) {
  getLessonPlanStatus(moduleId: $moduleId) {
    success
    message
    data {
      moduleId
      moduleTitle
      isGenerating
      hasLessonPlan
      lessonPlanFile {
        id
        fileName
        fileURL
      }
    }
  }
}
    `;
/**
 * __useGetLessonPlanStatusQuery__
 *
 * To run a query within a React component, call `useGetLessonPlanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonPlanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonPlanStatusQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *   },
 * });
 */
export function useGetLessonPlanStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLessonPlanStatusDocument, options);
}
export function useGetLessonPlanStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLessonPlanStatusDocument, options);
}
export function useGetLessonPlanStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLessonPlanStatusDocument, options);
}
export const GetModernizeCourseJobStatusDocument = gql `
    query GetModernizeCourseJobStatus($jobId: String!) {
  getModernizeCourseJobStatus(jobId: $jobId) {
    success
    status
    generationStatus
    message
    currentStepKey
    currentStepIndex
    totalSteps
    percent
    modernizedCourseId
    steps {
      key
      title
      agent
      description
      status
    }
  }
}
    `;
/**
 * __useGetModernizeCourseJobStatusQuery__
 *
 * To run a query within a React component, call `useGetModernizeCourseJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizeCourseJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizeCourseJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetModernizeCourseJobStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizeCourseJobStatusDocument, options);
}
export function useGetModernizeCourseJobStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizeCourseJobStatusDocument, options);
}
export function useGetModernizeCourseJobStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizeCourseJobStatusDocument, options);
}
export const GetModernizedCourseReviewAccessDocument = gql `
    query GetModernizedCourseReviewAccess($courseId: ID!) {
  getModernizedCourseReviewAccess(courseId: $courseId) {
    success
    canEnterReview
    message
    generationStatus
    modernizationStatus
  }
}
    `;
/**
 * __useGetModernizedCourseReviewAccessQuery__
 *
 * To run a query within a React component, call `useGetModernizedCourseReviewAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModernizedCourseReviewAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModernizedCourseReviewAccessQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetModernizedCourseReviewAccessQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetModernizedCourseReviewAccessDocument, options);
}
export function useGetModernizedCourseReviewAccessLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetModernizedCourseReviewAccessDocument, options);
}
export function useGetModernizedCourseReviewAccessSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetModernizedCourseReviewAccessDocument, options);
}
export const GetNotesForStudentDocument = gql `
    query GetNotesForStudent($studentId: ID!) {
  getNotesForStudent(studentId: $studentId) {
    success
    message
    data {
      id
      content
      created
      lastModified
      author {
        id
        name
        profilePicture
      }
      subject {
        id
        name
      }
    }
    count
  }
}
    `;
/**
 * __useGetNotesForStudentQuery__
 *
 * To run a query within a React component, call `useGetNotesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesForStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetNotesForStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetNotesForStudentDocument, options);
}
export function useGetNotesForStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetNotesForStudentDocument, options);
}
export function useGetNotesForStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetNotesForStudentDocument, options);
}
export const GetPostByIdDocument = gql `
    query GetPostById($postId: ID!) {
  getPostById(postId: $postId) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      thread {
        id
        title
        forum {
          course {
            id
            name
          }
        }
      }
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        lastModified
        author {
          id
          name
        }
        files {
          id
          fileName
          fileURL
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetPostByIdQuery__
 *
 * To run a query within a React component, call `useGetPostByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPostByIdDocument, options);
}
export function useGetPostByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPostByIdDocument, options);
}
export function useGetPostByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPostByIdDocument, options);
}
export const GetPostsByThreadDocument = gql `
    query GetPostsByThread($threadId: ID!, $page: Int, $pageSize: Int) {
  getPostsByThread(threadId: $threadId, page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      message
      depth
      threadId
      created
      lastModified
      author {
        id
        name
      }
      files {
        id
        fileName
        fileURL
      }
      replies {
        id
        message
        depth
        created
        author {
          id
          name
        }
      }
      replyTo {
        id
        message
        author {
          id
          name
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetPostsByThreadQuery__
 *
 * To run a query within a React component, call `useGetPostsByThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByThreadQuery({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetPostsByThreadQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPostsByThreadDocument, options);
}
export function useGetPostsByThreadLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPostsByThreadDocument, options);
}
export function useGetPostsByThreadSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPostsByThreadDocument, options);
}
export const GetReviewDocument = gql `
    query GetReview($id: ID!) {
  getReview(id: $id) {
    success
    message
    data {
      id
      created
      lastModified
      hasReviewFor {
        id
        moduleHasAssessment {
          id
          title
        }
      }
      hasAITutors {
        id
        title
        objectives {
          id
          objective
          sequence
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetReviewQuery__
 *
 * To run a query within a React component, call `useGetReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetReviewDocument, options);
}
export function useGetReviewLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetReviewDocument, options);
}
export function useGetReviewSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetReviewDocument, options);
}
export const GetStudentAnalyticsBySchoolDocument = gql `
    query GetStudentAnalyticsBySchool($schoolId: ID!) {
  getStudentAnalyticsBySchool(schoolId: $schoolId) {
    success
    message
    count
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      details {
        courses {
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          details {
            modules {
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              details {
                aiTutors {
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  details {
                    objectives {
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentAnalyticsBySchoolQuery__
 *
 * To run a query within a React component, call `useGetStudentAnalyticsBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAnalyticsBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAnalyticsBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetStudentAnalyticsBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentAnalyticsBySchoolDocument, options);
}
export function useGetStudentAnalyticsBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentAnalyticsBySchoolDocument, options);
}
export function useGetStudentAnalyticsBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentAnalyticsBySchoolDocument, options);
}
export const GetStudentAnalyticsForStudentDocument = gql `
    query GetStudentAnalyticsForStudent($schoolId: ID!, $studentId: ID!) {
  getStudentAnalyticsForStudent(schoolId: $schoolId, studentId: $studentId) {
    success
    message
    data {
      id
      label
      success_points
      confusion_points
      questions_asked
      active_interaction_count
      distractions
      sentiment
      completion_percentage
      total_time_taken
      details {
        courses {
          id
          label
          success_points
          confusion_points
          questions_asked
          active_interaction_count
          distractions
          sentiment
          completion_percentage
          total_time_taken
          details {
            modules {
              id
              label
              success_points
              confusion_points
              questions_asked
              active_interaction_count
              distractions
              sentiment
              completion_percentage
              total_time_taken
              details {
                aiTutors {
                  id
                  label
                  success_points
                  confusion_points
                  questions_asked
                  active_interaction_count
                  distractions
                  sentiment
                  completion_percentage
                  total_time_taken
                  details {
                    objectives {
                      id
                      label
                      success_points
                      confusion_points
                      questions_asked
                      active_interaction_count
                      distractions
                      status
                      progress_details {
                        level
                        confusion_points
                        success_points
                        further_recommendations
                        questions_asked
                        distractions
                        sentiment_analysis
                        summary
                        num_messages
                        student_messages_count
                        ai_messages_count
                        average_student_response_time
                        total_time_taken
                      }
                    }
                  }
                  chatAnalytics {
                    id
                    level
                    confusion_points
                    success_points
                    further_recommendations
                    questions_asked
                    distractions
                    sentiment_analysis
                    summary
                    num_messages
                    student_messages_count
                    ai_messages_count
                    average_student_response_time
                    total_time_taken
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetStudentAnalyticsForStudentQuery__
 *
 * To run a query within a React component, call `useGetStudentAnalyticsForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentAnalyticsForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentAnalyticsForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetStudentAnalyticsForStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentAnalyticsForStudentDocument, options);
}
export function useGetStudentAnalyticsForStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentAnalyticsForStudentDocument, options);
}
export function useGetStudentAnalyticsForStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentAnalyticsForStudentDocument, options);
}
export const GetStudentsByCourseIdDocument = gql `
    query GetStudentsByCourseId($courseId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsByCourseId(
    courseId: $courseId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    data {
      id
      name
      email
      pendingCourseEnrollmentInvite
      expiredInvitation
      enrollmentDate
      roles
      analytics {
        success_points
        confusion_points
        questions_asked
        active_interaction_count
        distractions
        sentiment
        completion_percentage
        total_time_taken
      }
    }
    count
  }
}
    `;
/**
 * __useGetStudentsByCourseIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByCourseIdQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsByCourseIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentsByCourseIdDocument, options);
}
export function useGetStudentsByCourseIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentsByCourseIdDocument, options);
}
export function useGetStudentsByCourseIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentsByCourseIdDocument, options);
}
export const GetThreadsByCourseDocument = gql `
    query GetThreadsByCourse($courseId: ID!, $page: Int, $pageSize: Int) {
  getThreadsByCourse(courseId: $courseId, page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      title
      created
      lastModified
      forum {
        id
        course {
          id
          name
        }
      }
      posts {
        id
        message
        depth
        created
        author {
          id
          name
        }
      }
      subscribers {
        id
      }
    }
    count
  }
}
    `;
/**
 * __useGetThreadsByCourseQuery__
 *
 * To run a query within a React component, call `useGetThreadsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetThreadsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetThreadsByCourseDocument, options);
}
export function useGetThreadsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetThreadsByCourseDocument, options);
}
export function useGetThreadsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetThreadsByCourseDocument, options);
}
export const GetUnifiedSubmissionsByFacultyDocument = gql `
    query GetUnifiedSubmissionsByFaculty($input: GetUnifiedSubmissionsByFacultyInput!) {
  getUnifiedSubmissionsByFaculty(input: $input) {
    success
    data {
      submissions {
        id
        created
        submissionType
        moduleName
        submissionTitle
        courseName
        student {
          id
          name
          email
          initials
        }
        submittedOn
        submittedTime
        status
        grade
        maximumPoints
        courseCode
        courseId
        dueDate
        retakeDeadline
        isRetake
        retakeDeadlineSnapshot
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetUnifiedSubmissionsByFacultyQuery__
 *
 * To run a query within a React component, call `useGetUnifiedSubmissionsByFacultyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedSubmissionsByFacultyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedSubmissionsByFacultyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnifiedSubmissionsByFacultyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUnifiedSubmissionsByFacultyDocument, options);
}
export function useGetUnifiedSubmissionsByFacultyLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUnifiedSubmissionsByFacultyDocument, options);
}
export function useGetUnifiedSubmissionsByFacultySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUnifiedSubmissionsByFacultyDocument, options);
}
export const GetUnifiedSubmissionsByFacultyByUserDocument = gql `
    query GetUnifiedSubmissionsByFacultyByUser($input: GetUnifiedSubmissionsByFacultyByUserInput!) {
  getUnifiedSubmissionsByFacultyByUser(input: $input) {
    success
    data {
      submissions {
        id
        created
        submissionType
        moduleName
        submissionTitle
        courseName
        student {
          id
          name
          email
          initials
        }
        submittedOn
        submittedTime
        status
        grade
        maximumPoints
        courseCode
        courseId
        dueDate
        retakeDeadline
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetUnifiedSubmissionsByFacultyByUserQuery__
 *
 * To run a query within a React component, call `useGetUnifiedSubmissionsByFacultyByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedSubmissionsByFacultyByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedSubmissionsByFacultyByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnifiedSubmissionsByFacultyByUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUnifiedSubmissionsByFacultyByUserDocument, options);
}
export function useGetUnifiedSubmissionsByFacultyByUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUnifiedSubmissionsByFacultyByUserDocument, options);
}
export function useGetUnifiedSubmissionsByFacultyByUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUnifiedSubmissionsByFacultyByUserDocument, options);
}
export const ListExternalCoursesDocument = gql `
    query ListExternalCourses($input: ListExternalCoursesInput) {
  listExternalCourses(input: $input) {
    success
    message
    count
    data {
      totalCount
      summary {
        totalCourses
        modernized
        inProgress
        notStarted
      }
      filterOptions {
        faculty {
          label
          value
        }
        terms {
          label
          value
        }
        sourceTypes {
          label
          value
        }
      }
      courses {
        id
        name
        courseCode
        providerCourseId
        sourceType
        sourceLabel
        sourceMeta
        modernizationStatus
        syncedAt
        visibility
        modernizerIntakeSummary {
          id
          intakeStatus
          architect {
            id
            name
            email
            profilePicture
          }
        }
        term {
          id
          label
          season
          year
        }
        modernizedCourses {
          id
          status
          totalScore
          totalMaxScore
          created
          lastModified
        }
        teachingFaculty {
          id
          name
          email
        }
      }
    }
  }
}
    `;
/**
 * __useListExternalCoursesQuery__
 *
 * To run a query within a React component, call `useListExternalCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListExternalCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListExternalCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListExternalCoursesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ListExternalCoursesDocument, options);
}
export function useListExternalCoursesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ListExternalCoursesDocument, options);
}
export function useListExternalCoursesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ListExternalCoursesDocument, options);
}
export const GetAiTutorDocument = gql `
    query getAITutor($id: ID!) {
  getAITutor(id: $id) {
    data {
      id
      title
      description
      created
      lastModified
      dueDate
      context
      targetAudience
      activityState
      scheduledDate
      visualization {
        id
        code
        visualizationType
      }
      hasChatChats {
        id
      }
      objectives {
        id
        objective
        sequence
        evalCriteria
        pendingVideoProcessing
        videos {
          id
          videoId
          title
          url
          thumbnailUrl
          isTeacherAdded
        }
        imagePool {
          id
          url
          objectiveText
          objectiveSequence
          isTeacherUploaded
          description
          created
        }
        status
      }
    }
  }
}
    `;
/**
 * __useGetAiTutorQuery__
 *
 * To run a query within a React component, call `useGetAiTutorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiTutorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiTutorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiTutorQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAiTutorDocument, options);
}
export function useGetAiTutorLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAiTutorDocument, options);
}
export function useGetAiTutorSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAiTutorDocument, options);
}
export const GetAiTutorVideosDocument = gql `
    query GetAiTutorVideos($id: ID!) {
  getAITutorVideos(id: $id) {
    success
    message
    count
    data {
      id
      videoId
      url
      title
      description
      thumbnailUrl
      isTeacherAdded
    }
  }
}
    `;
/**
 * __useGetAiTutorVideosQuery__
 *
 * To run a query within a React component, call `useGetAiTutorVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiTutorVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiTutorVideosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAiTutorVideosQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAiTutorVideosDocument, options);
}
export function useGetAiTutorVideosLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAiTutorVideosDocument, options);
}
export function useGetAiTutorVideosSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAiTutorVideosDocument, options);
}
export const GetAllAiTutorsByCourseDocument = gql `
    query GetAllAiTutorsByCourse($courseIds: [ID!]!) {
  getAllAITutorsByCourse(courseIds: $courseIds) {
    data {
      id
      title
      dueDate
      context
      visualization {
        id
        code
        visualizationType
      }
      objectives {
        id
        objective
        status
        evalCriteria
      }
      courseId
    }
  }
}
    `;
/**
 * __useGetAllAiTutorsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAiTutorsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAiTutorsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAiTutorsByCourseQuery({
 *   variables: {
 *      courseIds: // value for 'courseIds'
 *   },
 * });
 */
export function useGetAllAiTutorsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllAiTutorsByCourseDocument, options);
}
export function useGetAllAiTutorsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllAiTutorsByCourseDocument, options);
}
export function useGetAllAiTutorsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllAiTutorsByCourseDocument, options);
}
export const GetAllAssessmentsByCourseDocument = gql `
    query GetAllAssessmentsByCourse($courseId: ID!) {
  getAllAssessmentsByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      created
      lastModified
      aiTutors {
        id
        title
      }
      moduleHasAssessment {
        id
        title
        courseHasModules {
          id
          name
        }
      }
      activityState
      scheduledDate
      hasReviews {
        id
        moduleHasReviews {
          id
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetAllAssessmentsByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllAssessmentsByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAssessmentsByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAssessmentsByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllAssessmentsByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllAssessmentsByCourseDocument, options);
}
export function useGetAllAssessmentsByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllAssessmentsByCourseDocument, options);
}
export function useGetAllAssessmentsByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllAssessmentsByCourseDocument, options);
}
export const GetAllModulesByCourseDocument = gql `
    query GetAllModulesByCourse($courseId: ID!) {
  getAllModulesByCourse(courseId: $courseId) {
    success
    message
    data {
      id
      title
      thumbnail
      description
      resourceOrder
      aiTutors {
        id
        title
        description
      }
      assignments {
        id
        name
        description
        due_date
      }
      axioResources {
        id
        name
        description
      }
    }
    count
  }
}
    `;
/**
 * __useGetAllModulesByCourseQuery__
 *
 * To run a query within a React component, call `useGetAllModulesByCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllModulesByCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllModulesByCourseQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAllModulesByCourseQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllModulesByCourseDocument, options);
}
export function useGetAllModulesByCourseLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllModulesByCourseDocument, options);
}
export function useGetAllModulesByCourseSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllModulesByCourseDocument, options);
}
export const GetAnnouncementByIdDocument = gql `
    query GetAnnouncementById($id: ID!) {
  getAnnouncementById(id: $id) {
    success
    message
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      audienceType
      scope
    }
    count
  }
}
    `;
/**
 * __useGetAnnouncementByIdQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnnouncementByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAnnouncementByIdDocument, options);
}
export function useGetAnnouncementByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAnnouncementByIdDocument, options);
}
export function useGetAnnouncementByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAnnouncementByIdDocument, options);
}
export const GetAssessmentDocument = gql `
    query getAssessment($assessmentId: ID!) {
  getAssessment(assessmentId: $assessmentId) {
    data {
      id
      created
      lastModified
      assessmentType
      numberOfQuestions
      timeLimit
      freeTextInstructions
      dueDate
      activityState
      scheduledDate
      moduleHasAssessment {
        id
        title
        courseHasModules {
          id
        }
      }
      aiTutors {
        id
        title
      }
    }
  }
}
    `;
/**
 * __useGetAssessmentQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentDocument, options);
}
export function useGetAssessmentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentDocument, options);
}
export function useGetAssessmentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentDocument, options);
}
export const GetAssessmentQuestionBankDocument = gql `
    query getAssessmentQuestionBank($assessmentId: ID!, $pagination: AssessmentQuestionBankPaginationInput) {
  getAssessmentQuestionBank(assessmentId: $assessmentId, pagination: $pagination) {
    count
    socraticTotalCount
    mcqTotalCount
    data {
      id
      assessmentType
      aiTutors {
        id
        title
        questionGenerationStatus
        questions {
          id
          question
          totalScore
          rubrics {
            id
            component
            points
          }
        }
      }
      mcqQuestions {
        id
        created
        lastModified
        question
        choices
        correctChoiceIndices
        explanation
        totalScore
        order
      }
    }
  }
}
    `;
/**
 * __useGetAssessmentQuestionBankQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuestionBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuestionBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuestionBankQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAssessmentQuestionBankQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentQuestionBankDocument, options);
}
export function useGetAssessmentQuestionBankLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentQuestionBankDocument, options);
}
export function useGetAssessmentQuestionBankSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentQuestionBankDocument, options);
}
export const GetAssessmentQuestionBankGenerationStatusDocument = gql `
    query GetAssessmentQuestionBankGenerationStatus($jobId: String!) {
  getAssessmentQuestionBankGenerationStatus(jobId: $jobId) {
    success
    message
    status
    assessmentId
  }
}
    `;
/**
 * __useGetAssessmentQuestionBankGenerationStatusQuery__
 *
 * To run a query within a React component, call `useGetAssessmentQuestionBankGenerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentQuestionBankGenerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentQuestionBankGenerationStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetAssessmentQuestionBankGenerationStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentQuestionBankGenerationStatusDocument, options);
}
export function useGetAssessmentQuestionBankGenerationStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentQuestionBankGenerationStatusDocument, options);
}
export function useGetAssessmentQuestionBankGenerationStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentQuestionBankGenerationStatusDocument, options);
}
export const GetAssessmentSubmissionAttemptHistoryDocument = gql `
    query getAssessmentSubmissionAttemptHistory($assessmentId: ID!, $userId: ID!) {
  getAttemptHistory(assessmentId: $assessmentId, userId: $userId) {
    data {
      assessmentSubmissions {
        id
        created
        lastModified
        startedAt
        completedAt
        totalPoints
        maximumPoints
        hasTeacherGraded
        hasTeacherAdjustedGrade
        retakeAllowed
        retakeDeadline
        isRetake
        retakeDeadlineSnapshot
        status
        timeLimit
        isEvaluationPending
        mcqAnswersConnection {
          edges {
            properties {
              selectedChoiceIndices
            }
            node {
              id
              question
              choices
              order
              explanation
            }
          }
        }
        questionsConnection {
          edges {
            node {
              id
              question
            }
            properties {
              answer
              createdAt
              totalPoints
              maximumPoints
            }
          }
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetAssessmentSubmissionAttemptHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssessmentSubmissionAttemptHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentSubmissionAttemptHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentSubmissionAttemptHistoryQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAssessmentSubmissionAttemptHistoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentSubmissionAttemptHistoryDocument, options);
}
export function useGetAssessmentSubmissionAttemptHistoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentSubmissionAttemptHistoryDocument, options);
}
export function useGetAssessmentSubmissionAttemptHistorySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentSubmissionAttemptHistoryDocument, options);
}
export const GetRunningAssessmentSubmissionByUserDocument = gql `
    query getRunningAssessmentSubmissionByUser {
  getRunningAssessmentSubmissionByUser {
    data {
      id
      status
      retakeAllowed
      retakeDeadline
      isRetake
      retakeDeadlineSnapshot
      assessment {
        id
      }
    }
  }
}
    `;
/**
 * __useGetRunningAssessmentSubmissionByUserQuery__
 *
 * To run a query within a React component, call `useGetRunningAssessmentSubmissionByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRunningAssessmentSubmissionByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunningAssessmentSubmissionByUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRunningAssessmentSubmissionByUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetRunningAssessmentSubmissionByUserDocument, options);
}
export function useGetRunningAssessmentSubmissionByUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetRunningAssessmentSubmissionByUserDocument, options);
}
export function useGetRunningAssessmentSubmissionByUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetRunningAssessmentSubmissionByUserDocument, options);
}
export const GetAssessmentSubmissionsDetailsDocument = gql `
    query GetAssessmentSubmissionsDetails($assessmentSubmissionId: ID!, $studentId: ID) {
  getAssessmentSubmissionDetails(
    assessmentSubmissionId: $assessmentSubmissionId
    studentId: $studentId
  ) {
    success
    data {
      id
      userName
      userId
      userEmail
      status
      completedAt
      startedAt
      totalPoints
      aiTotalPoints
      maximumPoints
      hasTeacherGraded
      hasTeacherAdjustedGrade
      manualOverrideActive
      assessmentId
      assessmentType
      created
      lastModified
      timeLimit
      moduleName
      courseName
      feedback
      retakeAllowed
      retakeDeadline
      isRetake
      retakeDeadlineSnapshot
      questions {
        id
        question
        totalScore
        rubrics {
          id
          component
          points
          pointsAwarded
          aiPointsAwarded
          maxPoints
          remarks
        }
        userAnswer {
          answer
          createdAt
          totalPoints
          aiTotalPoints
          maximumPoints
        }
      }
      mcqAnswers {
        id
        question
        choices
        correctChoiceIndices
        explanation
        totalScore
        order
        selectedChoiceIndices
        isCorrect
        pointsAwarded
      }
    }
  }
}
    `;
/**
 * __useGetAssessmentSubmissionsDetailsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentSubmissionsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentSubmissionsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentSubmissionsDetailsQuery({
 *   variables: {
 *      assessmentSubmissionId: // value for 'assessmentSubmissionId'
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetAssessmentSubmissionsDetailsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentSubmissionsDetailsDocument, options);
}
export function useGetAssessmentSubmissionsDetailsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentSubmissionsDetailsDocument, options);
}
export function useGetAssessmentSubmissionsDetailsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentSubmissionsDetailsDocument, options);
}
export const GetAssessmentSubmissionsForGradingDocument = gql `
    query GetAssessmentSubmissionsForGrading($assessmentId: ID!) {
  getAssessmentSubmissionsForGrading(assessmentId: $assessmentId) {
    success
    message
    count
    data {
      id
      userId
      userName
      userEmail
      submittedAt
      completedAt
      status
      totalPoints
      maximumPoints
      gradePostedToLms
      ltiGradePassbackStatus
    }
  }
}
    `;
/**
 * __useGetAssessmentSubmissionsForGradingQuery__
 *
 * To run a query within a React component, call `useGetAssessmentSubmissionsForGradingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentSubmissionsForGradingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentSubmissionsForGradingQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentSubmissionsForGradingQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentSubmissionsForGradingDocument, options);
}
export function useGetAssessmentSubmissionsForGradingLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentSubmissionsForGradingDocument, options);
}
export function useGetAssessmentSubmissionsForGradingSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentSubmissionsForGradingDocument, options);
}
export const GetAssessmentAiTutorsDocument = gql `
    query getAssessmentAiTutors($moduleId: ID!, $courseId: ID!) {
  getAssessmentAiTutors(moduleId: $moduleId, courseId: $courseId) {
    data {
      currentModuleAiTutors {
        title
        aiTutors {
          id
          title
        }
      }
      pastModulesAiTutors {
        id
        title
        aiTutors {
          id
          title
        }
      }
      futureModulesAiTutors {
        id
        title
        aiTutors {
          id
          title
        }
      }
    }
  }
}
    `;
/**
 * __useGetAssessmentAiTutorsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentAiTutorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentAiTutorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentAiTutorsQuery({
 *   variables: {
 *      moduleId: // value for 'moduleId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetAssessmentAiTutorsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssessmentAiTutorsDocument, options);
}
export function useGetAssessmentAiTutorsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssessmentAiTutorsDocument, options);
}
export function useGetAssessmentAiTutorsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssessmentAiTutorsDocument, options);
}
export const GetAssignmentDocument = gql `
    query getAssignment($id: ID!) {
  getAssignment(id: $id) {
    success
    message
    data {
      id
      name
      description
      due_date
      enableStudentFileUpload
      files {
        id
        fileName
        fileURL
        created
        status
      }
      videoUrl
      created
      lastModified
      usersHasSchoolAssignmentConnection {
        edges {
          node {
            id
          }
          properties {
            retakeAllowed
            retakeDeadline
          }
        }
      }
      worksheet {
        id
        title
        coverage
        instructions
        numQuestions
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
    }
  }
}
    `;
/**
 * __useGetAssignmentQuery__
 *
 * To run a query within a React component, call `useGetAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssignmentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssignmentDocument, options);
}
export function useGetAssignmentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssignmentDocument, options);
}
export function useGetAssignmentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssignmentDocument, options);
}
export const GetAssignmentAndSubmissionBySubmissionIdDocument = gql `
    query getAssignmentAndSubmissionBySubmissionId($submissionId: ID!) {
  getAssignmentAndSubmissionBySubmissionId(submissionId: $submissionId) {
    success
    data {
      assignment {
        id
        name
        description
        due_date
        usersHasSchoolAssignmentConnection {
          edges {
            properties {
              retakeAllowed
              retakeDeadline
            }
          }
        }
      }
      submission {
        id
        created
        lastModified
        grade
        isCompleted
        completedAt
        feedback
        hasTeacherGraded
        wordCount
        isExcused
        isMissing
        isLateAllowed
        files {
          id
          fileName
          fileURL
          created
          status
        }
        feedbackFiles {
          id
          fileName
          fileURL
          created
          status
        }
      }
    }
  }
}
    `;
/**
 * __useGetAssignmentAndSubmissionBySubmissionIdQuery__
 *
 * To run a query within a React component, call `useGetAssignmentAndSubmissionBySubmissionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentAndSubmissionBySubmissionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentAndSubmissionBySubmissionIdQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetAssignmentAndSubmissionBySubmissionIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
}
export function useGetAssignmentAndSubmissionBySubmissionIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
}
export function useGetAssignmentAndSubmissionBySubmissionIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssignmentAndSubmissionBySubmissionIdDocument, options);
}
export const GetAssignmentSubmissionAttemptHistoryDocument = gql `
    query getAssignmentSubmissionAttemptHistory($assignmentId: ID!, $userId: ID!) {
  getAssignmentSubmissionAttemptHistory(
    assignmentId: $assignmentId
    userId: $userId
  ) {
    data {
      submissions {
        id
        created
        lastModified
        grade
        isCompleted
        completedAt
        hasTeacherGraded
        feedback
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetAssignmentSubmissionAttemptHistoryQuery__
 *
 * To run a query within a React component, call `useGetAssignmentSubmissionAttemptHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssignmentSubmissionAttemptHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssignmentSubmissionAttemptHistoryQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetAssignmentSubmissionAttemptHistoryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAssignmentSubmissionAttemptHistoryDocument, options);
}
export function useGetAssignmentSubmissionAttemptHistoryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAssignmentSubmissionAttemptHistoryDocument, options);
}
export function useGetAssignmentSubmissionAttemptHistorySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAssignmentSubmissionAttemptHistoryDocument, options);
}
export const GetCourseActivitiesProgressDocument = gql `
    query GetCourseActivitiesProgress($id: ID!) {
  getCourseActivitiesProgress(id: $id) {
    data {
      id
      name
      modules {
        id
        title
        resourceOrder
        aiTutors {
          id
          title
          lastModified
          dueDate
          activityState
          scheduledDate
          objectives {
            id
            userHasProgressConnection {
              edges {
                properties {
                  status
                }
              }
            }
          }
        }
        axioResources {
          id
          name
          description
          videoUrl
          lastModified
          activityState
          scheduledDate
          files {
            id
            fileName
            fileURL
          }
        }
        assignments {
          id
          name
          description
          due_date
          videoUrl
          lastModified
          activityState
          scheduledDate
          submissions {
            id
            created
            grade
            hasTeacherGraded
          }
          files {
            id
          }
        }
        assessment {
          id
          assessmentType
          lastModified
          dueDate
          activityState
          scheduledDate
          aiTutors {
            id
          }
          submissions {
            id
            created
            status
            isEvaluationPending
            totalPoints
            maximumPoints
            retakeAllowed
            retakeDeadline
          }
        }
        projects {
          id
          name
          description
          status
          lastModified
          dueDate
          expectedOutcomes
          scopeDocument
          deliverableTypes
          assessmentCriteria
          activityState
          scheduledDate
        }
        reviews {
          id
          lastModified
          activityState
          scheduledDate
          hasReviewFor {
            id
            moduleHasAssessment {
              id
              title
            }
          }
          generatingReviewAITutorForConnection {
            edges {
              node {
                id
              }
              properties {
                isGenerating
              }
            }
          }
          hasAITutors {
            id
            created
            reviewForUser {
              id
            }
            objectives {
              id
              userHasProgressConnection {
                edges {
                  properties {
                    status
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseActivitiesProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseActivitiesProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseActivitiesProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseActivitiesProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseActivitiesProgressQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseActivitiesProgressDocument, options);
}
export function useGetCourseActivitiesProgressLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseActivitiesProgressDocument, options);
}
export function useGetCourseActivitiesProgressSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseActivitiesProgressDocument, options);
}
export const GetCourseAdminStatsDocument = gql `
    query GetCourseAdminStats($id: ID!) {
  getCourseAdminStats(id: $id) {
    data {
      id
      name
      isDraft
      enrolledStudents {
        id
      }
      modules {
        id
        assignments {
          id
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseAdminStatsQuery__
 *
 * To run a query within a React component, call `useGetCourseAdminStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseAdminStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseAdminStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseAdminStatsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseAdminStatsDocument, options);
}
export function useGetCourseAdminStatsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseAdminStatsDocument, options);
}
export function useGetCourseAdminStatsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseAdminStatsDocument, options);
}
export const GetCourseByIdWithEnrolledUserInfoDocument = gql `
    query GetCourseByIdWithEnrolledUserInfo($id: ID!) {
  getCourseByIdWithEnrolledUserInfo(id: $id) {
    data {
      id
      name
      course_code
      description
      cost
      startDate
      endDate
      dueDateStartDate
      dueDateEndDate
      isDraft
      isEnrollmentAvailable
      learningStandards
      lengthInWeeks
      generationStatus
      targetAudience
      objectives
      thumbnail
      last_modified
      stripeProductId
      enrolledStudentsConnection {
        edges {
          node {
            id
          }
          properties {
            pendingCourseEnrollmentInvite
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseByIdWithEnrolledUserInfoQuery__
 *
 * To run a query within a React component, call `useGetCourseByIdWithEnrolledUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseByIdWithEnrolledUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseByIdWithEnrolledUserInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseByIdWithEnrolledUserInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseByIdWithEnrolledUserInfoDocument, options);
}
export function useGetCourseByIdWithEnrolledUserInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseByIdWithEnrolledUserInfoDocument, options);
}
export function useGetCourseByIdWithEnrolledUserInfoSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseByIdWithEnrolledUserInfoDocument, options);
}
export const GetCourseChatResourcesDocument = gql `
    query GetCourseChatResources($id: ID!) {
  getCourseChatResources(id: $id) {
    data {
      id
      modules {
        id
        resourceOrder
        aiTutors {
          id
          title
          lastModified
        }
        axioResources {
          id
          name
          lastModified
        }
        assignments {
          id
          name
          lastModified
        }
        assessment {
          id
          lastModified
        }
        projects {
          id
          name
          lastModified
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseChatResourcesQuery__
 *
 * To run a query within a React component, call `useGetCourseChatResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseChatResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseChatResourcesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseChatResourcesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseChatResourcesDocument, options);
}
export function useGetCourseChatResourcesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseChatResourcesDocument, options);
}
export function useGetCourseChatResourcesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseChatResourcesDocument, options);
}
export const GetCourseCoreDocument = gql `
    query GetCourseCore($id: ID!) {
  getCourseCore(id: $id) {
    data {
      id
      name
      course_code
      description
      moduleOrder
      cost
      startDate
      endDate
      dueDateStartDate
      dueDateEndDate
      isDraft
      isEnrollmentAvailable
      generationStatus
      targetAudience
      objectives
      thumbnail
      stripeProductId
      preRequisites {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useGetCourseCoreQuery__
 *
 * To run a query within a React component, call `useGetCourseCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseCoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseCoreQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseCoreDocument, options);
}
export function useGetCourseCoreLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseCoreDocument, options);
}
export function useGetCourseCoreSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseCoreDocument, options);
}
export const GetCourseModulesActivitiesLiteDocument = gql `
    query GetCourseModulesActivitiesLite($id: ID!) {
  getCourseModulesActivitiesLite(id: $id) {
    data {
      id
      name
      isDraft
      generationStatus
      moduleOrder
      modules {
        id
        title
        description
        thumbnail
        imageGenerationStatus
        resourceOrder
        aiTutors {
          id
          title
          lastModified
          dueDate
          activityState
          scheduledDate
          objectives {
            id
            pendingVideoProcessing
          }
        }
        pages {
          id
          title
          lastModified
        }
        assessment {
          id
          assessmentType
          lastModified
          dueDate
          activityState
          scheduledDate
          aiTutors {
            id
          }
          moduleHasAssessment {
            id
            title
          }
        }
        axioResources {
          id
          name
          lastModified
          activityState
          scheduledDate
        }
        assignments {
          id
          name
          lastModified
          due_date
          activityState
          scheduledDate
        }
        projects {
          id
          name
          lastModified
          activityState
          scheduledDate
        }
        reviews {
          id
          lastModified
          activityState
          scheduledDate
          hasReviewFor {
            id
            moduleHasAssessment {
              id
              title
            }
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetCourseModulesActivitiesLiteQuery__
 *
 * To run a query within a React component, call `useGetCourseModulesActivitiesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModulesActivitiesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModulesActivitiesLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseModulesActivitiesLiteQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseModulesActivitiesLiteDocument, options);
}
export function useGetCourseModulesActivitiesLiteLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseModulesActivitiesLiteDocument, options);
}
export function useGetCourseModulesActivitiesLiteSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseModulesActivitiesLiteDocument, options);
}
export const GetCourseModulesLiteDocument = gql `
    query GetCourseModulesLite($id: ID!) {
  getCourseModulesLite(id: $id) {
    data {
      id
      name
      course_code
      description
      moduleOrder
      thumbnail
      isDraft
      isEnrollmentAvailable
      preRequisites {
        id
        name
      }
      modules {
        id
        title
        description
        thumbnail
        imageGenerationStatus
        resourceOrder
      }
    }
  }
}
    `;
/**
 * __useGetCourseModulesLiteQuery__
 *
 * To run a query within a React component, call `useGetCourseModulesLiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseModulesLiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseModulesLiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseModulesLiteQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseModulesLiteDocument, options);
}
export function useGetCourseModulesLiteLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseModulesLiteDocument, options);
}
export function useGetCourseModulesLiteSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseModulesLiteDocument, options);
}
export const GetCourseProgressInformationDocument = gql `
    query GetCourseProgressInformation($courseId: ID!) {
  getCourseProgressInformation(courseId: $courseId) {
    success
    message
    count
    data {
      courseId
      progress
      totalModules
      completedModules
      modules {
        id
        title
        progress
        totalActivities
        completedActivities
      }
    }
  }
}
    `;
/**
 * __useGetCourseProgressInformationQuery__
 *
 * To run a query within a React component, call `useGetCourseProgressInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgressInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgressInformationQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseProgressInformationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseProgressInformationDocument, options);
}
export function useGetCourseProgressInformationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseProgressInformationDocument, options);
}
export function useGetCourseProgressInformationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseProgressInformationDocument, options);
}
export const CoursesAndAssignmentsDocument = gql `
    query CoursesAndAssignments($schoolId: ID!) {
  getCoursesAndAssignments(schoolId: $schoolId) {
    success
    message
    data {
      courses {
        id
        name
        course_code
        assignments {
          id
          name
          description
          due_date
          points_possible
          created
        }
      }
    }
    count
  }
}
    `;
/**
 * __useCoursesAndAssignmentsQuery__
 *
 * To run a query within a React component, call `useCoursesAndAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoursesAndAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoursesAndAssignmentsQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useCoursesAndAssignmentsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(CoursesAndAssignmentsDocument, options);
}
export function useCoursesAndAssignmentsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(CoursesAndAssignmentsDocument, options);
}
export function useCoursesAndAssignmentsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(CoursesAndAssignmentsDocument, options);
}
export const GetCoursesForTranscriptGenerationDocument = gql `
    query GetCoursesForTranscriptGeneration($schoolId: ID!) {
  getCoursesForTranscriptGeneration(schoolId: $schoolId) {
    success
    message
    data {
      id
      name
      modules {
        title
        aiTutors {
          title
          id
          hasChatChats {
            id
            date
            name
            context
            params
            hasMessageMessages {
              id
              content
              index
              parameters
              aspectDetails
              sender
              created
              snackType
              type
            }
          }
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetCoursesForTranscriptGenerationQuery__
 *
 * To run a query within a React component, call `useGetCoursesForTranscriptGenerationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoursesForTranscriptGenerationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoursesForTranscriptGenerationQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetCoursesForTranscriptGenerationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCoursesForTranscriptGenerationDocument, options);
}
export function useGetCoursesForTranscriptGenerationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCoursesForTranscriptGenerationDocument, options);
}
export function useGetCoursesForTranscriptGenerationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCoursesForTranscriptGenerationDocument, options);
}
export const GetDueSoonActivitiesBySchoolAndUserDocument = gql `
    query GetDueSoonActivitiesBySchoolAndUser($schoolId: ID!) {
  getDueSoonActivitiesBySchoolAndUser(schoolId: $schoolId) {
    success
    data {
      id
      name
      modules {
        id
        title
        assignments {
          id
          name
          description
          due_date
          submissions {
            id
            isCompleted
            completedAt
          }
        }
        aiTutors {
          id
          title
          description
          dueDate
          objectives {
            id
            objective
            sequence
            userHasProgressConnection {
              edges {
                properties {
                  status
                }
              }
            }
          }
        }
      }
    }
    count
  }
}
    `;
/**
 * __useGetDueSoonActivitiesBySchoolAndUserQuery__
 *
 * To run a query within a React component, call `useGetDueSoonActivitiesBySchoolAndUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDueSoonActivitiesBySchoolAndUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDueSoonActivitiesBySchoolAndUserQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetDueSoonActivitiesBySchoolAndUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDueSoonActivitiesBySchoolAndUserDocument, options);
}
export function useGetDueSoonActivitiesBySchoolAndUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDueSoonActivitiesBySchoolAndUserDocument, options);
}
export function useGetDueSoonActivitiesBySchoolAndUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDueSoonActivitiesBySchoolAndUserDocument, options);
}
export const GetEnrolledCoursesForStudentDocument = gql `
    query GetEnrolledCoursesForStudent($schoolId: ID!, $studentId: ID, $degreeId: ID, $page: Int, $pageSize: Int) {
  getEnrolledCoursesForStudent(
    schoolId: $schoolId
    studentId: $studentId
    degreeId: $degreeId
    page: $page
    pageSize: $pageSize
  ) {
    data {
      courses {
        course {
          id
          name
          course_code
          isDraft
          learningStandards
          lengthInWeeks
          objectives
          last_modified
          thumbnail
          cost
          startDate
          description
          targetAudience
          generationStatus
          preRequisites {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          preRequisiteFor {
            id
            name
            cost
            description
            enrolledStudents {
              id
              name
            }
          }
          modules {
            id
            title
            assignments {
              id
              name
            }
            aiTutors {
              id
              title
            }
            axioResources {
              id
              name
            }
          }
          enrolledStudents {
            id
            name
          }
          degreesHasCourse {
            id
            name
            usersEnrolledIn {
              id
              name
            }
          }
        }
        progress
        preRequisitesCompleted
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetEnrolledCoursesForStudentQuery__
 *
 * To run a query within a React component, call `useGetEnrolledCoursesForStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrolledCoursesForStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrolledCoursesForStudentQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      studentId: // value for 'studentId'
 *      degreeId: // value for 'degreeId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetEnrolledCoursesForStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEnrolledCoursesForStudentDocument, options);
}
export function useGetEnrolledCoursesForStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEnrolledCoursesForStudentDocument, options);
}
export function useGetEnrolledCoursesForStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetEnrolledCoursesForStudentDocument, options);
}
export const GetGradingCenterDashboardDataDocument = gql `
    query getGradingCenterDashboardData($facultyId: ID!) {
  getGradingCenterDashboardData(facultyId: $facultyId) {
    success
    message
    data {
      assignmentsAndAssessmentsToGrade
      newSubmissionsToday
    }
  }
}
    `;
/**
 * __useGetGradingCenterDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetGradingCenterDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGradingCenterDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGradingCenterDashboardDataQuery({
 *   variables: {
 *      facultyId: // value for 'facultyId'
 *   },
 * });
 */
export function useGetGradingCenterDashboardDataQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetGradingCenterDashboardDataDocument, options);
}
export function useGetGradingCenterDashboardDataLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetGradingCenterDashboardDataDocument, options);
}
export function useGetGradingCenterDashboardDataSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetGradingCenterDashboardDataDocument, options);
}
export const GetIsRoomDeletedDocument = gql `
    query getIsRoomDeleted {
  getIsRoomDeleted {
    success
    data
  }
}
    `;
/**
 * __useGetIsRoomDeletedQuery__
 *
 * To run a query within a React component, call `useGetIsRoomDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsRoomDeletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsRoomDeletedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsRoomDeletedQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetIsRoomDeletedDocument, options);
}
export function useGetIsRoomDeletedLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetIsRoomDeletedDocument, options);
}
export function useGetIsRoomDeletedSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetIsRoomDeletedDocument, options);
}
export const GetOralAssessmentSessionStateDocument = gql `
    query GetOralAssessmentSessionState($submissionId: ID!) {
  getOralAssessmentSessionState(submissionId: $submissionId) {
    success
    message
    data {
      submissionId
      assessmentId
      status
      serverTimeMs
      remainingSec
      totalDurationSec
      introText
      introAudioUrl
      introAudioFileId
      currentTurn {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
      questions {
        questionIndex
        questionId
        questionText
        questionAudioUrl
        questionAudioFileId
      }
    }
  }
}
    `;
/**
 * __useGetOralAssessmentSessionStateQuery__
 *
 * To run a query within a React component, call `useGetOralAssessmentSessionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOralAssessmentSessionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOralAssessmentSessionStateQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetOralAssessmentSessionStateQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOralAssessmentSessionStateDocument, options);
}
export function useGetOralAssessmentSessionStateLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOralAssessmentSessionStateDocument, options);
}
export function useGetOralAssessmentSessionStateSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetOralAssessmentSessionStateDocument, options);
}
export const GetUserAnnouncementsDocument = gql `
    query getUserAnnouncements($page: Int!, $pageSize: Int!) {
  getUserAnnouncements(page: $page, pageSize: $pageSize) {
    success
    message
    count
    data {
      id
      title
      message
      expirationDate
      created
      lastModified
      isActive
      isNew
      audienceType
      author {
        id
        name
      }
      courses {
        id
        name
      }
      degrees {
        id
        name
      }
      school {
        id
        provider_name
      }
    }
  }
}
    `;
/**
 * __useGetUserAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetUserAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAnnouncementsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetUserAnnouncementsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAnnouncementsDocument, options);
}
export function useGetUserAnnouncementsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAnnouncementsDocument, options);
}
export function useGetUserAnnouncementsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserAnnouncementsDocument, options);
}
export const GetUserSubmissionsDocument = gql `
    query getUserSubmissions($assignmentId: ID!) {
  getUserSubmissions(assignmentId: $assignmentId) {
    success
    message
    data {
      id
      isCompleted
      completedAt
      hasTeacherGraded
      grade
      feedback
      created
      files {
        id
        fileName
        fileURL
        created
        status
      }
      feedbackFiles {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;
/**
 * __useGetUserSubmissionsQuery__
 *
 * To run a query within a React component, call `useGetUserSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubmissionsQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useGetUserSubmissionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserSubmissionsDocument, options);
}
export function useGetUserSubmissionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserSubmissionsDocument, options);
}
export function useGetUserSubmissionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserSubmissionsDocument, options);
}
export const GetWorksheetDocument = gql `
    query getWorksheet($id: ID!) {
  getWorksheet(id: $id) {
    success
    message
    data {
      worksheetId
      pdfUrl
      generationStatus
    }
  }
}
    `;
/**
 * __useGetWorksheetQuery__
 *
 * To run a query within a React component, call `useGetWorksheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorksheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorksheetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorksheetQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetWorksheetDocument, options);
}
export function useGetWorksheetLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetWorksheetDocument, options);
}
export function useGetWorksheetSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetWorksheetDocument, options);
}
export const GetProjectDocument = gql `
    query GetProject($id: ID!) {
  getProject(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;
/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectDocument, options);
}
export function useGetProjectLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectDocument, options);
}
export function useGetProjectSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectDocument, options);
}
export const GetProjectFrameworkDocument = gql `
    query GetProjectFramework($id: ID!) {
  getProject(id: $id) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;
/**
 * __useGetProjectFrameworkQuery__
 *
 * To run a query within a React component, call `useGetProjectFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFrameworkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectFrameworkQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectFrameworkDocument, options);
}
export function useGetProjectFrameworkLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectFrameworkDocument, options);
}
export function useGetProjectFrameworkSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectFrameworkDocument, options);
}
export const GetProjectsByStudentDocument = gql `
    query GetProjectsByStudent($page: Int, $pageSize: Int) {
  getProjectsByStudent(page: $page, pageSize: $pageSize) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
      files {
        id
        fileName
        fileURL
        created
        status
      }
    }
  }
}
    `;
/**
 * __useGetProjectsByStudentQuery__
 *
 * To run a query within a React component, call `useGetProjectsByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByStudentQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProjectsByStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectsByStudentDocument, options);
}
export function useGetProjectsByStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectsByStudentDocument, options);
}
export function useGetProjectsByStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectsByStudentDocument, options);
}
export const GetProjectSubmissionDocument = gql `
    query GetProjectSubmission($id: ID!) {
  getProjectSubmission(id: $id) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      gradedAt
      isExcused
      isMissing
      isLateAllowed
      feedback
      created
      lastModified
      totalTasks
      completedTasks
      submissionLink
      submissionNotes
      files {
        id
        fileName
        fileURL
        created
        status
      }
      requirements {
        id
        title
        description
        type
        priority
        completed
      }
      rubricScores {
        id
        criterionId
        criterionName
        earnedPoints
        maxPoints
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
        rubricCriteria {
          id
          name
          maxPoints
          displayOrder
        }
      }
      user {
        id
      }
    }
  }
}
    `;
/**
 * __useGetProjectSubmissionQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectSubmissionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectSubmissionDocument, options);
}
export function useGetProjectSubmissionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectSubmissionDocument, options);
}
export function useGetProjectSubmissionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectSubmissionDocument, options);
}
export const GetProjectSubmissionsByProjectDocument = gql `
    query GetProjectSubmissionsByProject($projectId: ID!) {
  getProjectSubmissionsByProject(projectId: $projectId) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      gradedAt
      feedback
      created
      lastModified
      totalTasks
      completedTasks
      submissionLink
      submissionNotes
      files {
        id
        fileName
        fileURL
        created
        status
      }
      requirements {
        id
        title
        description
        type
        priority
        category
        estimatedHours
        completed
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
      user {
        id
      }
    }
  }
}
    `;
/**
 * __useGetProjectSubmissionsByProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionsByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectSubmissionsByProjectQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectSubmissionsByProjectDocument, options);
}
export function useGetProjectSubmissionsByProjectLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectSubmissionsByProjectDocument, options);
}
export function useGetProjectSubmissionsByProjectSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectSubmissionsByProjectDocument, options);
}
export const GetProjectSubmissionsByStudentDocument = gql `
    query GetProjectSubmissionsByStudent($studentId: ID!) {
  getProjectSubmissionsByStudent(studentId: $studentId) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      created
      lastModified
      totalTasks
      completedTasks
      requirements {
        id
        title
        description
        type
        priority
        completed
      }
      project {
        id
        moduleId
        order
        name
        description
        scopeDocument
        deliverableTypes
        assessmentCriteria
        expectedOutcomes
        status
        dueDate
        created
        lastModified
        files {
          id
          fileName
          fileURL
          created
          status
        }
      }
      user {
        id
      }
    }
  }
}
    `;
/**
 * __useGetProjectSubmissionsByStudentQuery__
 *
 * To run a query within a React component, call `useGetProjectSubmissionsByStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectSubmissionsByStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectSubmissionsByStudentQuery({
 *   variables: {
 *      studentId: // value for 'studentId'
 *   },
 * });
 */
export function useGetProjectSubmissionsByStudentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetProjectSubmissionsByStudentDocument, options);
}
export function useGetProjectSubmissionsByStudentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetProjectSubmissionsByStudentDocument, options);
}
export function useGetProjectSubmissionsByStudentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetProjectSubmissionsByStudentDocument, options);
}
export const CreateProjectDocument = gql `
    mutation CreateProject($project: CreateProjectInput!) {
  createProject(project: $project) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      created
      lastModified
    }
  }
}
    `;
/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateProjectDocument, options);
}
export const UpdateProjectDocument = gql `
    mutation UpdateProject($id: ID!, $project: UpdateProjectInput!) {
  updateProject(id: $id, project: $project) {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      deliverableTypes
      assessmentCriteria
      expectedOutcomes
      status
      dueDate
      lastModified
    }
  }
}
    `;
/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      project: // value for 'project'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateProjectDocument, options);
}
export const DeleteProjectDocument = gql `
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteProjectDocument, options);
}
export const CreateProjectSubmissionDocument = gql `
    mutation CreateProjectSubmission($submission: CreateProjectSubmissionInput!) {
  createProjectSubmission(submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      created
      lastModified
    }
  }
}
    `;
/**
 * __useCreateProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useCreateProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectSubmissionMutation, { data, loading, error }] = useCreateProjectSubmissionMutation({
 *   variables: {
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useCreateProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateProjectSubmissionDocument, options);
}
export const UpdateProjectSubmissionDocument = gql `
    mutation UpdateProjectSubmission($id: ID!, $submission: UpdateProjectSubmissionInput!) {
  updateProjectSubmission(id: $id, submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      lastModified
    }
  }
}
    `;
/**
 * __useUpdateProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSubmissionMutation, { data, loading, error }] = useUpdateProjectSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useUpdateProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateProjectSubmissionDocument, options);
}
export const SubmitProjectForReviewDocument = gql `
    mutation SubmitProjectForReview($submissionId: ID!) {
  submitProjectForReview(submissionId: $submissionId) {
    success
    message
    data {
      id
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      lastModified
    }
  }
}
    `;
/**
 * __useSubmitProjectForReviewMutation__
 *
 * To run a mutation, you first call `useSubmitProjectForReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProjectForReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProjectForReviewMutation, { data, loading, error }] = useSubmitProjectForReviewMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useSubmitProjectForReviewMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitProjectForReviewDocument, options);
}
export const ApproveProjectSubmissionDocument = gql `
    mutation ApproveProjectSubmission($submissionId: ID!) {
  approveProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      status
      lastModified
    }
  }
}
    `;
/**
 * __useApproveProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useApproveProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveProjectSubmissionMutation, { data, loading, error }] = useApproveProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useApproveProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ApproveProjectSubmissionDocument, options);
}
export const RejectProjectSubmissionDocument = gql `
    mutation RejectProjectSubmission($submissionId: ID!, $reason: String!) {
  rejectProjectSubmission(submissionId: $submissionId, reason: $reason) {
    success
    message
    data {
      id
      status
      lastModified
    }
  }
}
    `;
/**
 * __useRejectProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useRejectProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectProjectSubmissionMutation, { data, loading, error }] = useRejectProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRejectProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(RejectProjectSubmissionDocument, options);
}
export const GradeProjectSubmissionDocument = gql `
    mutation GradeProjectSubmission($submissionId: ID!, $grade: Float!, $feedback: String, $rubricScores: [ProjectRubricScoreInput!]) {
  gradeProjectSubmission(
    submissionId: $submissionId
    grade: $grade
    feedback: $feedback
    rubricScores: $rubricScores
  ) {
    success
    message
    data {
      id
      grade
      hasTeacherGraded
      isCompleted
      completedAt
      lastModified
    }
  }
}
    `;
/**
 * __useGradeProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useGradeProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeProjectSubmissionMutation, { data, loading, error }] = useGradeProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      grade: // value for 'grade'
 *      feedback: // value for 'feedback'
 *      rubricScores: // value for 'rubricScores'
 *   },
 * });
 */
export function useGradeProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GradeProjectSubmissionDocument, options);
}
export const ResubmitProjectProposalDocument = gql `
    mutation ResubmitProjectProposal($submissionId: ID!, $submission: UpdateProjectSubmissionInput!) {
  resubmitProjectProposal(submissionId: $submissionId, submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      status
      vettingStatus
      lastModified
    }
  }
}
    `;
/**
 * __useResubmitProjectProposalMutation__
 *
 * To run a mutation, you first call `useResubmitProjectProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResubmitProjectProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resubmitProjectProposalMutation, { data, loading, error }] = useResubmitProjectProposalMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useResubmitProjectProposalMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ResubmitProjectProposalDocument, options);
}
export const GetActiveProjectsDocument = gql `
    query GetActiveProjects {
  getProjectsByStudent {
    success
    message
    data {
      id
      moduleId
      order
      name
      description
      scopeDocument
      status
      dueDate
      created
      lastModified
      submissions {
        id
        status
        vettingStatus
        complianceScore
        requirements {
          id
          title
          description
          type
          priority
          completed
        }
        completedTasks
        totalTasks
      }
    }
  }
}
    `;
/**
 * __useGetActiveProjectsQuery__
 *
 * To run a query within a React component, call `useGetActiveProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveProjectsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetActiveProjectsDocument, options);
}
export function useGetActiveProjectsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetActiveProjectsDocument, options);
}
export function useGetActiveProjectsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetActiveProjectsDocument, options);
}
export const GetSubmissionRequirementsDocument = gql `
    query GetSubmissionRequirements($submissionId: ID!) {
  getSubmissionRequirements(submissionId: $submissionId) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      order
      completed
      completedDate
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;
/**
 * __useGetSubmissionRequirementsQuery__
 *
 * To run a query within a React component, call `useGetSubmissionRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubmissionRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubmissionRequirementsQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGetSubmissionRequirementsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSubmissionRequirementsDocument, options);
}
export function useGetSubmissionRequirementsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSubmissionRequirementsDocument, options);
}
export function useGetSubmissionRequirementsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSubmissionRequirementsDocument, options);
}
export const CreateProjectRequirementDocument = gql `
    mutation CreateProjectRequirement($requirement: CreateProjectRequirementInput!) {
  createProjectRequirement(requirement: $requirement) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;
/**
 * __useCreateProjectRequirementMutation__
 *
 * To run a mutation, you first call `useCreateProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectRequirementMutation, { data, loading, error }] = useCreateProjectRequirementMutation({
 *   variables: {
 *      requirement: // value for 'requirement'
 *   },
 * });
 */
export function useCreateProjectRequirementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(CreateProjectRequirementDocument, options);
}
export const UpdateProjectRequirementDocument = gql `
    mutation UpdateProjectRequirement($id: ID!, $requirement: UpdateProjectRequirementInput!) {
  updateProjectRequirement(id: $id, requirement: $requirement) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      completedDate
      lastModified
    }
  }
}
    `;
/**
 * __useUpdateProjectRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRequirementMutation, { data, loading, error }] = useUpdateProjectRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      requirement: // value for 'requirement'
 *   },
 * });
 */
export function useUpdateProjectRequirementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateProjectRequirementDocument, options);
}
export const MarkProjectRequirementCompleteDocument = gql `
    mutation MarkProjectRequirementComplete($id: ID!) {
  markProjectRequirementComplete(id: $id) {
    success
    message
    data {
      id
      completed
      completedDate
      lastModified
    }
  }
}
    `;
/**
 * __useMarkProjectRequirementCompleteMutation__
 *
 * To run a mutation, you first call `useMarkProjectRequirementCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProjectRequirementCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProjectRequirementCompleteMutation, { data, loading, error }] = useMarkProjectRequirementCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkProjectRequirementCompleteMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkProjectRequirementCompleteDocument, options);
}
export const DeleteProjectRequirementDocument = gql `
    mutation DeleteProjectRequirement($id: ID!) {
  deleteProjectRequirement(id: $id) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteProjectRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteProjectRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectRequirementMutation, { data, loading, error }] = useDeleteProjectRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectRequirementMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteProjectRequirementDocument, options);
}
export const GenerateProjectRequirementsDocument = gql `
    mutation GenerateProjectRequirements($projectId: ID!, $submissionId: ID!) {
  generateProjectRequirements(projectId: $projectId, submissionId: $submissionId) {
    success
    message
    data {
      id
      title
      description
      type
      priority
      estimatedHours
      dueDate
      dependencies
      completed
      isGenerated
      aiRationale
      created
      lastModified
    }
  }
}
    `;
/**
 * __useGenerateProjectRequirementsMutation__
 *
 * To run a mutation, you first call `useGenerateProjectRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectRequirementsMutation, { data, loading, error }] = useGenerateProjectRequirementsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useGenerateProjectRequirementsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(GenerateProjectRequirementsDocument, options);
}
export const SubmitFinalProjectDocument = gql `
    mutation SubmitFinalProject($submission: SubmitFinalProjectInput!) {
  submitFinalProject(submission: $submission) {
    success
    message
    data {
      id
      proposal
      approachMethodology
      scopeJustification
      expectedOutcomes
      grade
      isCompleted
      completedAt
      hasTeacherGraded
      status
      vettingStatus
      complianceScore
      aiAssessment
      suggestedImprovements
      created
      lastModified
    }
  }
}
    `;
/**
 * __useSubmitFinalProjectMutation__
 *
 * To run a mutation, you first call `useSubmitFinalProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFinalProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFinalProjectMutation, { data, loading, error }] = useSubmitFinalProjectMutation({
 *   variables: {
 *      submission: // value for 'submission'
 *   },
 * });
 */
export function useSubmitFinalProjectMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitFinalProjectDocument, options);
}
export const SubmitProjectSubmissionFilesDocument = gql `
    mutation SubmitProjectSubmissionFiles($submissionId: ID!, $files: [FileInput!]!) {
  submitProjectSubmissionFiles(submissionId: $submissionId, files: $files) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useSubmitProjectSubmissionFilesMutation__
 *
 * To run a mutation, you first call `useSubmitProjectSubmissionFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitProjectSubmissionFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitProjectSubmissionFilesMutation, { data, loading, error }] = useSubmitProjectSubmissionFilesMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSubmitProjectSubmissionFilesMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SubmitProjectSubmissionFilesDocument, options);
}
export const DeleteProjectSubmissionDocument = gql `
    mutation DeleteProjectSubmission($submissionId: ID!) {
  deleteProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
    }
  }
}
    `;
/**
 * __useDeleteProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectSubmissionMutation, { data, loading, error }] = useDeleteProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useDeleteProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteProjectSubmissionDocument, options);
}
export const ExcuseProjectSubmissionDocument = gql `
    mutation ExcuseProjectSubmission($submissionId: ID!) {
  excuseProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useExcuseProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useExcuseProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExcuseProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [excuseProjectSubmissionMutation, { data, loading, error }] = useExcuseProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useExcuseProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ExcuseProjectSubmissionDocument, options);
}
export const MarkProjectSubmissionMissingDocument = gql `
    mutation MarkProjectSubmissionMissing($submissionId: ID!) {
  markProjectSubmissionMissing(submissionId: $submissionId) {
    success
    message
    data {
      id
      isMissing
      grade
      isExcused
      isLateAllowed
    }
  }
}
    `;
/**
 * __useMarkProjectSubmissionMissingMutation__
 *
 * To run a mutation, you first call `useMarkProjectSubmissionMissingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProjectSubmissionMissingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProjectSubmissionMissingMutation, { data, loading, error }] = useMarkProjectSubmissionMissingMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useMarkProjectSubmissionMissingMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(MarkProjectSubmissionMissingDocument, options);
}
export const AllowLateProjectSubmissionDocument = gql `
    mutation AllowLateProjectSubmission($submissionId: ID!) {
  allowLateProjectSubmission(submissionId: $submissionId) {
    success
    message
    data {
      id
      isLateAllowed
      isMissing
    }
  }
}
    `;
/**
 * __useAllowLateProjectSubmissionMutation__
 *
 * To run a mutation, you first call `useAllowLateProjectSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAllowLateProjectSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [allowLateProjectSubmissionMutation, { data, loading, error }] = useAllowLateProjectSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useAllowLateProjectSubmissionMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(AllowLateProjectSubmissionDocument, options);
}
export const ClearProjectSubmissionStatusDocument = gql `
    mutation ClearProjectSubmissionStatus($submissionId: ID!) {
  clearProjectSubmissionStatus(submissionId: $submissionId) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useClearProjectSubmissionStatusMutation__
 *
 * To run a mutation, you first call `useClearProjectSubmissionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearProjectSubmissionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearProjectSubmissionStatusMutation, { data, loading, error }] = useClearProjectSubmissionStatusMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useClearProjectSubmissionStatusMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(ClearProjectSubmissionStatusDocument, options);
}
export const SetProjectStatusForStudentDocument = gql `
    mutation SetProjectStatusForStudent($studentId: ID!, $projectId: ID!, $status: StudentActivityStatus!) {
  setProjectStatusForStudent(
    studentId: $studentId
    projectId: $projectId
    status: $status
  ) {
    success
    message
    data {
      id
      isExcused
      isMissing
      isLateAllowed
    }
  }
}
    `;
/**
 * __useSetProjectStatusForStudentMutation__
 *
 * To run a mutation, you first call `useSetProjectStatusForStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectStatusForStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectStatusForStudentMutation, { data, loading, error }] = useSetProjectStatusForStudentMutation({
 *   variables: {
 *      studentId: // value for 'studentId'
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetProjectStatusForStudentMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SetProjectStatusForStudentDocument, options);
}
export const GetFacultyDashboardDocument = gql `
    query GetFacultyDashboard($schoolId: ID!, $userId: ID!, $searchQuery: String) {
  getFacultyDashboard(
    schoolId: $schoolId
    userId: $userId
    searchQuery: $searchQuery
  ) {
    count
    data {
      courses {
        id
        isDraft
        name
        course_code
        created
        description
        last_modified
        enrolledStudents {
          id
          name
        }
      }
      submissions {
        data {
          totalCount
        }
      }
      courseWiseRosterInsights {
        count
        data {
          courseId
          needsAttention {
            summary {
              atRiskCount
              onTrackCount
              watchCount
            }
          }
          snapshotDate
          students {
            aggregateGradePct
            assessmentTakenPct
            lastActiveAt
            latestActionLabel
            progressPct
            riskLevel
            riskScore
            sentiment
            statusSummary
            studentName
            userId
          }
          cohortSummary {
            avgCompletionPct
            avgGradePct
            negativeSentimentPct
          }
        }
      }
      courseWiseInactiveInsights {
        count
        data {
          courseId
          snapshotDate
          students {
            aggregateGradePct
            assessmentTakenPct
            lastActiveAt
            latestActionLabel
            progressPct
            riskLevel
            riskScore
            sentiment
            statusSummary
            studentName
            userId
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetFacultyDashboardQuery__
 *
 * To run a query within a React component, call `useGetFacultyDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyDashboardQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      userId: // value for 'userId'
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetFacultyDashboardQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFacultyDashboardDocument, options);
}
export function useGetFacultyDashboardLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFacultyDashboardDocument, options);
}
export function useGetFacultyDashboardSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFacultyDashboardDocument, options);
}
export const SuggestionsDocument = gql `
    query Suggestions {
  getSuggestions {
    type
    content
    integrationId
    classId
    assignmentId
    trackName
  }
}
    `;
/**
 * __useSuggestionsQuery__
 *
 * To run a query within a React component, call `useSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SuggestionsDocument, options);
}
export function useSuggestionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SuggestionsDocument, options);
}
export function useSuggestionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SuggestionsDocument, options);
}
export const GetDegreesByDegreeIdDocument = gql `
    query GetDegreesByDegreeId($id: ID!) {
  getDegree(id: $id) {
    success
    message
    data {
      id
      name
      description
      usersEnrolledIn {
        id
        name
      }
      coursesHasCourse {
        id
        name
        isDraft
        course_code
      }
    }
    count
  }
}
    `;
/**
 * __useGetDegreesByDegreeIdQuery__
 *
 * To run a query within a React component, call `useGetDegreesByDegreeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreesByDegreeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreesByDegreeIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDegreesByDegreeIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDegreesByDegreeIdDocument, options);
}
export function useGetDegreesByDegreeIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDegreesByDegreeIdDocument, options);
}
export function useGetDegreesByDegreeIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDegreesByDegreeIdDocument, options);
}
export const GetDegreeBySchoolDocument = gql `
    query GetDegreeBySchool($schoolId: ID!) {
  getDegreeBySchool(schoolId: $schoolId) {
    success
    message
    data {
      id
      name
      created
      last_modified
      description
    }
    count
  }
}
    `;
/**
 * __useGetDegreeBySchoolQuery__
 *
 * To run a query within a React component, call `useGetDegreeBySchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeBySchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeBySchoolQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function useGetDegreeBySchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDegreeBySchoolDocument, options);
}
export function useGetDegreeBySchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDegreeBySchoolDocument, options);
}
export function useGetDegreeBySchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDegreeBySchoolDocument, options);
}
export const GetDegreesBySchoolByQueryDocument = gql `
    query GetDegreesBySchoolByQuery($schoolId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getDegreesBySchoolByQuery(
    schoolId: $schoolId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      degrees {
        id
        name
        description
        usersEnrolledIn {
          id
          name
        }
        coursesHasCourse {
          id
          name
          course_code
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetDegreesBySchoolByQueryQuery__
 *
 * To run a query within a React component, call `useGetDegreesBySchoolByQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreesBySchoolByQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreesBySchoolByQueryQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDegreesBySchoolByQueryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDegreesBySchoolByQueryDocument, options);
}
export function useGetDegreesBySchoolByQueryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDegreesBySchoolByQueryDocument, options);
}
export function useGetDegreesBySchoolByQuerySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDegreesBySchoolByQueryDocument, options);
}
export const GetDegreeForUserDocument = gql `
    query GetDegreeForUser {
  getDegreeForUser {
    count
    message
    success
    data {
      description
      name
      id
    }
  }
}
    `;
/**
 * __useGetDegreeForUserQuery__
 *
 * To run a query within a React component, call `useGetDegreeForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDegreeForUserQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDegreeForUserDocument, options);
}
export function useGetDegreeForUserLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDegreeForUserDocument, options);
}
export function useGetDegreeForUserSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDegreeForUserDocument, options);
}
export const GetDegreeForUserWithEnrolledUserInfoDocument = gql `
    query GetDegreeForUserWithEnrolledUserInfo {
  getDegreeForUserWithEnrolledUserInfo {
    count
    message
    success
    data {
      description
      name
      id
      usersEnrolledInConnection {
        edges {
          node {
            id
          }
          properties {
            pendingDegreeEnrollmentInvite
          }
        }
      }
    }
  }
}
    `;
/**
 * __useGetDegreeForUserWithEnrolledUserInfoQuery__
 *
 * To run a query within a React component, call `useGetDegreeForUserWithEnrolledUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDegreeForUserWithEnrolledUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDegreeForUserWithEnrolledUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDegreeForUserWithEnrolledUserInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDegreeForUserWithEnrolledUserInfoDocument, options);
}
export function useGetDegreeForUserWithEnrolledUserInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDegreeForUserWithEnrolledUserInfoDocument, options);
}
export function useGetDegreeForUserWithEnrolledUserInfoSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDegreeForUserWithEnrolledUserInfoDocument, options);
}
export const GetStudentsByDegreeIdDocument = gql `
    query GetStudentsByDegreeId($degreeId: ID!, $searchQuery: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getStudentsByDegreeId(
    degreeId: $degreeId
    searchQuery: $searchQuery
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
  ) {
    success
    message
    data {
      id
      name
      email
      pendingDegreeEnrollmentInvite
      enrollmentDate
    }
    count
  }
}
    `;
/**
 * __useGetStudentsByDegreeIdQuery__
 *
 * To run a query within a React component, call `useGetStudentsByDegreeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudentsByDegreeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudentsByDegreeIdQuery({
 *   variables: {
 *      degreeId: // value for 'degreeId'
 *      searchQuery: // value for 'searchQuery'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetStudentsByDegreeIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetStudentsByDegreeIdDocument, options);
}
export function useGetStudentsByDegreeIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetStudentsByDegreeIdDocument, options);
}
export function useGetStudentsByDegreeIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetStudentsByDegreeIdDocument, options);
}
export const GetAdminDocumentsForTenantDocument = gql `
    query GetAdminDocumentsForTenant {
  getAdminDocumentsForTenant {
    success
    message
    data {
      id
      title
      status
      adminDoc
      isPolicy
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;
/**
 * __useGetAdminDocumentsForTenantQuery__
 *
 * To run a query within a React component, call `useGetAdminDocumentsForTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDocumentsForTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDocumentsForTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminDocumentsForTenantQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAdminDocumentsForTenantDocument, options);
}
export function useGetAdminDocumentsForTenantLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAdminDocumentsForTenantDocument, options);
}
export function useGetAdminDocumentsForTenantSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAdminDocumentsForTenantDocument, options);
}
export const GetAdminDocumentAnalyticsDocument = gql `
    query GetAdminDocumentAnalytics($input: DocumentReferenceAnalyticsInput) {
  getAdminDocumentAnalytics(input: $input) {
    success
    message
    data {
      document {
        id
        title
      }
      referenceCount
    }
    count
  }
}
    `;
/**
 * __useGetAdminDocumentAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAdminDocumentAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminDocumentAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminDocumentAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAdminDocumentAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAdminDocumentAnalyticsDocument, options);
}
export function useGetAdminDocumentAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAdminDocumentAnalyticsDocument, options);
}
export function useGetAdminDocumentAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAdminDocumentAnalyticsDocument, options);
}
export const GetDocumentDocument = gql `
    query getDocument($id: ID!) {
  getDocument(id: $id) {
    success
    message
    data {
      id
      title
      summary
      status
      sourceType
      created
      last_modified
      files {
        id
        fileName
        fileURL
        status
      }
    }
    count
  }
}
    `;
/**
 * __useGetDocumentQuery__
 *
 * To run a query within a React component, call `useGetDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDocumentDocument, options);
}
export function useGetDocumentLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDocumentDocument, options);
}
export function useGetDocumentSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDocumentDocument, options);
}
export const GetEnrollmentLinkDocument = gql `
    query GetEnrollmentLink($courseId: ID!) {
  getEnrollmentLink(courseId: $courseId) {
    success
    message
    data {
      id
      enrollmentLink
      maxEnrollments
      currentEnrollments
      expiresAt
      createdAt
      lastModified
    }
    count
  }
}
    `;
/**
 * __useGetEnrollmentLinkQuery__
 *
 * To run a query within a React component, call `useGetEnrollmentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnrollmentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnrollmentLinkQuery({
 *   variables: {
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetEnrollmentLinkQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEnrollmentLinkDocument, options);
}
export function useGetEnrollmentLinkLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEnrollmentLinkDocument, options);
}
export function useGetEnrollmentLinkSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetEnrollmentLinkDocument, options);
}
export const GetAllowedUploadSpecificationsDocument = gql `
    query GetAllowedUploadSpecifications($storagePath: StoragePathType!) {
  getAllowedUploadSpecifications(storagePath: $storagePath) {
    count
    data {
      allowedMimeTypes
      maxFileSize
    }
    message
    success
  }
}
    `;
/**
 * __useGetAllowedUploadSpecificationsQuery__
 *
 * To run a query within a React component, call `useGetAllowedUploadSpecificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllowedUploadSpecificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllowedUploadSpecificationsQuery({
 *   variables: {
 *      storagePath: // value for 'storagePath'
 *   },
 * });
 */
export function useGetAllowedUploadSpecificationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllowedUploadSpecificationsDocument, options);
}
export function useGetAllowedUploadSpecificationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllowedUploadSpecificationsDocument, options);
}
export function useGetAllowedUploadSpecificationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllowedUploadSpecificationsDocument, options);
}
export const GetFileDocument = gql `
    query GetFile($fileId: ID!) {
  getFile(fileId: $fileId) {
    count
    data {
      fileName
      id
      status
    }
    message
    success
  }
}
    `;
/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFileDocument, options);
}
export function useGetFileLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFileDocument, options);
}
export function useGetFileSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFileDocument, options);
}
export const FoodByDateDocument = gql `
    query FoodByDate($date: String!, $timezone: String!) {
  getFoodsByDate(date: $date, timezone: $timezone) {
    name
    calories
    carbohydrates_grams
    fat_grams
    fiber_grams
    protein_grams
    serving_size
    sodium_mg
    sugars_grams
  }
}
    `;
/**
 * __useFoodByDateQuery__
 *
 * To run a query within a React component, call `useFoodByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFoodByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFoodByDateQuery({
 *   variables: {
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useFoodByDateQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(FoodByDateDocument, options);
}
export function useFoodByDateLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(FoodByDateDocument, options);
}
export function useFoodByDateSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(FoodByDateDocument, options);
}
export const GetIleCreationJobStatusDocument = gql `
    query GetIleCreationJobStatus($jobId: String!) {
  getIleCreationJobStatus(jobId: $jobId) {
    success
    status
    message
    result {
      id
      title
      description
      objectives {
        id
        objective
        sequence
      }
    }
  }
}
    `;
/**
 * __useGetIleCreationJobStatusQuery__
 *
 * To run a query within a React component, call `useGetIleCreationJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIleCreationJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIleCreationJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetIleCreationJobStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetIleCreationJobStatusDocument, options);
}
export function useGetIleCreationJobStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetIleCreationJobStatusDocument, options);
}
export function useGetIleCreationJobStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetIleCreationJobStatusDocument, options);
}
export const GetPendingIleCreationJobDocument = gql `
    query GetPendingIleCreationJob {
  getPendingIleCreationJob {
    jobId
  }
}
    `;
/**
 * __useGetPendingIleCreationJobQuery__
 *
 * To run a query within a React component, call `useGetPendingIleCreationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingIleCreationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingIleCreationJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPendingIleCreationJobQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPendingIleCreationJobDocument, options);
}
export function useGetPendingIleCreationJobLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPendingIleCreationJobDocument, options);
}
export function useGetPendingIleCreationJobSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPendingIleCreationJobDocument, options);
}
export const GetAllUserIlEsDocument = gql `
    query GetAllUserILEs($completionStatus: ILECompletionStatus) {
  getAllUserILEs(completionStatus: $completionStatus) {
    success
    message
    count
    data {
      id
      title
      description
      created
      lastModified
      ileType
      kgTopicId
      context
      activityStatus
      objectives {
        id
        objective
        sequence
        status
      }
      courseObjectives {
        id
        objective
        sequence
        status
      }
      course {
        id
      }
      assignment {
        id
      }
    }
  }
}
    `;
/**
 * __useGetAllUserIlEsQuery__
 *
 * To run a query within a React component, call `useGetAllUserIlEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUserIlEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUserIlEsQuery({
 *   variables: {
 *      completionStatus: // value for 'completionStatus'
 *   },
 * });
 */
export function useGetAllUserIlEsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllUserIlEsDocument, options);
}
export function useGetAllUserIlEsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllUserIlEsDocument, options);
}
export function useGetAllUserIlEsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllUserIlEsDocument, options);
}
export const GetLmsLinkedUserIlEsDocument = gql `
    query GetLmsLinkedUserILEs($integrationId: ID!, $completionStatus: ILECompletionStatus) {
  getLmsLinkedUserILEs(
    integrationId: $integrationId
    completionStatus: $completionStatus
  ) {
    success
    message
    count
    data {
      id
      title
      description
      created
      lastModified
      ileType
      kgTopicId
      context
      activityStatus
      objectives {
        id
        objective
        sequence
        status
      }
      courseObjectives {
        id
        objective
        sequence
        status
      }
      course {
        id
      }
      assignment {
        id
      }
    }
  }
}
    `;
/**
 * __useGetLmsLinkedUserIlEsQuery__
 *
 * To run a query within a React component, call `useGetLmsLinkedUserIlEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLmsLinkedUserIlEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLmsLinkedUserIlEsQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      completionStatus: // value for 'completionStatus'
 *   },
 * });
 */
export function useGetLmsLinkedUserIlEsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLmsLinkedUserIlEsDocument, options);
}
export function useGetLmsLinkedUserIlEsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLmsLinkedUserIlEsDocument, options);
}
export function useGetLmsLinkedUserIlEsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLmsLinkedUserIlEsDocument, options);
}
export const GetImageGenerationJobStatusDocument = gql `
    query GetImageGenerationJobStatus($jobId: String!) {
  getImageGenerationJobStatus(jobId: $jobId) {
    success
    status
    message
    result {
      imageUrl
      fileId
      description
    }
  }
}
    `;
/**
 * __useGetImageGenerationJobStatusQuery__
 *
 * To run a query within a React component, call `useGetImageGenerationJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageGenerationJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageGenerationJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetImageGenerationJobStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetImageGenerationJobStatusDocument, options);
}
export function useGetImageGenerationJobStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetImageGenerationJobStatusDocument, options);
}
export function useGetImageGenerationJobStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetImageGenerationJobStatusDocument, options);
}
export const BrowseExternalSourceDocument = gql `
    query BrowseExternalSource($connectorType: ConnectorType!, $input: ExternalBrowseInput!) {
  browseExternalSource(connectorType: $connectorType, input: $input) {
    success
    message
    count
    data {
      items {
        id
        name
        type
        createdAt
        updatedAt
        url
        mimeType
        sizeBytes
        parentExternalId
        thumbnailUrl
        durationSeconds
        transcriptAvailable
        providerMetadata
      }
      pageInfo {
        nextCursor
        hasNextPage
      }
    }
  }
}
    `;
/**
 * __useBrowseExternalSourceQuery__
 *
 * To run a query within a React component, call `useBrowseExternalSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrowseExternalSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrowseExternalSourceQuery({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrowseExternalSourceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(BrowseExternalSourceDocument, options);
}
export function useBrowseExternalSourceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(BrowseExternalSourceDocument, options);
}
export function useBrowseExternalSourceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(BrowseExternalSourceDocument, options);
}
export const GetConnectorCatalogDocument = gql `
    query GetConnectorCatalog($filter: ConnectorCatalogFilter, $cursor: String, $pageSize: Int, $returnUrl: String) {
  getConnectorCatalog(
    filter: $filter
    cursor: $cursor
    pageSize: $pageSize
    returnUrl: $returnUrl
  ) {
    success
    message
    data {
      id
      connectorType
      name
      icon
      description
      category
      capabilities
      authModes
      setupConfig {
        strategies {
          authMode
          credentialFields {
            key
            label
            description
            isSecret
            required
          }
        }
      }
      savedConfiguration {
        authMode
        authorizationUrl
        fields {
          key
          label
          value
          isSecret
        }
      }
      supportedContentTypes
      created
      lastModified
    }
  }
}
    `;
/**
 * __useGetConnectorCatalogQuery__
 *
 * To run a query within a React component, call `useGetConnectorCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectorCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectorCatalogQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *      returnUrl: // value for 'returnUrl'
 *   },
 * });
 */
export function useGetConnectorCatalogQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetConnectorCatalogDocument, options);
}
export function useGetConnectorCatalogLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetConnectorCatalogDocument, options);
}
export function useGetConnectorCatalogSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetConnectorCatalogDocument, options);
}
export const GetConnectorHealthDocument = gql `
    query GetConnectorHealth {
  getConnectorHealth {
    success
    message
    data {
      id
      status
      errorMessage
      userConnectionCount
      totalConnectionCount
      healthyConnectionCount
      expiringConnectionCount
      expiredConnectionCount
      revokedConnectionCount
      unknownConnectionCount
      lastCheckedAt
      created
      lastModified
      connectorInstance {
        id
        connectorType
      }
    }
  }
}
    `;
/**
 * __useGetConnectorHealthQuery__
 *
 * To run a query within a React component, call `useGetConnectorHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectorHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectorHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetConnectorHealthQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetConnectorHealthDocument, options);
}
export function useGetConnectorHealthLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetConnectorHealthDocument, options);
}
export function useGetConnectorHealthSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetConnectorHealthDocument, options);
}
export const GetEnabledConnectorsDocument = gql `
    query GetEnabledConnectors($filter: EnabledConnectorsFilter, $cursor: String, $pageSize: Int) {
  getEnabledConnectors(filter: $filter, cursor: $cursor, pageSize: $pageSize) {
    success
    message
    data {
      id
      connectorType
      status
      enabledRoles
      configSummary
      created
      lastModified
      healthStatus {
        id
        status
        errorMessage
        userConnectionCount
        lastCheckedAt
        created
        lastModified
      }
    }
  }
}
    `;
/**
 * __useGetEnabledConnectorsQuery__
 *
 * To run a query within a React component, call `useGetEnabledConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnabledConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnabledConnectorsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetEnabledConnectorsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetEnabledConnectorsDocument, options);
}
export function useGetEnabledConnectorsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetEnabledConnectorsDocument, options);
}
export function useGetEnabledConnectorsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetEnabledConnectorsDocument, options);
}
export const GetExternalIngestionJobStatusDocument = gql `
    query GetExternalIngestionJobStatus($jobId: String!) {
  getExternalIngestionJobStatus(jobId: $jobId) {
    success
    message
    count
    data {
      jobId
      state
      phase
      progress
      failedReason
      file {
        id
        fileName
        fileURL
        filePath
        bucketName
        status
        created
      }
    }
  }
}
    `;
/**
 * __useGetExternalIngestionJobStatusQuery__
 *
 * To run a query within a React component, call `useGetExternalIngestionJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalIngestionJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalIngestionJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetExternalIngestionJobStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetExternalIngestionJobStatusDocument, options);
}
export function useGetExternalIngestionJobStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetExternalIngestionJobStatusDocument, options);
}
export function useGetExternalIngestionJobStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetExternalIngestionJobStatusDocument, options);
}
export const GetExternalItemMetadataDocument = gql `
    query GetExternalItemMetadata($connectorType: ConnectorType!, $externalId: String!) {
  getExternalItemMetadata(connectorType: $connectorType, externalId: $externalId) {
    success
    message
    count
    data {
      id
      name
      type
      createdAt
      updatedAt
      url
      mimeType
      sizeBytes
      parentExternalId
      thumbnailUrl
      durationSeconds
      transcriptAvailable
      providerMetadata
    }
  }
}
    `;
/**
 * __useGetExternalItemMetadataQuery__
 *
 * To run a query within a React component, call `useGetExternalItemMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalItemMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalItemMetadataQuery({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetExternalItemMetadataQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetExternalItemMetadataDocument, options);
}
export function useGetExternalItemMetadataLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetExternalItemMetadataDocument, options);
}
export function useGetExternalItemMetadataSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetExternalItemMetadataDocument, options);
}
export const GetUserConnectionsDocument = gql `
    query GetUserConnections($statuses: [UserExternalAuthStatus], $cursor: String, $pageSize: Int) {
  getUserConnections(statuses: $statuses, cursor: $cursor, pageSize: $pageSize) {
    success
    message
    authorizationUrl
    data {
      id
      status
      healthStatus
      connectorType
      accountIdentifier
      accountEmail: accountIdentifier
      scopes
      permissions: scopes
      lastHealthCheckedAt
      lastHealthError
      lastSyncAt: lastHealthCheckedAt
      lastError
      tokenExpiresAt
      refreshTokenExpiresAt
      revokedAt
      created
      lastModified: last_modified
    }
    pageInfo {
      nextCursor
      hasNextPage
    }
    expiredCount
  }
}
    `;
/**
 * __useGetUserConnectionsQuery__
 *
 * To run a query within a React component, call `useGetUserConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserConnectionsQuery({
 *   variables: {
 *      statuses: // value for 'statuses'
 *      cursor: // value for 'cursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetUserConnectionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserConnectionsDocument, options);
}
export function useGetUserConnectionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserConnectionsDocument, options);
}
export function useGetUserConnectionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserConnectionsDocument, options);
}
export const SearchExternalSourceDocument = gql `
    query SearchExternalSource($connectorType: ConnectorType!, $input: ExternalSearchInput!) {
  searchExternalSource(connectorType: $connectorType, input: $input) {
    success
    message
    count
    data {
      items {
        id
        name
        type
        createdAt
        updatedAt
        url
        mimeType
        sizeBytes
        parentExternalId
        thumbnailUrl
        durationSeconds
        transcriptAvailable
        providerMetadata
      }
      pageInfo {
        nextCursor
        hasNextPage
      }
    }
  }
}
    `;
/**
 * __useSearchExternalSourceQuery__
 *
 * To run a query within a React component, call `useSearchExternalSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExternalSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExternalSourceQuery({
 *   variables: {
 *      connectorType: // value for 'connectorType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchExternalSourceQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchExternalSourceDocument, options);
}
export function useSearchExternalSourceLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchExternalSourceDocument, options);
}
export function useSearchExternalSourceSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SearchExternalSourceDocument, options);
}
export const InviteCountDocument = gql `
    query InviteCount {
  userInviteCount {
    count
  }
  me {
    name
    username
    gender
    isOnboarded
    isPro
    phoneNumber
    isEmailVerified
  }
}
    `;
/**
 * __useInviteCountQuery__
 *
 * To run a query within a React component, call `useInviteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useInviteCountQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(InviteCountDocument, options);
}
export function useInviteCountLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(InviteCountDocument, options);
}
export function useInviteCountSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(InviteCountDocument, options);
}
export const DateForChatDocument = gql `
    query DateForChat($date: String!, $timezone: String!) {
  getChatForDate(date: $date, timezone: $timezone) {
    id
    date
    timezone
    conversation {
      id
      sender
      content
      type
      nodeId
      snackType
      file {
        fileName
        id
      }
      parameters {
        lastGeneratedTopic
        lastGeneratedLabel
        questContext
        userResponse
      }
      aspectDetails {
        name
        category
        id
        friendId
        relationshipType
        connectionStrength
        frequencyOfInteraction
        lastInteractionDate
        sharedInterests
        sharedGoals
        sharedEventsAttended
        friendPersonalityTraits
        communicationChannel
        level
        startDate
        lastUpdated
        learningStyle
        language
        timeOfDay
        learningDuration
        contentType
        notificationPreferences
        type
        completionStatus
        deadline
        priority
        value
        description
        date
        importance
        status
        endDate
        text
        sentiment
        context
        intensity
        timestamp
        trigger
        calories
        carbohydrates_grams
        fat_grams
        fiber_grams
        protein_grams
        serving_size
        sodium_mg
        sugars_grams
        totalCalories
        totalCarbs
        totalFats
        totalProteins
        totalCaloriesBurned
        totalDurationMinutes
        totalWorkouts
        water_intake_oz
      }
    }
  }
}
    `;
/**
 * __useDateForChatQuery__
 *
 * To run a query within a React component, call `useDateForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useDateForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDateForChatQuery({
 *   variables: {
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useDateForChatQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(DateForChatDocument, options);
}
export function useDateForChatLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(DateForChatDocument, options);
}
export function useDateForChatSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(DateForChatDocument, options);
}
export const GetLearningTreeDocument = gql `
    query GetLearningTree($level: String!, $name: String!) {
  getLearningTree(level: $level, name: $name) {
    FieldName
    SubfieldName
    TopicName
    ChapterName
    SubchapterName
  }
}
    `;
/**
 * __useGetLearningTreeQuery__
 *
 * To run a query within a React component, call `useGetLearningTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningTreeQuery({
 *   variables: {
 *      level: // value for 'level'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetLearningTreeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLearningTreeDocument, options);
}
export function useGetLearningTreeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLearningTreeDocument, options);
}
export function useGetLearningTreeSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLearningTreeDocument, options);
}
export const GetFirstSubchapterByTopicNameDocument = gql `
    query GetFirstSubchapterByTopicName($topicName: String!) {
  getFirstSubchapterByTopicName(topicName: $topicName) {
    success
    message
    id
    name
    description
    objectives {
      id
      title
      description
      completed
    }
  }
}
    `;
/**
 * __useGetFirstSubchapterByTopicNameQuery__
 *
 * To run a query within a React component, call `useGetFirstSubchapterByTopicNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFirstSubchapterByTopicNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFirstSubchapterByTopicNameQuery({
 *   variables: {
 *      topicName: // value for 'topicName'
 *   },
 * });
 */
export function useGetFirstSubchapterByTopicNameQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFirstSubchapterByTopicNameDocument, options);
}
export function useGetFirstSubchapterByTopicNameLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFirstSubchapterByTopicNameDocument, options);
}
export function useGetFirstSubchapterByTopicNameSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFirstSubchapterByTopicNameDocument, options);
}
export const GetLearningObjectiveByIdDocument = gql `
    query GetLearningObjectiveById($loId: ID!) {
  getLearningObjectiveById(loId: $loId) {
    success
    message
    id
    title
    description
    completed
  }
}
    `;
/**
 * __useGetLearningObjectiveByIdQuery__
 *
 * To run a query within a React component, call `useGetLearningObjectiveByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningObjectiveByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningObjectiveByIdQuery({
 *   variables: {
 *      loId: // value for 'loId'
 *   },
 * });
 */
export function useGetLearningObjectiveByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLearningObjectiveByIdDocument, options);
}
export function useGetLearningObjectiveByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLearningObjectiveByIdDocument, options);
}
export function useGetLearningObjectiveByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLearningObjectiveByIdDocument, options);
}
export const GetLearningObjectivesBySubchapterDocument = gql `
    query GetLearningObjectivesBySubchapter($learningObjectiveId: ID!) {
  getLearningObjectivesBySubchapter(learningObjectiveId: $learningObjectiveId) {
    id
    title
    description
    index
    completed
  }
}
    `;
/**
 * __useGetLearningObjectivesBySubchapterQuery__
 *
 * To run a query within a React component, call `useGetLearningObjectivesBySubchapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningObjectivesBySubchapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningObjectivesBySubchapterQuery({
 *   variables: {
 *      learningObjectiveId: // value for 'learningObjectiveId'
 *   },
 * });
 */
export function useGetLearningObjectivesBySubchapterQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLearningObjectivesBySubchapterDocument, options);
}
export function useGetLearningObjectivesBySubchapterLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLearningObjectivesBySubchapterDocument, options);
}
export function useGetLearningObjectivesBySubchapterSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLearningObjectivesBySubchapterDocument, options);
}
export const SubchapterByIdDocument = gql `
    query SubchapterById($name: String!) {
  getSubchapterById(name: $name) {
    id
    name
    description
    objectives {
      id
      title
      description
      completed
    }
    totalMastery
  }
}
    `;
/**
 * __useSubchapterByIdQuery__
 *
 * To run a query within a React component, call `useSubchapterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubchapterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubchapterByIdQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSubchapterByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SubchapterByIdDocument, options);
}
export function useSubchapterByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SubchapterByIdDocument, options);
}
export function useSubchapterByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SubchapterByIdDocument, options);
}
export const GetMasteryDocument = gql `
    query GetMastery($learningObjectiveId: ID!) {
  getUserLearningObjectiveMastery(learningObjectiveId: $learningObjectiveId) {
    learningObjectiveId
    userId
    totalMastery
  }
}
    `;
/**
 * __useGetMasteryQuery__
 *
 * To run a query within a React component, call `useGetMasteryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasteryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasteryQuery({
 *   variables: {
 *      learningObjectiveId: // value for 'learningObjectiveId'
 *   },
 * });
 */
export function useGetMasteryQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetMasteryDocument, options);
}
export function useGetMasteryLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetMasteryDocument, options);
}
export function useGetMasterySuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetMasteryDocument, options);
}
export const GetDeepResearchJobStatusDocument = gql `
    query GetDeepResearchJobStatus($jobId: String!) {
  getDeepResearchJobStatus(jobId: $jobId) {
    success
    status
    message
    result {
      chatId
      messageId
    }
  }
}
    `;
/**
 * __useGetDeepResearchJobStatusQuery__
 *
 * To run a query within a React component, call `useGetDeepResearchJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeepResearchJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeepResearchJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetDeepResearchJobStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetDeepResearchJobStatusDocument, options);
}
export function useGetDeepResearchJobStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetDeepResearchJobStatusDocument, options);
}
export function useGetDeepResearchJobStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetDeepResearchJobStatusDocument, options);
}
export const GetUserNotificationsDocument = gql `
    query GetUserNotifications {
  getUserNotifications {
    success
    message
    data {
      id
      title
      message
      created
      type
      isRead
      actionUrl
      event {
        id
        eventType
      }
    }
    count
  }
}
    `;
/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserNotificationsDocument, options);
}
export function useGetUserNotificationsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserNotificationsDocument, options);
}
export function useGetUserNotificationsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserNotificationsDocument, options);
}
export const GetOAuthClientDocument = gql `
    query GetOAuthClient($id: ID!) {
  getOAuthClient(id: $id) {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;
/**
 * __useGetOAuthClientQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOAuthClientQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOAuthClientDocument, options);
}
export function useGetOAuthClientLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOAuthClientDocument, options);
}
export function useGetOAuthClientSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetOAuthClientDocument, options);
}
export const GetOAuthClientsDocument = gql `
    query GetOAuthClients {
  getOAuthClients {
    success
    message
    data {
      id
      clientId
      clientSecret
      created
      tenant {
        id
        tenantDomain
      }
    }
    count
  }
}
    `;
/**
 * __useGetOAuthClientsQuery__
 *
 * To run a query within a React component, call `useGetOAuthClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOAuthClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOAuthClientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOAuthClientsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetOAuthClientsDocument, options);
}
export function useGetOAuthClientsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetOAuthClientsDocument, options);
}
export function useGetOAuthClientsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetOAuthClientsDocument, options);
}
export const ExportCsvDocument = gql `
    query ExportCsv {
  exportCsv {
    success
    csvData
    message
  }
}
    `;
/**
 * __useExportCsvQuery__
 *
 * To run a query within a React component, call `useExportCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportCsvQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ExportCsvDocument, options);
}
export function useExportCsvLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ExportCsvDocument, options);
}
export function useExportCsvSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ExportCsvDocument, options);
}
export const AssignmentsDocument = gql `
    query Assignments {
  getAssignments {
    id
    title
    description
    gradePoints
    createdDate
    pointsPossible
    dueDate
    url
    objectives {
      id
      objective
      status
    }
  }
}
    `;
/**
 * __useAssignmentsQuery__
 *
 * To run a query within a React component, call `useAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignmentsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(AssignmentsDocument, options);
}
export function useAssignmentsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(AssignmentsDocument, options);
}
export function useAssignmentsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(AssignmentsDocument, options);
}
export const SchoolsDocument = gql `
    query Schools {
  getSchools {
    id
    provider_name
    team_name
    provider_icon_url
  }
}
    `;
/**
 * __useSchoolsQuery__
 *
 * To run a query within a React component, call `useSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchoolsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SchoolsDocument, options);
}
export function useSchoolsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SchoolsDocument, options);
}
export function useSchoolsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SchoolsDocument, options);
}
export const DeleteTodoDocument = gql `
    mutation DeleteTodo($id: String!) {
  deleteTodo(id: $id) {
    success
    message
  }
}
    `;
/**
 * __useDeleteTodoMutation__
 *
 * To run a mutation, you first call `useDeleteTodoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTodoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTodoMutation, { data, loading, error }] = useDeleteTodoMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTodoMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(DeleteTodoDocument, options);
}
export const RecentTodosDocument = gql `
    query RecentTodos {
  getRecentTodosForUser {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useRecentTodosQuery__
 *
 * To run a query within a React component, call `useRecentTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentTodosQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(RecentTodosDocument, options);
}
export function useRecentTodosLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(RecentTodosDocument, options);
}
export function useRecentTodosSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(RecentTodosDocument, options);
}
export const SearchTodosDocument = gql `
    query SearchTodos($searchQuery: String) {
  searchTodosForUser(searchQuery: $searchQuery) {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useSearchTodosQuery__
 *
 * To run a query within a React component, call `useSearchTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTodosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchTodosQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchTodosDocument, options);
}
export function useSearchTodosLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchTodosDocument, options);
}
export function useSearchTodosSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SearchTodosDocument, options);
}
export const TodosDocument = gql `
    query Todos {
  getTodosForUser {
    success
    message
    count
    data {
      id
      name
      description
      priority
      date
      completed
      completed_date
      isRecurring
      recurringFrequency
      recurringDaily
      recurringDayOfWeek
      recurringDayOfMonth
      recurringTime
      timeOfDay
      timezone
      aiSummary
      workspacesHasTodo {
        id
        name
      }
    }
  }
}
    `;
/**
 * __useTodosQuery__
 *
 * To run a query within a React component, call `useTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodosQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodosQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(TodosDocument, options);
}
export function useTodosLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(TodosDocument, options);
}
export function useTodosSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(TodosDocument, options);
}
export const GetAllTenantsDocument = gql `
    query GetAllTenants {
  getAllTenants {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
    }
    count
  }
}
    `;
/**
 * __useGetAllTenantsQuery__
 *
 * To run a query within a React component, call `useGetAllTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTenantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTenantsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllTenantsDocument, options);
}
export function useGetAllTenantsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllTenantsDocument, options);
}
export function useGetAllTenantsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllTenantsDocument, options);
}
export const GetContentSafetySettingsDocument = gql `
    query GetContentSafetySettings {
  getContentSafetySettings {
    count
    success
    message
    data {
      sexual
      hate
      harassment
      selfHarm
      violence
      withdrawal
      ada
      sexualEmails
      hateEmails
      harassmentEmails
      selfHarmEmails
      violenceEmails
      withdrawalEmails
      adaEmails
    }
  }
}
    `;
/**
 * __useGetContentSafetySettingsQuery__
 *
 * To run a query within a React component, call `useGetContentSafetySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentSafetySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentSafetySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentSafetySettingsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetContentSafetySettingsDocument, options);
}
export function useGetContentSafetySettingsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetContentSafetySettingsDocument, options);
}
export function useGetContentSafetySettingsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetContentSafetySettingsDocument, options);
}
export const GetLtiConfigForSchoolAdminDocument = gql `
    query GetLtiConfigForSchoolAdmin {
  getLtiConfigForSchoolAdmin {
    success
    message
    data {
      ltiActivitiesEnabled
      tenantDomain
      provider
      platformUrl
      clientId
      deploymentId
    }
  }
}
    `;
/**
 * __useGetLtiConfigForSchoolAdminQuery__
 *
 * To run a query within a React component, call `useGetLtiConfigForSchoolAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLtiConfigForSchoolAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLtiConfigForSchoolAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLtiConfigForSchoolAdminQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetLtiConfigForSchoolAdminDocument, options);
}
export function useGetLtiConfigForSchoolAdminLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetLtiConfigForSchoolAdminDocument, options);
}
export function useGetLtiConfigForSchoolAdminSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetLtiConfigForSchoolAdminDocument, options);
}
export const GetNudgeTypeConfigsDocument = gql `
    query GetNudgeTypeConfigs($keys: [String!]!) {
  getNudgeTypeConfigs(keys: $keys) {
    success
    message
    count
    data {
      id
      key
      nudgeType
      enabled
      lastModified
    }
  }
}
    `;
/**
 * __useGetNudgeTypeConfigsQuery__
 *
 * To run a query within a React component, call `useGetNudgeTypeConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNudgeTypeConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNudgeTypeConfigsQuery({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useGetNudgeTypeConfigsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetNudgeTypeConfigsDocument, options);
}
export function useGetNudgeTypeConfigsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetNudgeTypeConfigsDocument, options);
}
export function useGetNudgeTypeConfigsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetNudgeTypeConfigsDocument, options);
}
export const GetSamlConfigByTenantDocument = gql `
    query GetSamlConfigByTenant($tenantId: ID!) {
  getSamlConfigByTenant(tenantId: $tenantId) {
    success
    message
    data {
      id
      entryPoint
      issuer
      cert
      callbackUrl
      emailAttribute
      firstNameAttribute
      lastNameAttribute
      signRequest
      signatureAlgorithm
      tenant {
        id
        tenantDomain
      }
    }
  }
}
    `;
/**
 * __useGetSamlConfigByTenantQuery__
 *
 * To run a query within a React component, call `useGetSamlConfigByTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSamlConfigByTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSamlConfigByTenantQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetSamlConfigByTenantQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSamlConfigByTenantDocument, options);
}
export function useGetSamlConfigByTenantLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSamlConfigByTenantDocument, options);
}
export function useGetSamlConfigByTenantSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSamlConfigByTenantDocument, options);
}
export const GetTenantDocument = gql `
    query GetTenant {
  getTenant {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      oralAssessmentV2Enabled
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      deepResearchSupportFlag
      courseModernizerEnabled
      courseModernizerOnlyEnabled
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
      adminEmails
    }
    count
  }
}
    `;
/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantDocument, options);
}
export function useGetTenantLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantDocument, options);
}
export function useGetTenantSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantDocument, options);
}
export const GetTenantByDomainDocument = gql `
    query GetTenantByDomain($domain: String!) {
  getTenantByDomain(domain: $domain) {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      deepResearchSupportFlag
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
    }
    count
  }
}
    `;
/**
 * __useGetTenantByDomainQuery__
 *
 * To run a query within a React component, call `useGetTenantByDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantByDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantByDomainQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetTenantByDomainQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantByDomainDocument, options);
}
export function useGetTenantByDomainLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantByDomainDocument, options);
}
export function useGetTenantByDomainSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantByDomainDocument, options);
}
export const GetTenantByIdDocument = gql `
    query GetTenantById($id: ID!) {
  getTenantById(id: $id) {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      axioSchools
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      created
      last_modified
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      oralAssessmentV2Enabled
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      deepResearchSupportFlag
      courseModernizerEnabled
      courseModernizerOnlyEnabled
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
      adminEmails
    }
    count
  }
}
    `;
/**
 * __useGetTenantByIdQuery__
 *
 * To run a query within a React component, call `useGetTenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTenantByIdQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantByIdDocument, options);
}
export function useGetTenantByIdLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantByIdDocument, options);
}
export function useGetTenantByIdSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantByIdDocument, options);
}
export const GetTenantDefaultsDocument = gql `
    query GetTenantDefaults {
  getTenantDefaults {
    success
    message
    data {
      tenantName
      tenantDomain
      ogDescription
      ogImage
      ogImageHeight
      ogImageWidth
      ogSiteName
      ogTitle
      ogType
      stripeSubscriptionId
      hasTrial
      stripeTrialDays
      externalSendGridDailyEmailTemplateId
      externalSendGridFromEmail
      externalSendGridFromName
      externalSendGridTwilioServiceSID
      moderationSexual
      moderationHate
      moderationHarassment
      moderationSelfHarm
      moderationSexualMinors
      moderationHateThreatening
      moderationViolenceGraphic
      moderationSelfHarmIntent
      moderationSelfHarmInstructions
      moderationHarassmentThreatening
      moderationViolence
      moderationSexualEmails
      moderationHateEmails
      moderationHarassmentEmails
      moderationSelfHarmEmails
      moderationViolenceEmails
      moderationWithdrawal
      moderationWithdrawalEmails
      moderationAda
      moderationAdaEmails
      companionName
      isCompanionMode
      key
      isLMS
      isLTI
      ltiActivitiesEnabled
      ltiLaunchUrl
      isAxioOffering
      isSuggestedInsights
      hasCourseEnrollment
      doRAG
      primaryColor
      gameMenuBg
      gameMenuTrack
      gameMenuProgress
      gameMenuCardBg
      emulationStatement
      learningEmulationStatement
      companionWebSearchDomains
      companionCourseAllowList
      logo
      proLogo
      miniLogo
      showMiniLogo
      scope
      additionalScope
      termsOfServiceLink
      generalPrompt
      onboardingPrompt
      customNews
      newsSearchTerms
      showFeedback
      bugReportEmails
      upgradeModalBody
      isFreemium
      hasEmailVerification
      hasDegrees
      isDailyEventEnabled
      emailFooterColor
      emailBackgroundColor
      hasProFlow
      stripeSecretKey
      allowFormSignup
      autoEnrollCourses
      hasLearningTopicsInChat
      favicon16Url
      favicon32Url
      favicon48Url
      favicon180Url
      favicon192Url
      favicon512Url
      faviconIcoUrl
      isTeacherNotifiedOnEnrollment
      allowStripeDiscountCodes
      requireSSO
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      reportProblemUrl
      scheduleAdvisorCallUrl
      submitHelpTicketLink
      hasTurnBasedAssessments
      useILEGraphV2
      allowThirdPartyCredentials
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      lmsDirectFacultyMode
      gradebookEnabled
      imageGenerationSupportFlag
      deepResearchSupportFlag
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      newCourseEditorEnabled
    }
    count
  }
}
    `;
/**
 * __useGetTenantDefaultsQuery__
 *
 * To run a query within a React component, call `useGetTenantDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantDefaultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantDefaultsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantDefaultsDocument, options);
}
export function useGetTenantDefaultsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantDefaultsDocument, options);
}
export function useGetTenantDefaultsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantDefaultsDocument, options);
}
export const GetTenantForSchoolAdminDocument = gql `
    query GetTenantForSchoolAdmin {
  getTenantForSchoolAdmin {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      logo
      primaryColor
      favicon16Url
      favicon180Url
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      htmlEmbedAllowedDomains
      ltiActivitiesEnabled
      termsOfServiceLink
      aiDisclaimerText
    }
    count
  }
}
    `;
/**
 * __useGetTenantForSchoolAdminQuery__
 *
 * To run a query within a React component, call `useGetTenantForSchoolAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantForSchoolAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantForSchoolAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantForSchoolAdminQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantForSchoolAdminDocument, options);
}
export function useGetTenantForSchoolAdminLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantForSchoolAdminDocument, options);
}
export function useGetTenantForSchoolAdminSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantForSchoolAdminDocument, options);
}
export const GetTenantPublicConfigDocument = gql `
    query GetTenantPublicConfig {
  getTenantPublicConfig {
    success
    message
    data {
      id
      tenantName
      tenantDomain
      logo
      primaryColor
      favicon16Url
      favicon180Url
      officialTranscriptsUrl
      financialInformationUrl
      helpCenterUrl
      schoolResourcesUrl
      htmlEmbedAllowedDomains
      hasIntegrationsEnabled
      imageGenerationSupportFlag
      allowIleRecommendationInModernizeCourse
      allowPdfGenerationInModernizeCourse
      allowPptGenerationInModernizeCourse
      allowVideoGenerationInModernizeCourse
      courseModernizerEnabled
      courseModernizerOnlyEnabled
    }
    count
  }
}
    `;
/**
 * __useGetTenantPublicConfigQuery__
 *
 * To run a query within a React component, call `useGetTenantPublicConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantPublicConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantPublicConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantPublicConfigQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantPublicConfigDocument, options);
}
export function useGetTenantPublicConfigLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantPublicConfigDocument, options);
}
export function useGetTenantPublicConfigSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantPublicConfigDocument, options);
}
export const GetTenantSchemaDocument = gql `
    query GetTenantSchema {
  getTenantSchema {
    success
    message
    data
  }
}
    `;
/**
 * __useGetTenantSchemaQuery__
 *
 * To run a query within a React component, call `useGetTenantSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSchemaQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantSchemaDocument, options);
}
export function useGetTenantSchemaLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantSchemaDocument, options);
}
export function useGetTenantSchemaSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantSchemaDocument, options);
}
export const GetTenantSubmitHelpTicketLinkDocument = gql `
    query GetTenantSubmitHelpTicketLink {
  getTenantSubmitHelpTicketLink {
    success
    message
    data
  }
}
    `;
/**
 * __useGetTenantSubmitHelpTicketLinkQuery__
 *
 * To run a query within a React component, call `useGetTenantSubmitHelpTicketLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSubmitHelpTicketLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSubmitHelpTicketLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSubmitHelpTicketLinkQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetTenantSubmitHelpTicketLinkDocument, options);
}
export function useGetTenantSubmitHelpTicketLinkLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetTenantSubmitHelpTicketLinkDocument, options);
}
export function useGetTenantSubmitHelpTicketLinkSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetTenantSubmitHelpTicketLinkDocument, options);
}
export const ExportStudentNudgePreferencesDocument = gql `
    query ExportStudentNudgePreferences {
  exportStudentNudgePreferences {
    success
    message
    data
  }
}
    `;
/**
 * __useExportStudentNudgePreferencesQuery__
 *
 * To run a query within a React component, call `useExportStudentNudgePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportStudentNudgePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportStudentNudgePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExportStudentNudgePreferencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(ExportStudentNudgePreferencesDocument, options);
}
export function useExportStudentNudgePreferencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(ExportStudentNudgePreferencesDocument, options);
}
export function useExportStudentNudgePreferencesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(ExportStudentNudgePreferencesDocument, options);
}
export const GetAllStudentNudgePreferencesDocument = gql `
    query GetAllStudentNudgePreferences {
  getAllStudentNudgePreferences {
    success
    message
    count
    data {
      userId
      name
      email
      smsConsent
      smsEnabled
      emailEnabled
      frequency
      preferredSendTime
      snoozeAllUntil
      nudgesSent
      lastNudge
    }
  }
}
    `;
/**
 * __useGetAllStudentNudgePreferencesQuery__
 *
 * To run a query within a React component, call `useGetAllStudentNudgePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllStudentNudgePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllStudentNudgePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllStudentNudgePreferencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetAllStudentNudgePreferencesDocument, options);
}
export function useGetAllStudentNudgePreferencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetAllStudentNudgePreferencesDocument, options);
}
export function useGetAllStudentNudgePreferencesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetAllStudentNudgePreferencesDocument, options);
}
export const GetCourseNudgePreferencesDocument = gql `
    query GetCourseNudgePreferences {
  getCourseNudgePreferences {
    success
    message
    data {
      id
      key
      userId
      courseId
      courseRefType
      enabled
      courseUpdatesEnabled
      facultyUpdatesEnabled
      courseName
      courseCode
      instructorName
      created
      lastModified
    }
    count
  }
}
    `;
/**
 * __useGetCourseNudgePreferencesQuery__
 *
 * To run a query within a React component, call `useGetCourseNudgePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseNudgePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseNudgePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCourseNudgePreferencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseNudgePreferencesDocument, options);
}
export function useGetCourseNudgePreferencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseNudgePreferencesDocument, options);
}
export function useGetCourseNudgePreferencesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseNudgePreferencesDocument, options);
}
export const GetNudgePreferencesDocument = gql `
    query GetNudgePreferences {
  getNudgePreferences {
    success
    message
    data {
      id
      emailEnabled
      smsEnabled
      smsConsent
      frequency
      preferredSendTime
      timezone
      snoozeAllUntil
      maxEmailPerDay
      maxSmsPerDay
    }
    count
  }
  me {
    phoneNumber
    countryCode
    isPhoneVerified
  }
}
    `;
/**
 * __useGetNudgePreferencesQuery__
 *
 * To run a query within a React component, call `useGetNudgePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNudgePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNudgePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNudgePreferencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetNudgePreferencesDocument, options);
}
export function useGetNudgePreferencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetNudgePreferencesDocument, options);
}
export function useGetNudgePreferencesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetNudgePreferencesDocument, options);
}
export const MeDocument = gql `
    query Me {
  me {
    audioOn
    countryCode
    currentWeightLbs
    dailyEmailOptIn
    enrolledTracks
    email
    fullPhoneNumber
    gender
    goalWeightLbs
    googleCalendarAuthToken
    id
    isCareerLoading
    isCourseLoading
    isEmailVerified
    isPro
    isOnboarded
    hasAcceptedAiDisclaimer
    modalOnboarding
    name
    otpPreference
    phoneNumber
    trialEndDate
    username
    meetingLink
    profilePicture
    biography
    enrolledDegrees {
      id
      name
    }
    isFaculty
    created
    skipAllNotificationEmail
    showLearningActivityIntro
  }
}
    `;
/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(MeDocument, options);
}
export function useMeLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(MeDocument, options);
}
export function useMeSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(MeDocument, options);
}
export const GetCourseSessionAnalyticsDocument = gql `
    query GetCourseSessionAnalytics($input: CourseSessionAnalyticsInput) {
  getCourseSessionAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      course_code
      students
      instructor
      totalSessions
      totalDuration
      averageDuration
      lastActiveDate
      firstActiveDate
    }
    totalCount
    topActiveUsers {
      id
      name
      totalSessions
    }
  }
}
    `;
/**
 * __useGetCourseSessionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetCourseSessionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseSessionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseSessionAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCourseSessionAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetCourseSessionAnalyticsDocument, options);
}
export function useGetCourseSessionAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetCourseSessionAnalyticsDocument, options);
}
export function useGetCourseSessionAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetCourseSessionAnalyticsDocument, options);
}
export const GetFacultyByNameOrEmailDocument = gql `
    query GetFacultyByNameOrEmail($searchQuery: String!, $schoolId: ID!, $page: Int!, $pageSize: Int) {
  getFacultyByNameOrEmail(
    searchQuery: $searchQuery
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetFacultyByNameOrEmailQuery__
 *
 * To run a query within a React component, call `useGetFacultyByNameOrEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyByNameOrEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyByNameOrEmailQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetFacultyByNameOrEmailQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFacultyByNameOrEmailDocument, options);
}
export function useGetFacultyByNameOrEmailLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFacultyByNameOrEmailDocument, options);
}
export function useGetFacultyByNameOrEmailSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFacultyByNameOrEmailDocument, options);
}
export const GetFacultyDashboardStatsDocument = gql `
    query GetFacultyDashboardStats {
  getFacultyDashboardStats {
    success
    totalUsers
    totalSessions
    avgSessionLength
    totalQuestionsAnswered
  }
}
    `;
/**
 * __useGetFacultyDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetFacultyDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFacultyDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFacultyDashboardStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFacultyDashboardStatsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetFacultyDashboardStatsDocument, options);
}
export function useGetFacultyDashboardStatsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetFacultyDashboardStatsDocument, options);
}
export function useGetFacultyDashboardStatsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetFacultyDashboardStatsDocument, options);
}
export const GetIsInvitationTokenValidDocument = gql `
    query GetIsInvitationTokenValid($token: String!, $service: String!) {
  getIsInvitationTokenValid(token: $token, service: $service) {
    isValid
  }
}
    `;
/**
 * __useGetIsInvitationTokenValidQuery__
 *
 * To run a query within a React component, call `useGetIsInvitationTokenValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsInvitationTokenValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsInvitationTokenValidQuery({
 *   variables: {
 *      token: // value for 'token'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetIsInvitationTokenValidQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetIsInvitationTokenValidDocument, options);
}
export function useGetIsInvitationTokenValidLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetIsInvitationTokenValidDocument, options);
}
export function useGetIsInvitationTokenValidSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetIsInvitationTokenValidDocument, options);
}
export const GetUserLearningPreferencesDocument = gql `
    query GetUserLearningPreferences {
  getUserLearningPreferences {
    id
    interests
    careerInterests
    continuingEducation
    skillsToImprove
    learningStyles
    motivations
    semesterGoal
    studyTimePreference
    checkInFrequency
    assignmentReminders
    textReminders
  }
}
    `;
/**
 * __useGetUserLearningPreferencesQuery__
 *
 * To run a query within a React component, call `useGetUserLearningPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLearningPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLearningPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLearningPreferencesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserLearningPreferencesDocument, options);
}
export function useGetUserLearningPreferencesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserLearningPreferencesDocument, options);
}
export function useGetUserLearningPreferencesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserLearningPreferencesDocument, options);
}
export const GetUserSessionAnalyticsDocument = gql `
    query GetUserSessionAnalytics($input: UserSessionAnalyticsInput!) {
  getUserSessionAnalytics(input: $input) {
    success
    message
    data {
      id
      name
      email
      totalSessions
      totalDuration
      averageDuration
      lastActiveDate
      firstActiveDate
      courses {
        id
        name
      }
    }
    count
    totalCount
    totalUsers
    totalSessions
    avgSessionLength
  }
}
    `;
/**
 * __useGetUserSessionAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetUserSessionAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionAnalyticsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSessionAnalyticsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserSessionAnalyticsDocument, options);
}
export function useGetUserSessionAnalyticsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserSessionAnalyticsDocument, options);
}
export function useGetUserSessionAnalyticsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserSessionAnalyticsDocument, options);
}
export const GetUserSessionAnalyticsDailyBreakdownDocument = gql `
    query GetUserSessionAnalyticsDailyBreakdown($input: UserSessionAnalyticsDailyBreakdownInput!) {
  getUserSessionAnalyticsDailyBreakdown(input: $input) {
    success
    message
    data {
      day
      date
      sessions
      hourly
    }
  }
}
    `;
/**
 * __useGetUserSessionAnalyticsDailyBreakdownQuery__
 *
 * To run a query within a React component, call `useGetUserSessionAnalyticsDailyBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSessionAnalyticsDailyBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSessionAnalyticsDailyBreakdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSessionAnalyticsDailyBreakdownQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserSessionAnalyticsDailyBreakdownDocument, options);
}
export function useGetUserSessionAnalyticsDailyBreakdownLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserSessionAnalyticsDailyBreakdownDocument, options);
}
export function useGetUserSessionAnalyticsDailyBreakdownSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserSessionAnalyticsDailyBreakdownDocument, options);
}
export const GetUsersForSchoolDocument = gql `
    query GetUsersForSchool($searchQuery: String!, $schoolId: ID!, $page: Int!, $pageSize: Int, $sortBy: String, $fetchStudentsOnly: Boolean) {
  getUsersForSchool(
    searchQuery: $searchQuery
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
    sortBy: $sortBy
    fetchStudentsOnly: $fetchStudentsOnly
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        pendingCourseEnrollmentInvite
        created
        expiredInvitation
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
          course_code
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetUsersForSchoolQuery__
 *
 * To run a query within a React component, call `useGetUsersForSchoolQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForSchoolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForSchoolQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *      fetchStudentsOnly: // value for 'fetchStudentsOnly'
 *   },
 * });
 */
export function useGetUsersForSchoolQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUsersForSchoolDocument, options);
}
export function useGetUsersForSchoolLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUsersForSchoolDocument, options);
}
export function useGetUsersForSchoolSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUsersForSchoolDocument, options);
}
export const GetUsersWithElevatedRolesDocument = gql `
    query GetUsersWithElevatedRoles($schoolId: ID!, $page: Int!, $pageSize: Int, $searchQuery: String, $sortBy: String) {
  getUsersWithElevatedRoles(
    schoolId: $schoolId
    page: $page
    pageSize: $pageSize
    searchQuery: $searchQuery
    sortBy: $sortBy
  ) {
    success
    message
    data {
      faculties {
        id
        name
        email
        pendingFacultyInvite
        expiredInvitation
        hasRoleRoles {
          name
        }
        teachingCourses {
          id
          name
          course_code
        }
        hasSessionDeviceSessions {
          id
        }
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetUsersWithElevatedRolesQuery__
 *
 * To run a query within a React component, call `useGetUsersWithElevatedRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithElevatedRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithElevatedRolesQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      searchQuery: // value for 'searchQuery'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetUsersWithElevatedRolesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUsersWithElevatedRolesDocument, options);
}
export function useGetUsersWithElevatedRolesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUsersWithElevatedRolesDocument, options);
}
export function useGetUsersWithElevatedRolesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUsersWithElevatedRolesDocument, options);
}
export const GetYoutubeVideoInfoDocument = gql `
    query GetYoutubeVideoInfo($videoId: String!) {
  getYoutubeVideoInfo(videoId: $videoId) {
    title
    description
  }
}
    `;
/**
 * __useGetYoutubeVideoInfoQuery__
 *
 * To run a query within a React component, call `useGetYoutubeVideoInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYoutubeVideoInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYoutubeVideoInfoQuery({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useGetYoutubeVideoInfoQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetYoutubeVideoInfoDocument, options);
}
export function useGetYoutubeVideoInfoLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetYoutubeVideoInfoDocument, options);
}
export function useGetYoutubeVideoInfoSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetYoutubeVideoInfoDocument, options);
}
export const SearchYoutubeVideosDocument = gql `
    query SearchYoutubeVideos($query: String!) {
  searchYoutubeVideos(query: $query) {
    videoId
    title
    description
  }
}
    `;
/**
 * __useSearchYoutubeVideosQuery__
 *
 * To run a query within a React component, call `useSearchYoutubeVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchYoutubeVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchYoutubeVideosQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchYoutubeVideosQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(SearchYoutubeVideosDocument, options);
}
export function useSearchYoutubeVideosLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(SearchYoutubeVideosDocument, options);
}
export function useSearchYoutubeVideosSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(SearchYoutubeVideosDocument, options);
}
export const GetPageVisitsBySessionDocument = gql `
    query GetPageVisitsBySession($sessionId: ID!, $startDate: String, $endDate: String, $page: Int, $pageSize: Int, $sortBy: String) {
  getPageVisitsBySession(
    input: {sessionId: $sessionId, startDate: $startDate, endDate: $endDate, page: $page, pageSize: $pageSize, sortBy: $sortBy}
  ) {
    success
    message
    data {
      pageVisits {
        id
        path
        timestamp
        endTimestamp
        lastActiveTime
        visitSessionId
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetPageVisitsBySessionQuery__
 *
 * To run a query within a React component, call `useGetPageVisitsBySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageVisitsBySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageVisitsBySessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPageVisitsBySessionQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetPageVisitsBySessionDocument, options);
}
export function useGetPageVisitsBySessionLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetPageVisitsBySessionDocument, options);
}
export function useGetPageVisitsBySessionSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetPageVisitsBySessionDocument, options);
}
export const GetVisitSessionsDocument = gql `
    query GetVisitSessions($input: GetVisitSessionsInput!) {
  getVisitSessions(input: $input) {
    success
    message
    data {
      visitSessions {
        id
        startTime
        lastActiveTime
        ended
        userName
        userId
        pageVisitsCount
      }
      totalCount
    }
    count
  }
}
    `;
/**
 * __useGetVisitSessionsQuery__
 *
 * To run a query within a React component, call `useGetVisitSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetVisitSessionsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetVisitSessionsDocument, options);
}
export function useGetVisitSessionsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetVisitSessionsDocument, options);
}
export function useGetVisitSessionsSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetVisitSessionsDocument, options);
}
export const GetSessionAnalyticsCsvDocument = gql `
    query GetSessionAnalyticsCsv {
  getSessionAnalyticsCsv {
    success
    jobId
    message
  }
}
    `;
/**
 * __useGetSessionAnalyticsCsvQuery__
 *
 * To run a query within a React component, call `useGetSessionAnalyticsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAnalyticsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAnalyticsCsvQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionAnalyticsCsvQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSessionAnalyticsCsvDocument, options);
}
export function useGetSessionAnalyticsCsvLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSessionAnalyticsCsvDocument, options);
}
export function useGetSessionAnalyticsCsvSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSessionAnalyticsCsvDocument, options);
}
export const GetSessionAnalyticsCsvStatusDocument = gql `
    query GetSessionAnalyticsCsvStatus($jobId: String!) {
  getSessionAnalyticsCsvStatus(jobId: $jobId) {
    success
    downloadUrl
    message
    jobId
  }
}
    `;
/**
 * __useGetSessionAnalyticsCsvStatusQuery__
 *
 * To run a query within a React component, call `useGetSessionAnalyticsCsvStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionAnalyticsCsvStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionAnalyticsCsvStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetSessionAnalyticsCsvStatusQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetSessionAnalyticsCsvStatusDocument, options);
}
export function useGetSessionAnalyticsCsvStatusLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetSessionAnalyticsCsvStatusDocument, options);
}
export function useGetSessionAnalyticsCsvStatusSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetSessionAnalyticsCsvStatusDocument, options);
}
export const GetVisualizationDocument = gql `
    query GetVisualization($id: ID!) {
  getVisualization(id: $id) {
    count
    data {
      code
      created
      id
      lastModified
      visualizationType
      visualizationDescription
      status
    }
    message
    success
  }
}
    `;
/**
 * __useGetVisualizationQuery__
 *
 * To run a query within a React component, call `useGetVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisualizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVisualizationQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetVisualizationDocument, options);
}
export function useGetVisualizationLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetVisualizationDocument, options);
}
export function useGetVisualizationSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetVisualizationDocument, options);
}
export const GetUserWorkspacesDocument = gql `
    query GetUserWorkspaces {
  getUserWorkspaces {
    id
    name
  }
}
    `;
/**
 * __useGetUserWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetUserWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWorkspacesQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserWorkspacesDocument, options);
}
export function useGetUserWorkspacesLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserWorkspacesDocument, options);
}
export function useGetUserWorkspacesSuspenseQuery(baseOptions) {
    const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery(GetUserWorkspacesDocument, options);
}
export const CompanionLlmStreamDocument = gql `
    subscription CompanionLlmStream($question: String!, $chatId: String, $workspaceId: String, $tools: CompanionStreamToolsInput, $attachment: AttachmentInput, $enableTts: Boolean, $timeZone: String, $timestamp: String, $userMessageId: String, $isEditReplay: Boolean, $anchorMessageId: String, $branchId: String) {
  companionLlmStream(
    question: $question
    chatId: $chatId
    workspaceId: $workspaceId
    tools: $tools
    attachment: $attachment
    enableTts: $enableTts
    timeZone: $timeZone
    timestamp: $timestamp
    userMessageId: $userMessageId
    isEditReplay: $isEditReplay
    anchorMessageId: $anchorMessageId
    branchId: $branchId
  ) {
    __typename
    ... on LLMStreamMessageDeltaEvent {
      type
      chatId
      timestamp
      messageId
      isFinalChunk
      delta {
        __typename
        ... on LLMStreamTextBlock {
          text
        }
        ... on LLMStreamFileBlock {
          fileId
          purpose
          displayName
        }
        ... on LLMStreamArtifactBlock {
          artifactId
          artifactType
        }
      }
    }
    ... on LLMStreamMessageCompletedEvent {
      type
      chatId
      timestamp
      message {
        id
        chatId
        role
        createdAt
        metadata
        blocks {
          __typename
          ... on LLMStreamTextBlock {
            text
          }
          ... on LLMStreamFileBlock {
            fileId
            purpose
            displayName
          }
          ... on LLMStreamArtifactBlock {
            artifactId
            artifactType
          }
        }
      }
    }
    ... on LLMStreamAudioSegmentStartEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamAudioSegmentTextEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
      text
    }
    ... on LLMStreamAudioSegmentEndEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamArtifactCreatedEvent {
      type
      chatId
      timestamp
      artifact
    }
    ... on LLMStreamChatRenamedEvent {
      type
      chatId
      timestamp
      name
    }
    ... on LLMStreamDeepSearchStateEvent {
      type
      chatId
      timestamp
      state
      payload
    }
    ... on LLMStreamErrorEvent {
      type
      chatId
      timestamp
      code
      errorMessage
    }
    ... on LLMStreamStatusEvent {
      type
      chatId
      timestamp
      data
    }
    ... on LLMStreamToolStartEvent {
      type
      chatId
      timestamp
      tool
      jobId
    }
    ... on LLMStreamToolResultEvent {
      type
      chatId
      timestamp
      tool
      result
    }
  }
}
    `;
/**
 * __useCompanionLlmStreamSubscription__
 *
 * To run a query within a React component, call `useCompanionLlmStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanionLlmStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanionLlmStreamSubscription({
 *   variables: {
 *      question: // value for 'question'
 *      chatId: // value for 'chatId'
 *      workspaceId: // value for 'workspaceId'
 *      tools: // value for 'tools'
 *      attachment: // value for 'attachment'
 *      enableTts: // value for 'enableTts'
 *      timeZone: // value for 'timeZone'
 *      timestamp: // value for 'timestamp'
 *      userMessageId: // value for 'userMessageId'
 *      isEditReplay: // value for 'isEditReplay'
 *      anchorMessageId: // value for 'anchorMessageId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCompanionLlmStreamSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(CompanionLlmStreamDocument, options);
}
export const LearningLlmStreamDocument = gql `
    subscription LearningLlmStream($question: String!, $chatId: String, $workspaceId: String, $attachment: AttachmentInput, $contentNodeId: String, $enableTts: Boolean, $mediaFocus: String, $mediaBlockKind: MediaBlockKind, $inlineResponseChoiceIndex: Int, $skipChatLookup: Boolean, $isAutoStart: Boolean) {
  learningLlmStream(
    question: $question
    chatId: $chatId
    workspaceId: $workspaceId
    attachment: $attachment
    contentNodeId: $contentNodeId
    enableTts: $enableTts
    mediaFocus: $mediaFocus
    mediaBlockKind: $mediaBlockKind
    inlineResponseChoiceIndex: $inlineResponseChoiceIndex
    skipChatLookup: $skipChatLookup
    isAutoStart: $isAutoStart
  ) {
    __typename
    ... on LLMStreamMessageDeltaEvent {
      type
      chatId
      timestamp
      messageId
      isFinalChunk
      delta {
        __typename
        ... on LLMStreamTextBlock {
          text
        }
        ... on LLMStreamFileBlock {
          fileId
          purpose
          displayName
        }
        ... on LLMStreamArtifactBlock {
          artifactId
          artifactType
        }
        ... on LLMStreamImageBlock {
          status
          url
          title
          description
        }
        ... on LLMStreamVideoBlock {
          videoId
          title
          description
          url
          thumbnailUrl
          startTime
          endTime
          segmentSummary
          blockId
          mediaChatId
        }
        ... on LLMStreamVisualizationBlock {
          visualizationId
          visualizationType
          visualizationDescription
          content
        }
        ... on LLMStreamMcqQuestionBlock {
          type
          questionId
          question
          choices
        }
        ... on LLMStreamSubjectiveQuestionBlock {
          type
          questionId
          question
        }
      }
    }
    ... on LLMStreamAudioSegmentStartEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamAudioSegmentTextEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
      text
    }
    ... on LLMStreamAudioSegmentEndEvent {
      type
      chatId
      timestamp
      messageId
      chunkIndex
    }
    ... on LLMStreamMessageCompletedEvent {
      type
      chatId
      timestamp
      message {
        id
        chatId
        role
        createdAt
        metadata
        blocks {
          __typename
          ... on LLMStreamTextBlock {
            text
          }
          ... on LLMStreamFileBlock {
            fileId
            purpose
            displayName
          }
          ... on LLMStreamArtifactBlock {
            artifactId
            artifactType
          }
          ... on LLMStreamImageBlock {
            status
            url
            title
            description
          }
          ... on LLMStreamVideoBlock {
            videoId
            title
            description
            url
            thumbnailUrl
            startTime
            endTime
            segmentSummary
          }
          ... on LLMStreamVisualizationBlock {
            visualizationId
            visualizationType
            visualizationDescription
            content
          }
          ... on LLMStreamMcqQuestionBlock {
            type
            questionId
            question
            choices
          }
          ... on LLMStreamSubjectiveQuestionBlock {
            type
            questionId
            question
          }
        }
      }
    }
    ... on LLMStreamArtifactCreatedEvent {
      type
      chatId
      timestamp
      artifact
    }
    ... on LLMStreamChatRenamedEvent {
      type
      chatId
      timestamp
      name
    }
    ... on LLMStreamErrorEvent {
      type
      chatId
      timestamp
      code
      errorMessage
    }
    ... on LLMStreamToolStartEvent {
      type
      chatId
      timestamp
      tool
      jobId
    }
    ... on LLMStreamToolResultEvent {
      type
      chatId
      timestamp
      tool
      result
    }
  }
}
    `;
/**
 * __useLearningLlmStreamSubscription__
 *
 * To run a query within a React component, call `useLearningLlmStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLearningLlmStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningLlmStreamSubscription({
 *   variables: {
 *      question: // value for 'question'
 *      chatId: // value for 'chatId'
 *      workspaceId: // value for 'workspaceId'
 *      attachment: // value for 'attachment'
 *      contentNodeId: // value for 'contentNodeId'
 *      enableTts: // value for 'enableTts'
 *      mediaFocus: // value for 'mediaFocus'
 *      mediaBlockKind: // value for 'mediaBlockKind'
 *      inlineResponseChoiceIndex: // value for 'inlineResponseChoiceIndex'
 *      skipChatLookup: // value for 'skipChatLookup'
 *      isAutoStart: // value for 'isAutoStart'
 *   },
 * });
 */
export function useLearningLlmStreamSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(LearningLlmStreamDocument, options);
}
export const OnNotificationCreatedDocument = gql `
    subscription OnNotificationCreated($userId: ID!) {
  onNotificationCreated(userId: $userId) {
    id
    userId
    title
    message
    created
    isRead
    actionUrl
    type
  }
}
    `;
/**
 * __useOnNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useOnNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationCreatedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOnNotificationCreatedSubscription(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useSubscription(OnNotificationCreatedDocument, options);
}
